
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefb24"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefb24"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2T6zX", function(module, exports) {
"use strict";

module.exports = (parcelRequire("bH5Ki"));

});
parcelRegister("bH5Ki", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $88382ad49822721f$export$ffb0004e005737fa; }, function (v) { return $88382ad49822721f$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $88382ad49822721f$export$34b9dba7ce09269b; }, function (v) { return $88382ad49822721f$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $88382ad49822721f$export$25062201e9e25d76; }, function (v) { return $88382ad49822721f$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $88382ad49822721f$export$ffb0004e005737fa;
var $88382ad49822721f$export$34b9dba7ce09269b;
var $88382ad49822721f$export$25062201e9e25d76;
"use strict";

var $bCCVl = parcelRequire("bCCVl");
var $88382ad49822721f$var$k = Symbol.for("react.element"), $88382ad49822721f$var$l = Symbol.for("react.fragment"), $88382ad49822721f$var$m = Object.prototype.hasOwnProperty, $88382ad49822721f$var$n = $bCCVl.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $88382ad49822721f$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $88382ad49822721f$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$88382ad49822721f$var$m.call(a, b) && !$88382ad49822721f$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $88382ad49822721f$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $88382ad49822721f$var$n.current
    };
}
$88382ad49822721f$export$ffb0004e005737fa = $88382ad49822721f$var$l;
$88382ad49822721f$export$34b9dba7ce09269b = $88382ad49822721f$var$q;
$88382ad49822721f$export$25062201e9e25d76 = $88382ad49822721f$var$q;

});
parcelRegister("bCCVl", function(module, exports) {
"use strict";

module.exports = (parcelRequire("6dFDe"));

});
parcelRegister("6dFDe", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $4874402e516ac9b3$export$dca3b0875bd9a954; }, function (v) { return $4874402e516ac9b3$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $4874402e516ac9b3$export$16fa2f45be04daa8; }, function (v) { return $4874402e516ac9b3$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $4874402e516ac9b3$export$ffb0004e005737fa; }, function (v) { return $4874402e516ac9b3$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $4874402e516ac9b3$export$e2c29f18771995cb; }, function (v) { return $4874402e516ac9b3$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $4874402e516ac9b3$export$221d75b3f55bb0bd; }, function (v) { return $4874402e516ac9b3$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $4874402e516ac9b3$export$5f8d39834fd61797; }, function (v) { return $4874402e516ac9b3$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $4874402e516ac9b3$export$74bf444e3cd11ea5; }, function (v) { return $4874402e516ac9b3$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $4874402e516ac9b3$export$ae55be85d98224ed; }, function (v) { return $4874402e516ac9b3$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $4874402e516ac9b3$export$3ba232387fd5d6dd; }, function (v) { return $4874402e516ac9b3$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $4874402e516ac9b3$export$e530037191fcd5d7; }, function (v) { return $4874402e516ac9b3$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $4874402e516ac9b3$export$fd42f52fd3ae1109; }, function (v) { return $4874402e516ac9b3$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $4874402e516ac9b3$export$c8a8987d4410bf2d; }, function (v) { return $4874402e516ac9b3$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $4874402e516ac9b3$export$d38cd72104c1f0e9; }, function (v) { return $4874402e516ac9b3$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $4874402e516ac9b3$export$7d1e3a5e95ceca43; }, function (v) { return $4874402e516ac9b3$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $4874402e516ac9b3$export$257a8862b851cb5b; }, function (v) { return $4874402e516ac9b3$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $4874402e516ac9b3$export$a8257692ac88316c; }, function (v) { return $4874402e516ac9b3$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $4874402e516ac9b3$export$488013bae63b21da; }, function (v) { return $4874402e516ac9b3$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $4874402e516ac9b3$export$7c73462e0d25e514; }, function (v) { return $4874402e516ac9b3$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $4874402e516ac9b3$export$7568632d0d33d16d; }, function (v) { return $4874402e516ac9b3$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $4874402e516ac9b3$export$88948ce120ea2619; }, function (v) { return $4874402e516ac9b3$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $4874402e516ac9b3$export$35808ee640e87ca7; }, function (v) { return $4874402e516ac9b3$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $4874402e516ac9b3$export$fae74005e78b1a27; }, function (v) { return $4874402e516ac9b3$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $4874402e516ac9b3$export$dc8fbce3eb94dc1e; }, function (v) { return $4874402e516ac9b3$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $4874402e516ac9b3$export$6a7bc4e911dc01cf; }, function (v) { return $4874402e516ac9b3$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $4874402e516ac9b3$export$6d9c69b0de29b591; }, function (v) { return $4874402e516ac9b3$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $4874402e516ac9b3$export$f680877a34711e37; }, function (v) { return $4874402e516ac9b3$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $4874402e516ac9b3$export$d5a552a76deda3c2; }, function (v) { return $4874402e516ac9b3$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $4874402e516ac9b3$export$aaabe4eda9ed9969; }, function (v) { return $4874402e516ac9b3$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $4874402e516ac9b3$export$e5c5a5f917a5871c; }, function (v) { return $4874402e516ac9b3$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $4874402e516ac9b3$export$1538c33de8887b59; }, function (v) { return $4874402e516ac9b3$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $4874402e516ac9b3$export$13e3392192263954; }, function (v) { return $4874402e516ac9b3$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $4874402e516ac9b3$export$b8f5890fc79d6aca; }, function (v) { return $4874402e516ac9b3$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $4874402e516ac9b3$export$60241385465d0a34; }, function (v) { return $4874402e516ac9b3$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $4874402e516ac9b3$export$306c0aa65ff9ec16; }, function (v) { return $4874402e516ac9b3$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $4874402e516ac9b3$export$7b286972b8d8ccbf; }, function (v) { return $4874402e516ac9b3$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $4874402e516ac9b3$export$83d89fbfd8236492; }, function (v) { return $4874402e516ac9b3$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4874402e516ac9b3$export$dca3b0875bd9a954;
var $4874402e516ac9b3$export$16fa2f45be04daa8;
var $4874402e516ac9b3$export$ffb0004e005737fa;
var $4874402e516ac9b3$export$e2c29f18771995cb;
var $4874402e516ac9b3$export$221d75b3f55bb0bd;
var $4874402e516ac9b3$export$5f8d39834fd61797;
var $4874402e516ac9b3$export$74bf444e3cd11ea5;
var $4874402e516ac9b3$export$ae55be85d98224ed;
var $4874402e516ac9b3$export$3ba232387fd5d6dd;
var $4874402e516ac9b3$export$e530037191fcd5d7;
var $4874402e516ac9b3$export$fd42f52fd3ae1109;
var $4874402e516ac9b3$export$c8a8987d4410bf2d;
var $4874402e516ac9b3$export$d38cd72104c1f0e9;
var $4874402e516ac9b3$export$7d1e3a5e95ceca43;
var $4874402e516ac9b3$export$257a8862b851cb5b;
var $4874402e516ac9b3$export$a8257692ac88316c;
var $4874402e516ac9b3$export$488013bae63b21da;
var $4874402e516ac9b3$export$7c73462e0d25e514;
var $4874402e516ac9b3$export$7568632d0d33d16d;
var $4874402e516ac9b3$export$88948ce120ea2619;
var $4874402e516ac9b3$export$35808ee640e87ca7;
var $4874402e516ac9b3$export$fae74005e78b1a27;
var $4874402e516ac9b3$export$dc8fbce3eb94dc1e;
var $4874402e516ac9b3$export$6a7bc4e911dc01cf;
var $4874402e516ac9b3$export$6d9c69b0de29b591;
var $4874402e516ac9b3$export$f680877a34711e37;
var $4874402e516ac9b3$export$d5a552a76deda3c2;
var $4874402e516ac9b3$export$aaabe4eda9ed9969;
var $4874402e516ac9b3$export$e5c5a5f917a5871c;
var $4874402e516ac9b3$export$1538c33de8887b59;
var $4874402e516ac9b3$export$13e3392192263954;
var $4874402e516ac9b3$export$b8f5890fc79d6aca;
var $4874402e516ac9b3$export$60241385465d0a34;
var $4874402e516ac9b3$export$306c0aa65ff9ec16;
var $4874402e516ac9b3$export$7b286972b8d8ccbf;
var $4874402e516ac9b3$export$83d89fbfd8236492;
"use strict";
var $4874402e516ac9b3$var$l = Symbol.for("react.element"), $4874402e516ac9b3$var$n = Symbol.for("react.portal"), $4874402e516ac9b3$var$p = Symbol.for("react.fragment"), $4874402e516ac9b3$var$q = Symbol.for("react.strict_mode"), $4874402e516ac9b3$var$r = Symbol.for("react.profiler"), $4874402e516ac9b3$var$t = Symbol.for("react.provider"), $4874402e516ac9b3$var$u = Symbol.for("react.context"), $4874402e516ac9b3$var$v = Symbol.for("react.forward_ref"), $4874402e516ac9b3$var$w = Symbol.for("react.suspense"), $4874402e516ac9b3$var$x = Symbol.for("react.memo"), $4874402e516ac9b3$var$y = Symbol.for("react.lazy"), $4874402e516ac9b3$var$z = Symbol.iterator;
function $4874402e516ac9b3$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $4874402e516ac9b3$var$z && a[$4874402e516ac9b3$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $4874402e516ac9b3$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $4874402e516ac9b3$var$C = Object.assign, $4874402e516ac9b3$var$D = {};
function $4874402e516ac9b3$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $4874402e516ac9b3$var$D;
    this.updater = e || $4874402e516ac9b3$var$B;
}
$4874402e516ac9b3$var$E.prototype.isReactComponent = {};
$4874402e516ac9b3$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$4874402e516ac9b3$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $4874402e516ac9b3$var$F() {}
$4874402e516ac9b3$var$F.prototype = $4874402e516ac9b3$var$E.prototype;
function $4874402e516ac9b3$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $4874402e516ac9b3$var$D;
    this.updater = e || $4874402e516ac9b3$var$B;
}
var $4874402e516ac9b3$var$H = $4874402e516ac9b3$var$G.prototype = new $4874402e516ac9b3$var$F;
$4874402e516ac9b3$var$H.constructor = $4874402e516ac9b3$var$G;
$4874402e516ac9b3$var$C($4874402e516ac9b3$var$H, $4874402e516ac9b3$var$E.prototype);
$4874402e516ac9b3$var$H.isPureReactComponent = !0;
var $4874402e516ac9b3$var$I = Array.isArray, $4874402e516ac9b3$var$J = Object.prototype.hasOwnProperty, $4874402e516ac9b3$var$K = {
    current: null
}, $4874402e516ac9b3$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $4874402e516ac9b3$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$4874402e516ac9b3$var$J.call(b, d) && !$4874402e516ac9b3$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $4874402e516ac9b3$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $4874402e516ac9b3$var$K.current
    };
}
function $4874402e516ac9b3$var$N(a, b) {
    return {
        $$typeof: $4874402e516ac9b3$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $4874402e516ac9b3$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $4874402e516ac9b3$var$l;
}
function $4874402e516ac9b3$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $4874402e516ac9b3$var$P = /\/+/g;
function $4874402e516ac9b3$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $4874402e516ac9b3$var$escape("" + a.key) : b.toString(36);
}
function $4874402e516ac9b3$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $4874402e516ac9b3$var$l:
                case $4874402e516ac9b3$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $4874402e516ac9b3$var$Q(h, 0) : d, $4874402e516ac9b3$var$I(c) ? (e = "", null != a && (e = a.replace($4874402e516ac9b3$var$P, "$&/") + "/"), $4874402e516ac9b3$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($4874402e516ac9b3$var$O(c) && (c = $4874402e516ac9b3$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($4874402e516ac9b3$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($4874402e516ac9b3$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $4874402e516ac9b3$var$Q(k, g);
        h += $4874402e516ac9b3$var$R(k, b, e, f, c);
    }
    else if (f = $4874402e516ac9b3$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $4874402e516ac9b3$var$Q(k, g++), h += $4874402e516ac9b3$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $4874402e516ac9b3$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $4874402e516ac9b3$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $4874402e516ac9b3$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $4874402e516ac9b3$var$U = {
    current: null
}, $4874402e516ac9b3$var$V = {
    transition: null
}, $4874402e516ac9b3$var$W = {
    ReactCurrentDispatcher: $4874402e516ac9b3$var$U,
    ReactCurrentBatchConfig: $4874402e516ac9b3$var$V,
    ReactCurrentOwner: $4874402e516ac9b3$var$K
};
function $4874402e516ac9b3$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$4874402e516ac9b3$export$dca3b0875bd9a954 = {
    map: $4874402e516ac9b3$var$S,
    forEach: function(a, b, e) {
        $4874402e516ac9b3$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $4874402e516ac9b3$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $4874402e516ac9b3$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$4874402e516ac9b3$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$4874402e516ac9b3$export$16fa2f45be04daa8 = $4874402e516ac9b3$var$E;
$4874402e516ac9b3$export$ffb0004e005737fa = $4874402e516ac9b3$var$p;
$4874402e516ac9b3$export$e2c29f18771995cb = $4874402e516ac9b3$var$r;
$4874402e516ac9b3$export$221d75b3f55bb0bd = $4874402e516ac9b3$var$G;
$4874402e516ac9b3$export$5f8d39834fd61797 = $4874402e516ac9b3$var$q;
$4874402e516ac9b3$export$74bf444e3cd11ea5 = $4874402e516ac9b3$var$w;
$4874402e516ac9b3$export$ae55be85d98224ed = $4874402e516ac9b3$var$W;
$4874402e516ac9b3$export$3ba232387fd5d6dd = $4874402e516ac9b3$var$X;
$4874402e516ac9b3$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $4874402e516ac9b3$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $4874402e516ac9b3$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$4874402e516ac9b3$var$J.call(b, f) && !$4874402e516ac9b3$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $4874402e516ac9b3$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$4874402e516ac9b3$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $4874402e516ac9b3$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $4874402e516ac9b3$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$4874402e516ac9b3$export$c8a8987d4410bf2d = $4874402e516ac9b3$var$M;
$4874402e516ac9b3$export$d38cd72104c1f0e9 = function(a) {
    var b = $4874402e516ac9b3$var$M.bind(null, a);
    b.type = a;
    return b;
};
$4874402e516ac9b3$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$4874402e516ac9b3$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $4874402e516ac9b3$var$v,
        render: a
    };
};
$4874402e516ac9b3$export$a8257692ac88316c = $4874402e516ac9b3$var$O;
$4874402e516ac9b3$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $4874402e516ac9b3$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $4874402e516ac9b3$var$T
    };
};
$4874402e516ac9b3$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $4874402e516ac9b3$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$4874402e516ac9b3$export$7568632d0d33d16d = function(a) {
    var b = $4874402e516ac9b3$var$V.transition;
    $4874402e516ac9b3$var$V.transition = {};
    try {
        a();
    } finally{
        $4874402e516ac9b3$var$V.transition = b;
    }
};
$4874402e516ac9b3$export$88948ce120ea2619 = $4874402e516ac9b3$var$X;
$4874402e516ac9b3$export$35808ee640e87ca7 = function(a, b) {
    return $4874402e516ac9b3$var$U.current.useCallback(a, b);
};
$4874402e516ac9b3$export$fae74005e78b1a27 = function(a) {
    return $4874402e516ac9b3$var$U.current.useContext(a);
};
$4874402e516ac9b3$export$dc8fbce3eb94dc1e = function() {};
$4874402e516ac9b3$export$6a7bc4e911dc01cf = function(a) {
    return $4874402e516ac9b3$var$U.current.useDeferredValue(a);
};
$4874402e516ac9b3$export$6d9c69b0de29b591 = function(a, b) {
    return $4874402e516ac9b3$var$U.current.useEffect(a, b);
};
$4874402e516ac9b3$export$f680877a34711e37 = function() {
    return $4874402e516ac9b3$var$U.current.useId();
};
$4874402e516ac9b3$export$d5a552a76deda3c2 = function(a, b, e) {
    return $4874402e516ac9b3$var$U.current.useImperativeHandle(a, b, e);
};
$4874402e516ac9b3$export$aaabe4eda9ed9969 = function(a, b) {
    return $4874402e516ac9b3$var$U.current.useInsertionEffect(a, b);
};
$4874402e516ac9b3$export$e5c5a5f917a5871c = function(a, b) {
    return $4874402e516ac9b3$var$U.current.useLayoutEffect(a, b);
};
$4874402e516ac9b3$export$1538c33de8887b59 = function(a, b) {
    return $4874402e516ac9b3$var$U.current.useMemo(a, b);
};
$4874402e516ac9b3$export$13e3392192263954 = function(a, b, e) {
    return $4874402e516ac9b3$var$U.current.useReducer(a, b, e);
};
$4874402e516ac9b3$export$b8f5890fc79d6aca = function(a) {
    return $4874402e516ac9b3$var$U.current.useRef(a);
};
$4874402e516ac9b3$export$60241385465d0a34 = function(a) {
    return $4874402e516ac9b3$var$U.current.useState(a);
};
$4874402e516ac9b3$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $4874402e516ac9b3$var$U.current.useSyncExternalStore(a, b, e);
};
$4874402e516ac9b3$export$7b286972b8d8ccbf = function() {
    return $4874402e516ac9b3$var$U.current.useTransition();
};
$4874402e516ac9b3$export$83d89fbfd8236492 = "18.3.1";

});




parcelRegister("fL3Dm", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b78e106b2dfe8e1a$export$ae55be85d98224ed; }, function (v) { return $b78e106b2dfe8e1a$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $b78e106b2dfe8e1a$export$d39a5bbd09211389; }, function (v) { return $b78e106b2dfe8e1a$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $b78e106b2dfe8e1a$export$882461b6382ed46c; }, function (v) { return $b78e106b2dfe8e1a$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $b78e106b2dfe8e1a$export$466bfc07425424d5; }, function (v) { return $b78e106b2dfe8e1a$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $b78e106b2dfe8e1a$export$cd75ccfd720a3cd4; }, function (v) { return $b78e106b2dfe8e1a$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $b78e106b2dfe8e1a$export$fa8d919ba61d84db; }, function (v) { return $b78e106b2dfe8e1a$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $b78e106b2dfe8e1a$export$757ceba2d55c277e; }, function (v) { return $b78e106b2dfe8e1a$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $b78e106b2dfe8e1a$export$b3890eb0ae9dca99; }, function (v) { return $b78e106b2dfe8e1a$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $b78e106b2dfe8e1a$export$502457920280e6be; }, function (v) { return $b78e106b2dfe8e1a$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $b78e106b2dfe8e1a$export$c78a37762a8d58e1; }, function (v) { return $b78e106b2dfe8e1a$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $b78e106b2dfe8e1a$export$dc54d992c10e8a18; }, function (v) { return $b78e106b2dfe8e1a$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $b78e106b2dfe8e1a$export$83d89fbfd8236492; }, function (v) { return $b78e106b2dfe8e1a$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $b78e106b2dfe8e1a$export$ae55be85d98224ed;
var $b78e106b2dfe8e1a$export$d39a5bbd09211389;
var $b78e106b2dfe8e1a$export$882461b6382ed46c;
var $b78e106b2dfe8e1a$export$466bfc07425424d5;
var $b78e106b2dfe8e1a$export$cd75ccfd720a3cd4;
var $b78e106b2dfe8e1a$export$fa8d919ba61d84db;
var $b78e106b2dfe8e1a$export$757ceba2d55c277e;
var $b78e106b2dfe8e1a$export$b3890eb0ae9dca99;
var $b78e106b2dfe8e1a$export$502457920280e6be;
var $b78e106b2dfe8e1a$export$c78a37762a8d58e1;
var $b78e106b2dfe8e1a$export$dc54d992c10e8a18;
var $b78e106b2dfe8e1a$export$83d89fbfd8236492;
"use strict";

var $bCCVl = parcelRequire("bCCVl");

var $2plYB = parcelRequire("2plYB");
function $b78e106b2dfe8e1a$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $b78e106b2dfe8e1a$var$da = new Set, $b78e106b2dfe8e1a$var$ea = {};
function $b78e106b2dfe8e1a$var$fa(a, b) {
    $b78e106b2dfe8e1a$var$ha(a, b);
    $b78e106b2dfe8e1a$var$ha(a + "Capture", b);
}
function $b78e106b2dfe8e1a$var$ha(a, b) {
    $b78e106b2dfe8e1a$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$b78e106b2dfe8e1a$var$da.add(b[a]);
}
var $b78e106b2dfe8e1a$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $b78e106b2dfe8e1a$var$ja = Object.prototype.hasOwnProperty, $b78e106b2dfe8e1a$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $b78e106b2dfe8e1a$var$la = {}, $b78e106b2dfe8e1a$var$ma = {};
function $b78e106b2dfe8e1a$var$oa(a) {
    if ($b78e106b2dfe8e1a$var$ja.call($b78e106b2dfe8e1a$var$ma, a)) return !0;
    if ($b78e106b2dfe8e1a$var$ja.call($b78e106b2dfe8e1a$var$la, a)) return !1;
    if ($b78e106b2dfe8e1a$var$ka.test(a)) return $b78e106b2dfe8e1a$var$ma[a] = !0;
    $b78e106b2dfe8e1a$var$la[a] = !0;
    return !1;
}
function $b78e106b2dfe8e1a$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $b78e106b2dfe8e1a$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $b78e106b2dfe8e1a$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $b78e106b2dfe8e1a$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $b78e106b2dfe8e1a$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $b78e106b2dfe8e1a$var$z[a] = new $b78e106b2dfe8e1a$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $b78e106b2dfe8e1a$var$z[b] = new $b78e106b2dfe8e1a$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $b78e106b2dfe8e1a$var$z[a] = new $b78e106b2dfe8e1a$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $b78e106b2dfe8e1a$var$z[a] = new $b78e106b2dfe8e1a$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $b78e106b2dfe8e1a$var$z[a] = new $b78e106b2dfe8e1a$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $b78e106b2dfe8e1a$var$z[a] = new $b78e106b2dfe8e1a$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $b78e106b2dfe8e1a$var$z[a] = new $b78e106b2dfe8e1a$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $b78e106b2dfe8e1a$var$z[a] = new $b78e106b2dfe8e1a$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $b78e106b2dfe8e1a$var$z[a] = new $b78e106b2dfe8e1a$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $b78e106b2dfe8e1a$var$ra = /[\-:]([a-z])/g;
function $b78e106b2dfe8e1a$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($b78e106b2dfe8e1a$var$ra, $b78e106b2dfe8e1a$var$sa);
    $b78e106b2dfe8e1a$var$z[b] = new $b78e106b2dfe8e1a$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($b78e106b2dfe8e1a$var$ra, $b78e106b2dfe8e1a$var$sa);
    $b78e106b2dfe8e1a$var$z[b] = new $b78e106b2dfe8e1a$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($b78e106b2dfe8e1a$var$ra, $b78e106b2dfe8e1a$var$sa);
    $b78e106b2dfe8e1a$var$z[b] = new $b78e106b2dfe8e1a$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $b78e106b2dfe8e1a$var$z[a] = new $b78e106b2dfe8e1a$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$b78e106b2dfe8e1a$var$z.xlinkHref = new $b78e106b2dfe8e1a$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $b78e106b2dfe8e1a$var$z[a] = new $b78e106b2dfe8e1a$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $b78e106b2dfe8e1a$var$ta(a, b, c, d) {
    var e = $b78e106b2dfe8e1a$var$z.hasOwnProperty(b) ? $b78e106b2dfe8e1a$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $b78e106b2dfe8e1a$var$qa(b, c, e, d) && (c = null), d || null === e ? $b78e106b2dfe8e1a$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $b78e106b2dfe8e1a$var$ua = $bCCVl.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $b78e106b2dfe8e1a$var$va = Symbol.for("react.element"), $b78e106b2dfe8e1a$var$wa = Symbol.for("react.portal"), $b78e106b2dfe8e1a$var$ya = Symbol.for("react.fragment"), $b78e106b2dfe8e1a$var$za = Symbol.for("react.strict_mode"), $b78e106b2dfe8e1a$var$Aa = Symbol.for("react.profiler"), $b78e106b2dfe8e1a$var$Ba = Symbol.for("react.provider"), $b78e106b2dfe8e1a$var$Ca = Symbol.for("react.context"), $b78e106b2dfe8e1a$var$Da = Symbol.for("react.forward_ref"), $b78e106b2dfe8e1a$var$Ea = Symbol.for("react.suspense"), $b78e106b2dfe8e1a$var$Fa = Symbol.for("react.suspense_list"), $b78e106b2dfe8e1a$var$Ga = Symbol.for("react.memo"), $b78e106b2dfe8e1a$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $b78e106b2dfe8e1a$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $b78e106b2dfe8e1a$var$Ja = Symbol.iterator;
function $b78e106b2dfe8e1a$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b78e106b2dfe8e1a$var$Ja && a[$b78e106b2dfe8e1a$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b78e106b2dfe8e1a$var$A = Object.assign, $b78e106b2dfe8e1a$var$La;
function $b78e106b2dfe8e1a$var$Ma(a) {
    if (void 0 === $b78e106b2dfe8e1a$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $b78e106b2dfe8e1a$var$La = b && b[1] || "";
    }
    return "\n" + $b78e106b2dfe8e1a$var$La + a;
}
var $b78e106b2dfe8e1a$var$Na = !1;
function $b78e106b2dfe8e1a$var$Oa(a, b) {
    if (!a || $b78e106b2dfe8e1a$var$Na) return "";
    $b78e106b2dfe8e1a$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $b78e106b2dfe8e1a$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $b78e106b2dfe8e1a$var$Ma(a) : "";
}
function $b78e106b2dfe8e1a$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $b78e106b2dfe8e1a$var$Ma(a.type);
        case 16:
            return $b78e106b2dfe8e1a$var$Ma("Lazy");
        case 13:
            return $b78e106b2dfe8e1a$var$Ma("Suspense");
        case 19:
            return $b78e106b2dfe8e1a$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $b78e106b2dfe8e1a$var$Oa(a.type, !1), a;
        case 11:
            return a = $b78e106b2dfe8e1a$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $b78e106b2dfe8e1a$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $b78e106b2dfe8e1a$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $b78e106b2dfe8e1a$var$ya:
            return "Fragment";
        case $b78e106b2dfe8e1a$var$wa:
            return "Portal";
        case $b78e106b2dfe8e1a$var$Aa:
            return "Profiler";
        case $b78e106b2dfe8e1a$var$za:
            return "StrictMode";
        case $b78e106b2dfe8e1a$var$Ea:
            return "Suspense";
        case $b78e106b2dfe8e1a$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $b78e106b2dfe8e1a$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $b78e106b2dfe8e1a$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $b78e106b2dfe8e1a$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $b78e106b2dfe8e1a$var$Ga:
            return b = a.displayName || null, null !== b ? b : $b78e106b2dfe8e1a$var$Qa(a.type) || "Memo";
        case $b78e106b2dfe8e1a$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $b78e106b2dfe8e1a$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $b78e106b2dfe8e1a$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $b78e106b2dfe8e1a$var$Qa(b);
        case 8:
            return b === $b78e106b2dfe8e1a$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $b78e106b2dfe8e1a$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $b78e106b2dfe8e1a$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $b78e106b2dfe8e1a$var$Ua(a) {
    var b = $b78e106b2dfe8e1a$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $b78e106b2dfe8e1a$var$Va(a) {
    a._valueTracker || (a._valueTracker = $b78e106b2dfe8e1a$var$Ua(a));
}
function $b78e106b2dfe8e1a$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $b78e106b2dfe8e1a$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $b78e106b2dfe8e1a$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $b78e106b2dfe8e1a$var$Ya(a, b) {
    var c = b.checked;
    return $b78e106b2dfe8e1a$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $b78e106b2dfe8e1a$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $b78e106b2dfe8e1a$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $b78e106b2dfe8e1a$var$ab(a, b) {
    b = b.checked;
    null != b && $b78e106b2dfe8e1a$var$ta(a, "checked", b, !1);
}
function $b78e106b2dfe8e1a$var$bb(a, b) {
    $b78e106b2dfe8e1a$var$ab(a, b);
    var c = $b78e106b2dfe8e1a$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $b78e106b2dfe8e1a$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $b78e106b2dfe8e1a$var$cb(a, b.type, $b78e106b2dfe8e1a$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $b78e106b2dfe8e1a$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $b78e106b2dfe8e1a$var$cb(a, b, c) {
    if ("number" !== b || $b78e106b2dfe8e1a$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $b78e106b2dfe8e1a$var$eb = Array.isArray;
function $b78e106b2dfe8e1a$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $b78e106b2dfe8e1a$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $b78e106b2dfe8e1a$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($b78e106b2dfe8e1a$var$p(91));
    return $b78e106b2dfe8e1a$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $b78e106b2dfe8e1a$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($b78e106b2dfe8e1a$var$p(92));
            if ($b78e106b2dfe8e1a$var$eb(c)) {
                if (1 < c.length) throw Error($b78e106b2dfe8e1a$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $b78e106b2dfe8e1a$var$Sa(c)
    };
}
function $b78e106b2dfe8e1a$var$ib(a, b) {
    var c = $b78e106b2dfe8e1a$var$Sa(b.value), d = $b78e106b2dfe8e1a$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $b78e106b2dfe8e1a$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $b78e106b2dfe8e1a$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $b78e106b2dfe8e1a$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $b78e106b2dfe8e1a$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $b78e106b2dfe8e1a$var$mb, $b78e106b2dfe8e1a$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $b78e106b2dfe8e1a$var$mb = $b78e106b2dfe8e1a$var$mb || document.createElement("div");
        $b78e106b2dfe8e1a$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $b78e106b2dfe8e1a$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $b78e106b2dfe8e1a$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $b78e106b2dfe8e1a$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $b78e106b2dfe8e1a$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($b78e106b2dfe8e1a$var$pb).forEach(function(a) {
    $b78e106b2dfe8e1a$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $b78e106b2dfe8e1a$var$pb[b] = $b78e106b2dfe8e1a$var$pb[a];
    });
});
function $b78e106b2dfe8e1a$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $b78e106b2dfe8e1a$var$pb.hasOwnProperty(a) && $b78e106b2dfe8e1a$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $b78e106b2dfe8e1a$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $b78e106b2dfe8e1a$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $b78e106b2dfe8e1a$var$tb = $b78e106b2dfe8e1a$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $b78e106b2dfe8e1a$var$ub(a, b) {
    if (b) {
        if ($b78e106b2dfe8e1a$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($b78e106b2dfe8e1a$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($b78e106b2dfe8e1a$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($b78e106b2dfe8e1a$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($b78e106b2dfe8e1a$var$p(62));
    }
}
function $b78e106b2dfe8e1a$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $b78e106b2dfe8e1a$var$wb = null;
function $b78e106b2dfe8e1a$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $b78e106b2dfe8e1a$var$yb = null, $b78e106b2dfe8e1a$var$zb = null, $b78e106b2dfe8e1a$var$Ab = null;
function $b78e106b2dfe8e1a$var$Bb(a) {
    if (a = $b78e106b2dfe8e1a$var$Cb(a)) {
        if ("function" !== typeof $b78e106b2dfe8e1a$var$yb) throw Error($b78e106b2dfe8e1a$var$p(280));
        var b = a.stateNode;
        b && (b = $b78e106b2dfe8e1a$var$Db(b), $b78e106b2dfe8e1a$var$yb(a.stateNode, a.type, b));
    }
}
function $b78e106b2dfe8e1a$var$Eb(a) {
    $b78e106b2dfe8e1a$var$zb ? $b78e106b2dfe8e1a$var$Ab ? $b78e106b2dfe8e1a$var$Ab.push(a) : $b78e106b2dfe8e1a$var$Ab = [
        a
    ] : $b78e106b2dfe8e1a$var$zb = a;
}
function $b78e106b2dfe8e1a$var$Fb() {
    if ($b78e106b2dfe8e1a$var$zb) {
        var a = $b78e106b2dfe8e1a$var$zb, b = $b78e106b2dfe8e1a$var$Ab;
        $b78e106b2dfe8e1a$var$Ab = $b78e106b2dfe8e1a$var$zb = null;
        $b78e106b2dfe8e1a$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$b78e106b2dfe8e1a$var$Bb(b[a]);
    }
}
function $b78e106b2dfe8e1a$var$Gb(a, b) {
    return a(b);
}
function $b78e106b2dfe8e1a$var$Hb() {}
var $b78e106b2dfe8e1a$var$Ib = !1;
function $b78e106b2dfe8e1a$var$Jb(a, b, c) {
    if ($b78e106b2dfe8e1a$var$Ib) return a(b, c);
    $b78e106b2dfe8e1a$var$Ib = !0;
    try {
        return $b78e106b2dfe8e1a$var$Gb(a, b, c);
    } finally{
        if ($b78e106b2dfe8e1a$var$Ib = !1, null !== $b78e106b2dfe8e1a$var$zb || null !== $b78e106b2dfe8e1a$var$Ab) $b78e106b2dfe8e1a$var$Hb(), $b78e106b2dfe8e1a$var$Fb();
    }
}
function $b78e106b2dfe8e1a$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $b78e106b2dfe8e1a$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($b78e106b2dfe8e1a$var$p(231, b, typeof c));
    return c;
}
var $b78e106b2dfe8e1a$var$Lb = !1;
if ($b78e106b2dfe8e1a$var$ia) try {
    var $b78e106b2dfe8e1a$var$Mb = {};
    Object.defineProperty($b78e106b2dfe8e1a$var$Mb, "passive", {
        get: function() {
            $b78e106b2dfe8e1a$var$Lb = !0;
        }
    });
    window.addEventListener("test", $b78e106b2dfe8e1a$var$Mb, $b78e106b2dfe8e1a$var$Mb);
    window.removeEventListener("test", $b78e106b2dfe8e1a$var$Mb, $b78e106b2dfe8e1a$var$Mb);
} catch (a) {
    $b78e106b2dfe8e1a$var$Lb = !1;
}
function $b78e106b2dfe8e1a$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $b78e106b2dfe8e1a$var$Ob = !1, $b78e106b2dfe8e1a$var$Pb = null, $b78e106b2dfe8e1a$var$Qb = !1, $b78e106b2dfe8e1a$var$Rb = null, $b78e106b2dfe8e1a$var$Sb = {
    onError: function(a) {
        $b78e106b2dfe8e1a$var$Ob = !0;
        $b78e106b2dfe8e1a$var$Pb = a;
    }
};
function $b78e106b2dfe8e1a$var$Tb(a, b, c, d, e, f, g, h, k) {
    $b78e106b2dfe8e1a$var$Ob = !1;
    $b78e106b2dfe8e1a$var$Pb = null;
    $b78e106b2dfe8e1a$var$Nb.apply($b78e106b2dfe8e1a$var$Sb, arguments);
}
function $b78e106b2dfe8e1a$var$Ub(a, b, c, d, e, f, g, h, k) {
    $b78e106b2dfe8e1a$var$Tb.apply(this, arguments);
    if ($b78e106b2dfe8e1a$var$Ob) {
        if ($b78e106b2dfe8e1a$var$Ob) {
            var l = $b78e106b2dfe8e1a$var$Pb;
            $b78e106b2dfe8e1a$var$Ob = !1;
            $b78e106b2dfe8e1a$var$Pb = null;
        } else throw Error($b78e106b2dfe8e1a$var$p(198));
        $b78e106b2dfe8e1a$var$Qb || ($b78e106b2dfe8e1a$var$Qb = !0, $b78e106b2dfe8e1a$var$Rb = l);
    }
}
function $b78e106b2dfe8e1a$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b78e106b2dfe8e1a$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $b78e106b2dfe8e1a$var$Xb(a) {
    if ($b78e106b2dfe8e1a$var$Vb(a) !== a) throw Error($b78e106b2dfe8e1a$var$p(188));
}
function $b78e106b2dfe8e1a$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $b78e106b2dfe8e1a$var$Vb(a);
        if (null === b) throw Error($b78e106b2dfe8e1a$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $b78e106b2dfe8e1a$var$Xb(e), a;
                if (f === d) return $b78e106b2dfe8e1a$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($b78e106b2dfe8e1a$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($b78e106b2dfe8e1a$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($b78e106b2dfe8e1a$var$p(190));
    }
    if (3 !== c.tag) throw Error($b78e106b2dfe8e1a$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $b78e106b2dfe8e1a$var$Zb(a) {
    a = $b78e106b2dfe8e1a$var$Yb(a);
    return null !== a ? $b78e106b2dfe8e1a$var$$b(a) : null;
}
function $b78e106b2dfe8e1a$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b78e106b2dfe8e1a$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $b78e106b2dfe8e1a$var$ac = $2plYB.unstable_scheduleCallback, $b78e106b2dfe8e1a$var$bc = $2plYB.unstable_cancelCallback, $b78e106b2dfe8e1a$var$cc = $2plYB.unstable_shouldYield, $b78e106b2dfe8e1a$var$dc = $2plYB.unstable_requestPaint, $b78e106b2dfe8e1a$var$B = $2plYB.unstable_now, $b78e106b2dfe8e1a$var$ec = $2plYB.unstable_getCurrentPriorityLevel, $b78e106b2dfe8e1a$var$fc = $2plYB.unstable_ImmediatePriority, $b78e106b2dfe8e1a$var$gc = $2plYB.unstable_UserBlockingPriority, $b78e106b2dfe8e1a$var$hc = $2plYB.unstable_NormalPriority, $b78e106b2dfe8e1a$var$ic = $2plYB.unstable_LowPriority, $b78e106b2dfe8e1a$var$jc = $2plYB.unstable_IdlePriority, $b78e106b2dfe8e1a$var$kc = null, $b78e106b2dfe8e1a$var$lc = null;
function $b78e106b2dfe8e1a$var$mc(a) {
    if ($b78e106b2dfe8e1a$var$lc && "function" === typeof $b78e106b2dfe8e1a$var$lc.onCommitFiberRoot) try {
        $b78e106b2dfe8e1a$var$lc.onCommitFiberRoot($b78e106b2dfe8e1a$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $b78e106b2dfe8e1a$var$oc = Math.clz32 ? Math.clz32 : $b78e106b2dfe8e1a$var$nc, $b78e106b2dfe8e1a$var$pc = Math.log, $b78e106b2dfe8e1a$var$qc = Math.LN2;
function $b78e106b2dfe8e1a$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($b78e106b2dfe8e1a$var$pc(a) / $b78e106b2dfe8e1a$var$qc | 0) | 0;
}
var $b78e106b2dfe8e1a$var$rc = 64, $b78e106b2dfe8e1a$var$sc = 4194304;
function $b78e106b2dfe8e1a$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $b78e106b2dfe8e1a$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $b78e106b2dfe8e1a$var$tc(h) : (f &= g, 0 !== f && (d = $b78e106b2dfe8e1a$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $b78e106b2dfe8e1a$var$tc(g) : 0 !== f && (d = $b78e106b2dfe8e1a$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $b78e106b2dfe8e1a$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $b78e106b2dfe8e1a$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $b78e106b2dfe8e1a$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $b78e106b2dfe8e1a$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $b78e106b2dfe8e1a$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $b78e106b2dfe8e1a$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $b78e106b2dfe8e1a$var$yc() {
    var a = $b78e106b2dfe8e1a$var$rc;
    $b78e106b2dfe8e1a$var$rc <<= 1;
    0 === ($b78e106b2dfe8e1a$var$rc & 4194240) && ($b78e106b2dfe8e1a$var$rc = 64);
    return a;
}
function $b78e106b2dfe8e1a$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $b78e106b2dfe8e1a$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $b78e106b2dfe8e1a$var$oc(b);
    a[b] = c;
}
function $b78e106b2dfe8e1a$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $b78e106b2dfe8e1a$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $b78e106b2dfe8e1a$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $b78e106b2dfe8e1a$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $b78e106b2dfe8e1a$var$C = 0;
function $b78e106b2dfe8e1a$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $b78e106b2dfe8e1a$var$Ec, $b78e106b2dfe8e1a$var$Fc, $b78e106b2dfe8e1a$var$Gc, $b78e106b2dfe8e1a$var$Hc, $b78e106b2dfe8e1a$var$Ic, $b78e106b2dfe8e1a$var$Jc = !1, $b78e106b2dfe8e1a$var$Kc = [], $b78e106b2dfe8e1a$var$Lc = null, $b78e106b2dfe8e1a$var$Mc = null, $b78e106b2dfe8e1a$var$Nc = null, $b78e106b2dfe8e1a$var$Oc = new Map, $b78e106b2dfe8e1a$var$Pc = new Map, $b78e106b2dfe8e1a$var$Qc = [], $b78e106b2dfe8e1a$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $b78e106b2dfe8e1a$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $b78e106b2dfe8e1a$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $b78e106b2dfe8e1a$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $b78e106b2dfe8e1a$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $b78e106b2dfe8e1a$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $b78e106b2dfe8e1a$var$Pc.delete(b.pointerId);
    }
}
function $b78e106b2dfe8e1a$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $b78e106b2dfe8e1a$var$Cb(b), null !== b && $b78e106b2dfe8e1a$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $b78e106b2dfe8e1a$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $b78e106b2dfe8e1a$var$Lc = $b78e106b2dfe8e1a$var$Tc($b78e106b2dfe8e1a$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $b78e106b2dfe8e1a$var$Mc = $b78e106b2dfe8e1a$var$Tc($b78e106b2dfe8e1a$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $b78e106b2dfe8e1a$var$Nc = $b78e106b2dfe8e1a$var$Tc($b78e106b2dfe8e1a$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $b78e106b2dfe8e1a$var$Oc.set(f, $b78e106b2dfe8e1a$var$Tc($b78e106b2dfe8e1a$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $b78e106b2dfe8e1a$var$Pc.set(f, $b78e106b2dfe8e1a$var$Tc($b78e106b2dfe8e1a$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $b78e106b2dfe8e1a$var$Vc(a) {
    var b = $b78e106b2dfe8e1a$var$Wc(a.target);
    if (null !== b) {
        var c = $b78e106b2dfe8e1a$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b78e106b2dfe8e1a$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $b78e106b2dfe8e1a$var$Ic(a.priority, function() {
                        $b78e106b2dfe8e1a$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $b78e106b2dfe8e1a$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $b78e106b2dfe8e1a$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $b78e106b2dfe8e1a$var$wb = d;
            c.target.dispatchEvent(d);
            $b78e106b2dfe8e1a$var$wb = null;
        } else return b = $b78e106b2dfe8e1a$var$Cb(c), null !== b && $b78e106b2dfe8e1a$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $b78e106b2dfe8e1a$var$Zc(a, b, c) {
    $b78e106b2dfe8e1a$var$Xc(a) && c.delete(b);
}
function $b78e106b2dfe8e1a$var$$c() {
    $b78e106b2dfe8e1a$var$Jc = !1;
    null !== $b78e106b2dfe8e1a$var$Lc && $b78e106b2dfe8e1a$var$Xc($b78e106b2dfe8e1a$var$Lc) && ($b78e106b2dfe8e1a$var$Lc = null);
    null !== $b78e106b2dfe8e1a$var$Mc && $b78e106b2dfe8e1a$var$Xc($b78e106b2dfe8e1a$var$Mc) && ($b78e106b2dfe8e1a$var$Mc = null);
    null !== $b78e106b2dfe8e1a$var$Nc && $b78e106b2dfe8e1a$var$Xc($b78e106b2dfe8e1a$var$Nc) && ($b78e106b2dfe8e1a$var$Nc = null);
    $b78e106b2dfe8e1a$var$Oc.forEach($b78e106b2dfe8e1a$var$Zc);
    $b78e106b2dfe8e1a$var$Pc.forEach($b78e106b2dfe8e1a$var$Zc);
}
function $b78e106b2dfe8e1a$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $b78e106b2dfe8e1a$var$Jc || ($b78e106b2dfe8e1a$var$Jc = !0, $2plYB.unstable_scheduleCallback($2plYB.unstable_NormalPriority, $b78e106b2dfe8e1a$var$$c)));
}
function $b78e106b2dfe8e1a$var$bd(a) {
    function b(b) {
        return $b78e106b2dfe8e1a$var$ad(b, a);
    }
    if (0 < $b78e106b2dfe8e1a$var$Kc.length) {
        $b78e106b2dfe8e1a$var$ad($b78e106b2dfe8e1a$var$Kc[0], a);
        for(var c = 1; c < $b78e106b2dfe8e1a$var$Kc.length; c++){
            var d = $b78e106b2dfe8e1a$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $b78e106b2dfe8e1a$var$Lc && $b78e106b2dfe8e1a$var$ad($b78e106b2dfe8e1a$var$Lc, a);
    null !== $b78e106b2dfe8e1a$var$Mc && $b78e106b2dfe8e1a$var$ad($b78e106b2dfe8e1a$var$Mc, a);
    null !== $b78e106b2dfe8e1a$var$Nc && $b78e106b2dfe8e1a$var$ad($b78e106b2dfe8e1a$var$Nc, a);
    $b78e106b2dfe8e1a$var$Oc.forEach(b);
    $b78e106b2dfe8e1a$var$Pc.forEach(b);
    for(c = 0; c < $b78e106b2dfe8e1a$var$Qc.length; c++)d = $b78e106b2dfe8e1a$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $b78e106b2dfe8e1a$var$Qc.length && (c = $b78e106b2dfe8e1a$var$Qc[0], null === c.blockedOn);)$b78e106b2dfe8e1a$var$Vc(c), null === c.blockedOn && $b78e106b2dfe8e1a$var$Qc.shift();
}
var $b78e106b2dfe8e1a$var$cd = $b78e106b2dfe8e1a$var$ua.ReactCurrentBatchConfig, $b78e106b2dfe8e1a$var$dd = !0;
function $b78e106b2dfe8e1a$var$ed(a, b, c, d) {
    var e = $b78e106b2dfe8e1a$var$C, f = $b78e106b2dfe8e1a$var$cd.transition;
    $b78e106b2dfe8e1a$var$cd.transition = null;
    try {
        $b78e106b2dfe8e1a$var$C = 1, $b78e106b2dfe8e1a$var$fd(a, b, c, d);
    } finally{
        $b78e106b2dfe8e1a$var$C = e, $b78e106b2dfe8e1a$var$cd.transition = f;
    }
}
function $b78e106b2dfe8e1a$var$gd(a, b, c, d) {
    var e = $b78e106b2dfe8e1a$var$C, f = $b78e106b2dfe8e1a$var$cd.transition;
    $b78e106b2dfe8e1a$var$cd.transition = null;
    try {
        $b78e106b2dfe8e1a$var$C = 4, $b78e106b2dfe8e1a$var$fd(a, b, c, d);
    } finally{
        $b78e106b2dfe8e1a$var$C = e, $b78e106b2dfe8e1a$var$cd.transition = f;
    }
}
function $b78e106b2dfe8e1a$var$fd(a, b, c, d) {
    if ($b78e106b2dfe8e1a$var$dd) {
        var e = $b78e106b2dfe8e1a$var$Yc(a, b, c, d);
        if (null === e) $b78e106b2dfe8e1a$var$hd(a, b, d, $b78e106b2dfe8e1a$var$id, c), $b78e106b2dfe8e1a$var$Sc(a, d);
        else if ($b78e106b2dfe8e1a$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($b78e106b2dfe8e1a$var$Sc(a, d), b & 4 && -1 < $b78e106b2dfe8e1a$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $b78e106b2dfe8e1a$var$Cb(e);
                null !== f && $b78e106b2dfe8e1a$var$Ec(f);
                f = $b78e106b2dfe8e1a$var$Yc(a, b, c, d);
                null === f && $b78e106b2dfe8e1a$var$hd(a, b, d, $b78e106b2dfe8e1a$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $b78e106b2dfe8e1a$var$hd(a, b, d, null, c);
    }
}
var $b78e106b2dfe8e1a$var$id = null;
function $b78e106b2dfe8e1a$var$Yc(a, b, c, d) {
    $b78e106b2dfe8e1a$var$id = null;
    a = $b78e106b2dfe8e1a$var$xb(d);
    a = $b78e106b2dfe8e1a$var$Wc(a);
    if (null !== a) {
        if (b = $b78e106b2dfe8e1a$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $b78e106b2dfe8e1a$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $b78e106b2dfe8e1a$var$id = a;
    return null;
}
function $b78e106b2dfe8e1a$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($b78e106b2dfe8e1a$var$ec()){
                case $b78e106b2dfe8e1a$var$fc:
                    return 1;
                case $b78e106b2dfe8e1a$var$gc:
                    return 4;
                case $b78e106b2dfe8e1a$var$hc:
                case $b78e106b2dfe8e1a$var$ic:
                    return 16;
                case $b78e106b2dfe8e1a$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $b78e106b2dfe8e1a$var$kd = null, $b78e106b2dfe8e1a$var$ld = null, $b78e106b2dfe8e1a$var$md = null;
function $b78e106b2dfe8e1a$var$nd() {
    if ($b78e106b2dfe8e1a$var$md) return $b78e106b2dfe8e1a$var$md;
    var a, b = $b78e106b2dfe8e1a$var$ld, c = b.length, d, e = "value" in $b78e106b2dfe8e1a$var$kd ? $b78e106b2dfe8e1a$var$kd.value : $b78e106b2dfe8e1a$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $b78e106b2dfe8e1a$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $b78e106b2dfe8e1a$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $b78e106b2dfe8e1a$var$pd() {
    return !0;
}
function $b78e106b2dfe8e1a$var$qd() {
    return !1;
}
function $b78e106b2dfe8e1a$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $b78e106b2dfe8e1a$var$pd : $b78e106b2dfe8e1a$var$qd;
        this.isPropagationStopped = $b78e106b2dfe8e1a$var$qd;
        return this;
    }
    $b78e106b2dfe8e1a$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $b78e106b2dfe8e1a$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $b78e106b2dfe8e1a$var$pd);
        },
        persist: function() {},
        isPersistent: $b78e106b2dfe8e1a$var$pd
    });
    return b;
}
var $b78e106b2dfe8e1a$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $b78e106b2dfe8e1a$var$td = $b78e106b2dfe8e1a$var$rd($b78e106b2dfe8e1a$var$sd), $b78e106b2dfe8e1a$var$ud = $b78e106b2dfe8e1a$var$A({}, $b78e106b2dfe8e1a$var$sd, {
    view: 0,
    detail: 0
}), $b78e106b2dfe8e1a$var$vd = $b78e106b2dfe8e1a$var$rd($b78e106b2dfe8e1a$var$ud), $b78e106b2dfe8e1a$var$wd, $b78e106b2dfe8e1a$var$xd, $b78e106b2dfe8e1a$var$yd, $b78e106b2dfe8e1a$var$Ad = $b78e106b2dfe8e1a$var$A({}, $b78e106b2dfe8e1a$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $b78e106b2dfe8e1a$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $b78e106b2dfe8e1a$var$yd && ($b78e106b2dfe8e1a$var$yd && "mousemove" === a.type ? ($b78e106b2dfe8e1a$var$wd = a.screenX - $b78e106b2dfe8e1a$var$yd.screenX, $b78e106b2dfe8e1a$var$xd = a.screenY - $b78e106b2dfe8e1a$var$yd.screenY) : $b78e106b2dfe8e1a$var$xd = $b78e106b2dfe8e1a$var$wd = 0, $b78e106b2dfe8e1a$var$yd = a);
        return $b78e106b2dfe8e1a$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $b78e106b2dfe8e1a$var$xd;
    }
}), $b78e106b2dfe8e1a$var$Bd = $b78e106b2dfe8e1a$var$rd($b78e106b2dfe8e1a$var$Ad), $b78e106b2dfe8e1a$var$Cd = $b78e106b2dfe8e1a$var$A({}, $b78e106b2dfe8e1a$var$Ad, {
    dataTransfer: 0
}), $b78e106b2dfe8e1a$var$Dd = $b78e106b2dfe8e1a$var$rd($b78e106b2dfe8e1a$var$Cd), $b78e106b2dfe8e1a$var$Ed = $b78e106b2dfe8e1a$var$A({}, $b78e106b2dfe8e1a$var$ud, {
    relatedTarget: 0
}), $b78e106b2dfe8e1a$var$Fd = $b78e106b2dfe8e1a$var$rd($b78e106b2dfe8e1a$var$Ed), $b78e106b2dfe8e1a$var$Gd = $b78e106b2dfe8e1a$var$A({}, $b78e106b2dfe8e1a$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b78e106b2dfe8e1a$var$Hd = $b78e106b2dfe8e1a$var$rd($b78e106b2dfe8e1a$var$Gd), $b78e106b2dfe8e1a$var$Id = $b78e106b2dfe8e1a$var$A({}, $b78e106b2dfe8e1a$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $b78e106b2dfe8e1a$var$Jd = $b78e106b2dfe8e1a$var$rd($b78e106b2dfe8e1a$var$Id), $b78e106b2dfe8e1a$var$Kd = $b78e106b2dfe8e1a$var$A({}, $b78e106b2dfe8e1a$var$sd, {
    data: 0
}), $b78e106b2dfe8e1a$var$Ld = $b78e106b2dfe8e1a$var$rd($b78e106b2dfe8e1a$var$Kd), $b78e106b2dfe8e1a$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $b78e106b2dfe8e1a$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $b78e106b2dfe8e1a$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $b78e106b2dfe8e1a$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $b78e106b2dfe8e1a$var$Od[a]) ? !!b[a] : !1;
}
function $b78e106b2dfe8e1a$var$zd() {
    return $b78e106b2dfe8e1a$var$Pd;
}
var $b78e106b2dfe8e1a$var$Qd = $b78e106b2dfe8e1a$var$A({}, $b78e106b2dfe8e1a$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $b78e106b2dfe8e1a$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $b78e106b2dfe8e1a$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $b78e106b2dfe8e1a$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $b78e106b2dfe8e1a$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $b78e106b2dfe8e1a$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $b78e106b2dfe8e1a$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $b78e106b2dfe8e1a$var$Rd = $b78e106b2dfe8e1a$var$rd($b78e106b2dfe8e1a$var$Qd), $b78e106b2dfe8e1a$var$Sd = $b78e106b2dfe8e1a$var$A({}, $b78e106b2dfe8e1a$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $b78e106b2dfe8e1a$var$Td = $b78e106b2dfe8e1a$var$rd($b78e106b2dfe8e1a$var$Sd), $b78e106b2dfe8e1a$var$Ud = $b78e106b2dfe8e1a$var$A({}, $b78e106b2dfe8e1a$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $b78e106b2dfe8e1a$var$zd
}), $b78e106b2dfe8e1a$var$Vd = $b78e106b2dfe8e1a$var$rd($b78e106b2dfe8e1a$var$Ud), $b78e106b2dfe8e1a$var$Wd = $b78e106b2dfe8e1a$var$A({}, $b78e106b2dfe8e1a$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b78e106b2dfe8e1a$var$Xd = $b78e106b2dfe8e1a$var$rd($b78e106b2dfe8e1a$var$Wd), $b78e106b2dfe8e1a$var$Yd = $b78e106b2dfe8e1a$var$A({}, $b78e106b2dfe8e1a$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $b78e106b2dfe8e1a$var$Zd = $b78e106b2dfe8e1a$var$rd($b78e106b2dfe8e1a$var$Yd), $b78e106b2dfe8e1a$var$$d = [
    9,
    13,
    27,
    32
], $b78e106b2dfe8e1a$var$ae = $b78e106b2dfe8e1a$var$ia && "CompositionEvent" in window, $b78e106b2dfe8e1a$var$be = null;
$b78e106b2dfe8e1a$var$ia && "documentMode" in document && ($b78e106b2dfe8e1a$var$be = document.documentMode);
var $b78e106b2dfe8e1a$var$ce = $b78e106b2dfe8e1a$var$ia && "TextEvent" in window && !$b78e106b2dfe8e1a$var$be, $b78e106b2dfe8e1a$var$de = $b78e106b2dfe8e1a$var$ia && (!$b78e106b2dfe8e1a$var$ae || $b78e106b2dfe8e1a$var$be && 8 < $b78e106b2dfe8e1a$var$be && 11 >= $b78e106b2dfe8e1a$var$be), $b78e106b2dfe8e1a$var$ee = String.fromCharCode(32), $b78e106b2dfe8e1a$var$fe = !1;
function $b78e106b2dfe8e1a$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $b78e106b2dfe8e1a$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $b78e106b2dfe8e1a$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $b78e106b2dfe8e1a$var$ie = !1;
function $b78e106b2dfe8e1a$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $b78e106b2dfe8e1a$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $b78e106b2dfe8e1a$var$fe = !0;
            return $b78e106b2dfe8e1a$var$ee;
        case "textInput":
            return a = b.data, a === $b78e106b2dfe8e1a$var$ee && $b78e106b2dfe8e1a$var$fe ? null : a;
        default:
            return null;
    }
}
function $b78e106b2dfe8e1a$var$ke(a, b) {
    if ($b78e106b2dfe8e1a$var$ie) return "compositionend" === a || !$b78e106b2dfe8e1a$var$ae && $b78e106b2dfe8e1a$var$ge(a, b) ? (a = $b78e106b2dfe8e1a$var$nd(), $b78e106b2dfe8e1a$var$md = $b78e106b2dfe8e1a$var$ld = $b78e106b2dfe8e1a$var$kd = null, $b78e106b2dfe8e1a$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $b78e106b2dfe8e1a$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $b78e106b2dfe8e1a$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $b78e106b2dfe8e1a$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$b78e106b2dfe8e1a$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $b78e106b2dfe8e1a$var$ne(a, b, c, d) {
    $b78e106b2dfe8e1a$var$Eb(d);
    b = $b78e106b2dfe8e1a$var$oe(b, "onChange");
    0 < b.length && (c = new $b78e106b2dfe8e1a$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $b78e106b2dfe8e1a$var$pe = null, $b78e106b2dfe8e1a$var$qe = null;
function $b78e106b2dfe8e1a$var$re(a) {
    $b78e106b2dfe8e1a$var$se(a, 0);
}
function $b78e106b2dfe8e1a$var$te(a) {
    var b = $b78e106b2dfe8e1a$var$ue(a);
    if ($b78e106b2dfe8e1a$var$Wa(b)) return a;
}
function $b78e106b2dfe8e1a$var$ve(a, b) {
    if ("change" === a) return b;
}
var $b78e106b2dfe8e1a$var$we = !1;
if ($b78e106b2dfe8e1a$var$ia) {
    var $b78e106b2dfe8e1a$var$xe;
    if ($b78e106b2dfe8e1a$var$ia) {
        var $b78e106b2dfe8e1a$var$ye = "oninput" in document;
        if (!$b78e106b2dfe8e1a$var$ye) {
            var $b78e106b2dfe8e1a$var$ze = document.createElement("div");
            $b78e106b2dfe8e1a$var$ze.setAttribute("oninput", "return;");
            $b78e106b2dfe8e1a$var$ye = "function" === typeof $b78e106b2dfe8e1a$var$ze.oninput;
        }
        $b78e106b2dfe8e1a$var$xe = $b78e106b2dfe8e1a$var$ye;
    } else $b78e106b2dfe8e1a$var$xe = !1;
    $b78e106b2dfe8e1a$var$we = $b78e106b2dfe8e1a$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $b78e106b2dfe8e1a$var$Ae() {
    $b78e106b2dfe8e1a$var$pe && ($b78e106b2dfe8e1a$var$pe.detachEvent("onpropertychange", $b78e106b2dfe8e1a$var$Be), $b78e106b2dfe8e1a$var$qe = $b78e106b2dfe8e1a$var$pe = null);
}
function $b78e106b2dfe8e1a$var$Be(a) {
    if ("value" === a.propertyName && $b78e106b2dfe8e1a$var$te($b78e106b2dfe8e1a$var$qe)) {
        var b = [];
        $b78e106b2dfe8e1a$var$ne(b, $b78e106b2dfe8e1a$var$qe, a, $b78e106b2dfe8e1a$var$xb(a));
        $b78e106b2dfe8e1a$var$Jb($b78e106b2dfe8e1a$var$re, b);
    }
}
function $b78e106b2dfe8e1a$var$Ce(a, b, c) {
    "focusin" === a ? ($b78e106b2dfe8e1a$var$Ae(), $b78e106b2dfe8e1a$var$pe = b, $b78e106b2dfe8e1a$var$qe = c, $b78e106b2dfe8e1a$var$pe.attachEvent("onpropertychange", $b78e106b2dfe8e1a$var$Be)) : "focusout" === a && $b78e106b2dfe8e1a$var$Ae();
}
function $b78e106b2dfe8e1a$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $b78e106b2dfe8e1a$var$te($b78e106b2dfe8e1a$var$qe);
}
function $b78e106b2dfe8e1a$var$Ee(a, b) {
    if ("click" === a) return $b78e106b2dfe8e1a$var$te(b);
}
function $b78e106b2dfe8e1a$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $b78e106b2dfe8e1a$var$te(b);
}
function $b78e106b2dfe8e1a$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $b78e106b2dfe8e1a$var$He = "function" === typeof Object.is ? Object.is : $b78e106b2dfe8e1a$var$Ge;
function $b78e106b2dfe8e1a$var$Ie(a, b) {
    if ($b78e106b2dfe8e1a$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$b78e106b2dfe8e1a$var$ja.call(b, e) || !$b78e106b2dfe8e1a$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $b78e106b2dfe8e1a$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $b78e106b2dfe8e1a$var$Ke(a, b) {
    var c = $b78e106b2dfe8e1a$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $b78e106b2dfe8e1a$var$Je(c);
    }
}
function $b78e106b2dfe8e1a$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $b78e106b2dfe8e1a$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $b78e106b2dfe8e1a$var$Me() {
    for(var a = window, b = $b78e106b2dfe8e1a$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $b78e106b2dfe8e1a$var$Xa(a.document);
    }
    return b;
}
function $b78e106b2dfe8e1a$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $b78e106b2dfe8e1a$var$Oe(a) {
    var b = $b78e106b2dfe8e1a$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $b78e106b2dfe8e1a$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $b78e106b2dfe8e1a$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $b78e106b2dfe8e1a$var$Ke(c, f);
                var g = $b78e106b2dfe8e1a$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $b78e106b2dfe8e1a$var$Pe = $b78e106b2dfe8e1a$var$ia && "documentMode" in document && 11 >= document.documentMode, $b78e106b2dfe8e1a$var$Qe = null, $b78e106b2dfe8e1a$var$Re = null, $b78e106b2dfe8e1a$var$Se = null, $b78e106b2dfe8e1a$var$Te = !1;
function $b78e106b2dfe8e1a$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $b78e106b2dfe8e1a$var$Te || null == $b78e106b2dfe8e1a$var$Qe || $b78e106b2dfe8e1a$var$Qe !== $b78e106b2dfe8e1a$var$Xa(d) || (d = $b78e106b2dfe8e1a$var$Qe, "selectionStart" in d && $b78e106b2dfe8e1a$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $b78e106b2dfe8e1a$var$Se && $b78e106b2dfe8e1a$var$Ie($b78e106b2dfe8e1a$var$Se, d) || ($b78e106b2dfe8e1a$var$Se = d, d = $b78e106b2dfe8e1a$var$oe($b78e106b2dfe8e1a$var$Re, "onSelect"), 0 < d.length && (b = new $b78e106b2dfe8e1a$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $b78e106b2dfe8e1a$var$Qe)));
}
function $b78e106b2dfe8e1a$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $b78e106b2dfe8e1a$var$We = {
    animationend: $b78e106b2dfe8e1a$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $b78e106b2dfe8e1a$var$Ve("Animation", "AnimationIteration"),
    animationstart: $b78e106b2dfe8e1a$var$Ve("Animation", "AnimationStart"),
    transitionend: $b78e106b2dfe8e1a$var$Ve("Transition", "TransitionEnd")
}, $b78e106b2dfe8e1a$var$Xe = {}, $b78e106b2dfe8e1a$var$Ye = {};
$b78e106b2dfe8e1a$var$ia && ($b78e106b2dfe8e1a$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $b78e106b2dfe8e1a$var$We.animationend.animation, delete $b78e106b2dfe8e1a$var$We.animationiteration.animation, delete $b78e106b2dfe8e1a$var$We.animationstart.animation), "TransitionEvent" in window || delete $b78e106b2dfe8e1a$var$We.transitionend.transition);
function $b78e106b2dfe8e1a$var$Ze(a) {
    if ($b78e106b2dfe8e1a$var$Xe[a]) return $b78e106b2dfe8e1a$var$Xe[a];
    if (!$b78e106b2dfe8e1a$var$We[a]) return a;
    var b = $b78e106b2dfe8e1a$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $b78e106b2dfe8e1a$var$Ye) return $b78e106b2dfe8e1a$var$Xe[a] = b[c];
    return a;
}
var $b78e106b2dfe8e1a$var$$e = $b78e106b2dfe8e1a$var$Ze("animationend"), $b78e106b2dfe8e1a$var$af = $b78e106b2dfe8e1a$var$Ze("animationiteration"), $b78e106b2dfe8e1a$var$bf = $b78e106b2dfe8e1a$var$Ze("animationstart"), $b78e106b2dfe8e1a$var$cf = $b78e106b2dfe8e1a$var$Ze("transitionend"), $b78e106b2dfe8e1a$var$df = new Map, $b78e106b2dfe8e1a$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $b78e106b2dfe8e1a$var$ff(a, b) {
    $b78e106b2dfe8e1a$var$df.set(a, b);
    $b78e106b2dfe8e1a$var$fa(b, [
        a
    ]);
}
for(var $b78e106b2dfe8e1a$var$gf = 0; $b78e106b2dfe8e1a$var$gf < $b78e106b2dfe8e1a$var$ef.length; $b78e106b2dfe8e1a$var$gf++){
    var $b78e106b2dfe8e1a$var$hf = $b78e106b2dfe8e1a$var$ef[$b78e106b2dfe8e1a$var$gf], $b78e106b2dfe8e1a$var$jf = $b78e106b2dfe8e1a$var$hf.toLowerCase(), $b78e106b2dfe8e1a$var$kf = $b78e106b2dfe8e1a$var$hf[0].toUpperCase() + $b78e106b2dfe8e1a$var$hf.slice(1);
    $b78e106b2dfe8e1a$var$ff($b78e106b2dfe8e1a$var$jf, "on" + $b78e106b2dfe8e1a$var$kf);
}
$b78e106b2dfe8e1a$var$ff($b78e106b2dfe8e1a$var$$e, "onAnimationEnd");
$b78e106b2dfe8e1a$var$ff($b78e106b2dfe8e1a$var$af, "onAnimationIteration");
$b78e106b2dfe8e1a$var$ff($b78e106b2dfe8e1a$var$bf, "onAnimationStart");
$b78e106b2dfe8e1a$var$ff("dblclick", "onDoubleClick");
$b78e106b2dfe8e1a$var$ff("focusin", "onFocus");
$b78e106b2dfe8e1a$var$ff("focusout", "onBlur");
$b78e106b2dfe8e1a$var$ff($b78e106b2dfe8e1a$var$cf, "onTransitionEnd");
$b78e106b2dfe8e1a$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$b78e106b2dfe8e1a$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$b78e106b2dfe8e1a$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$b78e106b2dfe8e1a$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$b78e106b2dfe8e1a$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$b78e106b2dfe8e1a$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$b78e106b2dfe8e1a$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$b78e106b2dfe8e1a$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$b78e106b2dfe8e1a$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$b78e106b2dfe8e1a$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $b78e106b2dfe8e1a$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $b78e106b2dfe8e1a$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($b78e106b2dfe8e1a$var$lf));
function $b78e106b2dfe8e1a$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $b78e106b2dfe8e1a$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $b78e106b2dfe8e1a$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b78e106b2dfe8e1a$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b78e106b2dfe8e1a$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($b78e106b2dfe8e1a$var$Qb) throw a = $b78e106b2dfe8e1a$var$Rb, $b78e106b2dfe8e1a$var$Qb = !1, $b78e106b2dfe8e1a$var$Rb = null, a;
}
function $b78e106b2dfe8e1a$var$D(a, b) {
    var c = b[$b78e106b2dfe8e1a$var$of];
    void 0 === c && (c = b[$b78e106b2dfe8e1a$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($b78e106b2dfe8e1a$var$pf(b, a, 2, !1), c.add(d));
}
function $b78e106b2dfe8e1a$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $b78e106b2dfe8e1a$var$pf(c, a, d, b);
}
var $b78e106b2dfe8e1a$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $b78e106b2dfe8e1a$var$sf(a) {
    if (!a[$b78e106b2dfe8e1a$var$rf]) {
        a[$b78e106b2dfe8e1a$var$rf] = !0;
        $b78e106b2dfe8e1a$var$da.forEach(function(b) {
            "selectionchange" !== b && ($b78e106b2dfe8e1a$var$mf.has(b) || $b78e106b2dfe8e1a$var$qf(b, !1, a), $b78e106b2dfe8e1a$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$b78e106b2dfe8e1a$var$rf] || (b[$b78e106b2dfe8e1a$var$rf] = !0, $b78e106b2dfe8e1a$var$qf("selectionchange", !1, b));
    }
}
function $b78e106b2dfe8e1a$var$pf(a, b, c, d) {
    switch($b78e106b2dfe8e1a$var$jd(b)){
        case 1:
            var e = $b78e106b2dfe8e1a$var$ed;
            break;
        case 4:
            e = $b78e106b2dfe8e1a$var$gd;
            break;
        default:
            e = $b78e106b2dfe8e1a$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$b78e106b2dfe8e1a$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $b78e106b2dfe8e1a$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $b78e106b2dfe8e1a$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $b78e106b2dfe8e1a$var$Jb(function() {
        var d = f, e = $b78e106b2dfe8e1a$var$xb(c), g = [];
        a: {
            var h = $b78e106b2dfe8e1a$var$df.get(a);
            if (void 0 !== h) {
                var k = $b78e106b2dfe8e1a$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $b78e106b2dfe8e1a$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $b78e106b2dfe8e1a$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $b78e106b2dfe8e1a$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $b78e106b2dfe8e1a$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $b78e106b2dfe8e1a$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $b78e106b2dfe8e1a$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $b78e106b2dfe8e1a$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $b78e106b2dfe8e1a$var$Vd;
                        break;
                    case $b78e106b2dfe8e1a$var$$e:
                    case $b78e106b2dfe8e1a$var$af:
                    case $b78e106b2dfe8e1a$var$bf:
                        k = $b78e106b2dfe8e1a$var$Hd;
                        break;
                    case $b78e106b2dfe8e1a$var$cf:
                        k = $b78e106b2dfe8e1a$var$Xd;
                        break;
                    case "scroll":
                        k = $b78e106b2dfe8e1a$var$vd;
                        break;
                    case "wheel":
                        k = $b78e106b2dfe8e1a$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $b78e106b2dfe8e1a$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $b78e106b2dfe8e1a$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $b78e106b2dfe8e1a$var$Kb(w, x), null != F && t.push($b78e106b2dfe8e1a$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $b78e106b2dfe8e1a$var$wb && (n = c.relatedTarget || c.fromElement) && ($b78e106b2dfe8e1a$var$Wc(n) || n[$b78e106b2dfe8e1a$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $b78e106b2dfe8e1a$var$Wc(n) : null, null !== n && (J = $b78e106b2dfe8e1a$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $b78e106b2dfe8e1a$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $b78e106b2dfe8e1a$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $b78e106b2dfe8e1a$var$ue(k);
                        u = null == n ? h : $b78e106b2dfe8e1a$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $b78e106b2dfe8e1a$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $b78e106b2dfe8e1a$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $b78e106b2dfe8e1a$var$vf(F))u++;
                            for(; 0 < w - u;)t = $b78e106b2dfe8e1a$var$vf(t), w--;
                            for(; 0 < u - w;)x = $b78e106b2dfe8e1a$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $b78e106b2dfe8e1a$var$vf(t);
                                x = $b78e106b2dfe8e1a$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $b78e106b2dfe8e1a$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $b78e106b2dfe8e1a$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $b78e106b2dfe8e1a$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $b78e106b2dfe8e1a$var$ve;
                else if ($b78e106b2dfe8e1a$var$me(h)) {
                    if ($b78e106b2dfe8e1a$var$we) na = $b78e106b2dfe8e1a$var$Fe;
                    else {
                        na = $b78e106b2dfe8e1a$var$De;
                        var xa = $b78e106b2dfe8e1a$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $b78e106b2dfe8e1a$var$Ee);
                if (na && (na = na(a, d))) {
                    $b78e106b2dfe8e1a$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $b78e106b2dfe8e1a$var$cb(h, "number", h.value);
            }
            xa = d ? $b78e106b2dfe8e1a$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($b78e106b2dfe8e1a$var$me(xa) || "true" === xa.contentEditable) $b78e106b2dfe8e1a$var$Qe = xa, $b78e106b2dfe8e1a$var$Re = d, $b78e106b2dfe8e1a$var$Se = null;
                    break;
                case "focusout":
                    $b78e106b2dfe8e1a$var$Se = $b78e106b2dfe8e1a$var$Re = $b78e106b2dfe8e1a$var$Qe = null;
                    break;
                case "mousedown":
                    $b78e106b2dfe8e1a$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $b78e106b2dfe8e1a$var$Te = !1;
                    $b78e106b2dfe8e1a$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($b78e106b2dfe8e1a$var$Pe) break;
                case "keydown":
                case "keyup":
                    $b78e106b2dfe8e1a$var$Ue(g, c, e);
            }
            var $a;
            if ($b78e106b2dfe8e1a$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $b78e106b2dfe8e1a$var$ie ? $b78e106b2dfe8e1a$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($b78e106b2dfe8e1a$var$de && "ko" !== c.locale && ($b78e106b2dfe8e1a$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $b78e106b2dfe8e1a$var$ie && ($a = $b78e106b2dfe8e1a$var$nd()) : ($b78e106b2dfe8e1a$var$kd = e, $b78e106b2dfe8e1a$var$ld = "value" in $b78e106b2dfe8e1a$var$kd ? $b78e106b2dfe8e1a$var$kd.value : $b78e106b2dfe8e1a$var$kd.textContent, $b78e106b2dfe8e1a$var$ie = !0)), xa = $b78e106b2dfe8e1a$var$oe(d, ba), 0 < xa.length && (ba = new $b78e106b2dfe8e1a$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $b78e106b2dfe8e1a$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $b78e106b2dfe8e1a$var$ce ? $b78e106b2dfe8e1a$var$je(a, c) : $b78e106b2dfe8e1a$var$ke(a, c)) d = $b78e106b2dfe8e1a$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $b78e106b2dfe8e1a$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $b78e106b2dfe8e1a$var$se(g, b);
    });
}
function $b78e106b2dfe8e1a$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $b78e106b2dfe8e1a$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $b78e106b2dfe8e1a$var$Kb(a, c), null != f && d.unshift($b78e106b2dfe8e1a$var$tf(a, f, e)), f = $b78e106b2dfe8e1a$var$Kb(a, b), null != f && d.push($b78e106b2dfe8e1a$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $b78e106b2dfe8e1a$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $b78e106b2dfe8e1a$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $b78e106b2dfe8e1a$var$Kb(c, f), null != k && g.unshift($b78e106b2dfe8e1a$var$tf(c, k, h))) : e || (k = $b78e106b2dfe8e1a$var$Kb(c, f), null != k && g.push($b78e106b2dfe8e1a$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $b78e106b2dfe8e1a$var$xf = /\r\n?/g, $b78e106b2dfe8e1a$var$yf = /\u0000|\uFFFD/g;
function $b78e106b2dfe8e1a$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($b78e106b2dfe8e1a$var$xf, "\n").replace($b78e106b2dfe8e1a$var$yf, "");
}
function $b78e106b2dfe8e1a$var$Af(a, b, c) {
    b = $b78e106b2dfe8e1a$var$zf(b);
    if ($b78e106b2dfe8e1a$var$zf(a) !== b && c) throw Error($b78e106b2dfe8e1a$var$p(425));
}
function $b78e106b2dfe8e1a$var$Bf() {}
var $b78e106b2dfe8e1a$var$Cf = null, $b78e106b2dfe8e1a$var$Df = null;
function $b78e106b2dfe8e1a$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $b78e106b2dfe8e1a$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $b78e106b2dfe8e1a$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $b78e106b2dfe8e1a$var$Hf = "function" === typeof Promise ? Promise : void 0, $b78e106b2dfe8e1a$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $b78e106b2dfe8e1a$var$Hf ? function(a) {
    return $b78e106b2dfe8e1a$var$Hf.resolve(null).then(a).catch($b78e106b2dfe8e1a$var$If);
} : $b78e106b2dfe8e1a$var$Ff;
function $b78e106b2dfe8e1a$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $b78e106b2dfe8e1a$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $b78e106b2dfe8e1a$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $b78e106b2dfe8e1a$var$bd(b);
}
function $b78e106b2dfe8e1a$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $b78e106b2dfe8e1a$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $b78e106b2dfe8e1a$var$Nf = Math.random().toString(36).slice(2), $b78e106b2dfe8e1a$var$Of = "__reactFiber$" + $b78e106b2dfe8e1a$var$Nf, $b78e106b2dfe8e1a$var$Pf = "__reactProps$" + $b78e106b2dfe8e1a$var$Nf, $b78e106b2dfe8e1a$var$uf = "__reactContainer$" + $b78e106b2dfe8e1a$var$Nf, $b78e106b2dfe8e1a$var$of = "__reactEvents$" + $b78e106b2dfe8e1a$var$Nf, $b78e106b2dfe8e1a$var$Qf = "__reactListeners$" + $b78e106b2dfe8e1a$var$Nf, $b78e106b2dfe8e1a$var$Rf = "__reactHandles$" + $b78e106b2dfe8e1a$var$Nf;
function $b78e106b2dfe8e1a$var$Wc(a) {
    var b = a[$b78e106b2dfe8e1a$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$b78e106b2dfe8e1a$var$uf] || c[$b78e106b2dfe8e1a$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $b78e106b2dfe8e1a$var$Mf(a); null !== a;){
                if (c = a[$b78e106b2dfe8e1a$var$Of]) return c;
                a = $b78e106b2dfe8e1a$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $b78e106b2dfe8e1a$var$Cb(a) {
    a = a[$b78e106b2dfe8e1a$var$Of] || a[$b78e106b2dfe8e1a$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $b78e106b2dfe8e1a$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($b78e106b2dfe8e1a$var$p(33));
}
function $b78e106b2dfe8e1a$var$Db(a) {
    return a[$b78e106b2dfe8e1a$var$Pf] || null;
}
var $b78e106b2dfe8e1a$var$Sf = [], $b78e106b2dfe8e1a$var$Tf = -1;
function $b78e106b2dfe8e1a$var$Uf(a) {
    return {
        current: a
    };
}
function $b78e106b2dfe8e1a$var$E(a) {
    0 > $b78e106b2dfe8e1a$var$Tf || (a.current = $b78e106b2dfe8e1a$var$Sf[$b78e106b2dfe8e1a$var$Tf], $b78e106b2dfe8e1a$var$Sf[$b78e106b2dfe8e1a$var$Tf] = null, $b78e106b2dfe8e1a$var$Tf--);
}
function $b78e106b2dfe8e1a$var$G(a, b) {
    $b78e106b2dfe8e1a$var$Tf++;
    $b78e106b2dfe8e1a$var$Sf[$b78e106b2dfe8e1a$var$Tf] = a.current;
    a.current = b;
}
var $b78e106b2dfe8e1a$var$Vf = {}, $b78e106b2dfe8e1a$var$H = $b78e106b2dfe8e1a$var$Uf($b78e106b2dfe8e1a$var$Vf), $b78e106b2dfe8e1a$var$Wf = $b78e106b2dfe8e1a$var$Uf(!1), $b78e106b2dfe8e1a$var$Xf = $b78e106b2dfe8e1a$var$Vf;
function $b78e106b2dfe8e1a$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $b78e106b2dfe8e1a$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $b78e106b2dfe8e1a$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $b78e106b2dfe8e1a$var$$f() {
    $b78e106b2dfe8e1a$var$E($b78e106b2dfe8e1a$var$Wf);
    $b78e106b2dfe8e1a$var$E($b78e106b2dfe8e1a$var$H);
}
function $b78e106b2dfe8e1a$var$ag(a, b, c) {
    if ($b78e106b2dfe8e1a$var$H.current !== $b78e106b2dfe8e1a$var$Vf) throw Error($b78e106b2dfe8e1a$var$p(168));
    $b78e106b2dfe8e1a$var$G($b78e106b2dfe8e1a$var$H, b);
    $b78e106b2dfe8e1a$var$G($b78e106b2dfe8e1a$var$Wf, c);
}
function $b78e106b2dfe8e1a$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($b78e106b2dfe8e1a$var$p(108, $b78e106b2dfe8e1a$var$Ra(a) || "Unknown", e));
    return $b78e106b2dfe8e1a$var$A({}, c, d);
}
function $b78e106b2dfe8e1a$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $b78e106b2dfe8e1a$var$Vf;
    $b78e106b2dfe8e1a$var$Xf = $b78e106b2dfe8e1a$var$H.current;
    $b78e106b2dfe8e1a$var$G($b78e106b2dfe8e1a$var$H, a);
    $b78e106b2dfe8e1a$var$G($b78e106b2dfe8e1a$var$Wf, $b78e106b2dfe8e1a$var$Wf.current);
    return !0;
}
function $b78e106b2dfe8e1a$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($b78e106b2dfe8e1a$var$p(169));
    c ? (a = $b78e106b2dfe8e1a$var$bg(a, b, $b78e106b2dfe8e1a$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $b78e106b2dfe8e1a$var$E($b78e106b2dfe8e1a$var$Wf), $b78e106b2dfe8e1a$var$E($b78e106b2dfe8e1a$var$H), $b78e106b2dfe8e1a$var$G($b78e106b2dfe8e1a$var$H, a)) : $b78e106b2dfe8e1a$var$E($b78e106b2dfe8e1a$var$Wf);
    $b78e106b2dfe8e1a$var$G($b78e106b2dfe8e1a$var$Wf, c);
}
var $b78e106b2dfe8e1a$var$eg = null, $b78e106b2dfe8e1a$var$fg = !1, $b78e106b2dfe8e1a$var$gg = !1;
function $b78e106b2dfe8e1a$var$hg(a) {
    null === $b78e106b2dfe8e1a$var$eg ? $b78e106b2dfe8e1a$var$eg = [
        a
    ] : $b78e106b2dfe8e1a$var$eg.push(a);
}
function $b78e106b2dfe8e1a$var$ig(a) {
    $b78e106b2dfe8e1a$var$fg = !0;
    $b78e106b2dfe8e1a$var$hg(a);
}
function $b78e106b2dfe8e1a$var$jg() {
    if (!$b78e106b2dfe8e1a$var$gg && null !== $b78e106b2dfe8e1a$var$eg) {
        $b78e106b2dfe8e1a$var$gg = !0;
        var a = 0, b = $b78e106b2dfe8e1a$var$C;
        try {
            var c = $b78e106b2dfe8e1a$var$eg;
            for($b78e106b2dfe8e1a$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $b78e106b2dfe8e1a$var$eg = null;
            $b78e106b2dfe8e1a$var$fg = !1;
        } catch (e) {
            throw null !== $b78e106b2dfe8e1a$var$eg && ($b78e106b2dfe8e1a$var$eg = $b78e106b2dfe8e1a$var$eg.slice(a + 1)), $b78e106b2dfe8e1a$var$ac($b78e106b2dfe8e1a$var$fc, $b78e106b2dfe8e1a$var$jg), e;
        } finally{
            $b78e106b2dfe8e1a$var$C = b, $b78e106b2dfe8e1a$var$gg = !1;
        }
    }
    return null;
}
var $b78e106b2dfe8e1a$var$kg = [], $b78e106b2dfe8e1a$var$lg = 0, $b78e106b2dfe8e1a$var$mg = null, $b78e106b2dfe8e1a$var$ng = 0, $b78e106b2dfe8e1a$var$og = [], $b78e106b2dfe8e1a$var$pg = 0, $b78e106b2dfe8e1a$var$qg = null, $b78e106b2dfe8e1a$var$rg = 1, $b78e106b2dfe8e1a$var$sg = "";
function $b78e106b2dfe8e1a$var$tg(a, b) {
    $b78e106b2dfe8e1a$var$kg[$b78e106b2dfe8e1a$var$lg++] = $b78e106b2dfe8e1a$var$ng;
    $b78e106b2dfe8e1a$var$kg[$b78e106b2dfe8e1a$var$lg++] = $b78e106b2dfe8e1a$var$mg;
    $b78e106b2dfe8e1a$var$mg = a;
    $b78e106b2dfe8e1a$var$ng = b;
}
function $b78e106b2dfe8e1a$var$ug(a, b, c) {
    $b78e106b2dfe8e1a$var$og[$b78e106b2dfe8e1a$var$pg++] = $b78e106b2dfe8e1a$var$rg;
    $b78e106b2dfe8e1a$var$og[$b78e106b2dfe8e1a$var$pg++] = $b78e106b2dfe8e1a$var$sg;
    $b78e106b2dfe8e1a$var$og[$b78e106b2dfe8e1a$var$pg++] = $b78e106b2dfe8e1a$var$qg;
    $b78e106b2dfe8e1a$var$qg = a;
    var d = $b78e106b2dfe8e1a$var$rg;
    a = $b78e106b2dfe8e1a$var$sg;
    var e = 32 - $b78e106b2dfe8e1a$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $b78e106b2dfe8e1a$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $b78e106b2dfe8e1a$var$rg = 1 << 32 - $b78e106b2dfe8e1a$var$oc(b) + e | c << e | d;
        $b78e106b2dfe8e1a$var$sg = f + a;
    } else $b78e106b2dfe8e1a$var$rg = 1 << f | c << e | d, $b78e106b2dfe8e1a$var$sg = a;
}
function $b78e106b2dfe8e1a$var$vg(a) {
    null !== a.return && ($b78e106b2dfe8e1a$var$tg(a, 1), $b78e106b2dfe8e1a$var$ug(a, 1, 0));
}
function $b78e106b2dfe8e1a$var$wg(a) {
    for(; a === $b78e106b2dfe8e1a$var$mg;)$b78e106b2dfe8e1a$var$mg = $b78e106b2dfe8e1a$var$kg[--$b78e106b2dfe8e1a$var$lg], $b78e106b2dfe8e1a$var$kg[$b78e106b2dfe8e1a$var$lg] = null, $b78e106b2dfe8e1a$var$ng = $b78e106b2dfe8e1a$var$kg[--$b78e106b2dfe8e1a$var$lg], $b78e106b2dfe8e1a$var$kg[$b78e106b2dfe8e1a$var$lg] = null;
    for(; a === $b78e106b2dfe8e1a$var$qg;)$b78e106b2dfe8e1a$var$qg = $b78e106b2dfe8e1a$var$og[--$b78e106b2dfe8e1a$var$pg], $b78e106b2dfe8e1a$var$og[$b78e106b2dfe8e1a$var$pg] = null, $b78e106b2dfe8e1a$var$sg = $b78e106b2dfe8e1a$var$og[--$b78e106b2dfe8e1a$var$pg], $b78e106b2dfe8e1a$var$og[$b78e106b2dfe8e1a$var$pg] = null, $b78e106b2dfe8e1a$var$rg = $b78e106b2dfe8e1a$var$og[--$b78e106b2dfe8e1a$var$pg], $b78e106b2dfe8e1a$var$og[$b78e106b2dfe8e1a$var$pg] = null;
}
var $b78e106b2dfe8e1a$var$xg = null, $b78e106b2dfe8e1a$var$yg = null, $b78e106b2dfe8e1a$var$I = !1, $b78e106b2dfe8e1a$var$zg = null;
function $b78e106b2dfe8e1a$var$Ag(a, b) {
    var c = $b78e106b2dfe8e1a$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $b78e106b2dfe8e1a$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $b78e106b2dfe8e1a$var$xg = a, $b78e106b2dfe8e1a$var$yg = $b78e106b2dfe8e1a$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $b78e106b2dfe8e1a$var$xg = a, $b78e106b2dfe8e1a$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $b78e106b2dfe8e1a$var$qg ? {
                id: $b78e106b2dfe8e1a$var$rg,
                overflow: $b78e106b2dfe8e1a$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $b78e106b2dfe8e1a$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $b78e106b2dfe8e1a$var$xg = a, $b78e106b2dfe8e1a$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $b78e106b2dfe8e1a$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $b78e106b2dfe8e1a$var$Eg(a) {
    if ($b78e106b2dfe8e1a$var$I) {
        var b = $b78e106b2dfe8e1a$var$yg;
        if (b) {
            var c = b;
            if (!$b78e106b2dfe8e1a$var$Cg(a, b)) {
                if ($b78e106b2dfe8e1a$var$Dg(a)) throw Error($b78e106b2dfe8e1a$var$p(418));
                b = $b78e106b2dfe8e1a$var$Lf(c.nextSibling);
                var d = $b78e106b2dfe8e1a$var$xg;
                b && $b78e106b2dfe8e1a$var$Cg(a, b) ? $b78e106b2dfe8e1a$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $b78e106b2dfe8e1a$var$I = !1, $b78e106b2dfe8e1a$var$xg = a);
            }
        } else {
            if ($b78e106b2dfe8e1a$var$Dg(a)) throw Error($b78e106b2dfe8e1a$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $b78e106b2dfe8e1a$var$I = !1;
            $b78e106b2dfe8e1a$var$xg = a;
        }
    }
}
function $b78e106b2dfe8e1a$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $b78e106b2dfe8e1a$var$xg = a;
}
function $b78e106b2dfe8e1a$var$Gg(a) {
    if (a !== $b78e106b2dfe8e1a$var$xg) return !1;
    if (!$b78e106b2dfe8e1a$var$I) return $b78e106b2dfe8e1a$var$Fg(a), $b78e106b2dfe8e1a$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$b78e106b2dfe8e1a$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $b78e106b2dfe8e1a$var$yg)) {
        if ($b78e106b2dfe8e1a$var$Dg(a)) throw $b78e106b2dfe8e1a$var$Hg(), Error($b78e106b2dfe8e1a$var$p(418));
        for(; b;)$b78e106b2dfe8e1a$var$Ag(a, b), b = $b78e106b2dfe8e1a$var$Lf(b.nextSibling);
    }
    $b78e106b2dfe8e1a$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($b78e106b2dfe8e1a$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $b78e106b2dfe8e1a$var$yg = $b78e106b2dfe8e1a$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $b78e106b2dfe8e1a$var$yg = null;
        }
    } else $b78e106b2dfe8e1a$var$yg = $b78e106b2dfe8e1a$var$xg ? $b78e106b2dfe8e1a$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $b78e106b2dfe8e1a$var$Hg() {
    for(var a = $b78e106b2dfe8e1a$var$yg; a;)a = $b78e106b2dfe8e1a$var$Lf(a.nextSibling);
}
function $b78e106b2dfe8e1a$var$Ig() {
    $b78e106b2dfe8e1a$var$yg = $b78e106b2dfe8e1a$var$xg = null;
    $b78e106b2dfe8e1a$var$I = !1;
}
function $b78e106b2dfe8e1a$var$Jg(a) {
    null === $b78e106b2dfe8e1a$var$zg ? $b78e106b2dfe8e1a$var$zg = [
        a
    ] : $b78e106b2dfe8e1a$var$zg.push(a);
}
var $b78e106b2dfe8e1a$var$Kg = $b78e106b2dfe8e1a$var$ua.ReactCurrentBatchConfig;
function $b78e106b2dfe8e1a$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($b78e106b2dfe8e1a$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($b78e106b2dfe8e1a$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($b78e106b2dfe8e1a$var$p(284));
        if (!c._owner) throw Error($b78e106b2dfe8e1a$var$p(290, a));
    }
    return a;
}
function $b78e106b2dfe8e1a$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($b78e106b2dfe8e1a$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $b78e106b2dfe8e1a$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $b78e106b2dfe8e1a$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $b78e106b2dfe8e1a$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $b78e106b2dfe8e1a$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $b78e106b2dfe8e1a$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $b78e106b2dfe8e1a$var$Ha && $b78e106b2dfe8e1a$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $b78e106b2dfe8e1a$var$Lg(a, b, c), d.return = a, d;
        d = $b78e106b2dfe8e1a$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $b78e106b2dfe8e1a$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $b78e106b2dfe8e1a$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $b78e106b2dfe8e1a$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $b78e106b2dfe8e1a$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $b78e106b2dfe8e1a$var$va:
                    return c = $b78e106b2dfe8e1a$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $b78e106b2dfe8e1a$var$Lg(a, null, b), c.return = a, c;
                case $b78e106b2dfe8e1a$var$wa:
                    return b = $b78e106b2dfe8e1a$var$Sg(b, a.mode, c), b.return = a, b;
                case $b78e106b2dfe8e1a$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($b78e106b2dfe8e1a$var$eb(b) || $b78e106b2dfe8e1a$var$Ka(b)) return b = $b78e106b2dfe8e1a$var$Tg(b, a.mode, c, null), b.return = a, b;
            $b78e106b2dfe8e1a$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $b78e106b2dfe8e1a$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $b78e106b2dfe8e1a$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $b78e106b2dfe8e1a$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($b78e106b2dfe8e1a$var$eb(c) || $b78e106b2dfe8e1a$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $b78e106b2dfe8e1a$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $b78e106b2dfe8e1a$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $b78e106b2dfe8e1a$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $b78e106b2dfe8e1a$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($b78e106b2dfe8e1a$var$eb(d) || $b78e106b2dfe8e1a$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $b78e106b2dfe8e1a$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $b78e106b2dfe8e1a$var$I && $b78e106b2dfe8e1a$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $b78e106b2dfe8e1a$var$I && $b78e106b2dfe8e1a$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $b78e106b2dfe8e1a$var$I && $b78e106b2dfe8e1a$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $b78e106b2dfe8e1a$var$Ka(h);
        if ("function" !== typeof l) throw Error($b78e106b2dfe8e1a$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($b78e106b2dfe8e1a$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $b78e106b2dfe8e1a$var$I && $b78e106b2dfe8e1a$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $b78e106b2dfe8e1a$var$I && $b78e106b2dfe8e1a$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $b78e106b2dfe8e1a$var$I && $b78e106b2dfe8e1a$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $b78e106b2dfe8e1a$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $b78e106b2dfe8e1a$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $b78e106b2dfe8e1a$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $b78e106b2dfe8e1a$var$Ha && $b78e106b2dfe8e1a$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $b78e106b2dfe8e1a$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $b78e106b2dfe8e1a$var$ya ? (d = $b78e106b2dfe8e1a$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $b78e106b2dfe8e1a$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $b78e106b2dfe8e1a$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $b78e106b2dfe8e1a$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $b78e106b2dfe8e1a$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $b78e106b2dfe8e1a$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($b78e106b2dfe8e1a$var$eb(f)) return n(a, d, f, h);
            if ($b78e106b2dfe8e1a$var$Ka(f)) return t(a, d, f, h);
            $b78e106b2dfe8e1a$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $b78e106b2dfe8e1a$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $b78e106b2dfe8e1a$var$Ug = $b78e106b2dfe8e1a$var$Og(!0), $b78e106b2dfe8e1a$var$Vg = $b78e106b2dfe8e1a$var$Og(!1), $b78e106b2dfe8e1a$var$Wg = $b78e106b2dfe8e1a$var$Uf(null), $b78e106b2dfe8e1a$var$Xg = null, $b78e106b2dfe8e1a$var$Yg = null, $b78e106b2dfe8e1a$var$Zg = null;
function $b78e106b2dfe8e1a$var$$g() {
    $b78e106b2dfe8e1a$var$Zg = $b78e106b2dfe8e1a$var$Yg = $b78e106b2dfe8e1a$var$Xg = null;
}
function $b78e106b2dfe8e1a$var$ah(a) {
    var b = $b78e106b2dfe8e1a$var$Wg.current;
    $b78e106b2dfe8e1a$var$E($b78e106b2dfe8e1a$var$Wg);
    a._currentValue = b;
}
function $b78e106b2dfe8e1a$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $b78e106b2dfe8e1a$var$ch(a, b) {
    $b78e106b2dfe8e1a$var$Xg = a;
    $b78e106b2dfe8e1a$var$Zg = $b78e106b2dfe8e1a$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($b78e106b2dfe8e1a$var$dh = !0), a.firstContext = null);
}
function $b78e106b2dfe8e1a$var$eh(a) {
    var b = a._currentValue;
    if ($b78e106b2dfe8e1a$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $b78e106b2dfe8e1a$var$Yg) {
            if (null === $b78e106b2dfe8e1a$var$Xg) throw Error($b78e106b2dfe8e1a$var$p(308));
            $b78e106b2dfe8e1a$var$Yg = a;
            $b78e106b2dfe8e1a$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $b78e106b2dfe8e1a$var$Yg = $b78e106b2dfe8e1a$var$Yg.next = a;
    }
    return b;
}
var $b78e106b2dfe8e1a$var$fh = null;
function $b78e106b2dfe8e1a$var$gh(a) {
    null === $b78e106b2dfe8e1a$var$fh ? $b78e106b2dfe8e1a$var$fh = [
        a
    ] : $b78e106b2dfe8e1a$var$fh.push(a);
}
function $b78e106b2dfe8e1a$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $b78e106b2dfe8e1a$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $b78e106b2dfe8e1a$var$ih(a, d);
}
function $b78e106b2dfe8e1a$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $b78e106b2dfe8e1a$var$jh = !1;
function $b78e106b2dfe8e1a$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $b78e106b2dfe8e1a$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $b78e106b2dfe8e1a$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $b78e106b2dfe8e1a$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($b78e106b2dfe8e1a$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $b78e106b2dfe8e1a$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $b78e106b2dfe8e1a$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $b78e106b2dfe8e1a$var$ih(a, c);
}
function $b78e106b2dfe8e1a$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b78e106b2dfe8e1a$var$Cc(a, c);
    }
}
function $b78e106b2dfe8e1a$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $b78e106b2dfe8e1a$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $b78e106b2dfe8e1a$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $b78e106b2dfe8e1a$var$A({}, q, r);
                            break a;
                        case 2:
                            $b78e106b2dfe8e1a$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $b78e106b2dfe8e1a$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $b78e106b2dfe8e1a$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($b78e106b2dfe8e1a$var$p(191, e));
            e.call(d);
        }
    }
}
var $b78e106b2dfe8e1a$var$th = {}, $b78e106b2dfe8e1a$var$uh = $b78e106b2dfe8e1a$var$Uf($b78e106b2dfe8e1a$var$th), $b78e106b2dfe8e1a$var$vh = $b78e106b2dfe8e1a$var$Uf($b78e106b2dfe8e1a$var$th), $b78e106b2dfe8e1a$var$wh = $b78e106b2dfe8e1a$var$Uf($b78e106b2dfe8e1a$var$th);
function $b78e106b2dfe8e1a$var$xh(a) {
    if (a === $b78e106b2dfe8e1a$var$th) throw Error($b78e106b2dfe8e1a$var$p(174));
    return a;
}
function $b78e106b2dfe8e1a$var$yh(a, b) {
    $b78e106b2dfe8e1a$var$G($b78e106b2dfe8e1a$var$wh, b);
    $b78e106b2dfe8e1a$var$G($b78e106b2dfe8e1a$var$vh, a);
    $b78e106b2dfe8e1a$var$G($b78e106b2dfe8e1a$var$uh, $b78e106b2dfe8e1a$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $b78e106b2dfe8e1a$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $b78e106b2dfe8e1a$var$lb(b, a);
    }
    $b78e106b2dfe8e1a$var$E($b78e106b2dfe8e1a$var$uh);
    $b78e106b2dfe8e1a$var$G($b78e106b2dfe8e1a$var$uh, b);
}
function $b78e106b2dfe8e1a$var$zh() {
    $b78e106b2dfe8e1a$var$E($b78e106b2dfe8e1a$var$uh);
    $b78e106b2dfe8e1a$var$E($b78e106b2dfe8e1a$var$vh);
    $b78e106b2dfe8e1a$var$E($b78e106b2dfe8e1a$var$wh);
}
function $b78e106b2dfe8e1a$var$Ah(a) {
    $b78e106b2dfe8e1a$var$xh($b78e106b2dfe8e1a$var$wh.current);
    var b = $b78e106b2dfe8e1a$var$xh($b78e106b2dfe8e1a$var$uh.current);
    var c = $b78e106b2dfe8e1a$var$lb(b, a.type);
    b !== c && ($b78e106b2dfe8e1a$var$G($b78e106b2dfe8e1a$var$vh, a), $b78e106b2dfe8e1a$var$G($b78e106b2dfe8e1a$var$uh, c));
}
function $b78e106b2dfe8e1a$var$Bh(a) {
    $b78e106b2dfe8e1a$var$vh.current === a && ($b78e106b2dfe8e1a$var$E($b78e106b2dfe8e1a$var$uh), $b78e106b2dfe8e1a$var$E($b78e106b2dfe8e1a$var$vh));
}
var $b78e106b2dfe8e1a$var$L = $b78e106b2dfe8e1a$var$Uf(0);
function $b78e106b2dfe8e1a$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $b78e106b2dfe8e1a$var$Dh = [];
function $b78e106b2dfe8e1a$var$Eh() {
    for(var a = 0; a < $b78e106b2dfe8e1a$var$Dh.length; a++)$b78e106b2dfe8e1a$var$Dh[a]._workInProgressVersionPrimary = null;
    $b78e106b2dfe8e1a$var$Dh.length = 0;
}
var $b78e106b2dfe8e1a$var$Fh = $b78e106b2dfe8e1a$var$ua.ReactCurrentDispatcher, $b78e106b2dfe8e1a$var$Gh = $b78e106b2dfe8e1a$var$ua.ReactCurrentBatchConfig, $b78e106b2dfe8e1a$var$Hh = 0, $b78e106b2dfe8e1a$var$M = null, $b78e106b2dfe8e1a$var$N = null, $b78e106b2dfe8e1a$var$O = null, $b78e106b2dfe8e1a$var$Ih = !1, $b78e106b2dfe8e1a$var$Jh = !1, $b78e106b2dfe8e1a$var$Kh = 0, $b78e106b2dfe8e1a$var$Lh = 0;
function $b78e106b2dfe8e1a$var$P() {
    throw Error($b78e106b2dfe8e1a$var$p(321));
}
function $b78e106b2dfe8e1a$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$b78e106b2dfe8e1a$var$He(a[c], b[c])) return !1;
    return !0;
}
function $b78e106b2dfe8e1a$var$Nh(a, b, c, d, e, f) {
    $b78e106b2dfe8e1a$var$Hh = f;
    $b78e106b2dfe8e1a$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $b78e106b2dfe8e1a$var$Fh.current = null === a || null === a.memoizedState ? $b78e106b2dfe8e1a$var$Oh : $b78e106b2dfe8e1a$var$Ph;
    a = c(d, e);
    if ($b78e106b2dfe8e1a$var$Jh) {
        f = 0;
        do {
            $b78e106b2dfe8e1a$var$Jh = !1;
            $b78e106b2dfe8e1a$var$Kh = 0;
            if (25 <= f) throw Error($b78e106b2dfe8e1a$var$p(301));
            f += 1;
            $b78e106b2dfe8e1a$var$O = $b78e106b2dfe8e1a$var$N = null;
            b.updateQueue = null;
            $b78e106b2dfe8e1a$var$Fh.current = $b78e106b2dfe8e1a$var$Qh;
            a = c(d, e);
        }while ($b78e106b2dfe8e1a$var$Jh);
    }
    $b78e106b2dfe8e1a$var$Fh.current = $b78e106b2dfe8e1a$var$Rh;
    b = null !== $b78e106b2dfe8e1a$var$N && null !== $b78e106b2dfe8e1a$var$N.next;
    $b78e106b2dfe8e1a$var$Hh = 0;
    $b78e106b2dfe8e1a$var$O = $b78e106b2dfe8e1a$var$N = $b78e106b2dfe8e1a$var$M = null;
    $b78e106b2dfe8e1a$var$Ih = !1;
    if (b) throw Error($b78e106b2dfe8e1a$var$p(300));
    return a;
}
function $b78e106b2dfe8e1a$var$Sh() {
    var a = 0 !== $b78e106b2dfe8e1a$var$Kh;
    $b78e106b2dfe8e1a$var$Kh = 0;
    return a;
}
function $b78e106b2dfe8e1a$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $b78e106b2dfe8e1a$var$O ? $b78e106b2dfe8e1a$var$M.memoizedState = $b78e106b2dfe8e1a$var$O = a : $b78e106b2dfe8e1a$var$O = $b78e106b2dfe8e1a$var$O.next = a;
    return $b78e106b2dfe8e1a$var$O;
}
function $b78e106b2dfe8e1a$var$Uh() {
    if (null === $b78e106b2dfe8e1a$var$N) {
        var a = $b78e106b2dfe8e1a$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $b78e106b2dfe8e1a$var$N.next;
    var b = null === $b78e106b2dfe8e1a$var$O ? $b78e106b2dfe8e1a$var$M.memoizedState : $b78e106b2dfe8e1a$var$O.next;
    if (null !== b) $b78e106b2dfe8e1a$var$O = b, $b78e106b2dfe8e1a$var$N = a;
    else {
        if (null === a) throw Error($b78e106b2dfe8e1a$var$p(310));
        $b78e106b2dfe8e1a$var$N = a;
        a = {
            memoizedState: $b78e106b2dfe8e1a$var$N.memoizedState,
            baseState: $b78e106b2dfe8e1a$var$N.baseState,
            baseQueue: $b78e106b2dfe8e1a$var$N.baseQueue,
            queue: $b78e106b2dfe8e1a$var$N.queue,
            next: null
        };
        null === $b78e106b2dfe8e1a$var$O ? $b78e106b2dfe8e1a$var$M.memoizedState = $b78e106b2dfe8e1a$var$O = a : $b78e106b2dfe8e1a$var$O = $b78e106b2dfe8e1a$var$O.next = a;
    }
    return $b78e106b2dfe8e1a$var$O;
}
function $b78e106b2dfe8e1a$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $b78e106b2dfe8e1a$var$Wh(a) {
    var b = $b78e106b2dfe8e1a$var$Uh(), c = b.queue;
    if (null === c) throw Error($b78e106b2dfe8e1a$var$p(311));
    c.lastRenderedReducer = a;
    var d = $b78e106b2dfe8e1a$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($b78e106b2dfe8e1a$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $b78e106b2dfe8e1a$var$M.lanes |= m;
                $b78e106b2dfe8e1a$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $b78e106b2dfe8e1a$var$He(d, b.memoizedState) || ($b78e106b2dfe8e1a$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $b78e106b2dfe8e1a$var$M.lanes |= f, $b78e106b2dfe8e1a$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $b78e106b2dfe8e1a$var$Xh(a) {
    var b = $b78e106b2dfe8e1a$var$Uh(), c = b.queue;
    if (null === c) throw Error($b78e106b2dfe8e1a$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $b78e106b2dfe8e1a$var$He(f, b.memoizedState) || ($b78e106b2dfe8e1a$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $b78e106b2dfe8e1a$var$Yh() {}
function $b78e106b2dfe8e1a$var$Zh(a, b) {
    var c = $b78e106b2dfe8e1a$var$M, d = $b78e106b2dfe8e1a$var$Uh(), e = b(), f = !$b78e106b2dfe8e1a$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $b78e106b2dfe8e1a$var$dh = !0);
    d = d.queue;
    $b78e106b2dfe8e1a$var$$h($b78e106b2dfe8e1a$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $b78e106b2dfe8e1a$var$O && $b78e106b2dfe8e1a$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $b78e106b2dfe8e1a$var$bi(9, $b78e106b2dfe8e1a$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $b78e106b2dfe8e1a$var$Q) throw Error($b78e106b2dfe8e1a$var$p(349));
        0 !== ($b78e106b2dfe8e1a$var$Hh & 30) || $b78e106b2dfe8e1a$var$di(c, b, e);
    }
    return e;
}
function $b78e106b2dfe8e1a$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $b78e106b2dfe8e1a$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b78e106b2dfe8e1a$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $b78e106b2dfe8e1a$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $b78e106b2dfe8e1a$var$ei(b) && $b78e106b2dfe8e1a$var$fi(a);
}
function $b78e106b2dfe8e1a$var$ai(a, b, c) {
    return c(function() {
        $b78e106b2dfe8e1a$var$ei(b) && $b78e106b2dfe8e1a$var$fi(a);
    });
}
function $b78e106b2dfe8e1a$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$b78e106b2dfe8e1a$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $b78e106b2dfe8e1a$var$fi(a) {
    var b = $b78e106b2dfe8e1a$var$ih(a, 1);
    null !== b && $b78e106b2dfe8e1a$var$gi(b, a, 1, -1);
}
function $b78e106b2dfe8e1a$var$hi(a) {
    var b = $b78e106b2dfe8e1a$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b78e106b2dfe8e1a$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $b78e106b2dfe8e1a$var$ii.bind(null, $b78e106b2dfe8e1a$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $b78e106b2dfe8e1a$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $b78e106b2dfe8e1a$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b78e106b2dfe8e1a$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $b78e106b2dfe8e1a$var$ji() {
    return $b78e106b2dfe8e1a$var$Uh().memoizedState;
}
function $b78e106b2dfe8e1a$var$ki(a, b, c, d) {
    var e = $b78e106b2dfe8e1a$var$Th();
    $b78e106b2dfe8e1a$var$M.flags |= a;
    e.memoizedState = $b78e106b2dfe8e1a$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $b78e106b2dfe8e1a$var$li(a, b, c, d) {
    var e = $b78e106b2dfe8e1a$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $b78e106b2dfe8e1a$var$N) {
        var g = $b78e106b2dfe8e1a$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $b78e106b2dfe8e1a$var$Mh(d, g.deps)) {
            e.memoizedState = $b78e106b2dfe8e1a$var$bi(b, c, f, d);
            return;
        }
    }
    $b78e106b2dfe8e1a$var$M.flags |= a;
    e.memoizedState = $b78e106b2dfe8e1a$var$bi(1 | b, c, f, d);
}
function $b78e106b2dfe8e1a$var$mi(a, b) {
    return $b78e106b2dfe8e1a$var$ki(8390656, 8, a, b);
}
function $b78e106b2dfe8e1a$var$$h(a, b) {
    return $b78e106b2dfe8e1a$var$li(2048, 8, a, b);
}
function $b78e106b2dfe8e1a$var$ni(a, b) {
    return $b78e106b2dfe8e1a$var$li(4, 2, a, b);
}
function $b78e106b2dfe8e1a$var$oi(a, b) {
    return $b78e106b2dfe8e1a$var$li(4, 4, a, b);
}
function $b78e106b2dfe8e1a$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $b78e106b2dfe8e1a$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $b78e106b2dfe8e1a$var$li(4, 4, $b78e106b2dfe8e1a$var$pi.bind(null, b, a), c);
}
function $b78e106b2dfe8e1a$var$ri() {}
function $b78e106b2dfe8e1a$var$si(a, b) {
    var c = $b78e106b2dfe8e1a$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b78e106b2dfe8e1a$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b78e106b2dfe8e1a$var$ti(a, b) {
    var c = $b78e106b2dfe8e1a$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b78e106b2dfe8e1a$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b78e106b2dfe8e1a$var$ui(a, b, c) {
    if (0 === ($b78e106b2dfe8e1a$var$Hh & 21)) return a.baseState && (a.baseState = !1, $b78e106b2dfe8e1a$var$dh = !0), a.memoizedState = c;
    $b78e106b2dfe8e1a$var$He(c, b) || (c = $b78e106b2dfe8e1a$var$yc(), $b78e106b2dfe8e1a$var$M.lanes |= c, $b78e106b2dfe8e1a$var$rh |= c, a.baseState = !0);
    return b;
}
function $b78e106b2dfe8e1a$var$vi(a, b) {
    var c = $b78e106b2dfe8e1a$var$C;
    $b78e106b2dfe8e1a$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $b78e106b2dfe8e1a$var$Gh.transition;
    $b78e106b2dfe8e1a$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $b78e106b2dfe8e1a$var$C = c, $b78e106b2dfe8e1a$var$Gh.transition = d;
    }
}
function $b78e106b2dfe8e1a$var$wi() {
    return $b78e106b2dfe8e1a$var$Uh().memoizedState;
}
function $b78e106b2dfe8e1a$var$xi(a, b, c) {
    var d = $b78e106b2dfe8e1a$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b78e106b2dfe8e1a$var$zi(a)) $b78e106b2dfe8e1a$var$Ai(b, c);
    else if (c = $b78e106b2dfe8e1a$var$hh(a, b, c, d), null !== c) {
        var e = $b78e106b2dfe8e1a$var$R();
        $b78e106b2dfe8e1a$var$gi(c, a, d, e);
        $b78e106b2dfe8e1a$var$Bi(c, b, d);
    }
}
function $b78e106b2dfe8e1a$var$ii(a, b, c) {
    var d = $b78e106b2dfe8e1a$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b78e106b2dfe8e1a$var$zi(a)) $b78e106b2dfe8e1a$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($b78e106b2dfe8e1a$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $b78e106b2dfe8e1a$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $b78e106b2dfe8e1a$var$hh(a, b, e, d);
        null !== c && (e = $b78e106b2dfe8e1a$var$R(), $b78e106b2dfe8e1a$var$gi(c, a, d, e), $b78e106b2dfe8e1a$var$Bi(c, b, d));
    }
}
function $b78e106b2dfe8e1a$var$zi(a) {
    var b = a.alternate;
    return a === $b78e106b2dfe8e1a$var$M || null !== b && b === $b78e106b2dfe8e1a$var$M;
}
function $b78e106b2dfe8e1a$var$Ai(a, b) {
    $b78e106b2dfe8e1a$var$Jh = $b78e106b2dfe8e1a$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $b78e106b2dfe8e1a$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b78e106b2dfe8e1a$var$Cc(a, c);
    }
}
var $b78e106b2dfe8e1a$var$Rh = {
    readContext: $b78e106b2dfe8e1a$var$eh,
    useCallback: $b78e106b2dfe8e1a$var$P,
    useContext: $b78e106b2dfe8e1a$var$P,
    useEffect: $b78e106b2dfe8e1a$var$P,
    useImperativeHandle: $b78e106b2dfe8e1a$var$P,
    useInsertionEffect: $b78e106b2dfe8e1a$var$P,
    useLayoutEffect: $b78e106b2dfe8e1a$var$P,
    useMemo: $b78e106b2dfe8e1a$var$P,
    useReducer: $b78e106b2dfe8e1a$var$P,
    useRef: $b78e106b2dfe8e1a$var$P,
    useState: $b78e106b2dfe8e1a$var$P,
    useDebugValue: $b78e106b2dfe8e1a$var$P,
    useDeferredValue: $b78e106b2dfe8e1a$var$P,
    useTransition: $b78e106b2dfe8e1a$var$P,
    useMutableSource: $b78e106b2dfe8e1a$var$P,
    useSyncExternalStore: $b78e106b2dfe8e1a$var$P,
    useId: $b78e106b2dfe8e1a$var$P,
    unstable_isNewReconciler: !1
}, $b78e106b2dfe8e1a$var$Oh = {
    readContext: $b78e106b2dfe8e1a$var$eh,
    useCallback: function(a, b) {
        $b78e106b2dfe8e1a$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $b78e106b2dfe8e1a$var$eh,
    useEffect: $b78e106b2dfe8e1a$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $b78e106b2dfe8e1a$var$ki(4194308, 4, $b78e106b2dfe8e1a$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $b78e106b2dfe8e1a$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $b78e106b2dfe8e1a$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $b78e106b2dfe8e1a$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $b78e106b2dfe8e1a$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $b78e106b2dfe8e1a$var$xi.bind(null, $b78e106b2dfe8e1a$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $b78e106b2dfe8e1a$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $b78e106b2dfe8e1a$var$hi,
    useDebugValue: $b78e106b2dfe8e1a$var$ri,
    useDeferredValue: function(a) {
        return $b78e106b2dfe8e1a$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $b78e106b2dfe8e1a$var$hi(!1), b = a[0];
        a = $b78e106b2dfe8e1a$var$vi.bind(null, a[1]);
        $b78e106b2dfe8e1a$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $b78e106b2dfe8e1a$var$M, e = $b78e106b2dfe8e1a$var$Th();
        if ($b78e106b2dfe8e1a$var$I) {
            if (void 0 === c) throw Error($b78e106b2dfe8e1a$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $b78e106b2dfe8e1a$var$Q) throw Error($b78e106b2dfe8e1a$var$p(349));
            0 !== ($b78e106b2dfe8e1a$var$Hh & 30) || $b78e106b2dfe8e1a$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $b78e106b2dfe8e1a$var$mi($b78e106b2dfe8e1a$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $b78e106b2dfe8e1a$var$bi(9, $b78e106b2dfe8e1a$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $b78e106b2dfe8e1a$var$Th(), b = $b78e106b2dfe8e1a$var$Q.identifierPrefix;
        if ($b78e106b2dfe8e1a$var$I) {
            var c = $b78e106b2dfe8e1a$var$sg;
            var d = $b78e106b2dfe8e1a$var$rg;
            c = (d & ~(1 << 32 - $b78e106b2dfe8e1a$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $b78e106b2dfe8e1a$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $b78e106b2dfe8e1a$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $b78e106b2dfe8e1a$var$Ph = {
    readContext: $b78e106b2dfe8e1a$var$eh,
    useCallback: $b78e106b2dfe8e1a$var$si,
    useContext: $b78e106b2dfe8e1a$var$eh,
    useEffect: $b78e106b2dfe8e1a$var$$h,
    useImperativeHandle: $b78e106b2dfe8e1a$var$qi,
    useInsertionEffect: $b78e106b2dfe8e1a$var$ni,
    useLayoutEffect: $b78e106b2dfe8e1a$var$oi,
    useMemo: $b78e106b2dfe8e1a$var$ti,
    useReducer: $b78e106b2dfe8e1a$var$Wh,
    useRef: $b78e106b2dfe8e1a$var$ji,
    useState: function() {
        return $b78e106b2dfe8e1a$var$Wh($b78e106b2dfe8e1a$var$Vh);
    },
    useDebugValue: $b78e106b2dfe8e1a$var$ri,
    useDeferredValue: function(a) {
        var b = $b78e106b2dfe8e1a$var$Uh();
        return $b78e106b2dfe8e1a$var$ui(b, $b78e106b2dfe8e1a$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $b78e106b2dfe8e1a$var$Wh($b78e106b2dfe8e1a$var$Vh)[0], b = $b78e106b2dfe8e1a$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b78e106b2dfe8e1a$var$Yh,
    useSyncExternalStore: $b78e106b2dfe8e1a$var$Zh,
    useId: $b78e106b2dfe8e1a$var$wi,
    unstable_isNewReconciler: !1
}, $b78e106b2dfe8e1a$var$Qh = {
    readContext: $b78e106b2dfe8e1a$var$eh,
    useCallback: $b78e106b2dfe8e1a$var$si,
    useContext: $b78e106b2dfe8e1a$var$eh,
    useEffect: $b78e106b2dfe8e1a$var$$h,
    useImperativeHandle: $b78e106b2dfe8e1a$var$qi,
    useInsertionEffect: $b78e106b2dfe8e1a$var$ni,
    useLayoutEffect: $b78e106b2dfe8e1a$var$oi,
    useMemo: $b78e106b2dfe8e1a$var$ti,
    useReducer: $b78e106b2dfe8e1a$var$Xh,
    useRef: $b78e106b2dfe8e1a$var$ji,
    useState: function() {
        return $b78e106b2dfe8e1a$var$Xh($b78e106b2dfe8e1a$var$Vh);
    },
    useDebugValue: $b78e106b2dfe8e1a$var$ri,
    useDeferredValue: function(a) {
        var b = $b78e106b2dfe8e1a$var$Uh();
        return null === $b78e106b2dfe8e1a$var$N ? b.memoizedState = a : $b78e106b2dfe8e1a$var$ui(b, $b78e106b2dfe8e1a$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $b78e106b2dfe8e1a$var$Xh($b78e106b2dfe8e1a$var$Vh)[0], b = $b78e106b2dfe8e1a$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b78e106b2dfe8e1a$var$Yh,
    useSyncExternalStore: $b78e106b2dfe8e1a$var$Zh,
    useId: $b78e106b2dfe8e1a$var$wi,
    unstable_isNewReconciler: !1
};
function $b78e106b2dfe8e1a$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $b78e106b2dfe8e1a$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $b78e106b2dfe8e1a$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $b78e106b2dfe8e1a$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $b78e106b2dfe8e1a$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $b78e106b2dfe8e1a$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b78e106b2dfe8e1a$var$R(), e = $b78e106b2dfe8e1a$var$yi(a), f = $b78e106b2dfe8e1a$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b78e106b2dfe8e1a$var$nh(a, f, e);
        null !== b && ($b78e106b2dfe8e1a$var$gi(b, a, e, d), $b78e106b2dfe8e1a$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b78e106b2dfe8e1a$var$R(), e = $b78e106b2dfe8e1a$var$yi(a), f = $b78e106b2dfe8e1a$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b78e106b2dfe8e1a$var$nh(a, f, e);
        null !== b && ($b78e106b2dfe8e1a$var$gi(b, a, e, d), $b78e106b2dfe8e1a$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $b78e106b2dfe8e1a$var$R(), d = $b78e106b2dfe8e1a$var$yi(a), e = $b78e106b2dfe8e1a$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $b78e106b2dfe8e1a$var$nh(a, e, d);
        null !== b && ($b78e106b2dfe8e1a$var$gi(b, a, d, c), $b78e106b2dfe8e1a$var$oh(b, a, d));
    }
};
function $b78e106b2dfe8e1a$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$b78e106b2dfe8e1a$var$Ie(c, d) || !$b78e106b2dfe8e1a$var$Ie(e, f) : !0;
}
function $b78e106b2dfe8e1a$var$Gi(a, b, c) {
    var d = !1, e = $b78e106b2dfe8e1a$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $b78e106b2dfe8e1a$var$eh(f) : (e = $b78e106b2dfe8e1a$var$Zf(b) ? $b78e106b2dfe8e1a$var$Xf : $b78e106b2dfe8e1a$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $b78e106b2dfe8e1a$var$Yf(a, e) : $b78e106b2dfe8e1a$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $b78e106b2dfe8e1a$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $b78e106b2dfe8e1a$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $b78e106b2dfe8e1a$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $b78e106b2dfe8e1a$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $b78e106b2dfe8e1a$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $b78e106b2dfe8e1a$var$eh(f) : (f = $b78e106b2dfe8e1a$var$Zf(b) ? $b78e106b2dfe8e1a$var$Xf : $b78e106b2dfe8e1a$var$H.current, e.context = $b78e106b2dfe8e1a$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($b78e106b2dfe8e1a$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $b78e106b2dfe8e1a$var$Ei.enqueueReplaceState(e, e.state, null), $b78e106b2dfe8e1a$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $b78e106b2dfe8e1a$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $b78e106b2dfe8e1a$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $b78e106b2dfe8e1a$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $b78e106b2dfe8e1a$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $b78e106b2dfe8e1a$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $b78e106b2dfe8e1a$var$Ni(a, b, c) {
    c = $b78e106b2dfe8e1a$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $b78e106b2dfe8e1a$var$Oi || ($b78e106b2dfe8e1a$var$Oi = !0, $b78e106b2dfe8e1a$var$Pi = d);
        $b78e106b2dfe8e1a$var$Li(a, b);
    };
    return c;
}
function $b78e106b2dfe8e1a$var$Qi(a, b, c) {
    c = $b78e106b2dfe8e1a$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $b78e106b2dfe8e1a$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $b78e106b2dfe8e1a$var$Li(a, b);
        "function" !== typeof d && (null === $b78e106b2dfe8e1a$var$Ri ? $b78e106b2dfe8e1a$var$Ri = new Set([
            this
        ]) : $b78e106b2dfe8e1a$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $b78e106b2dfe8e1a$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $b78e106b2dfe8e1a$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $b78e106b2dfe8e1a$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $b78e106b2dfe8e1a$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $b78e106b2dfe8e1a$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $b78e106b2dfe8e1a$var$mh(-1, 1), b.tag = 2, $b78e106b2dfe8e1a$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $b78e106b2dfe8e1a$var$Wi = $b78e106b2dfe8e1a$var$ua.ReactCurrentOwner, $b78e106b2dfe8e1a$var$dh = !1;
function $b78e106b2dfe8e1a$var$Xi(a, b, c, d) {
    b.child = null === a ? $b78e106b2dfe8e1a$var$Vg(b, null, c, d) : $b78e106b2dfe8e1a$var$Ug(b, a.child, c, d);
}
function $b78e106b2dfe8e1a$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $b78e106b2dfe8e1a$var$ch(b, e);
    d = $b78e106b2dfe8e1a$var$Nh(a, b, c, d, f, e);
    c = $b78e106b2dfe8e1a$var$Sh();
    if (null !== a && !$b78e106b2dfe8e1a$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b78e106b2dfe8e1a$var$Zi(a, b, e);
    $b78e106b2dfe8e1a$var$I && c && $b78e106b2dfe8e1a$var$vg(b);
    b.flags |= 1;
    $b78e106b2dfe8e1a$var$Xi(a, b, d, e);
    return b.child;
}
function $b78e106b2dfe8e1a$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$b78e106b2dfe8e1a$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $b78e106b2dfe8e1a$var$bj(a, b, f, d, e);
        a = $b78e106b2dfe8e1a$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $b78e106b2dfe8e1a$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $b78e106b2dfe8e1a$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $b78e106b2dfe8e1a$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $b78e106b2dfe8e1a$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($b78e106b2dfe8e1a$var$Ie(f, d) && a.ref === b.ref) {
            if ($b78e106b2dfe8e1a$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($b78e106b2dfe8e1a$var$dh = !0);
            else return b.lanes = a.lanes, $b78e106b2dfe8e1a$var$Zi(a, b, e);
        }
    }
    return $b78e106b2dfe8e1a$var$cj(a, b, c, d, e);
}
function $b78e106b2dfe8e1a$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $b78e106b2dfe8e1a$var$G($b78e106b2dfe8e1a$var$ej, $b78e106b2dfe8e1a$var$fj), $b78e106b2dfe8e1a$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $b78e106b2dfe8e1a$var$G($b78e106b2dfe8e1a$var$ej, $b78e106b2dfe8e1a$var$fj), $b78e106b2dfe8e1a$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $b78e106b2dfe8e1a$var$G($b78e106b2dfe8e1a$var$ej, $b78e106b2dfe8e1a$var$fj);
            $b78e106b2dfe8e1a$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $b78e106b2dfe8e1a$var$G($b78e106b2dfe8e1a$var$ej, $b78e106b2dfe8e1a$var$fj), $b78e106b2dfe8e1a$var$fj |= d;
    $b78e106b2dfe8e1a$var$Xi(a, b, e, c);
    return b.child;
}
function $b78e106b2dfe8e1a$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $b78e106b2dfe8e1a$var$cj(a, b, c, d, e) {
    var f = $b78e106b2dfe8e1a$var$Zf(c) ? $b78e106b2dfe8e1a$var$Xf : $b78e106b2dfe8e1a$var$H.current;
    f = $b78e106b2dfe8e1a$var$Yf(b, f);
    $b78e106b2dfe8e1a$var$ch(b, e);
    c = $b78e106b2dfe8e1a$var$Nh(a, b, c, d, f, e);
    d = $b78e106b2dfe8e1a$var$Sh();
    if (null !== a && !$b78e106b2dfe8e1a$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b78e106b2dfe8e1a$var$Zi(a, b, e);
    $b78e106b2dfe8e1a$var$I && d && $b78e106b2dfe8e1a$var$vg(b);
    b.flags |= 1;
    $b78e106b2dfe8e1a$var$Xi(a, b, c, e);
    return b.child;
}
function $b78e106b2dfe8e1a$var$hj(a, b, c, d, e) {
    if ($b78e106b2dfe8e1a$var$Zf(c)) {
        var f = !0;
        $b78e106b2dfe8e1a$var$cg(b);
    } else f = !1;
    $b78e106b2dfe8e1a$var$ch(b, e);
    if (null === b.stateNode) $b78e106b2dfe8e1a$var$ij(a, b), $b78e106b2dfe8e1a$var$Gi(b, c, d), $b78e106b2dfe8e1a$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $b78e106b2dfe8e1a$var$eh(l) : (l = $b78e106b2dfe8e1a$var$Zf(c) ? $b78e106b2dfe8e1a$var$Xf : $b78e106b2dfe8e1a$var$H.current, l = $b78e106b2dfe8e1a$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $b78e106b2dfe8e1a$var$Hi(b, g, d, l);
        $b78e106b2dfe8e1a$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $b78e106b2dfe8e1a$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $b78e106b2dfe8e1a$var$Wf.current || $b78e106b2dfe8e1a$var$jh ? ("function" === typeof m && ($b78e106b2dfe8e1a$var$Di(b, c, m, d), k = b.memoizedState), (h = $b78e106b2dfe8e1a$var$jh || $b78e106b2dfe8e1a$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $b78e106b2dfe8e1a$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $b78e106b2dfe8e1a$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $b78e106b2dfe8e1a$var$eh(k) : (k = $b78e106b2dfe8e1a$var$Zf(c) ? $b78e106b2dfe8e1a$var$Xf : $b78e106b2dfe8e1a$var$H.current, k = $b78e106b2dfe8e1a$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $b78e106b2dfe8e1a$var$Hi(b, g, d, k);
        $b78e106b2dfe8e1a$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $b78e106b2dfe8e1a$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $b78e106b2dfe8e1a$var$Wf.current || $b78e106b2dfe8e1a$var$jh ? ("function" === typeof y && ($b78e106b2dfe8e1a$var$Di(b, c, y, d), n = b.memoizedState), (l = $b78e106b2dfe8e1a$var$jh || $b78e106b2dfe8e1a$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $b78e106b2dfe8e1a$var$jj(a, b, c, d, f, e);
}
function $b78e106b2dfe8e1a$var$jj(a, b, c, d, e, f) {
    $b78e106b2dfe8e1a$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $b78e106b2dfe8e1a$var$dg(b, c, !1), $b78e106b2dfe8e1a$var$Zi(a, b, f);
    d = b.stateNode;
    $b78e106b2dfe8e1a$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $b78e106b2dfe8e1a$var$Ug(b, a.child, null, f), b.child = $b78e106b2dfe8e1a$var$Ug(b, null, h, f)) : $b78e106b2dfe8e1a$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $b78e106b2dfe8e1a$var$dg(b, c, !0);
    return b.child;
}
function $b78e106b2dfe8e1a$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $b78e106b2dfe8e1a$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $b78e106b2dfe8e1a$var$ag(a, b.context, !1);
    $b78e106b2dfe8e1a$var$yh(a, b.containerInfo);
}
function $b78e106b2dfe8e1a$var$lj(a, b, c, d, e) {
    $b78e106b2dfe8e1a$var$Ig();
    $b78e106b2dfe8e1a$var$Jg(e);
    b.flags |= 256;
    $b78e106b2dfe8e1a$var$Xi(a, b, c, d);
    return b.child;
}
var $b78e106b2dfe8e1a$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $b78e106b2dfe8e1a$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $b78e106b2dfe8e1a$var$oj(a, b, c) {
    var d = b.pendingProps, e = $b78e106b2dfe8e1a$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $b78e106b2dfe8e1a$var$G($b78e106b2dfe8e1a$var$L, e & 1);
    if (null === a) {
        $b78e106b2dfe8e1a$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $b78e106b2dfe8e1a$var$pj(g, d, 0, null), a = $b78e106b2dfe8e1a$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $b78e106b2dfe8e1a$var$nj(c), b.memoizedState = $b78e106b2dfe8e1a$var$mj, a) : $b78e106b2dfe8e1a$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $b78e106b2dfe8e1a$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $b78e106b2dfe8e1a$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $b78e106b2dfe8e1a$var$Pg(h, f) : (f = $b78e106b2dfe8e1a$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $b78e106b2dfe8e1a$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $b78e106b2dfe8e1a$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $b78e106b2dfe8e1a$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $b78e106b2dfe8e1a$var$qj(a, b) {
    b = $b78e106b2dfe8e1a$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $b78e106b2dfe8e1a$var$sj(a, b, c, d) {
    null !== d && $b78e106b2dfe8e1a$var$Jg(d);
    $b78e106b2dfe8e1a$var$Ug(b, a.child, null, c);
    a = $b78e106b2dfe8e1a$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $b78e106b2dfe8e1a$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $b78e106b2dfe8e1a$var$Ki(Error($b78e106b2dfe8e1a$var$p(422))), $b78e106b2dfe8e1a$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $b78e106b2dfe8e1a$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $b78e106b2dfe8e1a$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $b78e106b2dfe8e1a$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $b78e106b2dfe8e1a$var$nj(g);
        b.memoizedState = $b78e106b2dfe8e1a$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $b78e106b2dfe8e1a$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($b78e106b2dfe8e1a$var$p(419));
        d = $b78e106b2dfe8e1a$var$Ki(f, d, void 0);
        return $b78e106b2dfe8e1a$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($b78e106b2dfe8e1a$var$dh || h) {
        d = $b78e106b2dfe8e1a$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $b78e106b2dfe8e1a$var$ih(a, e), $b78e106b2dfe8e1a$var$gi(d, a, e, -1));
        }
        $b78e106b2dfe8e1a$var$tj();
        d = $b78e106b2dfe8e1a$var$Ki(Error($b78e106b2dfe8e1a$var$p(421)));
        return $b78e106b2dfe8e1a$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $b78e106b2dfe8e1a$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $b78e106b2dfe8e1a$var$yg = $b78e106b2dfe8e1a$var$Lf(e.nextSibling);
    $b78e106b2dfe8e1a$var$xg = b;
    $b78e106b2dfe8e1a$var$I = !0;
    $b78e106b2dfe8e1a$var$zg = null;
    null !== a && ($b78e106b2dfe8e1a$var$og[$b78e106b2dfe8e1a$var$pg++] = $b78e106b2dfe8e1a$var$rg, $b78e106b2dfe8e1a$var$og[$b78e106b2dfe8e1a$var$pg++] = $b78e106b2dfe8e1a$var$sg, $b78e106b2dfe8e1a$var$og[$b78e106b2dfe8e1a$var$pg++] = $b78e106b2dfe8e1a$var$qg, $b78e106b2dfe8e1a$var$rg = a.id, $b78e106b2dfe8e1a$var$sg = a.overflow, $b78e106b2dfe8e1a$var$qg = b);
    b = $b78e106b2dfe8e1a$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $b78e106b2dfe8e1a$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $b78e106b2dfe8e1a$var$bh(a.return, b, c);
}
function $b78e106b2dfe8e1a$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $b78e106b2dfe8e1a$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $b78e106b2dfe8e1a$var$Xi(a, b, d.children, c);
    d = $b78e106b2dfe8e1a$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $b78e106b2dfe8e1a$var$vj(a, c, b);
            else if (19 === a.tag) $b78e106b2dfe8e1a$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $b78e106b2dfe8e1a$var$G($b78e106b2dfe8e1a$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $b78e106b2dfe8e1a$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $b78e106b2dfe8e1a$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $b78e106b2dfe8e1a$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $b78e106b2dfe8e1a$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $b78e106b2dfe8e1a$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $b78e106b2dfe8e1a$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $b78e106b2dfe8e1a$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $b78e106b2dfe8e1a$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($b78e106b2dfe8e1a$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $b78e106b2dfe8e1a$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $b78e106b2dfe8e1a$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $b78e106b2dfe8e1a$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $b78e106b2dfe8e1a$var$kj(b);
            $b78e106b2dfe8e1a$var$Ig();
            break;
        case 5:
            $b78e106b2dfe8e1a$var$Ah(b);
            break;
        case 1:
            $b78e106b2dfe8e1a$var$Zf(b.type) && $b78e106b2dfe8e1a$var$cg(b);
            break;
        case 4:
            $b78e106b2dfe8e1a$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $b78e106b2dfe8e1a$var$G($b78e106b2dfe8e1a$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $b78e106b2dfe8e1a$var$G($b78e106b2dfe8e1a$var$L, $b78e106b2dfe8e1a$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $b78e106b2dfe8e1a$var$oj(a, b, c);
                $b78e106b2dfe8e1a$var$G($b78e106b2dfe8e1a$var$L, $b78e106b2dfe8e1a$var$L.current & 1);
                a = $b78e106b2dfe8e1a$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $b78e106b2dfe8e1a$var$G($b78e106b2dfe8e1a$var$L, $b78e106b2dfe8e1a$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $b78e106b2dfe8e1a$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $b78e106b2dfe8e1a$var$G($b78e106b2dfe8e1a$var$L, $b78e106b2dfe8e1a$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $b78e106b2dfe8e1a$var$dj(a, b, c);
    }
    return $b78e106b2dfe8e1a$var$Zi(a, b, c);
}
var $b78e106b2dfe8e1a$var$zj, $b78e106b2dfe8e1a$var$Aj, $b78e106b2dfe8e1a$var$Bj, $b78e106b2dfe8e1a$var$Cj;
$b78e106b2dfe8e1a$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$b78e106b2dfe8e1a$var$Aj = function() {};
$b78e106b2dfe8e1a$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $b78e106b2dfe8e1a$var$xh($b78e106b2dfe8e1a$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $b78e106b2dfe8e1a$var$Ya(a, e);
                d = $b78e106b2dfe8e1a$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $b78e106b2dfe8e1a$var$A({}, e, {
                    value: void 0
                });
                d = $b78e106b2dfe8e1a$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $b78e106b2dfe8e1a$var$gb(a, e);
                d = $b78e106b2dfe8e1a$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $b78e106b2dfe8e1a$var$Bf);
        }
        $b78e106b2dfe8e1a$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($b78e106b2dfe8e1a$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($b78e106b2dfe8e1a$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $b78e106b2dfe8e1a$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$b78e106b2dfe8e1a$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $b78e106b2dfe8e1a$var$Dj(a, b) {
    if (!$b78e106b2dfe8e1a$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $b78e106b2dfe8e1a$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $b78e106b2dfe8e1a$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $b78e106b2dfe8e1a$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $b78e106b2dfe8e1a$var$S(b), null;
        case 1:
            return $b78e106b2dfe8e1a$var$Zf(b.type) && $b78e106b2dfe8e1a$var$$f(), $b78e106b2dfe8e1a$var$S(b), null;
        case 3:
            d = b.stateNode;
            $b78e106b2dfe8e1a$var$zh();
            $b78e106b2dfe8e1a$var$E($b78e106b2dfe8e1a$var$Wf);
            $b78e106b2dfe8e1a$var$E($b78e106b2dfe8e1a$var$H);
            $b78e106b2dfe8e1a$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $b78e106b2dfe8e1a$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $b78e106b2dfe8e1a$var$zg && ($b78e106b2dfe8e1a$var$Fj($b78e106b2dfe8e1a$var$zg), $b78e106b2dfe8e1a$var$zg = null));
            $b78e106b2dfe8e1a$var$Aj(a, b);
            $b78e106b2dfe8e1a$var$S(b);
            return null;
        case 5:
            $b78e106b2dfe8e1a$var$Bh(b);
            var e = $b78e106b2dfe8e1a$var$xh($b78e106b2dfe8e1a$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $b78e106b2dfe8e1a$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($b78e106b2dfe8e1a$var$p(166));
                    $b78e106b2dfe8e1a$var$S(b);
                    return null;
                }
                a = $b78e106b2dfe8e1a$var$xh($b78e106b2dfe8e1a$var$uh.current);
                if ($b78e106b2dfe8e1a$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$b78e106b2dfe8e1a$var$Of] = b;
                    d[$b78e106b2dfe8e1a$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $b78e106b2dfe8e1a$var$D("cancel", d);
                            $b78e106b2dfe8e1a$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $b78e106b2dfe8e1a$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $b78e106b2dfe8e1a$var$lf.length; e++)$b78e106b2dfe8e1a$var$D($b78e106b2dfe8e1a$var$lf[e], d);
                            break;
                        case "source":
                            $b78e106b2dfe8e1a$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $b78e106b2dfe8e1a$var$D("error", d);
                            $b78e106b2dfe8e1a$var$D("load", d);
                            break;
                        case "details":
                            $b78e106b2dfe8e1a$var$D("toggle", d);
                            break;
                        case "input":
                            $b78e106b2dfe8e1a$var$Za(d, f);
                            $b78e106b2dfe8e1a$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $b78e106b2dfe8e1a$var$D("invalid", d);
                            break;
                        case "textarea":
                            $b78e106b2dfe8e1a$var$hb(d, f), $b78e106b2dfe8e1a$var$D("invalid", d);
                    }
                    $b78e106b2dfe8e1a$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $b78e106b2dfe8e1a$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $b78e106b2dfe8e1a$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $b78e106b2dfe8e1a$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $b78e106b2dfe8e1a$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $b78e106b2dfe8e1a$var$Va(d);
                            $b78e106b2dfe8e1a$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $b78e106b2dfe8e1a$var$Va(d);
                            $b78e106b2dfe8e1a$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $b78e106b2dfe8e1a$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $b78e106b2dfe8e1a$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$b78e106b2dfe8e1a$var$Of] = b;
                    a[$b78e106b2dfe8e1a$var$Pf] = d;
                    $b78e106b2dfe8e1a$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $b78e106b2dfe8e1a$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $b78e106b2dfe8e1a$var$D("cancel", a);
                                $b78e106b2dfe8e1a$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $b78e106b2dfe8e1a$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $b78e106b2dfe8e1a$var$lf.length; e++)$b78e106b2dfe8e1a$var$D($b78e106b2dfe8e1a$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $b78e106b2dfe8e1a$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $b78e106b2dfe8e1a$var$D("error", a);
                                $b78e106b2dfe8e1a$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $b78e106b2dfe8e1a$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $b78e106b2dfe8e1a$var$Za(a, d);
                                e = $b78e106b2dfe8e1a$var$Ya(a, d);
                                $b78e106b2dfe8e1a$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $b78e106b2dfe8e1a$var$A({}, d, {
                                    value: void 0
                                });
                                $b78e106b2dfe8e1a$var$D("invalid", a);
                                break;
                            case "textarea":
                                $b78e106b2dfe8e1a$var$hb(a, d);
                                e = $b78e106b2dfe8e1a$var$gb(a, d);
                                $b78e106b2dfe8e1a$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $b78e106b2dfe8e1a$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $b78e106b2dfe8e1a$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $b78e106b2dfe8e1a$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $b78e106b2dfe8e1a$var$ob(a, k) : "number" === typeof k && $b78e106b2dfe8e1a$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($b78e106b2dfe8e1a$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $b78e106b2dfe8e1a$var$D("scroll", a) : null != k && $b78e106b2dfe8e1a$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $b78e106b2dfe8e1a$var$Va(a);
                                $b78e106b2dfe8e1a$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $b78e106b2dfe8e1a$var$Va(a);
                                $b78e106b2dfe8e1a$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $b78e106b2dfe8e1a$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $b78e106b2dfe8e1a$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $b78e106b2dfe8e1a$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $b78e106b2dfe8e1a$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $b78e106b2dfe8e1a$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $b78e106b2dfe8e1a$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($b78e106b2dfe8e1a$var$p(166));
                c = $b78e106b2dfe8e1a$var$xh($b78e106b2dfe8e1a$var$wh.current);
                $b78e106b2dfe8e1a$var$xh($b78e106b2dfe8e1a$var$uh.current);
                if ($b78e106b2dfe8e1a$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$b78e106b2dfe8e1a$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $b78e106b2dfe8e1a$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $b78e106b2dfe8e1a$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $b78e106b2dfe8e1a$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$b78e106b2dfe8e1a$var$Of] = b, b.stateNode = d;
            }
            $b78e106b2dfe8e1a$var$S(b);
            return null;
        case 13:
            $b78e106b2dfe8e1a$var$E($b78e106b2dfe8e1a$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($b78e106b2dfe8e1a$var$I && null !== $b78e106b2dfe8e1a$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $b78e106b2dfe8e1a$var$Hg(), $b78e106b2dfe8e1a$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $b78e106b2dfe8e1a$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($b78e106b2dfe8e1a$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($b78e106b2dfe8e1a$var$p(317));
                        f[$b78e106b2dfe8e1a$var$Of] = b;
                    } else $b78e106b2dfe8e1a$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $b78e106b2dfe8e1a$var$S(b);
                    f = !1;
                } else null !== $b78e106b2dfe8e1a$var$zg && ($b78e106b2dfe8e1a$var$Fj($b78e106b2dfe8e1a$var$zg), $b78e106b2dfe8e1a$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($b78e106b2dfe8e1a$var$L.current & 1) ? 0 === $b78e106b2dfe8e1a$var$T && ($b78e106b2dfe8e1a$var$T = 3) : $b78e106b2dfe8e1a$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $b78e106b2dfe8e1a$var$S(b);
            return null;
        case 4:
            return $b78e106b2dfe8e1a$var$zh(), $b78e106b2dfe8e1a$var$Aj(a, b), null === a && $b78e106b2dfe8e1a$var$sf(b.stateNode.containerInfo), $b78e106b2dfe8e1a$var$S(b), null;
        case 10:
            return $b78e106b2dfe8e1a$var$ah(b.type._context), $b78e106b2dfe8e1a$var$S(b), null;
        case 17:
            return $b78e106b2dfe8e1a$var$Zf(b.type) && $b78e106b2dfe8e1a$var$$f(), $b78e106b2dfe8e1a$var$S(b), null;
        case 19:
            $b78e106b2dfe8e1a$var$E($b78e106b2dfe8e1a$var$L);
            f = b.memoizedState;
            if (null === f) return $b78e106b2dfe8e1a$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $b78e106b2dfe8e1a$var$Dj(f, !1);
                else {
                    if (0 !== $b78e106b2dfe8e1a$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $b78e106b2dfe8e1a$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $b78e106b2dfe8e1a$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $b78e106b2dfe8e1a$var$G($b78e106b2dfe8e1a$var$L, $b78e106b2dfe8e1a$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $b78e106b2dfe8e1a$var$B() > $b78e106b2dfe8e1a$var$Gj && (b.flags |= 128, d = !0, $b78e106b2dfe8e1a$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $b78e106b2dfe8e1a$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $b78e106b2dfe8e1a$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$b78e106b2dfe8e1a$var$I) return $b78e106b2dfe8e1a$var$S(b), null;
                    } else 2 * $b78e106b2dfe8e1a$var$B() - f.renderingStartTime > $b78e106b2dfe8e1a$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $b78e106b2dfe8e1a$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $b78e106b2dfe8e1a$var$B(), b.sibling = null, c = $b78e106b2dfe8e1a$var$L.current, $b78e106b2dfe8e1a$var$G($b78e106b2dfe8e1a$var$L, d ? c & 1 | 2 : c & 1), b;
            $b78e106b2dfe8e1a$var$S(b);
            return null;
        case 22:
        case 23:
            return $b78e106b2dfe8e1a$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($b78e106b2dfe8e1a$var$fj & 1073741824) && ($b78e106b2dfe8e1a$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $b78e106b2dfe8e1a$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($b78e106b2dfe8e1a$var$p(156, b.tag));
}
function $b78e106b2dfe8e1a$var$Ij(a, b) {
    $b78e106b2dfe8e1a$var$wg(b);
    switch(b.tag){
        case 1:
            return $b78e106b2dfe8e1a$var$Zf(b.type) && $b78e106b2dfe8e1a$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $b78e106b2dfe8e1a$var$zh(), $b78e106b2dfe8e1a$var$E($b78e106b2dfe8e1a$var$Wf), $b78e106b2dfe8e1a$var$E($b78e106b2dfe8e1a$var$H), $b78e106b2dfe8e1a$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $b78e106b2dfe8e1a$var$Bh(b), null;
        case 13:
            $b78e106b2dfe8e1a$var$E($b78e106b2dfe8e1a$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($b78e106b2dfe8e1a$var$p(340));
                $b78e106b2dfe8e1a$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $b78e106b2dfe8e1a$var$E($b78e106b2dfe8e1a$var$L), null;
        case 4:
            return $b78e106b2dfe8e1a$var$zh(), null;
        case 10:
            return $b78e106b2dfe8e1a$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $b78e106b2dfe8e1a$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $b78e106b2dfe8e1a$var$Jj = !1, $b78e106b2dfe8e1a$var$U = !1, $b78e106b2dfe8e1a$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $b78e106b2dfe8e1a$var$V = null;
function $b78e106b2dfe8e1a$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $b78e106b2dfe8e1a$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $b78e106b2dfe8e1a$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $b78e106b2dfe8e1a$var$W(a, b, d);
    }
}
var $b78e106b2dfe8e1a$var$Nj = !1;
function $b78e106b2dfe8e1a$var$Oj(a, b) {
    $b78e106b2dfe8e1a$var$Cf = $b78e106b2dfe8e1a$var$dd;
    a = $b78e106b2dfe8e1a$var$Me();
    if ($b78e106b2dfe8e1a$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $b78e106b2dfe8e1a$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $b78e106b2dfe8e1a$var$dd = !1;
    for($b78e106b2dfe8e1a$var$V = b; null !== $b78e106b2dfe8e1a$var$V;)if (b = $b78e106b2dfe8e1a$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $b78e106b2dfe8e1a$var$V = a;
    else for(; null !== $b78e106b2dfe8e1a$var$V;){
        b = $b78e106b2dfe8e1a$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $b78e106b2dfe8e1a$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($b78e106b2dfe8e1a$var$p(163));
            }
        } catch (F) {
            $b78e106b2dfe8e1a$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $b78e106b2dfe8e1a$var$V = a;
            break;
        }
        $b78e106b2dfe8e1a$var$V = b.return;
    }
    n = $b78e106b2dfe8e1a$var$Nj;
    $b78e106b2dfe8e1a$var$Nj = !1;
    return n;
}
function $b78e106b2dfe8e1a$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $b78e106b2dfe8e1a$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $b78e106b2dfe8e1a$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $b78e106b2dfe8e1a$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $b78e106b2dfe8e1a$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $b78e106b2dfe8e1a$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$b78e106b2dfe8e1a$var$Of], delete b[$b78e106b2dfe8e1a$var$Pf], delete b[$b78e106b2dfe8e1a$var$of], delete b[$b78e106b2dfe8e1a$var$Qf], delete b[$b78e106b2dfe8e1a$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $b78e106b2dfe8e1a$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $b78e106b2dfe8e1a$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $b78e106b2dfe8e1a$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $b78e106b2dfe8e1a$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $b78e106b2dfe8e1a$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($b78e106b2dfe8e1a$var$Vj(a, b, c), a = a.sibling; null !== a;)$b78e106b2dfe8e1a$var$Vj(a, b, c), a = a.sibling;
}
function $b78e106b2dfe8e1a$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($b78e106b2dfe8e1a$var$Wj(a, b, c), a = a.sibling; null !== a;)$b78e106b2dfe8e1a$var$Wj(a, b, c), a = a.sibling;
}
var $b78e106b2dfe8e1a$var$X = null, $b78e106b2dfe8e1a$var$Xj = !1;
function $b78e106b2dfe8e1a$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$b78e106b2dfe8e1a$var$Zj(a, b, c), c = c.sibling;
}
function $b78e106b2dfe8e1a$var$Zj(a, b, c) {
    if ($b78e106b2dfe8e1a$var$lc && "function" === typeof $b78e106b2dfe8e1a$var$lc.onCommitFiberUnmount) try {
        $b78e106b2dfe8e1a$var$lc.onCommitFiberUnmount($b78e106b2dfe8e1a$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $b78e106b2dfe8e1a$var$U || $b78e106b2dfe8e1a$var$Lj(c, b);
        case 6:
            var d = $b78e106b2dfe8e1a$var$X, e = $b78e106b2dfe8e1a$var$Xj;
            $b78e106b2dfe8e1a$var$X = null;
            $b78e106b2dfe8e1a$var$Yj(a, b, c);
            $b78e106b2dfe8e1a$var$X = d;
            $b78e106b2dfe8e1a$var$Xj = e;
            null !== $b78e106b2dfe8e1a$var$X && ($b78e106b2dfe8e1a$var$Xj ? (a = $b78e106b2dfe8e1a$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $b78e106b2dfe8e1a$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $b78e106b2dfe8e1a$var$X && ($b78e106b2dfe8e1a$var$Xj ? (a = $b78e106b2dfe8e1a$var$X, c = c.stateNode, 8 === a.nodeType ? $b78e106b2dfe8e1a$var$Kf(a.parentNode, c) : 1 === a.nodeType && $b78e106b2dfe8e1a$var$Kf(a, c), $b78e106b2dfe8e1a$var$bd(a)) : $b78e106b2dfe8e1a$var$Kf($b78e106b2dfe8e1a$var$X, c.stateNode));
            break;
        case 4:
            d = $b78e106b2dfe8e1a$var$X;
            e = $b78e106b2dfe8e1a$var$Xj;
            $b78e106b2dfe8e1a$var$X = c.stateNode.containerInfo;
            $b78e106b2dfe8e1a$var$Xj = !0;
            $b78e106b2dfe8e1a$var$Yj(a, b, c);
            $b78e106b2dfe8e1a$var$X = d;
            $b78e106b2dfe8e1a$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$b78e106b2dfe8e1a$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $b78e106b2dfe8e1a$var$Mj(c, b, g) : 0 !== (f & 4) && $b78e106b2dfe8e1a$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $b78e106b2dfe8e1a$var$Yj(a, b, c);
            break;
        case 1:
            if (!$b78e106b2dfe8e1a$var$U && ($b78e106b2dfe8e1a$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $b78e106b2dfe8e1a$var$W(c, b, h);
            }
            $b78e106b2dfe8e1a$var$Yj(a, b, c);
            break;
        case 21:
            $b78e106b2dfe8e1a$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($b78e106b2dfe8e1a$var$U = (d = $b78e106b2dfe8e1a$var$U) || null !== c.memoizedState, $b78e106b2dfe8e1a$var$Yj(a, b, c), $b78e106b2dfe8e1a$var$U = d) : $b78e106b2dfe8e1a$var$Yj(a, b, c);
            break;
        default:
            $b78e106b2dfe8e1a$var$Yj(a, b, c);
    }
}
function $b78e106b2dfe8e1a$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $b78e106b2dfe8e1a$var$Kj);
        b.forEach(function(b) {
            var d = $b78e106b2dfe8e1a$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $b78e106b2dfe8e1a$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $b78e106b2dfe8e1a$var$X = h.stateNode;
                        $b78e106b2dfe8e1a$var$Xj = !1;
                        break a;
                    case 3:
                        $b78e106b2dfe8e1a$var$X = h.stateNode.containerInfo;
                        $b78e106b2dfe8e1a$var$Xj = !0;
                        break a;
                    case 4:
                        $b78e106b2dfe8e1a$var$X = h.stateNode.containerInfo;
                        $b78e106b2dfe8e1a$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $b78e106b2dfe8e1a$var$X) throw Error($b78e106b2dfe8e1a$var$p(160));
            $b78e106b2dfe8e1a$var$Zj(f, g, e);
            $b78e106b2dfe8e1a$var$X = null;
            $b78e106b2dfe8e1a$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $b78e106b2dfe8e1a$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$b78e106b2dfe8e1a$var$dk(b, a), b = b.sibling;
}
function $b78e106b2dfe8e1a$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $b78e106b2dfe8e1a$var$ck(b, a);
            $b78e106b2dfe8e1a$var$ek(a);
            if (d & 4) {
                try {
                    $b78e106b2dfe8e1a$var$Pj(3, a, a.return), $b78e106b2dfe8e1a$var$Qj(3, a);
                } catch (t) {
                    $b78e106b2dfe8e1a$var$W(a, a.return, t);
                }
                try {
                    $b78e106b2dfe8e1a$var$Pj(5, a, a.return);
                } catch (t) {
                    $b78e106b2dfe8e1a$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $b78e106b2dfe8e1a$var$ck(b, a);
            $b78e106b2dfe8e1a$var$ek(a);
            d & 512 && null !== c && $b78e106b2dfe8e1a$var$Lj(c, c.return);
            break;
        case 5:
            $b78e106b2dfe8e1a$var$ck(b, a);
            $b78e106b2dfe8e1a$var$ek(a);
            d & 512 && null !== c && $b78e106b2dfe8e1a$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $b78e106b2dfe8e1a$var$ob(e, "");
                } catch (t) {
                    $b78e106b2dfe8e1a$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $b78e106b2dfe8e1a$var$ab(e, f);
                    $b78e106b2dfe8e1a$var$vb(h, g);
                    var l = $b78e106b2dfe8e1a$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $b78e106b2dfe8e1a$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $b78e106b2dfe8e1a$var$nb(e, q) : "children" === m ? $b78e106b2dfe8e1a$var$ob(e, q) : $b78e106b2dfe8e1a$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $b78e106b2dfe8e1a$var$bb(e, f);
                            break;
                        case "textarea":
                            $b78e106b2dfe8e1a$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $b78e106b2dfe8e1a$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $b78e106b2dfe8e1a$var$fb(e, !!f.multiple, f.defaultValue, !0) : $b78e106b2dfe8e1a$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$b78e106b2dfe8e1a$var$Pf] = f;
                } catch (t) {
                    $b78e106b2dfe8e1a$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $b78e106b2dfe8e1a$var$ck(b, a);
            $b78e106b2dfe8e1a$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($b78e106b2dfe8e1a$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $b78e106b2dfe8e1a$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $b78e106b2dfe8e1a$var$ck(b, a);
            $b78e106b2dfe8e1a$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $b78e106b2dfe8e1a$var$bd(b.containerInfo);
            } catch (t) {
                $b78e106b2dfe8e1a$var$W(a, a.return, t);
            }
            break;
        case 4:
            $b78e106b2dfe8e1a$var$ck(b, a);
            $b78e106b2dfe8e1a$var$ek(a);
            break;
        case 13:
            $b78e106b2dfe8e1a$var$ck(b, a);
            $b78e106b2dfe8e1a$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($b78e106b2dfe8e1a$var$fk = $b78e106b2dfe8e1a$var$B()));
            d & 4 && $b78e106b2dfe8e1a$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($b78e106b2dfe8e1a$var$U = (l = $b78e106b2dfe8e1a$var$U) || m, $b78e106b2dfe8e1a$var$ck(b, a), $b78e106b2dfe8e1a$var$U = l) : $b78e106b2dfe8e1a$var$ck(b, a);
            $b78e106b2dfe8e1a$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($b78e106b2dfe8e1a$var$V = a, m = a.child; null !== m;){
                    for(q = $b78e106b2dfe8e1a$var$V = m; null !== $b78e106b2dfe8e1a$var$V;){
                        r = $b78e106b2dfe8e1a$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $b78e106b2dfe8e1a$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $b78e106b2dfe8e1a$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $b78e106b2dfe8e1a$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $b78e106b2dfe8e1a$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $b78e106b2dfe8e1a$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $b78e106b2dfe8e1a$var$V = y) : $b78e106b2dfe8e1a$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $b78e106b2dfe8e1a$var$rb("display", g));
                            } catch (t) {
                                $b78e106b2dfe8e1a$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $b78e106b2dfe8e1a$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $b78e106b2dfe8e1a$var$ck(b, a);
            $b78e106b2dfe8e1a$var$ek(a);
            d & 4 && $b78e106b2dfe8e1a$var$ak(a);
            break;
        case 21:
            break;
        default:
            $b78e106b2dfe8e1a$var$ck(b, a), $b78e106b2dfe8e1a$var$ek(a);
    }
}
function $b78e106b2dfe8e1a$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($b78e106b2dfe8e1a$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($b78e106b2dfe8e1a$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($b78e106b2dfe8e1a$var$ob(e, ""), d.flags &= -33);
                    var f = $b78e106b2dfe8e1a$var$Uj(a);
                    $b78e106b2dfe8e1a$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $b78e106b2dfe8e1a$var$Uj(a);
                    $b78e106b2dfe8e1a$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($b78e106b2dfe8e1a$var$p(161));
            }
        } catch (k) {
            $b78e106b2dfe8e1a$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $b78e106b2dfe8e1a$var$hk(a, b, c) {
    $b78e106b2dfe8e1a$var$V = a;
    $b78e106b2dfe8e1a$var$ik(a, b, c);
}
function $b78e106b2dfe8e1a$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $b78e106b2dfe8e1a$var$V;){
        var e = $b78e106b2dfe8e1a$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $b78e106b2dfe8e1a$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $b78e106b2dfe8e1a$var$U;
                h = $b78e106b2dfe8e1a$var$Jj;
                var l = $b78e106b2dfe8e1a$var$U;
                $b78e106b2dfe8e1a$var$Jj = g;
                if (($b78e106b2dfe8e1a$var$U = k) && !l) for($b78e106b2dfe8e1a$var$V = e; null !== $b78e106b2dfe8e1a$var$V;)g = $b78e106b2dfe8e1a$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $b78e106b2dfe8e1a$var$jk(e) : null !== k ? (k.return = g, $b78e106b2dfe8e1a$var$V = k) : $b78e106b2dfe8e1a$var$jk(e);
                for(; null !== f;)$b78e106b2dfe8e1a$var$V = f, $b78e106b2dfe8e1a$var$ik(f, b, c), f = f.sibling;
                $b78e106b2dfe8e1a$var$V = e;
                $b78e106b2dfe8e1a$var$Jj = h;
                $b78e106b2dfe8e1a$var$U = l;
            }
            $b78e106b2dfe8e1a$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $b78e106b2dfe8e1a$var$V = f) : $b78e106b2dfe8e1a$var$kk(a, b, c);
    }
}
function $b78e106b2dfe8e1a$var$kk(a) {
    for(; null !== $b78e106b2dfe8e1a$var$V;){
        var b = $b78e106b2dfe8e1a$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $b78e106b2dfe8e1a$var$U || $b78e106b2dfe8e1a$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$b78e106b2dfe8e1a$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $b78e106b2dfe8e1a$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $b78e106b2dfe8e1a$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $b78e106b2dfe8e1a$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $b78e106b2dfe8e1a$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($b78e106b2dfe8e1a$var$p(163));
                }
                $b78e106b2dfe8e1a$var$U || b.flags & 512 && $b78e106b2dfe8e1a$var$Rj(b);
            } catch (r) {
                $b78e106b2dfe8e1a$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $b78e106b2dfe8e1a$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b78e106b2dfe8e1a$var$V = c;
            break;
        }
        $b78e106b2dfe8e1a$var$V = b.return;
    }
}
function $b78e106b2dfe8e1a$var$gk(a) {
    for(; null !== $b78e106b2dfe8e1a$var$V;){
        var b = $b78e106b2dfe8e1a$var$V;
        if (b === a) {
            $b78e106b2dfe8e1a$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b78e106b2dfe8e1a$var$V = c;
            break;
        }
        $b78e106b2dfe8e1a$var$V = b.return;
    }
}
function $b78e106b2dfe8e1a$var$jk(a) {
    for(; null !== $b78e106b2dfe8e1a$var$V;){
        var b = $b78e106b2dfe8e1a$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $b78e106b2dfe8e1a$var$Qj(4, b);
                    } catch (k) {
                        $b78e106b2dfe8e1a$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $b78e106b2dfe8e1a$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $b78e106b2dfe8e1a$var$Rj(b);
                    } catch (k) {
                        $b78e106b2dfe8e1a$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $b78e106b2dfe8e1a$var$Rj(b);
                    } catch (k) {
                        $b78e106b2dfe8e1a$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $b78e106b2dfe8e1a$var$W(b, b.return, k);
        }
        if (b === a) {
            $b78e106b2dfe8e1a$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $b78e106b2dfe8e1a$var$V = h;
            break;
        }
        $b78e106b2dfe8e1a$var$V = b.return;
    }
}
var $b78e106b2dfe8e1a$var$lk = Math.ceil, $b78e106b2dfe8e1a$var$mk = $b78e106b2dfe8e1a$var$ua.ReactCurrentDispatcher, $b78e106b2dfe8e1a$var$nk = $b78e106b2dfe8e1a$var$ua.ReactCurrentOwner, $b78e106b2dfe8e1a$var$ok = $b78e106b2dfe8e1a$var$ua.ReactCurrentBatchConfig, $b78e106b2dfe8e1a$var$K = 0, $b78e106b2dfe8e1a$var$Q = null, $b78e106b2dfe8e1a$var$Y = null, $b78e106b2dfe8e1a$var$Z = 0, $b78e106b2dfe8e1a$var$fj = 0, $b78e106b2dfe8e1a$var$ej = $b78e106b2dfe8e1a$var$Uf(0), $b78e106b2dfe8e1a$var$T = 0, $b78e106b2dfe8e1a$var$pk = null, $b78e106b2dfe8e1a$var$rh = 0, $b78e106b2dfe8e1a$var$qk = 0, $b78e106b2dfe8e1a$var$rk = 0, $b78e106b2dfe8e1a$var$sk = null, $b78e106b2dfe8e1a$var$tk = null, $b78e106b2dfe8e1a$var$fk = 0, $b78e106b2dfe8e1a$var$Gj = Infinity, $b78e106b2dfe8e1a$var$uk = null, $b78e106b2dfe8e1a$var$Oi = !1, $b78e106b2dfe8e1a$var$Pi = null, $b78e106b2dfe8e1a$var$Ri = null, $b78e106b2dfe8e1a$var$vk = !1, $b78e106b2dfe8e1a$var$wk = null, $b78e106b2dfe8e1a$var$xk = 0, $b78e106b2dfe8e1a$var$yk = 0, $b78e106b2dfe8e1a$var$zk = null, $b78e106b2dfe8e1a$var$Ak = -1, $b78e106b2dfe8e1a$var$Bk = 0;
function $b78e106b2dfe8e1a$var$R() {
    return 0 !== ($b78e106b2dfe8e1a$var$K & 6) ? $b78e106b2dfe8e1a$var$B() : -1 !== $b78e106b2dfe8e1a$var$Ak ? $b78e106b2dfe8e1a$var$Ak : $b78e106b2dfe8e1a$var$Ak = $b78e106b2dfe8e1a$var$B();
}
function $b78e106b2dfe8e1a$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($b78e106b2dfe8e1a$var$K & 2) && 0 !== $b78e106b2dfe8e1a$var$Z) return $b78e106b2dfe8e1a$var$Z & -$b78e106b2dfe8e1a$var$Z;
    if (null !== $b78e106b2dfe8e1a$var$Kg.transition) return 0 === $b78e106b2dfe8e1a$var$Bk && ($b78e106b2dfe8e1a$var$Bk = $b78e106b2dfe8e1a$var$yc()), $b78e106b2dfe8e1a$var$Bk;
    a = $b78e106b2dfe8e1a$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $b78e106b2dfe8e1a$var$jd(a.type);
    return a;
}
function $b78e106b2dfe8e1a$var$gi(a, b, c, d) {
    if (50 < $b78e106b2dfe8e1a$var$yk) throw $b78e106b2dfe8e1a$var$yk = 0, $b78e106b2dfe8e1a$var$zk = null, Error($b78e106b2dfe8e1a$var$p(185));
    $b78e106b2dfe8e1a$var$Ac(a, c, d);
    if (0 === ($b78e106b2dfe8e1a$var$K & 2) || a !== $b78e106b2dfe8e1a$var$Q) a === $b78e106b2dfe8e1a$var$Q && (0 === ($b78e106b2dfe8e1a$var$K & 2) && ($b78e106b2dfe8e1a$var$qk |= c), 4 === $b78e106b2dfe8e1a$var$T && $b78e106b2dfe8e1a$var$Ck(a, $b78e106b2dfe8e1a$var$Z)), $b78e106b2dfe8e1a$var$Dk(a, d), 1 === c && 0 === $b78e106b2dfe8e1a$var$K && 0 === (b.mode & 1) && ($b78e106b2dfe8e1a$var$Gj = $b78e106b2dfe8e1a$var$B() + 500, $b78e106b2dfe8e1a$var$fg && $b78e106b2dfe8e1a$var$jg());
}
function $b78e106b2dfe8e1a$var$Dk(a, b) {
    var c = a.callbackNode;
    $b78e106b2dfe8e1a$var$wc(a, b);
    var d = $b78e106b2dfe8e1a$var$uc(a, a === $b78e106b2dfe8e1a$var$Q ? $b78e106b2dfe8e1a$var$Z : 0);
    if (0 === d) null !== c && $b78e106b2dfe8e1a$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $b78e106b2dfe8e1a$var$bc(c);
        if (1 === b) 0 === a.tag ? $b78e106b2dfe8e1a$var$ig($b78e106b2dfe8e1a$var$Ek.bind(null, a)) : $b78e106b2dfe8e1a$var$hg($b78e106b2dfe8e1a$var$Ek.bind(null, a)), $b78e106b2dfe8e1a$var$Jf(function() {
            0 === ($b78e106b2dfe8e1a$var$K & 6) && $b78e106b2dfe8e1a$var$jg();
        }), c = null;
        else {
            switch($b78e106b2dfe8e1a$var$Dc(d)){
                case 1:
                    c = $b78e106b2dfe8e1a$var$fc;
                    break;
                case 4:
                    c = $b78e106b2dfe8e1a$var$gc;
                    break;
                case 16:
                    c = $b78e106b2dfe8e1a$var$hc;
                    break;
                case 536870912:
                    c = $b78e106b2dfe8e1a$var$jc;
                    break;
                default:
                    c = $b78e106b2dfe8e1a$var$hc;
            }
            c = $b78e106b2dfe8e1a$var$Fk(c, $b78e106b2dfe8e1a$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $b78e106b2dfe8e1a$var$Gk(a, b) {
    $b78e106b2dfe8e1a$var$Ak = -1;
    $b78e106b2dfe8e1a$var$Bk = 0;
    if (0 !== ($b78e106b2dfe8e1a$var$K & 6)) throw Error($b78e106b2dfe8e1a$var$p(327));
    var c = a.callbackNode;
    if ($b78e106b2dfe8e1a$var$Hk() && a.callbackNode !== c) return null;
    var d = $b78e106b2dfe8e1a$var$uc(a, a === $b78e106b2dfe8e1a$var$Q ? $b78e106b2dfe8e1a$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $b78e106b2dfe8e1a$var$Ik(a, d);
    else {
        b = d;
        var e = $b78e106b2dfe8e1a$var$K;
        $b78e106b2dfe8e1a$var$K |= 2;
        var f = $b78e106b2dfe8e1a$var$Jk();
        if ($b78e106b2dfe8e1a$var$Q !== a || $b78e106b2dfe8e1a$var$Z !== b) $b78e106b2dfe8e1a$var$uk = null, $b78e106b2dfe8e1a$var$Gj = $b78e106b2dfe8e1a$var$B() + 500, $b78e106b2dfe8e1a$var$Kk(a, b);
        for(;;)try {
            $b78e106b2dfe8e1a$var$Lk();
            break;
        } catch (h) {
            $b78e106b2dfe8e1a$var$Mk(a, h);
        }
        $b78e106b2dfe8e1a$var$$g();
        $b78e106b2dfe8e1a$var$mk.current = f;
        $b78e106b2dfe8e1a$var$K = e;
        null !== $b78e106b2dfe8e1a$var$Y ? b = 0 : ($b78e106b2dfe8e1a$var$Q = null, $b78e106b2dfe8e1a$var$Z = 0, b = $b78e106b2dfe8e1a$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $b78e106b2dfe8e1a$var$xc(a), 0 !== e && (d = e, b = $b78e106b2dfe8e1a$var$Nk(a, e)));
        if (1 === b) throw c = $b78e106b2dfe8e1a$var$pk, $b78e106b2dfe8e1a$var$Kk(a, 0), $b78e106b2dfe8e1a$var$Ck(a, d), $b78e106b2dfe8e1a$var$Dk(a, $b78e106b2dfe8e1a$var$B()), c;
        if (6 === b) $b78e106b2dfe8e1a$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$b78e106b2dfe8e1a$var$Ok(e) && (b = $b78e106b2dfe8e1a$var$Ik(a, d), 2 === b && (f = $b78e106b2dfe8e1a$var$xc(a), 0 !== f && (d = f, b = $b78e106b2dfe8e1a$var$Nk(a, f))), 1 === b)) throw c = $b78e106b2dfe8e1a$var$pk, $b78e106b2dfe8e1a$var$Kk(a, 0), $b78e106b2dfe8e1a$var$Ck(a, d), $b78e106b2dfe8e1a$var$Dk(a, $b78e106b2dfe8e1a$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($b78e106b2dfe8e1a$var$p(345));
                case 2:
                    $b78e106b2dfe8e1a$var$Pk(a, $b78e106b2dfe8e1a$var$tk, $b78e106b2dfe8e1a$var$uk);
                    break;
                case 3:
                    $b78e106b2dfe8e1a$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $b78e106b2dfe8e1a$var$fk + 500 - $b78e106b2dfe8e1a$var$B(), 10 < b)) {
                        if (0 !== $b78e106b2dfe8e1a$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $b78e106b2dfe8e1a$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $b78e106b2dfe8e1a$var$Ff($b78e106b2dfe8e1a$var$Pk.bind(null, a, $b78e106b2dfe8e1a$var$tk, $b78e106b2dfe8e1a$var$uk), b);
                        break;
                    }
                    $b78e106b2dfe8e1a$var$Pk(a, $b78e106b2dfe8e1a$var$tk, $b78e106b2dfe8e1a$var$uk);
                    break;
                case 4:
                    $b78e106b2dfe8e1a$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $b78e106b2dfe8e1a$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $b78e106b2dfe8e1a$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $b78e106b2dfe8e1a$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $b78e106b2dfe8e1a$var$Ff($b78e106b2dfe8e1a$var$Pk.bind(null, a, $b78e106b2dfe8e1a$var$tk, $b78e106b2dfe8e1a$var$uk), d);
                        break;
                    }
                    $b78e106b2dfe8e1a$var$Pk(a, $b78e106b2dfe8e1a$var$tk, $b78e106b2dfe8e1a$var$uk);
                    break;
                case 5:
                    $b78e106b2dfe8e1a$var$Pk(a, $b78e106b2dfe8e1a$var$tk, $b78e106b2dfe8e1a$var$uk);
                    break;
                default:
                    throw Error($b78e106b2dfe8e1a$var$p(329));
            }
        }
    }
    $b78e106b2dfe8e1a$var$Dk(a, $b78e106b2dfe8e1a$var$B());
    return a.callbackNode === c ? $b78e106b2dfe8e1a$var$Gk.bind(null, a) : null;
}
function $b78e106b2dfe8e1a$var$Nk(a, b) {
    var c = $b78e106b2dfe8e1a$var$sk;
    a.current.memoizedState.isDehydrated && ($b78e106b2dfe8e1a$var$Kk(a, b).flags |= 256);
    a = $b78e106b2dfe8e1a$var$Ik(a, b);
    2 !== a && (b = $b78e106b2dfe8e1a$var$tk, $b78e106b2dfe8e1a$var$tk = c, null !== b && $b78e106b2dfe8e1a$var$Fj(b));
    return a;
}
function $b78e106b2dfe8e1a$var$Fj(a) {
    null === $b78e106b2dfe8e1a$var$tk ? $b78e106b2dfe8e1a$var$tk = a : $b78e106b2dfe8e1a$var$tk.push.apply($b78e106b2dfe8e1a$var$tk, a);
}
function $b78e106b2dfe8e1a$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$b78e106b2dfe8e1a$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $b78e106b2dfe8e1a$var$Ck(a, b) {
    b &= ~$b78e106b2dfe8e1a$var$rk;
    b &= ~$b78e106b2dfe8e1a$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $b78e106b2dfe8e1a$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $b78e106b2dfe8e1a$var$Ek(a) {
    if (0 !== ($b78e106b2dfe8e1a$var$K & 6)) throw Error($b78e106b2dfe8e1a$var$p(327));
    $b78e106b2dfe8e1a$var$Hk();
    var b = $b78e106b2dfe8e1a$var$uc(a, 0);
    if (0 === (b & 1)) return $b78e106b2dfe8e1a$var$Dk(a, $b78e106b2dfe8e1a$var$B()), null;
    var c = $b78e106b2dfe8e1a$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $b78e106b2dfe8e1a$var$xc(a);
        0 !== d && (b = d, c = $b78e106b2dfe8e1a$var$Nk(a, d));
    }
    if (1 === c) throw c = $b78e106b2dfe8e1a$var$pk, $b78e106b2dfe8e1a$var$Kk(a, 0), $b78e106b2dfe8e1a$var$Ck(a, b), $b78e106b2dfe8e1a$var$Dk(a, $b78e106b2dfe8e1a$var$B()), c;
    if (6 === c) throw Error($b78e106b2dfe8e1a$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $b78e106b2dfe8e1a$var$Pk(a, $b78e106b2dfe8e1a$var$tk, $b78e106b2dfe8e1a$var$uk);
    $b78e106b2dfe8e1a$var$Dk(a, $b78e106b2dfe8e1a$var$B());
    return null;
}
function $b78e106b2dfe8e1a$var$Qk(a, b) {
    var c = $b78e106b2dfe8e1a$var$K;
    $b78e106b2dfe8e1a$var$K |= 1;
    try {
        return a(b);
    } finally{
        $b78e106b2dfe8e1a$var$K = c, 0 === $b78e106b2dfe8e1a$var$K && ($b78e106b2dfe8e1a$var$Gj = $b78e106b2dfe8e1a$var$B() + 500, $b78e106b2dfe8e1a$var$fg && $b78e106b2dfe8e1a$var$jg());
    }
}
function $b78e106b2dfe8e1a$var$Rk(a) {
    null !== $b78e106b2dfe8e1a$var$wk && 0 === $b78e106b2dfe8e1a$var$wk.tag && 0 === ($b78e106b2dfe8e1a$var$K & 6) && $b78e106b2dfe8e1a$var$Hk();
    var b = $b78e106b2dfe8e1a$var$K;
    $b78e106b2dfe8e1a$var$K |= 1;
    var c = $b78e106b2dfe8e1a$var$ok.transition, d = $b78e106b2dfe8e1a$var$C;
    try {
        if ($b78e106b2dfe8e1a$var$ok.transition = null, $b78e106b2dfe8e1a$var$C = 1, a) return a();
    } finally{
        $b78e106b2dfe8e1a$var$C = d, $b78e106b2dfe8e1a$var$ok.transition = c, $b78e106b2dfe8e1a$var$K = b, 0 === ($b78e106b2dfe8e1a$var$K & 6) && $b78e106b2dfe8e1a$var$jg();
    }
}
function $b78e106b2dfe8e1a$var$Hj() {
    $b78e106b2dfe8e1a$var$fj = $b78e106b2dfe8e1a$var$ej.current;
    $b78e106b2dfe8e1a$var$E($b78e106b2dfe8e1a$var$ej);
}
function $b78e106b2dfe8e1a$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $b78e106b2dfe8e1a$var$Gf(c));
    if (null !== $b78e106b2dfe8e1a$var$Y) for(c = $b78e106b2dfe8e1a$var$Y.return; null !== c;){
        var d = c;
        $b78e106b2dfe8e1a$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $b78e106b2dfe8e1a$var$$f();
                break;
            case 3:
                $b78e106b2dfe8e1a$var$zh();
                $b78e106b2dfe8e1a$var$E($b78e106b2dfe8e1a$var$Wf);
                $b78e106b2dfe8e1a$var$E($b78e106b2dfe8e1a$var$H);
                $b78e106b2dfe8e1a$var$Eh();
                break;
            case 5:
                $b78e106b2dfe8e1a$var$Bh(d);
                break;
            case 4:
                $b78e106b2dfe8e1a$var$zh();
                break;
            case 13:
                $b78e106b2dfe8e1a$var$E($b78e106b2dfe8e1a$var$L);
                break;
            case 19:
                $b78e106b2dfe8e1a$var$E($b78e106b2dfe8e1a$var$L);
                break;
            case 10:
                $b78e106b2dfe8e1a$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $b78e106b2dfe8e1a$var$Hj();
        }
        c = c.return;
    }
    $b78e106b2dfe8e1a$var$Q = a;
    $b78e106b2dfe8e1a$var$Y = a = $b78e106b2dfe8e1a$var$Pg(a.current, null);
    $b78e106b2dfe8e1a$var$Z = $b78e106b2dfe8e1a$var$fj = b;
    $b78e106b2dfe8e1a$var$T = 0;
    $b78e106b2dfe8e1a$var$pk = null;
    $b78e106b2dfe8e1a$var$rk = $b78e106b2dfe8e1a$var$qk = $b78e106b2dfe8e1a$var$rh = 0;
    $b78e106b2dfe8e1a$var$tk = $b78e106b2dfe8e1a$var$sk = null;
    if (null !== $b78e106b2dfe8e1a$var$fh) {
        for(b = 0; b < $b78e106b2dfe8e1a$var$fh.length; b++)if (c = $b78e106b2dfe8e1a$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $b78e106b2dfe8e1a$var$fh = null;
    }
    return a;
}
function $b78e106b2dfe8e1a$var$Mk(a, b) {
    do {
        var c = $b78e106b2dfe8e1a$var$Y;
        try {
            $b78e106b2dfe8e1a$var$$g();
            $b78e106b2dfe8e1a$var$Fh.current = $b78e106b2dfe8e1a$var$Rh;
            if ($b78e106b2dfe8e1a$var$Ih) {
                for(var d = $b78e106b2dfe8e1a$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $b78e106b2dfe8e1a$var$Ih = !1;
            }
            $b78e106b2dfe8e1a$var$Hh = 0;
            $b78e106b2dfe8e1a$var$O = $b78e106b2dfe8e1a$var$N = $b78e106b2dfe8e1a$var$M = null;
            $b78e106b2dfe8e1a$var$Jh = !1;
            $b78e106b2dfe8e1a$var$Kh = 0;
            $b78e106b2dfe8e1a$var$nk.current = null;
            if (null === c || null === c.return) {
                $b78e106b2dfe8e1a$var$T = 1;
                $b78e106b2dfe8e1a$var$pk = b;
                $b78e106b2dfe8e1a$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $b78e106b2dfe8e1a$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $b78e106b2dfe8e1a$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $b78e106b2dfe8e1a$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $b78e106b2dfe8e1a$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $b78e106b2dfe8e1a$var$Si(f, l, b);
                            $b78e106b2dfe8e1a$var$tj();
                            break a;
                        }
                        k = Error($b78e106b2dfe8e1a$var$p(426));
                    }
                } else if ($b78e106b2dfe8e1a$var$I && h.mode & 1) {
                    var J = $b78e106b2dfe8e1a$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $b78e106b2dfe8e1a$var$Vi(J, g, h, f, b);
                        $b78e106b2dfe8e1a$var$Jg($b78e106b2dfe8e1a$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $b78e106b2dfe8e1a$var$Ji(k, h);
                4 !== $b78e106b2dfe8e1a$var$T && ($b78e106b2dfe8e1a$var$T = 2);
                null === $b78e106b2dfe8e1a$var$sk ? $b78e106b2dfe8e1a$var$sk = [
                    f
                ] : $b78e106b2dfe8e1a$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $b78e106b2dfe8e1a$var$Ni(f, k, b);
                            $b78e106b2dfe8e1a$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $b78e106b2dfe8e1a$var$Ri || !$b78e106b2dfe8e1a$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $b78e106b2dfe8e1a$var$Qi(f, h, b);
                                $b78e106b2dfe8e1a$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $b78e106b2dfe8e1a$var$Sk(c);
        } catch (na) {
            b = na;
            $b78e106b2dfe8e1a$var$Y === c && null !== c && ($b78e106b2dfe8e1a$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $b78e106b2dfe8e1a$var$Jk() {
    var a = $b78e106b2dfe8e1a$var$mk.current;
    $b78e106b2dfe8e1a$var$mk.current = $b78e106b2dfe8e1a$var$Rh;
    return null === a ? $b78e106b2dfe8e1a$var$Rh : a;
}
function $b78e106b2dfe8e1a$var$tj() {
    if (0 === $b78e106b2dfe8e1a$var$T || 3 === $b78e106b2dfe8e1a$var$T || 2 === $b78e106b2dfe8e1a$var$T) $b78e106b2dfe8e1a$var$T = 4;
    null === $b78e106b2dfe8e1a$var$Q || 0 === ($b78e106b2dfe8e1a$var$rh & 268435455) && 0 === ($b78e106b2dfe8e1a$var$qk & 268435455) || $b78e106b2dfe8e1a$var$Ck($b78e106b2dfe8e1a$var$Q, $b78e106b2dfe8e1a$var$Z);
}
function $b78e106b2dfe8e1a$var$Ik(a, b) {
    var c = $b78e106b2dfe8e1a$var$K;
    $b78e106b2dfe8e1a$var$K |= 2;
    var d = $b78e106b2dfe8e1a$var$Jk();
    if ($b78e106b2dfe8e1a$var$Q !== a || $b78e106b2dfe8e1a$var$Z !== b) $b78e106b2dfe8e1a$var$uk = null, $b78e106b2dfe8e1a$var$Kk(a, b);
    for(;;)try {
        $b78e106b2dfe8e1a$var$Tk();
        break;
    } catch (e) {
        $b78e106b2dfe8e1a$var$Mk(a, e);
    }
    $b78e106b2dfe8e1a$var$$g();
    $b78e106b2dfe8e1a$var$K = c;
    $b78e106b2dfe8e1a$var$mk.current = d;
    if (null !== $b78e106b2dfe8e1a$var$Y) throw Error($b78e106b2dfe8e1a$var$p(261));
    $b78e106b2dfe8e1a$var$Q = null;
    $b78e106b2dfe8e1a$var$Z = 0;
    return $b78e106b2dfe8e1a$var$T;
}
function $b78e106b2dfe8e1a$var$Tk() {
    for(; null !== $b78e106b2dfe8e1a$var$Y;)$b78e106b2dfe8e1a$var$Uk($b78e106b2dfe8e1a$var$Y);
}
function $b78e106b2dfe8e1a$var$Lk() {
    for(; null !== $b78e106b2dfe8e1a$var$Y && !$b78e106b2dfe8e1a$var$cc();)$b78e106b2dfe8e1a$var$Uk($b78e106b2dfe8e1a$var$Y);
}
function $b78e106b2dfe8e1a$var$Uk(a) {
    var b = $b78e106b2dfe8e1a$var$Vk(a.alternate, a, $b78e106b2dfe8e1a$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $b78e106b2dfe8e1a$var$Sk(a) : $b78e106b2dfe8e1a$var$Y = b;
    $b78e106b2dfe8e1a$var$nk.current = null;
}
function $b78e106b2dfe8e1a$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $b78e106b2dfe8e1a$var$Ej(c, b, $b78e106b2dfe8e1a$var$fj), null !== c) {
                $b78e106b2dfe8e1a$var$Y = c;
                return;
            }
        } else {
            c = $b78e106b2dfe8e1a$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $b78e106b2dfe8e1a$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $b78e106b2dfe8e1a$var$T = 6;
                $b78e106b2dfe8e1a$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $b78e106b2dfe8e1a$var$Y = b;
            return;
        }
        $b78e106b2dfe8e1a$var$Y = b = a;
    }while (null !== b);
    0 === $b78e106b2dfe8e1a$var$T && ($b78e106b2dfe8e1a$var$T = 5);
}
function $b78e106b2dfe8e1a$var$Pk(a, b, c) {
    var d = $b78e106b2dfe8e1a$var$C, e = $b78e106b2dfe8e1a$var$ok.transition;
    try {
        $b78e106b2dfe8e1a$var$ok.transition = null, $b78e106b2dfe8e1a$var$C = 1, $b78e106b2dfe8e1a$var$Wk(a, b, c, d);
    } finally{
        $b78e106b2dfe8e1a$var$ok.transition = e, $b78e106b2dfe8e1a$var$C = d;
    }
    return null;
}
function $b78e106b2dfe8e1a$var$Wk(a, b, c, d) {
    do $b78e106b2dfe8e1a$var$Hk();
    while (null !== $b78e106b2dfe8e1a$var$wk);
    if (0 !== ($b78e106b2dfe8e1a$var$K & 6)) throw Error($b78e106b2dfe8e1a$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($b78e106b2dfe8e1a$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $b78e106b2dfe8e1a$var$Bc(a, f);
    a === $b78e106b2dfe8e1a$var$Q && ($b78e106b2dfe8e1a$var$Y = $b78e106b2dfe8e1a$var$Q = null, $b78e106b2dfe8e1a$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $b78e106b2dfe8e1a$var$vk || ($b78e106b2dfe8e1a$var$vk = !0, $b78e106b2dfe8e1a$var$Fk($b78e106b2dfe8e1a$var$hc, function() {
        $b78e106b2dfe8e1a$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $b78e106b2dfe8e1a$var$ok.transition;
        $b78e106b2dfe8e1a$var$ok.transition = null;
        var g = $b78e106b2dfe8e1a$var$C;
        $b78e106b2dfe8e1a$var$C = 1;
        var h = $b78e106b2dfe8e1a$var$K;
        $b78e106b2dfe8e1a$var$K |= 4;
        $b78e106b2dfe8e1a$var$nk.current = null;
        $b78e106b2dfe8e1a$var$Oj(a, c);
        $b78e106b2dfe8e1a$var$dk(c, a);
        $b78e106b2dfe8e1a$var$Oe($b78e106b2dfe8e1a$var$Df);
        $b78e106b2dfe8e1a$var$dd = !!$b78e106b2dfe8e1a$var$Cf;
        $b78e106b2dfe8e1a$var$Df = $b78e106b2dfe8e1a$var$Cf = null;
        a.current = c;
        $b78e106b2dfe8e1a$var$hk(c, a, e);
        $b78e106b2dfe8e1a$var$dc();
        $b78e106b2dfe8e1a$var$K = h;
        $b78e106b2dfe8e1a$var$C = g;
        $b78e106b2dfe8e1a$var$ok.transition = f;
    } else a.current = c;
    $b78e106b2dfe8e1a$var$vk && ($b78e106b2dfe8e1a$var$vk = !1, $b78e106b2dfe8e1a$var$wk = a, $b78e106b2dfe8e1a$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($b78e106b2dfe8e1a$var$Ri = null);
    $b78e106b2dfe8e1a$var$mc(c.stateNode, d);
    $b78e106b2dfe8e1a$var$Dk(a, $b78e106b2dfe8e1a$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($b78e106b2dfe8e1a$var$Oi) throw $b78e106b2dfe8e1a$var$Oi = !1, a = $b78e106b2dfe8e1a$var$Pi, $b78e106b2dfe8e1a$var$Pi = null, a;
    0 !== ($b78e106b2dfe8e1a$var$xk & 1) && 0 !== a.tag && $b78e106b2dfe8e1a$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $b78e106b2dfe8e1a$var$zk ? $b78e106b2dfe8e1a$var$yk++ : ($b78e106b2dfe8e1a$var$yk = 0, $b78e106b2dfe8e1a$var$zk = a) : $b78e106b2dfe8e1a$var$yk = 0;
    $b78e106b2dfe8e1a$var$jg();
    return null;
}
function $b78e106b2dfe8e1a$var$Hk() {
    if (null !== $b78e106b2dfe8e1a$var$wk) {
        var a = $b78e106b2dfe8e1a$var$Dc($b78e106b2dfe8e1a$var$xk), b = $b78e106b2dfe8e1a$var$ok.transition, c = $b78e106b2dfe8e1a$var$C;
        try {
            $b78e106b2dfe8e1a$var$ok.transition = null;
            $b78e106b2dfe8e1a$var$C = 16 > a ? 16 : a;
            if (null === $b78e106b2dfe8e1a$var$wk) var d = !1;
            else {
                a = $b78e106b2dfe8e1a$var$wk;
                $b78e106b2dfe8e1a$var$wk = null;
                $b78e106b2dfe8e1a$var$xk = 0;
                if (0 !== ($b78e106b2dfe8e1a$var$K & 6)) throw Error($b78e106b2dfe8e1a$var$p(331));
                var e = $b78e106b2dfe8e1a$var$K;
                $b78e106b2dfe8e1a$var$K |= 4;
                for($b78e106b2dfe8e1a$var$V = a.current; null !== $b78e106b2dfe8e1a$var$V;){
                    var f = $b78e106b2dfe8e1a$var$V, g = f.child;
                    if (0 !== ($b78e106b2dfe8e1a$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($b78e106b2dfe8e1a$var$V = l; null !== $b78e106b2dfe8e1a$var$V;){
                                    var m = $b78e106b2dfe8e1a$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $b78e106b2dfe8e1a$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $b78e106b2dfe8e1a$var$V = q;
                                    else for(; null !== $b78e106b2dfe8e1a$var$V;){
                                        m = $b78e106b2dfe8e1a$var$V;
                                        var r = m.sibling, y = m.return;
                                        $b78e106b2dfe8e1a$var$Sj(m);
                                        if (m === l) {
                                            $b78e106b2dfe8e1a$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $b78e106b2dfe8e1a$var$V = r;
                                            break;
                                        }
                                        $b78e106b2dfe8e1a$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $b78e106b2dfe8e1a$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $b78e106b2dfe8e1a$var$V = g;
                    else b: for(; null !== $b78e106b2dfe8e1a$var$V;){
                        f = $b78e106b2dfe8e1a$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $b78e106b2dfe8e1a$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $b78e106b2dfe8e1a$var$V = x;
                            break b;
                        }
                        $b78e106b2dfe8e1a$var$V = f.return;
                    }
                }
                var w = a.current;
                for($b78e106b2dfe8e1a$var$V = w; null !== $b78e106b2dfe8e1a$var$V;){
                    g = $b78e106b2dfe8e1a$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $b78e106b2dfe8e1a$var$V = u;
                    else b: for(g = w; null !== $b78e106b2dfe8e1a$var$V;){
                        h = $b78e106b2dfe8e1a$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $b78e106b2dfe8e1a$var$Qj(9, h);
                            }
                        } catch (na) {
                            $b78e106b2dfe8e1a$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $b78e106b2dfe8e1a$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $b78e106b2dfe8e1a$var$V = F;
                            break b;
                        }
                        $b78e106b2dfe8e1a$var$V = h.return;
                    }
                }
                $b78e106b2dfe8e1a$var$K = e;
                $b78e106b2dfe8e1a$var$jg();
                if ($b78e106b2dfe8e1a$var$lc && "function" === typeof $b78e106b2dfe8e1a$var$lc.onPostCommitFiberRoot) try {
                    $b78e106b2dfe8e1a$var$lc.onPostCommitFiberRoot($b78e106b2dfe8e1a$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $b78e106b2dfe8e1a$var$C = c, $b78e106b2dfe8e1a$var$ok.transition = b;
        }
    }
    return !1;
}
function $b78e106b2dfe8e1a$var$Xk(a, b, c) {
    b = $b78e106b2dfe8e1a$var$Ji(c, b);
    b = $b78e106b2dfe8e1a$var$Ni(a, b, 1);
    a = $b78e106b2dfe8e1a$var$nh(a, b, 1);
    b = $b78e106b2dfe8e1a$var$R();
    null !== a && ($b78e106b2dfe8e1a$var$Ac(a, 1, b), $b78e106b2dfe8e1a$var$Dk(a, b));
}
function $b78e106b2dfe8e1a$var$W(a, b, c) {
    if (3 === a.tag) $b78e106b2dfe8e1a$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $b78e106b2dfe8e1a$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $b78e106b2dfe8e1a$var$Ri || !$b78e106b2dfe8e1a$var$Ri.has(d))) {
                a = $b78e106b2dfe8e1a$var$Ji(c, a);
                a = $b78e106b2dfe8e1a$var$Qi(b, a, 1);
                b = $b78e106b2dfe8e1a$var$nh(b, a, 1);
                a = $b78e106b2dfe8e1a$var$R();
                null !== b && ($b78e106b2dfe8e1a$var$Ac(b, 1, a), $b78e106b2dfe8e1a$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $b78e106b2dfe8e1a$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $b78e106b2dfe8e1a$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $b78e106b2dfe8e1a$var$Q === a && ($b78e106b2dfe8e1a$var$Z & c) === c && (4 === $b78e106b2dfe8e1a$var$T || 3 === $b78e106b2dfe8e1a$var$T && ($b78e106b2dfe8e1a$var$Z & 130023424) === $b78e106b2dfe8e1a$var$Z && 500 > $b78e106b2dfe8e1a$var$B() - $b78e106b2dfe8e1a$var$fk ? $b78e106b2dfe8e1a$var$Kk(a, 0) : $b78e106b2dfe8e1a$var$rk |= c);
    $b78e106b2dfe8e1a$var$Dk(a, b);
}
function $b78e106b2dfe8e1a$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $b78e106b2dfe8e1a$var$sc, $b78e106b2dfe8e1a$var$sc <<= 1, 0 === ($b78e106b2dfe8e1a$var$sc & 130023424) && ($b78e106b2dfe8e1a$var$sc = 4194304)));
    var c = $b78e106b2dfe8e1a$var$R();
    a = $b78e106b2dfe8e1a$var$ih(a, b);
    null !== a && ($b78e106b2dfe8e1a$var$Ac(a, b, c), $b78e106b2dfe8e1a$var$Dk(a, c));
}
function $b78e106b2dfe8e1a$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $b78e106b2dfe8e1a$var$Yk(a, c);
}
function $b78e106b2dfe8e1a$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($b78e106b2dfe8e1a$var$p(314));
    }
    null !== d && d.delete(b);
    $b78e106b2dfe8e1a$var$Yk(a, c);
}
var $b78e106b2dfe8e1a$var$Vk;
$b78e106b2dfe8e1a$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $b78e106b2dfe8e1a$var$Wf.current) $b78e106b2dfe8e1a$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $b78e106b2dfe8e1a$var$dh = !1, $b78e106b2dfe8e1a$var$yj(a, b, c);
            $b78e106b2dfe8e1a$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $b78e106b2dfe8e1a$var$dh = !1, $b78e106b2dfe8e1a$var$I && 0 !== (b.flags & 1048576) && $b78e106b2dfe8e1a$var$ug(b, $b78e106b2dfe8e1a$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $b78e106b2dfe8e1a$var$ij(a, b);
            a = b.pendingProps;
            var e = $b78e106b2dfe8e1a$var$Yf(b, $b78e106b2dfe8e1a$var$H.current);
            $b78e106b2dfe8e1a$var$ch(b, c);
            e = $b78e106b2dfe8e1a$var$Nh(null, b, d, a, e, c);
            var f = $b78e106b2dfe8e1a$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $b78e106b2dfe8e1a$var$Zf(d) ? (f = !0, $b78e106b2dfe8e1a$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $b78e106b2dfe8e1a$var$kh(b), e.updater = $b78e106b2dfe8e1a$var$Ei, b.stateNode = e, e._reactInternals = b, $b78e106b2dfe8e1a$var$Ii(b, d, a, c), b = $b78e106b2dfe8e1a$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $b78e106b2dfe8e1a$var$I && f && $b78e106b2dfe8e1a$var$vg(b), $b78e106b2dfe8e1a$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $b78e106b2dfe8e1a$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $b78e106b2dfe8e1a$var$Zk(d);
                a = $b78e106b2dfe8e1a$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $b78e106b2dfe8e1a$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $b78e106b2dfe8e1a$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $b78e106b2dfe8e1a$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $b78e106b2dfe8e1a$var$$i(null, b, d, $b78e106b2dfe8e1a$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($b78e106b2dfe8e1a$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b78e106b2dfe8e1a$var$Ci(d, e), $b78e106b2dfe8e1a$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b78e106b2dfe8e1a$var$Ci(d, e), $b78e106b2dfe8e1a$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $b78e106b2dfe8e1a$var$kj(b);
                if (null === a) throw Error($b78e106b2dfe8e1a$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $b78e106b2dfe8e1a$var$lh(a, b);
                $b78e106b2dfe8e1a$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $b78e106b2dfe8e1a$var$Ji(Error($b78e106b2dfe8e1a$var$p(423)), b);
                        b = $b78e106b2dfe8e1a$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $b78e106b2dfe8e1a$var$Ji(Error($b78e106b2dfe8e1a$var$p(424)), b);
                        b = $b78e106b2dfe8e1a$var$lj(a, b, d, c, e);
                        break a;
                    } else for($b78e106b2dfe8e1a$var$yg = $b78e106b2dfe8e1a$var$Lf(b.stateNode.containerInfo.firstChild), $b78e106b2dfe8e1a$var$xg = b, $b78e106b2dfe8e1a$var$I = !0, $b78e106b2dfe8e1a$var$zg = null, c = $b78e106b2dfe8e1a$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $b78e106b2dfe8e1a$var$Ig();
                    if (d === e) {
                        b = $b78e106b2dfe8e1a$var$Zi(a, b, c);
                        break a;
                    }
                    $b78e106b2dfe8e1a$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $b78e106b2dfe8e1a$var$Ah(b), null === a && $b78e106b2dfe8e1a$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $b78e106b2dfe8e1a$var$Ef(d, e) ? g = null : null !== f && $b78e106b2dfe8e1a$var$Ef(d, f) && (b.flags |= 32), $b78e106b2dfe8e1a$var$gj(a, b), $b78e106b2dfe8e1a$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $b78e106b2dfe8e1a$var$Eg(b), null;
        case 13:
            return $b78e106b2dfe8e1a$var$oj(a, b, c);
        case 4:
            return $b78e106b2dfe8e1a$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $b78e106b2dfe8e1a$var$Ug(b, null, d, c) : $b78e106b2dfe8e1a$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b78e106b2dfe8e1a$var$Ci(d, e), $b78e106b2dfe8e1a$var$Yi(a, b, d, e, c);
        case 7:
            return $b78e106b2dfe8e1a$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $b78e106b2dfe8e1a$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $b78e106b2dfe8e1a$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $b78e106b2dfe8e1a$var$G($b78e106b2dfe8e1a$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($b78e106b2dfe8e1a$var$He(f.value, g)) {
                        if (f.children === e.children && !$b78e106b2dfe8e1a$var$Wf.current) {
                            b = $b78e106b2dfe8e1a$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $b78e106b2dfe8e1a$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $b78e106b2dfe8e1a$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($b78e106b2dfe8e1a$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $b78e106b2dfe8e1a$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $b78e106b2dfe8e1a$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $b78e106b2dfe8e1a$var$ch(b, c), e = $b78e106b2dfe8e1a$var$eh(e), d = d(e), b.flags |= 1, $b78e106b2dfe8e1a$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $b78e106b2dfe8e1a$var$Ci(d, b.pendingProps), e = $b78e106b2dfe8e1a$var$Ci(d.type, e), $b78e106b2dfe8e1a$var$$i(a, b, d, e, c);
        case 15:
            return $b78e106b2dfe8e1a$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b78e106b2dfe8e1a$var$Ci(d, e), $b78e106b2dfe8e1a$var$ij(a, b), b.tag = 1, $b78e106b2dfe8e1a$var$Zf(d) ? (a = !0, $b78e106b2dfe8e1a$var$cg(b)) : a = !1, $b78e106b2dfe8e1a$var$ch(b, c), $b78e106b2dfe8e1a$var$Gi(b, d, e), $b78e106b2dfe8e1a$var$Ii(b, d, e, c), $b78e106b2dfe8e1a$var$jj(null, b, d, !0, a, c);
        case 19:
            return $b78e106b2dfe8e1a$var$xj(a, b, c);
        case 22:
            return $b78e106b2dfe8e1a$var$dj(a, b, c);
    }
    throw Error($b78e106b2dfe8e1a$var$p(156, b.tag));
};
function $b78e106b2dfe8e1a$var$Fk(a, b) {
    return $b78e106b2dfe8e1a$var$ac(a, b);
}
function $b78e106b2dfe8e1a$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $b78e106b2dfe8e1a$var$Bg(a, b, c, d) {
    return new $b78e106b2dfe8e1a$var$$k(a, b, c, d);
}
function $b78e106b2dfe8e1a$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $b78e106b2dfe8e1a$var$Zk(a) {
    if ("function" === typeof a) return $b78e106b2dfe8e1a$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $b78e106b2dfe8e1a$var$Da) return 11;
        if (a === $b78e106b2dfe8e1a$var$Ga) return 14;
    }
    return 2;
}
function $b78e106b2dfe8e1a$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $b78e106b2dfe8e1a$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $b78e106b2dfe8e1a$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $b78e106b2dfe8e1a$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $b78e106b2dfe8e1a$var$ya:
            return $b78e106b2dfe8e1a$var$Tg(c.children, e, f, b);
        case $b78e106b2dfe8e1a$var$za:
            g = 8;
            e |= 8;
            break;
        case $b78e106b2dfe8e1a$var$Aa:
            return a = $b78e106b2dfe8e1a$var$Bg(12, c, b, e | 2), a.elementType = $b78e106b2dfe8e1a$var$Aa, a.lanes = f, a;
        case $b78e106b2dfe8e1a$var$Ea:
            return a = $b78e106b2dfe8e1a$var$Bg(13, c, b, e), a.elementType = $b78e106b2dfe8e1a$var$Ea, a.lanes = f, a;
        case $b78e106b2dfe8e1a$var$Fa:
            return a = $b78e106b2dfe8e1a$var$Bg(19, c, b, e), a.elementType = $b78e106b2dfe8e1a$var$Fa, a.lanes = f, a;
        case $b78e106b2dfe8e1a$var$Ia:
            return $b78e106b2dfe8e1a$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $b78e106b2dfe8e1a$var$Ba:
                    g = 10;
                    break a;
                case $b78e106b2dfe8e1a$var$Ca:
                    g = 9;
                    break a;
                case $b78e106b2dfe8e1a$var$Da:
                    g = 11;
                    break a;
                case $b78e106b2dfe8e1a$var$Ga:
                    g = 14;
                    break a;
                case $b78e106b2dfe8e1a$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($b78e106b2dfe8e1a$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $b78e106b2dfe8e1a$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $b78e106b2dfe8e1a$var$Tg(a, b, c, d) {
    a = $b78e106b2dfe8e1a$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $b78e106b2dfe8e1a$var$pj(a, b, c, d) {
    a = $b78e106b2dfe8e1a$var$Bg(22, a, d, b);
    a.elementType = $b78e106b2dfe8e1a$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $b78e106b2dfe8e1a$var$Qg(a, b, c) {
    a = $b78e106b2dfe8e1a$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $b78e106b2dfe8e1a$var$Sg(a, b, c) {
    b = $b78e106b2dfe8e1a$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $b78e106b2dfe8e1a$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $b78e106b2dfe8e1a$var$zc(0);
    this.expirationTimes = $b78e106b2dfe8e1a$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $b78e106b2dfe8e1a$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $b78e106b2dfe8e1a$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $b78e106b2dfe8e1a$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $b78e106b2dfe8e1a$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $b78e106b2dfe8e1a$var$kh(f);
    return a;
}
function $b78e106b2dfe8e1a$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $b78e106b2dfe8e1a$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $b78e106b2dfe8e1a$var$dl(a) {
    if (!a) return $b78e106b2dfe8e1a$var$Vf;
    a = a._reactInternals;
    a: {
        if ($b78e106b2dfe8e1a$var$Vb(a) !== a || 1 !== a.tag) throw Error($b78e106b2dfe8e1a$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($b78e106b2dfe8e1a$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($b78e106b2dfe8e1a$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($b78e106b2dfe8e1a$var$Zf(c)) return $b78e106b2dfe8e1a$var$bg(a, c, b);
    }
    return b;
}
function $b78e106b2dfe8e1a$var$el(a, b, c, d, e, f, g, h, k) {
    a = $b78e106b2dfe8e1a$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $b78e106b2dfe8e1a$var$dl(null);
    c = a.current;
    d = $b78e106b2dfe8e1a$var$R();
    e = $b78e106b2dfe8e1a$var$yi(c);
    f = $b78e106b2dfe8e1a$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $b78e106b2dfe8e1a$var$nh(c, f, e);
    a.current.lanes = e;
    $b78e106b2dfe8e1a$var$Ac(a, e, d);
    $b78e106b2dfe8e1a$var$Dk(a, d);
    return a;
}
function $b78e106b2dfe8e1a$var$fl(a, b, c, d) {
    var e = b.current, f = $b78e106b2dfe8e1a$var$R(), g = $b78e106b2dfe8e1a$var$yi(e);
    c = $b78e106b2dfe8e1a$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $b78e106b2dfe8e1a$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $b78e106b2dfe8e1a$var$nh(e, b, g);
    null !== a && ($b78e106b2dfe8e1a$var$gi(a, e, g, f), $b78e106b2dfe8e1a$var$oh(a, e, g));
    return g;
}
function $b78e106b2dfe8e1a$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $b78e106b2dfe8e1a$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $b78e106b2dfe8e1a$var$il(a, b) {
    $b78e106b2dfe8e1a$var$hl(a, b);
    (a = a.alternate) && $b78e106b2dfe8e1a$var$hl(a, b);
}
function $b78e106b2dfe8e1a$var$jl() {
    return null;
}
var $b78e106b2dfe8e1a$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $b78e106b2dfe8e1a$var$ll(a) {
    this._internalRoot = a;
}
$b78e106b2dfe8e1a$var$ml.prototype.render = $b78e106b2dfe8e1a$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($b78e106b2dfe8e1a$var$p(409));
    $b78e106b2dfe8e1a$var$fl(a, b, null, null);
};
$b78e106b2dfe8e1a$var$ml.prototype.unmount = $b78e106b2dfe8e1a$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $b78e106b2dfe8e1a$var$Rk(function() {
            $b78e106b2dfe8e1a$var$fl(null, a, null, null);
        });
        b[$b78e106b2dfe8e1a$var$uf] = null;
    }
};
function $b78e106b2dfe8e1a$var$ml(a) {
    this._internalRoot = a;
}
$b78e106b2dfe8e1a$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $b78e106b2dfe8e1a$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $b78e106b2dfe8e1a$var$Qc.length && 0 !== b && b < $b78e106b2dfe8e1a$var$Qc[c].priority; c++);
        $b78e106b2dfe8e1a$var$Qc.splice(c, 0, a);
        0 === c && $b78e106b2dfe8e1a$var$Vc(a);
    }
};
function $b78e106b2dfe8e1a$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $b78e106b2dfe8e1a$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $b78e106b2dfe8e1a$var$pl() {}
function $b78e106b2dfe8e1a$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $b78e106b2dfe8e1a$var$gl(g);
                f.call(a);
            };
        }
        var g = $b78e106b2dfe8e1a$var$el(b, d, a, 0, null, !1, !1, "", $b78e106b2dfe8e1a$var$pl);
        a._reactRootContainer = g;
        a[$b78e106b2dfe8e1a$var$uf] = g.current;
        $b78e106b2dfe8e1a$var$sf(8 === a.nodeType ? a.parentNode : a);
        $b78e106b2dfe8e1a$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $b78e106b2dfe8e1a$var$gl(k);
            h.call(a);
        };
    }
    var k = $b78e106b2dfe8e1a$var$bl(a, 0, !1, null, null, !1, !1, "", $b78e106b2dfe8e1a$var$pl);
    a._reactRootContainer = k;
    a[$b78e106b2dfe8e1a$var$uf] = k.current;
    $b78e106b2dfe8e1a$var$sf(8 === a.nodeType ? a.parentNode : a);
    $b78e106b2dfe8e1a$var$Rk(function() {
        $b78e106b2dfe8e1a$var$fl(b, k, c, d);
    });
    return k;
}
function $b78e106b2dfe8e1a$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $b78e106b2dfe8e1a$var$gl(g);
                h.call(a);
            };
        }
        $b78e106b2dfe8e1a$var$fl(b, g, a, e);
    } else g = $b78e106b2dfe8e1a$var$ql(c, b, a, e, d);
    return $b78e106b2dfe8e1a$var$gl(g);
}
$b78e106b2dfe8e1a$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $b78e106b2dfe8e1a$var$tc(b.pendingLanes);
                0 !== c && ($b78e106b2dfe8e1a$var$Cc(b, c | 1), $b78e106b2dfe8e1a$var$Dk(b, $b78e106b2dfe8e1a$var$B()), 0 === ($b78e106b2dfe8e1a$var$K & 6) && ($b78e106b2dfe8e1a$var$Gj = $b78e106b2dfe8e1a$var$B() + 500, $b78e106b2dfe8e1a$var$jg()));
            }
            break;
        case 13:
            $b78e106b2dfe8e1a$var$Rk(function() {
                var b = $b78e106b2dfe8e1a$var$ih(a, 1);
                if (null !== b) {
                    var c = $b78e106b2dfe8e1a$var$R();
                    $b78e106b2dfe8e1a$var$gi(b, a, 1, c);
                }
            }), $b78e106b2dfe8e1a$var$il(a, 1);
    }
};
$b78e106b2dfe8e1a$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $b78e106b2dfe8e1a$var$ih(a, 134217728);
        if (null !== b) {
            var c = $b78e106b2dfe8e1a$var$R();
            $b78e106b2dfe8e1a$var$gi(b, a, 134217728, c);
        }
        $b78e106b2dfe8e1a$var$il(a, 134217728);
    }
};
$b78e106b2dfe8e1a$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $b78e106b2dfe8e1a$var$yi(a), c = $b78e106b2dfe8e1a$var$ih(a, b);
        if (null !== c) {
            var d = $b78e106b2dfe8e1a$var$R();
            $b78e106b2dfe8e1a$var$gi(c, a, b, d);
        }
        $b78e106b2dfe8e1a$var$il(a, b);
    }
};
$b78e106b2dfe8e1a$var$Hc = function() {
    return $b78e106b2dfe8e1a$var$C;
};
$b78e106b2dfe8e1a$var$Ic = function(a, b) {
    var c = $b78e106b2dfe8e1a$var$C;
    try {
        return $b78e106b2dfe8e1a$var$C = a, b();
    } finally{
        $b78e106b2dfe8e1a$var$C = c;
    }
};
$b78e106b2dfe8e1a$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $b78e106b2dfe8e1a$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $b78e106b2dfe8e1a$var$Db(d);
                        if (!e) throw Error($b78e106b2dfe8e1a$var$p(90));
                        $b78e106b2dfe8e1a$var$Wa(d);
                        $b78e106b2dfe8e1a$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $b78e106b2dfe8e1a$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $b78e106b2dfe8e1a$var$fb(a, !!c.multiple, b, !1);
    }
};
$b78e106b2dfe8e1a$var$Gb = $b78e106b2dfe8e1a$var$Qk;
$b78e106b2dfe8e1a$var$Hb = $b78e106b2dfe8e1a$var$Rk;
var $b78e106b2dfe8e1a$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $b78e106b2dfe8e1a$var$Cb,
        $b78e106b2dfe8e1a$var$ue,
        $b78e106b2dfe8e1a$var$Db,
        $b78e106b2dfe8e1a$var$Eb,
        $b78e106b2dfe8e1a$var$Fb,
        $b78e106b2dfe8e1a$var$Qk
    ]
}, $b78e106b2dfe8e1a$var$tl = {
    findFiberByHostInstance: $b78e106b2dfe8e1a$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $b78e106b2dfe8e1a$var$ul = {
    bundleType: $b78e106b2dfe8e1a$var$tl.bundleType,
    version: $b78e106b2dfe8e1a$var$tl.version,
    rendererPackageName: $b78e106b2dfe8e1a$var$tl.rendererPackageName,
    rendererConfig: $b78e106b2dfe8e1a$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $b78e106b2dfe8e1a$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $b78e106b2dfe8e1a$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $b78e106b2dfe8e1a$var$tl.findFiberByHostInstance || $b78e106b2dfe8e1a$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $b78e106b2dfe8e1a$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$b78e106b2dfe8e1a$var$vl.isDisabled && $b78e106b2dfe8e1a$var$vl.supportsFiber) try {
        $b78e106b2dfe8e1a$var$kc = $b78e106b2dfe8e1a$var$vl.inject($b78e106b2dfe8e1a$var$ul), $b78e106b2dfe8e1a$var$lc = $b78e106b2dfe8e1a$var$vl;
    } catch (a) {}
}
$b78e106b2dfe8e1a$export$ae55be85d98224ed = $b78e106b2dfe8e1a$var$sl;
$b78e106b2dfe8e1a$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$b78e106b2dfe8e1a$var$nl(b)) throw Error($b78e106b2dfe8e1a$var$p(200));
    return $b78e106b2dfe8e1a$var$cl(a, b, null, c);
};
$b78e106b2dfe8e1a$export$882461b6382ed46c = function(a, b) {
    if (!$b78e106b2dfe8e1a$var$nl(a)) throw Error($b78e106b2dfe8e1a$var$p(299));
    var c = !1, d = "", e = $b78e106b2dfe8e1a$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $b78e106b2dfe8e1a$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$b78e106b2dfe8e1a$var$uf] = b.current;
    $b78e106b2dfe8e1a$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $b78e106b2dfe8e1a$var$ll(b);
};
$b78e106b2dfe8e1a$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($b78e106b2dfe8e1a$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($b78e106b2dfe8e1a$var$p(268, a));
    }
    a = $b78e106b2dfe8e1a$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$b78e106b2dfe8e1a$export$cd75ccfd720a3cd4 = function(a) {
    return $b78e106b2dfe8e1a$var$Rk(a);
};
$b78e106b2dfe8e1a$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$b78e106b2dfe8e1a$var$ol(b)) throw Error($b78e106b2dfe8e1a$var$p(200));
    return $b78e106b2dfe8e1a$var$rl(null, a, b, !0, c);
};
$b78e106b2dfe8e1a$export$757ceba2d55c277e = function(a, b, c) {
    if (!$b78e106b2dfe8e1a$var$nl(a)) throw Error($b78e106b2dfe8e1a$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $b78e106b2dfe8e1a$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $b78e106b2dfe8e1a$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$b78e106b2dfe8e1a$var$uf] = b.current;
    $b78e106b2dfe8e1a$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $b78e106b2dfe8e1a$var$ml(b);
};
$b78e106b2dfe8e1a$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$b78e106b2dfe8e1a$var$ol(b)) throw Error($b78e106b2dfe8e1a$var$p(200));
    return $b78e106b2dfe8e1a$var$rl(null, a, b, !1, c);
};
$b78e106b2dfe8e1a$export$502457920280e6be = function(a) {
    if (!$b78e106b2dfe8e1a$var$ol(a)) throw Error($b78e106b2dfe8e1a$var$p(40));
    return a._reactRootContainer ? ($b78e106b2dfe8e1a$var$Rk(function() {
        $b78e106b2dfe8e1a$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$b78e106b2dfe8e1a$var$uf] = null;
        });
    }), !0) : !1;
};
$b78e106b2dfe8e1a$export$c78a37762a8d58e1 = $b78e106b2dfe8e1a$var$Qk;
$b78e106b2dfe8e1a$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$b78e106b2dfe8e1a$var$ol(c)) throw Error($b78e106b2dfe8e1a$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($b78e106b2dfe8e1a$var$p(38));
    return $b78e106b2dfe8e1a$var$rl(a, b, c, !1, d);
};
$b78e106b2dfe8e1a$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("2plYB", function(module, exports) {
"use strict";

module.exports = (parcelRequire("kvE8p"));

});
parcelRegister("kvE8p", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $eee5d5cd5cf59913$export$c4744153514ff05d; }, function (v) { return $eee5d5cd5cf59913$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $eee5d5cd5cf59913$export$3e506c1ccc9cc1a7; }, function (v) { return $eee5d5cd5cf59913$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $eee5d5cd5cf59913$export$e26fe2ed2fa76875; }, function (v) { return $eee5d5cd5cf59913$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $eee5d5cd5cf59913$export$502329bbf4b505b1; }, function (v) { return $eee5d5cd5cf59913$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $eee5d5cd5cf59913$export$6e3807111c4874c4; }, function (v) { return $eee5d5cd5cf59913$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $eee5d5cd5cf59913$export$c27134553091fb3a; }, function (v) { return $eee5d5cd5cf59913$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $eee5d5cd5cf59913$export$33ee1acdc04fd2a2; }, function (v) { return $eee5d5cd5cf59913$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $eee5d5cd5cf59913$export$b00a404bbd5edef2; }, function (v) { return $eee5d5cd5cf59913$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $eee5d5cd5cf59913$export$8352ce38b91d0c62; }, function (v) { return $eee5d5cd5cf59913$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $eee5d5cd5cf59913$export$d66a1c1c77bd778b; }, function (v) { return $eee5d5cd5cf59913$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $eee5d5cd5cf59913$export$d3dfb8e4810cb555; }, function (v) { return $eee5d5cd5cf59913$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $eee5d5cd5cf59913$export$839f9183b0465a69; }, function (v) { return $eee5d5cd5cf59913$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $eee5d5cd5cf59913$export$72fdf0e06517287b; }, function (v) { return $eee5d5cd5cf59913$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $eee5d5cd5cf59913$export$4b844e58a3e414b4; }, function (v) { return $eee5d5cd5cf59913$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $eee5d5cd5cf59913$export$816d2913ae6b83b1; }, function (v) { return $eee5d5cd5cf59913$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $eee5d5cd5cf59913$export$61bcfe829111a1d0; }, function (v) { return $eee5d5cd5cf59913$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $eee5d5cd5cf59913$export$7ee8c9beb337bc3f; }, function (v) { return $eee5d5cd5cf59913$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $eee5d5cd5cf59913$export$b5836b71941fa3ed; }, function (v) { return $eee5d5cd5cf59913$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $eee5d5cd5cf59913$export$cf845f2c119da08a; }, function (v) { return $eee5d5cd5cf59913$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $eee5d5cd5cf59913$export$c4744153514ff05d;
var $eee5d5cd5cf59913$export$3e506c1ccc9cc1a7;
var $eee5d5cd5cf59913$export$e26fe2ed2fa76875;
var $eee5d5cd5cf59913$export$502329bbf4b505b1;
var $eee5d5cd5cf59913$export$6e3807111c4874c4;
var $eee5d5cd5cf59913$export$c27134553091fb3a;
var $eee5d5cd5cf59913$export$33ee1acdc04fd2a2;
var $eee5d5cd5cf59913$export$b00a404bbd5edef2;
var $eee5d5cd5cf59913$export$8352ce38b91d0c62;
var $eee5d5cd5cf59913$export$d66a1c1c77bd778b;
var $eee5d5cd5cf59913$export$d3dfb8e4810cb555;
var $eee5d5cd5cf59913$export$839f9183b0465a69;
var $eee5d5cd5cf59913$export$72fdf0e06517287b;
var $eee5d5cd5cf59913$export$4b844e58a3e414b4;
var $eee5d5cd5cf59913$export$816d2913ae6b83b1;
var $eee5d5cd5cf59913$export$61bcfe829111a1d0;
var $eee5d5cd5cf59913$export$7ee8c9beb337bc3f;
var $eee5d5cd5cf59913$export$b5836b71941fa3ed;
var $eee5d5cd5cf59913$export$cf845f2c119da08a;
"use strict";
function $eee5d5cd5cf59913$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $eee5d5cd5cf59913$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $eee5d5cd5cf59913$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $eee5d5cd5cf59913$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $eee5d5cd5cf59913$var$g(C, c)) n < e && 0 > $eee5d5cd5cf59913$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $eee5d5cd5cf59913$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $eee5d5cd5cf59913$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $eee5d5cd5cf59913$var$l = performance;
    $eee5d5cd5cf59913$export$c4744153514ff05d = function() {
        return $eee5d5cd5cf59913$var$l.now();
    };
} else {
    var $eee5d5cd5cf59913$var$p = Date, $eee5d5cd5cf59913$var$q = $eee5d5cd5cf59913$var$p.now();
    $eee5d5cd5cf59913$export$c4744153514ff05d = function() {
        return $eee5d5cd5cf59913$var$p.now() - $eee5d5cd5cf59913$var$q;
    };
}
var $eee5d5cd5cf59913$var$r = [], $eee5d5cd5cf59913$var$t = [], $eee5d5cd5cf59913$var$u = 1, $eee5d5cd5cf59913$var$v = null, $eee5d5cd5cf59913$var$y = 3, $eee5d5cd5cf59913$var$z = !1, $eee5d5cd5cf59913$var$A = !1, $eee5d5cd5cf59913$var$B = !1, $eee5d5cd5cf59913$var$D = "function" === typeof setTimeout ? setTimeout : null, $eee5d5cd5cf59913$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $eee5d5cd5cf59913$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $eee5d5cd5cf59913$var$G(a) {
    for(var b = $eee5d5cd5cf59913$var$h($eee5d5cd5cf59913$var$t); null !== b;){
        if (null === b.callback) $eee5d5cd5cf59913$var$k($eee5d5cd5cf59913$var$t);
        else if (b.startTime <= a) $eee5d5cd5cf59913$var$k($eee5d5cd5cf59913$var$t), b.sortIndex = b.expirationTime, $eee5d5cd5cf59913$var$f($eee5d5cd5cf59913$var$r, b);
        else break;
        b = $eee5d5cd5cf59913$var$h($eee5d5cd5cf59913$var$t);
    }
}
function $eee5d5cd5cf59913$var$H(a) {
    $eee5d5cd5cf59913$var$B = !1;
    $eee5d5cd5cf59913$var$G(a);
    if (!$eee5d5cd5cf59913$var$A) {
        if (null !== $eee5d5cd5cf59913$var$h($eee5d5cd5cf59913$var$r)) $eee5d5cd5cf59913$var$A = !0, $eee5d5cd5cf59913$var$I($eee5d5cd5cf59913$var$J);
        else {
            var b = $eee5d5cd5cf59913$var$h($eee5d5cd5cf59913$var$t);
            null !== b && $eee5d5cd5cf59913$var$K($eee5d5cd5cf59913$var$H, b.startTime - a);
        }
    }
}
function $eee5d5cd5cf59913$var$J(a, b) {
    $eee5d5cd5cf59913$var$A = !1;
    $eee5d5cd5cf59913$var$B && ($eee5d5cd5cf59913$var$B = !1, $eee5d5cd5cf59913$var$E($eee5d5cd5cf59913$var$L), $eee5d5cd5cf59913$var$L = -1);
    $eee5d5cd5cf59913$var$z = !0;
    var c = $eee5d5cd5cf59913$var$y;
    try {
        $eee5d5cd5cf59913$var$G(b);
        for($eee5d5cd5cf59913$var$v = $eee5d5cd5cf59913$var$h($eee5d5cd5cf59913$var$r); null !== $eee5d5cd5cf59913$var$v && (!($eee5d5cd5cf59913$var$v.expirationTime > b) || a && !$eee5d5cd5cf59913$var$M());){
            var d = $eee5d5cd5cf59913$var$v.callback;
            if ("function" === typeof d) {
                $eee5d5cd5cf59913$var$v.callback = null;
                $eee5d5cd5cf59913$var$y = $eee5d5cd5cf59913$var$v.priorityLevel;
                var e = d($eee5d5cd5cf59913$var$v.expirationTime <= b);
                b = $eee5d5cd5cf59913$export$c4744153514ff05d();
                "function" === typeof e ? $eee5d5cd5cf59913$var$v.callback = e : $eee5d5cd5cf59913$var$v === $eee5d5cd5cf59913$var$h($eee5d5cd5cf59913$var$r) && $eee5d5cd5cf59913$var$k($eee5d5cd5cf59913$var$r);
                $eee5d5cd5cf59913$var$G(b);
            } else $eee5d5cd5cf59913$var$k($eee5d5cd5cf59913$var$r);
            $eee5d5cd5cf59913$var$v = $eee5d5cd5cf59913$var$h($eee5d5cd5cf59913$var$r);
        }
        if (null !== $eee5d5cd5cf59913$var$v) var w = !0;
        else {
            var m = $eee5d5cd5cf59913$var$h($eee5d5cd5cf59913$var$t);
            null !== m && $eee5d5cd5cf59913$var$K($eee5d5cd5cf59913$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $eee5d5cd5cf59913$var$v = null, $eee5d5cd5cf59913$var$y = c, $eee5d5cd5cf59913$var$z = !1;
    }
}
var $eee5d5cd5cf59913$var$N = !1, $eee5d5cd5cf59913$var$O = null, $eee5d5cd5cf59913$var$L = -1, $eee5d5cd5cf59913$var$P = 5, $eee5d5cd5cf59913$var$Q = -1;
function $eee5d5cd5cf59913$var$M() {
    return $eee5d5cd5cf59913$export$c4744153514ff05d() - $eee5d5cd5cf59913$var$Q < $eee5d5cd5cf59913$var$P ? !1 : !0;
}
function $eee5d5cd5cf59913$var$R() {
    if (null !== $eee5d5cd5cf59913$var$O) {
        var a = $eee5d5cd5cf59913$export$c4744153514ff05d();
        $eee5d5cd5cf59913$var$Q = a;
        var b = !0;
        try {
            b = $eee5d5cd5cf59913$var$O(!0, a);
        } finally{
            b ? $eee5d5cd5cf59913$var$S() : ($eee5d5cd5cf59913$var$N = !1, $eee5d5cd5cf59913$var$O = null);
        }
    } else $eee5d5cd5cf59913$var$N = !1;
}
var $eee5d5cd5cf59913$var$S;
if ("function" === typeof $eee5d5cd5cf59913$var$F) $eee5d5cd5cf59913$var$S = function() {
    $eee5d5cd5cf59913$var$F($eee5d5cd5cf59913$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $eee5d5cd5cf59913$var$T = new MessageChannel, $eee5d5cd5cf59913$var$U = $eee5d5cd5cf59913$var$T.port2;
    $eee5d5cd5cf59913$var$T.port1.onmessage = $eee5d5cd5cf59913$var$R;
    $eee5d5cd5cf59913$var$S = function() {
        $eee5d5cd5cf59913$var$U.postMessage(null);
    };
} else $eee5d5cd5cf59913$var$S = function() {
    $eee5d5cd5cf59913$var$D($eee5d5cd5cf59913$var$R, 0);
};
function $eee5d5cd5cf59913$var$I(a) {
    $eee5d5cd5cf59913$var$O = a;
    $eee5d5cd5cf59913$var$N || ($eee5d5cd5cf59913$var$N = !0, $eee5d5cd5cf59913$var$S());
}
function $eee5d5cd5cf59913$var$K(a, b) {
    $eee5d5cd5cf59913$var$L = $eee5d5cd5cf59913$var$D(function() {
        a($eee5d5cd5cf59913$export$c4744153514ff05d());
    }, b);
}
$eee5d5cd5cf59913$export$3e506c1ccc9cc1a7 = 5;
$eee5d5cd5cf59913$export$e26fe2ed2fa76875 = 1;
$eee5d5cd5cf59913$export$502329bbf4b505b1 = 4;
$eee5d5cd5cf59913$export$6e3807111c4874c4 = 3;
$eee5d5cd5cf59913$export$c27134553091fb3a = null;
$eee5d5cd5cf59913$export$33ee1acdc04fd2a2 = 2;
$eee5d5cd5cf59913$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$eee5d5cd5cf59913$export$8352ce38b91d0c62 = function() {
    $eee5d5cd5cf59913$var$A || $eee5d5cd5cf59913$var$z || ($eee5d5cd5cf59913$var$A = !0, $eee5d5cd5cf59913$var$I($eee5d5cd5cf59913$var$J));
};
$eee5d5cd5cf59913$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $eee5d5cd5cf59913$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$eee5d5cd5cf59913$export$d3dfb8e4810cb555 = function() {
    return $eee5d5cd5cf59913$var$y;
};
$eee5d5cd5cf59913$export$839f9183b0465a69 = function() {
    return $eee5d5cd5cf59913$var$h($eee5d5cd5cf59913$var$r);
};
$eee5d5cd5cf59913$export$72fdf0e06517287b = function(a) {
    switch($eee5d5cd5cf59913$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $eee5d5cd5cf59913$var$y;
    }
    var c = $eee5d5cd5cf59913$var$y;
    $eee5d5cd5cf59913$var$y = b;
    try {
        return a();
    } finally{
        $eee5d5cd5cf59913$var$y = c;
    }
};
$eee5d5cd5cf59913$export$4b844e58a3e414b4 = function() {};
$eee5d5cd5cf59913$export$816d2913ae6b83b1 = function() {};
$eee5d5cd5cf59913$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $eee5d5cd5cf59913$var$y;
    $eee5d5cd5cf59913$var$y = a;
    try {
        return b();
    } finally{
        $eee5d5cd5cf59913$var$y = c;
    }
};
$eee5d5cd5cf59913$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $eee5d5cd5cf59913$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $eee5d5cd5cf59913$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $eee5d5cd5cf59913$var$f($eee5d5cd5cf59913$var$t, a), null === $eee5d5cd5cf59913$var$h($eee5d5cd5cf59913$var$r) && a === $eee5d5cd5cf59913$var$h($eee5d5cd5cf59913$var$t) && ($eee5d5cd5cf59913$var$B ? ($eee5d5cd5cf59913$var$E($eee5d5cd5cf59913$var$L), $eee5d5cd5cf59913$var$L = -1) : $eee5d5cd5cf59913$var$B = !0, $eee5d5cd5cf59913$var$K($eee5d5cd5cf59913$var$H, c - d))) : (a.sortIndex = e, $eee5d5cd5cf59913$var$f($eee5d5cd5cf59913$var$r, a), $eee5d5cd5cf59913$var$A || $eee5d5cd5cf59913$var$z || ($eee5d5cd5cf59913$var$A = !0, $eee5d5cd5cf59913$var$I($eee5d5cd5cf59913$var$J)));
    return a;
};
$eee5d5cd5cf59913$export$b5836b71941fa3ed = $eee5d5cd5cf59913$var$M;
$eee5d5cd5cf59913$export$cf845f2c119da08a = function(a) {
    var b = $eee5d5cd5cf59913$var$y;
    return function() {
        var c = $eee5d5cd5cf59913$var$y;
        $eee5d5cd5cf59913$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $eee5d5cd5cf59913$var$y = c;
        }
    };
};

});



parcelRegister("7WyXp", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $5c8910fb8bb7819b$export$bf730a2d8bf68b42; }, function (v) { return $5c8910fb8bb7819b$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5c8910fb8bb7819b$export$bf730a2d8bf68b42;
"use strict";

var $bCCVl = parcelRequire("bCCVl");
function $5c8910fb8bb7819b$var$n(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $5c8910fb8bb7819b$var$p = "function" === typeof Object.is ? Object.is : $5c8910fb8bb7819b$var$n, $5c8910fb8bb7819b$var$q = $bCCVl.useSyncExternalStore, $5c8910fb8bb7819b$var$r = $bCCVl.useRef, $5c8910fb8bb7819b$var$t = $bCCVl.useEffect, $5c8910fb8bb7819b$var$u = $bCCVl.useMemo, $5c8910fb8bb7819b$var$v = $bCCVl.useDebugValue;
$5c8910fb8bb7819b$export$bf730a2d8bf68b42 = function(a, b, e, l, h) {
    var c = $5c8910fb8bb7819b$var$r(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $5c8910fb8bb7819b$var$u(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== h && f.hasValue) {
                    var b = f.value;
                    if (h(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($5c8910fb8bb7819b$var$p(d, a)) return b;
            var e = l(a);
            if (void 0 !== h && h(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        h
    ]);
    var d = $5c8910fb8bb7819b$var$q(a, c[0], c[1]);
    $5c8910fb8bb7819b$var$t(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $5c8910fb8bb7819b$var$v(d);
    return d;
};

});

parcelRegister("98FoB", function(module, exports) {

var $4QJeI = parcelRequire("4QJeI");
module.exports = $4QJeI("laPmH").then(()=>parcelRequire("90CDL"));

});
parcelRegister("4QJeI", function(module, exports) {
"use strict";

function $387f1bc4917fbb3e$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("7pcrU")).resolve(id));
}
module.exports = $387f1bc4917fbb3e$var$load;

});



var $2T6zX = parcelRequire("2T6zX");

var $bCCVl = parcelRequire("bCCVl");
var $9a2f8d1b85cf3b27$exports = {};

$parcel$export($9a2f8d1b85cf3b27$exports, "createRoot", function () { return $9a2f8d1b85cf3b27$export$882461b6382ed46c; }, function (v) { return $9a2f8d1b85cf3b27$export$882461b6382ed46c = v; });
$parcel$export($9a2f8d1b85cf3b27$exports, "hydrateRoot", function () { return $9a2f8d1b85cf3b27$export$757ceba2d55c277e; }, function (v) { return $9a2f8d1b85cf3b27$export$757ceba2d55c277e = v; });
var $9a2f8d1b85cf3b27$export$882461b6382ed46c;
var $9a2f8d1b85cf3b27$export$757ceba2d55c277e;
"use strict";
var $02909f7325781ee4$exports = {};
"use strict";
function $02909f7325781ee4$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($02909f7325781ee4$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$02909f7325781ee4$var$checkDCE();

$02909f7325781ee4$exports = (parcelRequire("fL3Dm"));


var $9a2f8d1b85cf3b27$var$i;
$9a2f8d1b85cf3b27$export$882461b6382ed46c = $02909f7325781ee4$exports.createRoot;
$9a2f8d1b85cf3b27$export$757ceba2d55c277e = $02909f7325781ee4$exports.hydrateRoot;



var $2T6zX = parcelRequire("2T6zX");

var $bCCVl = parcelRequire("bCCVl");
//This is Named export 
const $7fd0baa016ace72e$export$c65137966c75edf0 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";
const $7fd0baa016ace72e$export$8878ead86ed0da0b = "https://png.pngtree.com/png-clipart/20200727/original/pngtree-restaurant-logo-design-vector-template-png-image_5441058.jpg";
const $7fd0baa016ace72e$export$d28dc33571f365ee = "https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=12.9351929&lng=77.62448069999999&restaurantId=";


/**
 * React Router DOM v6.25.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $bCCVl = parcelRequire("bCCVl");

/**
 * @remix-run/router v1.18.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $67befd869d250436$var$_extends() {
    $67befd869d250436$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $67befd869d250436$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $67befd869d250436$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($67befd869d250436$export$e19cd5f9376f8cee || ($67befd869d250436$export$e19cd5f9376f8cee = {}));
const $67befd869d250436$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $67befd869d250436$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $67befd869d250436$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $67befd869d250436$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $67befd869d250436$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $67befd869d250436$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $67befd869d250436$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $67befd869d250436$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $67befd869d250436$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $67befd869d250436$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $67befd869d250436$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $67befd869d250436$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $67befd869d250436$export$fe53371bee54353d(to);
    }
    return $67befd869d250436$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $67befd869d250436$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $67befd869d250436$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $67befd869d250436$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $67befd869d250436$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $67befd869d250436$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $67befd869d250436$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $67befd869d250436$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $67befd869d250436$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $67befd869d250436$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $67befd869d250436$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $67befd869d250436$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $67befd869d250436$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $67befd869d250436$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $67befd869d250436$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $67befd869d250436$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $67befd869d250436$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $67befd869d250436$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $67befd869d250436$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($67befd869d250436$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $67befd869d250436$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $67befd869d250436$export$e19cd5f9376f8cee.Push;
        let location = $67befd869d250436$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $67befd869d250436$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $67befd869d250436$export$e19cd5f9376f8cee.Replace;
        let location = $67befd869d250436$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $67befd869d250436$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $67befd869d250436$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $67befd869d250436$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($67befd869d250436$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($67befd869d250436$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $67befd869d250436$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($67befd869d250436$var$ResultType || ($67befd869d250436$var$ResultType = {}));
const $67befd869d250436$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $67befd869d250436$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $67befd869d250436$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $67befd869d250436$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $67befd869d250436$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($67befd869d250436$var$isIndexRoute(route)) {
            let indexRoute = $67befd869d250436$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $67befd869d250436$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $67befd869d250436$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $67befd869d250436$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $67befd869d250436$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $67befd869d250436$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $67befd869d250436$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $67befd869d250436$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $67befd869d250436$var$flattenRoutes(routes);
    $67befd869d250436$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $67befd869d250436$export$30d21fd6d7295f52(pathname);
        matches = $67befd869d250436$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $67befd869d250436$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $67befd869d250436$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $67befd869d250436$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $67befd869d250436$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $67befd869d250436$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $67befd869d250436$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $67befd869d250436$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $67befd869d250436$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $67befd869d250436$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $67befd869d250436$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $67befd869d250436$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $67befd869d250436$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $67befd869d250436$var$paramRe = /^:[\w-]+$/;
const $67befd869d250436$var$dynamicSegmentValue = 3;
const $67befd869d250436$var$indexRouteValue = 2;
const $67befd869d250436$var$emptySegmentValue = 1;
const $67befd869d250436$var$staticSegmentValue = 10;
const $67befd869d250436$var$splatPenalty = -2;
const $67befd869d250436$var$isSplat = (s)=>s === "*";
function $67befd869d250436$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($67befd869d250436$var$isSplat)) initialScore += $67befd869d250436$var$splatPenalty;
    if (index) initialScore += $67befd869d250436$var$indexRouteValue;
    return segments.filter((s)=>!$67befd869d250436$var$isSplat(s)).reduce((score, segment)=>score + ($67befd869d250436$var$paramRe.test(segment) ? $67befd869d250436$var$dynamicSegmentValue : segment === "" ? $67befd869d250436$var$emptySegmentValue : $67befd869d250436$var$staticSegmentValue), initialScore);
}
function $67befd869d250436$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $67befd869d250436$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $67befd869d250436$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $67befd869d250436$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $67befd869d250436$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $67befd869d250436$export$a5c6d149b50c1d86($67befd869d250436$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $67befd869d250436$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $67befd869d250436$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $67befd869d250436$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $67befd869d250436$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $67befd869d250436$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $67befd869d250436$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $67befd869d250436$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $67befd869d250436$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $67befd869d250436$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $67befd869d250436$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $67befd869d250436$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $67befd869d250436$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $67befd869d250436$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $67befd869d250436$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $67befd869d250436$var$normalizeSearch(search),
        hash: $67befd869d250436$var$normalizeHash(hash)
    };
}
function $67befd869d250436$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $67befd869d250436$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $67befd869d250436$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $67befd869d250436$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $67befd869d250436$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $67befd869d250436$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $67befd869d250436$export$8ccf933b0513f8d0(toArg);
    else {
        to = $67befd869d250436$var$_extends({}, toArg);
        $67befd869d250436$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $67befd869d250436$var$getInvalidPathError("?", "pathname", "search", to));
        $67befd869d250436$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $67befd869d250436$var$getInvalidPathError("#", "pathname", "hash", to));
        $67befd869d250436$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $67befd869d250436$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $67befd869d250436$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $67befd869d250436$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $67befd869d250436$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $67befd869d250436$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $67befd869d250436$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $67befd869d250436$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $67befd869d250436$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $67befd869d250436$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $67befd869d250436$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $67befd869d250436$export$42a99a7a4bc0e76a extends Error {
}
class $67befd869d250436$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $67befd869d250436$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $67befd869d250436$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $67befd869d250436$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $67befd869d250436$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $67befd869d250436$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $67befd869d250436$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $67befd869d250436$var$unwrapTrackedPromise(value) {
    if (!$67befd869d250436$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $67befd869d250436$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $67befd869d250436$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $67befd869d250436$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $67befd869d250436$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $67befd869d250436$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $67befd869d250436$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $67befd869d250436$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $67befd869d250436$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $67befd869d250436$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $67befd869d250436$var$validMutationMethods = new Set($67befd869d250436$var$validMutationMethodsArr);
const $67befd869d250436$var$validRequestMethodsArr = [
    "get",
    ...$67befd869d250436$var$validMutationMethodsArr
];
const $67befd869d250436$var$validRequestMethods = new Set($67befd869d250436$var$validRequestMethodsArr);
const $67befd869d250436$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $67befd869d250436$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $67befd869d250436$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $67befd869d250436$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $67befd869d250436$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $67befd869d250436$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $67befd869d250436$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $67befd869d250436$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $67befd869d250436$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $67befd869d250436$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $67befd869d250436$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $67befd869d250436$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.unstable_dataStrategy || $67befd869d250436$var$defaultDataStrategy;
    let patchRoutesOnMissImpl = init.unstable_patchRoutesOnMiss;
    // Config driven behavior flags
    let future = $67befd869d250436$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $67befd869d250436$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnMissImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $67befd869d250436$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $67befd869d250436$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnMiss implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && patchRoutesOnMissImpl && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        // We need to run patchRoutesOnMiss in initialize()
        initialized = false;
        initialMatches = [];
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (typeof m.route.loader === "function" && m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $67befd869d250436$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $67befd869d250436$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Map of pending patchRoutesOnMiss() promises (keyed by path/matches) so
    // that we only kick them off once for a given combo
    let pendingPatchRoutes = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $67befd869d250436$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $67befd869d250436$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $67befd869d250436$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$67befd869d250436$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($67befd869d250436$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $67befd869d250436$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $67befd869d250436$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $67befd869d250436$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $67befd869d250436$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $67befd869d250436$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $67befd869d250436$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $67befd869d250436$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $67befd869d250436$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $67befd869d250436$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($67befd869d250436$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $67befd869d250436$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $67befd869d250436$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $67befd869d250436$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $67befd869d250436$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $67befd869d250436$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $67befd869d250436$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $67befd869d250436$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $67befd869d250436$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $67befd869d250436$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $67befd869d250436$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $67befd869d250436$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $67befd869d250436$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $67befd869d250436$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $67befd869d250436$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $67befd869d250436$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $67befd869d250436$var$findNearestBoundary(matches).route.id,
            {
                type: $67befd869d250436$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $67befd869d250436$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($67befd869d250436$var$isErrorResult(result) && $67befd869d250436$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $67befd869d250436$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $67befd869d250436$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $67befd869d250436$var$_extends({
            matches: updatedMatches || matches
        }, $67befd869d250436$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $67befd869d250436$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let { boundaryId: boundaryId, error: error } = handleDiscoverRouteError(location.pathname, discoverResult);
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $67befd869d250436$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $67befd869d250436$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $67befd869d250436$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $67befd869d250436$var$ResultType.error,
            error: $67befd869d250436$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches);
            result = results[0];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($67befd869d250436$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $67befd869d250436$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($67befd869d250436$var$isDeferredResult(result)) throw $67befd869d250436$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($67befd869d250436$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $67befd869d250436$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $67befd869d250436$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $67befd869d250436$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $67befd869d250436$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($67befd869d250436$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let { boundaryId: boundaryId, error: error } = handleDiscoverRouteError(location.pathname, discoverResult);
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $67befd869d250436$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $67befd869d250436$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $67befd869d250436$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $67befd869d250436$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $67befd869d250436$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(request, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $67befd869d250436$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $67befd869d250436$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$67befd869d250436$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $67befd869d250436$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $67befd869d250436$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $67befd869d250436$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $67befd869d250436$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $67befd869d250436$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $67befd869d250436$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $67befd869d250436$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $67befd869d250436$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $67befd869d250436$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $67befd869d250436$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                let { error: error } = handleDiscoverRouteError(path, discoverResult);
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $67befd869d250436$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $67befd869d250436$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", fetchRequest, [
            match
        ], requestMatches);
        let actionResult = actionResults[0];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($67befd869d250436$var$isRedirectResult(actionResult) || $67befd869d250436$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $67befd869d250436$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($67befd869d250436$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $67befd869d250436$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $67befd869d250436$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($67befd869d250436$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($67befd869d250436$var$isDeferredResult(actionResult)) throw $67befd869d250436$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $67befd869d250436$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $67befd869d250436$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $67befd869d250436$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $67befd869d250436$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $67befd869d250436$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $67befd869d250436$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $67befd869d250436$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(revalidationRequest, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $67befd869d250436$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $67befd869d250436$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $67befd869d250436$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $67befd869d250436$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $67befd869d250436$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $67befd869d250436$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                let { error: error } = handleDiscoverRouteError(path, discoverResult);
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $67befd869d250436$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $67befd869d250436$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", fetchRequest, [
            match
        ], matches);
        let result = results[0];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($67befd869d250436$var$isDeferredResult(result)) result = await $67befd869d250436$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $67befd869d250436$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($67befd869d250436$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $67befd869d250436$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($67befd869d250436$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $67befd869d250436$export$3e9cee6b33872309(!$67befd869d250436$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $67befd869d250436$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $67befd869d250436$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $67befd869d250436$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $67befd869d250436$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($67befd869d250436$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $67befd869d250436$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $67befd869d250436$export$e19cd5f9376f8cee.Replace : $67befd869d250436$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $67befd869d250436$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($67befd869d250436$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $67befd869d250436$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $67befd869d250436$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $67befd869d250436$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches) {
        try {
            let results = await $67befd869d250436$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties);
            return await Promise.all(results.map((result, i)=>{
                if ($67befd869d250436$var$isRedirectHandlerResult(result)) {
                    let response = result.result;
                    return {
                        type: $67befd869d250436$var$ResultType.redirect,
                        response: $67befd869d250436$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath)
                    };
                }
                return $67befd869d250436$var$convertHandlerResultToDataResult(result);
            }));
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            return matchesToLoad.map(()=>({
                    type: $67befd869d250436$var$ResultType.error,
                    error: e
                }));
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        let [loaderResults, ...fetcherResults] = await Promise.all([
            matchesToLoad.length ? callDataStrategy("loader", request, matchesToLoad, matches) : [],
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) {
                    let fetcherRequest = $67befd869d250436$var$createClientSideRequest(init.history, f.path, f.controller.signal);
                    return callDataStrategy("loader", fetcherRequest, [
                        f.match
                    ], f.matches).then((r)=>r[0]);
                } else return Promise.resolve({
                    type: $67befd869d250436$var$ResultType.error,
                    error: $67befd869d250436$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                });
            })
        ]);
        await Promise.all([
            $67befd869d250436$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $67befd869d250436$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $67befd869d250436$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $67befd869d250436$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $67befd869d250436$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $67befd869d250436$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $67befd869d250436$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $67befd869d250436$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $67befd869d250436$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $67befd869d250436$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $67befd869d250436$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $67befd869d250436$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $67befd869d250436$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $67befd869d250436$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function handleDiscoverRouteError(pathname, discoverResult) {
        return {
            boundaryId: $67befd869d250436$var$findNearestBoundary(discoverResult.partialMatches).route.id,
            error: $67befd869d250436$var$getInternalRouterError(400, {
                type: "route-discovery",
                pathname: pathname,
                message: discoverResult.error != null && "message" in discoverResult.error ? discoverResult.error : String(discoverResult.error)
            })
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $67befd869d250436$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$67befd869d250436$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnMissImpl) {
            if (!matches) {
                let fogMatches = $67befd869d250436$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else {
                let leafRoute = matches[matches.length - 1].route;
                if (leafRoute.path && (leafRoute.path === "*" || leafRoute.path.endsWith("/*"))) {
                    // If we matched a splat, it might only be because we haven't yet fetched
                    // the children that would match with a higher score, so let's fetch
                    // around and find out
                    let partialMatches = $67befd869d250436$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                    return {
                        active: true,
                        matches: partialMatches
                    };
                }
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        let partialMatches = matches;
        let route = partialMatches.length > 0 ? partialMatches[partialMatches.length - 1].route : null;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            try {
                await $67befd869d250436$var$loadLazyRouteChildren(patchRoutesOnMissImpl, pathname, partialMatches, routesToUse, manifest, mapRouteProperties, pendingPatchRoutes, signal);
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $67befd869d250436$export$2708184779ceb39d(routesToUse, pathname, basename);
            let matchedSplat = false;
            if (newMatches) {
                let leafRoute = newMatches[newMatches.length - 1].route;
                if (leafRoute.index) // If we found an index route, we can stop
                return {
                    type: "success",
                    matches: newMatches
                };
                if (leafRoute.path && leafRoute.path.length > 0) {
                    if (leafRoute.path === "*") // If we found a splat route, we can't be sure there's not a
                    // higher-scoring route down some partial matches trail so we need
                    // to check that out
                    matchedSplat = true;
                    else // If we found a non-splat route, we can stop
                    return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            let newPartialMatches = $67befd869d250436$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // If we are no longer partially matching anything, this was either a
            // legit splat match above, or it's a 404.  Also avoid loops if the
            // second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.map((m)=>m.route.id).join("-") === newPartialMatches.map((m)=>m.route.id).join("-")) return {
                type: "success",
                matches: matchedSplat ? newMatches : null
            };
            partialMatches = newPartialMatches;
            route = partialMatches[partialMatches.length - 1].route;
            if (route.path === "*") // The splat is still our most accurate partial, so run with it
            return {
                type: "success",
                matches: partialMatches
            };
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $67befd869d250436$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $67befd869d250436$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $67befd869d250436$export$4d0306f8f6a4585b = Symbol("deferred");
function $67befd869d250436$export$3336b097a6fbc59a(routes, opts) {
    $67befd869d250436$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $67befd869d250436$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $67befd869d250436$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $67befd869d250436$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, unstable_dataStrategy: unstable_dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $67befd869d250436$var$createLocation("", $67befd869d250436$export$fe53371bee54353d(url), null, "default");
        let matches = $67befd869d250436$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$67befd869d250436$var$isValidMethod(method) && method !== "HEAD") {
            let error = $67befd869d250436$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $67befd869d250436$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $67befd869d250436$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $67befd869d250436$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($67befd869d250436$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $67befd869d250436$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, unstable_dataStrategy: unstable_dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $67befd869d250436$var$createLocation("", $67befd869d250436$export$fe53371bee54353d(url), null, "default");
        let matches = $67befd869d250436$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$67befd869d250436$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $67befd869d250436$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $67befd869d250436$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $67befd869d250436$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $67befd869d250436$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $67befd869d250436$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, false, match);
        if ($67befd869d250436$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$67befd869d250436$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $67befd869d250436$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($67befd869d250436$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $67befd869d250436$var$getTargetMatch(matches, location), requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $67befd869d250436$var$isResponse(result) ? result : $67befd869d250436$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `HandlerResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($67befd869d250436$var$isHandlerResult(e) && $67befd869d250436$var$isResponse(e.result)) {
                if (e.type === $67befd869d250436$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($67befd869d250436$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $67befd869d250436$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $67befd869d250436$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, unstable_dataStrategy);
            result = results[0];
            if (request.signal.aborted) $67befd869d250436$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($67befd869d250436$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($67befd869d250436$var$isDeferredResult(result)) {
            let error = $67befd869d250436$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $67befd869d250436$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($67befd869d250436$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($67befd869d250436$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $67befd869d250436$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $67befd869d250436$var$_extends({}, context, {
                statusCode: $67befd869d250436$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $67befd869d250436$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null);
        return $67befd869d250436$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $67befd869d250436$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $67befd869d250436$var$isErrorResult(pendingActionResult[1]) ? $67befd869d250436$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $67befd869d250436$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy);
        if (request.signal.aborted) $67befd869d250436$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $67befd869d250436$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $67befd869d250436$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy) {
        let results = await $67befd869d250436$var$callDataStrategyImpl(unstable_dataStrategy || $67befd869d250436$var$defaultDataStrategy, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext);
        return await Promise.all(results.map((result, i)=>{
            if ($67befd869d250436$var$isRedirectHandlerResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $67befd869d250436$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($67befd869d250436$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            return $67befd869d250436$var$convertHandlerResultToDataResult(result);
        }));
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $67befd869d250436$export$fec11da027c70692(routes, context, error) {
    let newContext = $67befd869d250436$var$_extends({}, context, {
        statusCode: $67befd869d250436$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $67befd869d250436$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $67befd869d250436$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $67befd869d250436$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $67befd869d250436$export$cae722b0cc860f13(to ? to : ".", $67befd869d250436$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $67befd869d250436$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$67befd869d250436$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $67befd869d250436$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $67befd869d250436$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $67befd869d250436$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$67befd869d250436$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$67befd869d250436$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $67befd869d250436$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $67befd869d250436$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $67befd869d250436$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$67befd869d250436$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$67befd869d250436$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $67befd869d250436$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $67befd869d250436$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $67befd869d250436$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $67befd869d250436$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $67befd869d250436$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($67befd869d250436$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $67befd869d250436$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $67befd869d250436$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $67befd869d250436$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $67befd869d250436$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $67befd869d250436$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $67befd869d250436$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingActionResult && $67befd869d250436$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[0] : undefined;
    let boundaryMatches = boundaryId ? $67befd869d250436$var$getLoaderMatchesUntilBoundary(matches, boundaryId) : matches;
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (typeof route.loader !== "function" || route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($67befd869d250436$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $67befd869d250436$var$shouldRevalidateLoader(match, $67befd869d250436$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $67befd869d250436$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $67befd869d250436$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $67befd869d250436$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $67befd869d250436$var$shouldRevalidateLoader(fetcherMatch, $67befd869d250436$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $67befd869d250436$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $67befd869d250436$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $67befd869d250436$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Idempotent utility to execute patchRoutesOnMiss() to lazily load route
 * definitions and update the routes/routeManifest
 */ async function $67befd869d250436$var$loadLazyRouteChildren(patchRoutesOnMissImpl, path, matches, routes, manifest, mapRouteProperties, pendingRouteChildren, signal) {
    let key = [
        path,
        ...matches.map((m)=>m.route.id)
    ].join("-");
    try {
        let pending = pendingRouteChildren.get(key);
        if (!pending) {
            pending = patchRoutesOnMissImpl({
                path: path,
                matches: matches,
                patch: (routeId, children)=>{
                    if (!signal.aborted) $67befd869d250436$var$patchRoutesImpl(routeId, children, routes, manifest, mapRouteProperties);
                }
            });
            pendingRouteChildren.set(key, pending);
        }
        if (pending && $67befd869d250436$var$isPromise(pending)) await pending;
    } finally{
        pendingRouteChildren.delete(key);
    }
}
function $67befd869d250436$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    if (routeId) {
        var _route$children;
        let route = manifest[routeId];
        $67befd869d250436$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        let dataChildren = $67befd869d250436$export$4a6d22b32134ea5d(children, mapRouteProperties, [
            routeId,
            "patch",
            String(((_route$children = route.children) == null ? void 0 : _route$children.length) || "0")
        ], manifest);
        if (route.children) route.children.push(...dataChildren);
        else route.children = dataChildren;
    } else {
        let dataChildren = $67befd869d250436$export$4a6d22b32134ea5d(children, mapRouteProperties, [
            "patch",
            String(routesToUse.length || "0")
        ], manifest);
        routesToUse.push(...dataChildren);
    }
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $67befd869d250436$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $67befd869d250436$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $67befd869d250436$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$67befd869d250436$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $67befd869d250436$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
function $67befd869d250436$var$defaultDataStrategy(opts) {
    return Promise.all(opts.matches.map((m)=>m.resolve()));
}
async function $67befd869d250436$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext) {
    let routeIdsToLoad = matchesToLoad.reduce((acc, m)=>acc.add(m.route.id), new Set());
    let loadedMatches = new Set();
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: matches.map((match)=>{
            let shouldLoad = routeIdsToLoad.has(match.route.id);
            // `resolve` encapsulates the route.lazy, executing the
            // loader/action, and mapping return values/thrown errors to a
            // HandlerResult.  Users can pass a callback to take fine-grained control
            // over the execution of the loader/action
            let resolve = (handlerOverride)=>{
                loadedMatches.add(match.route.id);
                return shouldLoad ? $67befd869d250436$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, requestContext) : Promise.resolve({
                    type: $67befd869d250436$var$ResultType.data,
                    result: undefined
                });
            };
            return $67befd869d250436$var$_extends({}, match, {
                shouldLoad: shouldLoad,
                resolve: resolve
            });
        }),
        request: request,
        params: matches[0].params,
        context: requestContext
    });
    // Throw if any loadRoute implementations not called since they are what
    // ensures a route is fully loaded
    matches.forEach((m)=>$67befd869d250436$export$3e9cee6b33872309(loadedMatches.has(m.route.id), '`match.resolve()` was not called for route id "' + m.route.id + '". ' + "You must call `match.resolve()` on every match passed to " + "`dataStrategy` to ensure all routes are properly loaded."));
    // Filter out any middleware-only matches for which we didn't need to run handlers
    return results.filter((_, i)=>routeIdsToLoad.has(matches[i].route.id));
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $67befd869d250436$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<HandlerResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise;
        if (handlerOverride) handlerPromise = handlerOverride((ctx)=>actualHandler(ctx));
        else handlerPromise = (async ()=>{
            try {
                let val = await actualHandler();
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $67befd869d250436$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await $67befd869d250436$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $67befd869d250436$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $67befd869d250436$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $67befd869d250436$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $67befd869d250436$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // HandlerResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $67befd869d250436$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $67befd869d250436$var$convertHandlerResultToDataResult(handlerResult) {
    let { result: result, type: type, status: status } = handlerResult;
    if ($67befd869d250436$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $67befd869d250436$var$ResultType.error,
                error: e
            };
        }
        if (type === $67befd869d250436$var$ResultType.error) return {
            type: $67befd869d250436$var$ResultType.error,
            error: new $67befd869d250436$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $67befd869d250436$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $67befd869d250436$var$ResultType.error) return {
        type: $67befd869d250436$var$ResultType.error,
        error: result,
        statusCode: $67befd869d250436$export$972111febbeef05b(result) ? result.status : status
    };
    if ($67befd869d250436$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $67befd869d250436$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $67befd869d250436$var$ResultType.data,
        data: result,
        statusCode: status
    };
}
// Support relative routing in internal redirects
function $67befd869d250436$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $67befd869d250436$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$67befd869d250436$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $67befd869d250436$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $67befd869d250436$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($67befd869d250436$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $67befd869d250436$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $67befd869d250436$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($67befd869d250436$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $67befd869d250436$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $67befd869d250436$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $67befd869d250436$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $67befd869d250436$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $67befd869d250436$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $67befd869d250436$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $67befd869d250436$export$3e9cee6b33872309(!$67befd869d250436$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($67befd869d250436$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $67befd869d250436$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $67befd869d250436$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($67befd869d250436$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $67befd869d250436$var$processLoaderData(state, matches, matchesToLoad, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $67befd869d250436$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $67befd869d250436$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($67befd869d250436$var$isErrorResult(result)) {
            let boundaryMatch = $67befd869d250436$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $67befd869d250436$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($67befd869d250436$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $67befd869d250436$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($67befd869d250436$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $67befd869d250436$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $67befd869d250436$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $67befd869d250436$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $67befd869d250436$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $67befd869d250436$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $67befd869d250436$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $67befd869d250436$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $67befd869d250436$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $67befd869d250436$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (type === "route-discovery") errorMessage = 'Unable to match URL "' + pathname + '" - the `unstable_patchRoutesOnMiss()` ' + ("function threw the following error:\n" + message);
        else if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $67befd869d250436$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $67befd869d250436$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($67befd869d250436$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $67befd869d250436$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $67befd869d250436$export$8ccf933b0513f8d0(path) : path;
    return $67befd869d250436$export$fe53371bee54353d($67befd869d250436$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $67befd869d250436$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $67befd869d250436$var$isPromise(val) {
    return typeof val === "object" && val != null && "then" in val;
}
function $67befd869d250436$var$isHandlerResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $67befd869d250436$var$ResultType.data || result.type === $67befd869d250436$var$ResultType.error);
}
function $67befd869d250436$var$isRedirectHandlerResult(result) {
    return $67befd869d250436$var$isResponse(result.result) && $67befd869d250436$var$redirectStatusCodes.has(result.result.status);
}
function $67befd869d250436$var$isDeferredResult(result) {
    return result.type === $67befd869d250436$var$ResultType.deferred;
}
function $67befd869d250436$var$isErrorResult(result) {
    return result.type === $67befd869d250436$var$ResultType.error;
}
function $67befd869d250436$var$isRedirectResult(result) {
    return (result && result.type) === $67befd869d250436$var$ResultType.redirect;
}
function $67befd869d250436$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $67befd869d250436$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $67befd869d250436$var$isRedirectResponse(result) {
    if (!$67befd869d250436$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $67befd869d250436$var$isValidMethod(method) {
    return $67befd869d250436$var$validRequestMethods.has(method.toLowerCase());
}
function $67befd869d250436$var$isMutationMethod(method) {
    return $67befd869d250436$var$validMutationMethods.has(method.toLowerCase());
}
async function $67befd869d250436$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$67befd869d250436$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($67befd869d250436$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $67befd869d250436$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $67befd869d250436$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $67befd869d250436$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $67befd869d250436$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $67befd869d250436$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $67befd869d250436$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $67befd869d250436$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $67befd869d250436$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $67befd869d250436$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $67befd869d250436$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $67befd869d250436$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $67befd869d250436$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $67befd869d250436$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $67befd869d250436$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $67befd869d250436$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $67befd869d250436$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $67befd869d250436$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $67befd869d250436$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($67befd869d250436$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $67befd869d250436$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($67befd869d250436$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $67befd869d250436$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.25.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $bCCVl = parcelRequire("bCCVl");

function $2bd9a3ffc1ab0195$var$_extends() {
    $2bd9a3ffc1ab0195$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2bd9a3ffc1ab0195$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $2bd9a3ffc1ab0195$export$3add0d5dce533e2e = /*#__PURE__*/ $bCCVl.createContext(null);
const $2bd9a3ffc1ab0195$export$145dfa71566a64dc = /*#__PURE__*/ $bCCVl.createContext(null);
const $2bd9a3ffc1ab0195$var$AwaitContext = /*#__PURE__*/ $bCCVl.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $2bd9a3ffc1ab0195$export$26749e8557646306 = /*#__PURE__*/ $bCCVl.createContext(null);
const $2bd9a3ffc1ab0195$export$c7914228fb69b0f5 = /*#__PURE__*/ $bCCVl.createContext(null);
const $2bd9a3ffc1ab0195$export$9072aa6dd1f93057 = /*#__PURE__*/ $bCCVl.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $2bd9a3ffc1ab0195$var$RouteErrorContext = /*#__PURE__*/ $bCCVl.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $2bd9a3ffc1ab0195$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$2bd9a3ffc1ab0195$export$9c954a9d03d32f4a() && (0, $67befd869d250436$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $bCCVl.useContext($2bd9a3ffc1ab0195$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $2bd9a3ffc1ab0195$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $67befd869d250436$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $2bd9a3ffc1ab0195$export$9c954a9d03d32f4a() {
    return $bCCVl.useContext($2bd9a3ffc1ab0195$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $2bd9a3ffc1ab0195$export$45d76561a5302f2b() {
    !$2bd9a3ffc1ab0195$export$9c954a9d03d32f4a() && (0, $67befd869d250436$export$3e9cee6b33872309)(false);
    return $bCCVl.useContext($2bd9a3ffc1ab0195$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $2bd9a3ffc1ab0195$export$1b3f31771c5d07c() {
    return $bCCVl.useContext($2bd9a3ffc1ab0195$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $2bd9a3ffc1ab0195$export$6c330e8992e8a295(pattern) {
    !$2bd9a3ffc1ab0195$export$9c954a9d03d32f4a() && (0, $67befd869d250436$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $2bd9a3ffc1ab0195$export$45d76561a5302f2b();
    return $bCCVl.useMemo(()=>(0, $67befd869d250436$export$81336c211d5ff295)(pattern, (0, $67befd869d250436$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $2bd9a3ffc1ab0195$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $2bd9a3ffc1ab0195$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $bCCVl.useContext($2bd9a3ffc1ab0195$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $bCCVl.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $2bd9a3ffc1ab0195$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $bCCVl.useContext($2bd9a3ffc1ab0195$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $2bd9a3ffc1ab0195$var$useNavigateStable() : $2bd9a3ffc1ab0195$var$useNavigateUnstable();
}
function $2bd9a3ffc1ab0195$var$useNavigateUnstable() {
    !$2bd9a3ffc1ab0195$export$9c954a9d03d32f4a() && (0, $67befd869d250436$export$3e9cee6b33872309)(false);
    let dataRouterContext = $bCCVl.useContext($2bd9a3ffc1ab0195$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $bCCVl.useContext($2bd9a3ffc1ab0195$export$26749e8557646306);
    let { matches: matches } = $bCCVl.useContext($2bd9a3ffc1ab0195$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $2bd9a3ffc1ab0195$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $67befd869d250436$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $bCCVl.useRef(false);
    $2bd9a3ffc1ab0195$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $bCCVl.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $67befd869d250436$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $67befd869d250436$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $2bd9a3ffc1ab0195$var$OutletContext = /*#__PURE__*/ $bCCVl.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $2bd9a3ffc1ab0195$export$4138103a3ae699cc() {
    return $bCCVl.useContext($2bd9a3ffc1ab0195$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $2bd9a3ffc1ab0195$export$a3be3530d8e40d0b(context) {
    let outlet = $bCCVl.useContext($2bd9a3ffc1ab0195$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $bCCVl.createElement($2bd9a3ffc1ab0195$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $2bd9a3ffc1ab0195$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $bCCVl.useContext($2bd9a3ffc1ab0195$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $2bd9a3ffc1ab0195$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $bCCVl.useContext($2bd9a3ffc1ab0195$export$26749e8557646306);
    let { matches: matches } = $bCCVl.useContext($2bd9a3ffc1ab0195$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $2bd9a3ffc1ab0195$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $67befd869d250436$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $bCCVl.useMemo(()=>(0, $67befd869d250436$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $2bd9a3ffc1ab0195$export$5d3fca4a98652595(routes, locationArg) {
    return $2bd9a3ffc1ab0195$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $2bd9a3ffc1ab0195$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$2bd9a3ffc1ab0195$export$9c954a9d03d32f4a() && (0, $67befd869d250436$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $bCCVl.useContext($2bd9a3ffc1ab0195$export$26749e8557646306);
    let { matches: parentMatches } = $bCCVl.useContext($2bd9a3ffc1ab0195$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $2bd9a3ffc1ab0195$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $67befd869d250436$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $67befd869d250436$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $67befd869d250436$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $2bd9a3ffc1ab0195$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $67befd869d250436$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $67befd869d250436$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $bCCVl.createElement($2bd9a3ffc1ab0195$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $2bd9a3ffc1ab0195$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $67befd869d250436$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $2bd9a3ffc1ab0195$var$DefaultErrorComponent() {
    let error = $2bd9a3ffc1ab0195$export$ed527bf60f6e05f2();
    let message = (0, $67befd869d250436$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $bCCVl.createElement($bCCVl.Fragment, null, /*#__PURE__*/ $bCCVl.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $bCCVl.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $bCCVl.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $2bd9a3ffc1ab0195$var$defaultErrorElement = /*#__PURE__*/ $bCCVl.createElement($2bd9a3ffc1ab0195$var$DefaultErrorComponent, null);
class $2bd9a3ffc1ab0195$var$RenderErrorBoundary extends $bCCVl.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $bCCVl.createElement($2bd9a3ffc1ab0195$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $bCCVl.createElement($2bd9a3ffc1ab0195$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $2bd9a3ffc1ab0195$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $bCCVl.useContext($2bd9a3ffc1ab0195$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $bCCVl.createElement($2bd9a3ffc1ab0195$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $2bd9a3ffc1ab0195$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $67befd869d250436$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $2bd9a3ffc1ab0195$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $2bd9a3ffc1ab0195$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $bCCVl.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $bCCVl.createElement($2bd9a3ffc1ab0195$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $bCCVl.createElement($2bd9a3ffc1ab0195$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $2bd9a3ffc1ab0195$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($2bd9a3ffc1ab0195$var$DataRouterHook || {});
var $2bd9a3ffc1ab0195$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($2bd9a3ffc1ab0195$var$DataRouterStateHook || {});
function $2bd9a3ffc1ab0195$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $2bd9a3ffc1ab0195$var$useDataRouterContext(hookName) {
    let ctx = $bCCVl.useContext($2bd9a3ffc1ab0195$export$3add0d5dce533e2e);
    !ctx && (0, $67befd869d250436$export$3e9cee6b33872309)(false);
    return ctx;
}
function $2bd9a3ffc1ab0195$var$useDataRouterState(hookName) {
    let state = $bCCVl.useContext($2bd9a3ffc1ab0195$export$145dfa71566a64dc);
    !state && (0, $67befd869d250436$export$3e9cee6b33872309)(false);
    return state;
}
function $2bd9a3ffc1ab0195$var$useRouteContext(hookName) {
    let route = $bCCVl.useContext($2bd9a3ffc1ab0195$export$9072aa6dd1f93057);
    !route && (0, $67befd869d250436$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $2bd9a3ffc1ab0195$var$useCurrentRouteId(hookName) {
    let route = $2bd9a3ffc1ab0195$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $67befd869d250436$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $2bd9a3ffc1ab0195$export$5fc8298006ad9e58() {
    return $2bd9a3ffc1ab0195$var$useCurrentRouteId($2bd9a3ffc1ab0195$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $2bd9a3ffc1ab0195$export$d0fd4b7106de2769() {
    let state = $2bd9a3ffc1ab0195$var$useDataRouterState($2bd9a3ffc1ab0195$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $2bd9a3ffc1ab0195$export$600dc272ed516c15() {
    let dataRouterContext = $2bd9a3ffc1ab0195$var$useDataRouterContext($2bd9a3ffc1ab0195$var$DataRouterHook.UseRevalidator);
    let state = $2bd9a3ffc1ab0195$var$useDataRouterState($2bd9a3ffc1ab0195$var$DataRouterStateHook.UseRevalidator);
    return $bCCVl.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $2bd9a3ffc1ab0195$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $2bd9a3ffc1ab0195$var$useDataRouterState($2bd9a3ffc1ab0195$var$DataRouterStateHook.UseMatches);
    return $bCCVl.useMemo(()=>matches.map((m)=>(0, $67befd869d250436$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $2bd9a3ffc1ab0195$export$1448a5050d252c4d() {
    let state = $2bd9a3ffc1ab0195$var$useDataRouterState($2bd9a3ffc1ab0195$var$DataRouterStateHook.UseLoaderData);
    let routeId = $2bd9a3ffc1ab0195$var$useCurrentRouteId($2bd9a3ffc1ab0195$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $2bd9a3ffc1ab0195$export$fd5d37484eab868d(routeId) {
    let state = $2bd9a3ffc1ab0195$var$useDataRouterState($2bd9a3ffc1ab0195$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $2bd9a3ffc1ab0195$export$fdc00f3f26066d5e() {
    let state = $2bd9a3ffc1ab0195$var$useDataRouterState($2bd9a3ffc1ab0195$var$DataRouterStateHook.UseActionData);
    let routeId = $2bd9a3ffc1ab0195$var$useCurrentRouteId($2bd9a3ffc1ab0195$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $2bd9a3ffc1ab0195$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $bCCVl.useContext($2bd9a3ffc1ab0195$var$RouteErrorContext);
    let state = $2bd9a3ffc1ab0195$var$useDataRouterState($2bd9a3ffc1ab0195$var$DataRouterStateHook.UseRouteError);
    let routeId = $2bd9a3ffc1ab0195$var$useCurrentRouteId($2bd9a3ffc1ab0195$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $2bd9a3ffc1ab0195$export$78a72ddb39bdd145() {
    let value = $bCCVl.useContext($2bd9a3ffc1ab0195$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $2bd9a3ffc1ab0195$export$17f53340677d5831() {
    let value = $bCCVl.useContext($2bd9a3ffc1ab0195$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $2bd9a3ffc1ab0195$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $2bd9a3ffc1ab0195$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $2bd9a3ffc1ab0195$var$useDataRouterContext($2bd9a3ffc1ab0195$var$DataRouterHook.UseBlocker);
    let state = $2bd9a3ffc1ab0195$var$useDataRouterState($2bd9a3ffc1ab0195$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $bCCVl.useState("");
    let blockerFunction = $bCCVl.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $2bd9a3ffc1ab0195$var$_extends({}, currentLocation, {
                pathname: (0, $67befd869d250436$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $2bd9a3ffc1ab0195$var$_extends({}, nextLocation, {
                pathname: (0, $67befd869d250436$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $bCCVl.useEffect(()=>{
        let key = String(++$2bd9a3ffc1ab0195$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $bCCVl.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $67befd869d250436$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $2bd9a3ffc1ab0195$var$useNavigateStable() {
    let { router: router } = $2bd9a3ffc1ab0195$var$useDataRouterContext($2bd9a3ffc1ab0195$var$DataRouterHook.UseNavigateStable);
    let id = $2bd9a3ffc1ab0195$var$useCurrentRouteId($2bd9a3ffc1ab0195$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $bCCVl.useRef(false);
    $2bd9a3ffc1ab0195$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $bCCVl.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $2bd9a3ffc1ab0195$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $2bd9a3ffc1ab0195$var$alreadyWarned = {};
function $2bd9a3ffc1ab0195$var$warningOnce(key, cond, message) {
    if (!cond && !$2bd9a3ffc1ab0195$var$alreadyWarned[key]) $2bd9a3ffc1ab0195$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $2bd9a3ffc1ab0195$var$START_TRANSITION = "startTransition";
const $2bd9a3ffc1ab0195$var$startTransitionImpl = $bCCVl[$2bd9a3ffc1ab0195$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $2bd9a3ffc1ab0195$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $bCCVl.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bCCVl.useCallback((newState)=>{
        if (v7_startTransition && $2bd9a3ffc1ab0195$var$startTransitionImpl) $2bd9a3ffc1ab0195$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $bCCVl.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $bCCVl.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $bCCVl.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $bCCVl.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $bCCVl.createElement($bCCVl.Fragment, null, /*#__PURE__*/ $bCCVl.createElement($2bd9a3ffc1ab0195$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $bCCVl.createElement($2bd9a3ffc1ab0195$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $bCCVl.createElement($2bd9a3ffc1ab0195$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $bCCVl.createElement($2bd9a3ffc1ab0195$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $2bd9a3ffc1ab0195$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $2bd9a3ffc1ab0195$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $2bd9a3ffc1ab0195$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $bCCVl.useRef();
    if (historyRef.current == null) historyRef.current = (0, $67befd869d250436$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $bCCVl.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bCCVl.useCallback((newState)=>{
        v7_startTransition && $2bd9a3ffc1ab0195$var$startTransitionImpl ? $2bd9a3ffc1ab0195$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $bCCVl.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $bCCVl.createElement($2bd9a3ffc1ab0195$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $2bd9a3ffc1ab0195$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$2bd9a3ffc1ab0195$export$9c954a9d03d32f4a() && (0, $67befd869d250436$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $bCCVl.useContext($2bd9a3ffc1ab0195$export$26749e8557646306);
    let { matches: matches } = $bCCVl.useContext($2bd9a3ffc1ab0195$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $2bd9a3ffc1ab0195$export$45d76561a5302f2b();
    let navigate = $2bd9a3ffc1ab0195$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $67befd869d250436$export$cae722b0cc860f13)(to, (0, $67befd869d250436$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $bCCVl.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $2bd9a3ffc1ab0195$export$910ae8079b2c2852(props) {
    return $2bd9a3ffc1ab0195$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $2bd9a3ffc1ab0195$export$e7b0ac011bb776c6(_props) {
    (0, $67befd869d250436$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $2bd9a3ffc1ab0195$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $67befd869d250436$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$2bd9a3ffc1ab0195$export$9c954a9d03d32f4a() && (0, $67befd869d250436$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $bCCVl.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $2bd9a3ffc1ab0195$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $67befd869d250436$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $bCCVl.useMemo(()=>{
        let trailingPathname = (0, $67befd869d250436$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $bCCVl.createElement($2bd9a3ffc1ab0195$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $bCCVl.createElement($2bd9a3ffc1ab0195$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $2bd9a3ffc1ab0195$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $2bd9a3ffc1ab0195$export$5d3fca4a98652595($2bd9a3ffc1ab0195$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $2bd9a3ffc1ab0195$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $bCCVl.createElement($2bd9a3ffc1ab0195$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $bCCVl.createElement($2bd9a3ffc1ab0195$var$ResolveAwait, null, children));
}
var $2bd9a3ffc1ab0195$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($2bd9a3ffc1ab0195$var$AwaitRenderStatus || {});
const $2bd9a3ffc1ab0195$var$neverSettledPromise = new Promise(()=>{});
class $2bd9a3ffc1ab0195$var$AwaitErrorBoundary extends $bCCVl.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $2bd9a3ffc1ab0195$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $2bd9a3ffc1ab0195$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $2bd9a3ffc1ab0195$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $2bd9a3ffc1ab0195$var$AwaitRenderStatus.error : "_data" in promise ? $2bd9a3ffc1ab0195$var$AwaitRenderStatus.success : $2bd9a3ffc1ab0195$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $2bd9a3ffc1ab0195$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $2bd9a3ffc1ab0195$var$AwaitRenderStatus.error && promise._error instanceof (0, $67befd869d250436$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $2bd9a3ffc1ab0195$var$neverSettledPromise;
        if (status === $2bd9a3ffc1ab0195$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $2bd9a3ffc1ab0195$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $bCCVl.createElement($2bd9a3ffc1ab0195$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $2bd9a3ffc1ab0195$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $bCCVl.createElement($2bd9a3ffc1ab0195$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $2bd9a3ffc1ab0195$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $2bd9a3ffc1ab0195$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $bCCVl.createElement($bCCVl.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $2bd9a3ffc1ab0195$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $bCCVl.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $bCCVl.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $bCCVl.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $2bd9a3ffc1ab0195$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $2bd9a3ffc1ab0195$export$e7b0ac011bb776c6) && (0, $67befd869d250436$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $67befd869d250436$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $2bd9a3ffc1ab0195$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $2bd9a3ffc1ab0195$export$daf73786167a7f72(matches) {
    return $2bd9a3ffc1ab0195$var$_renderMatches(matches);
}
function $2bd9a3ffc1ab0195$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $bCCVl.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $bCCVl.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $bCCVl.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $2bd9a3ffc1ab0195$export$f30f7e456d254e83(routes, opts) {
    return (0, $67befd869d250436$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $2bd9a3ffc1ab0195$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $67befd869d250436$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $2bd9a3ffc1ab0195$export$52b333d321859367,
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnMiss: opts == null ? void 0 : opts.unstable_patchRoutesOnMiss
    }).initialize();
}



function $1cceaedd24710e82$var$_extends() {
    $1cceaedd24710e82$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1cceaedd24710e82$var$_extends.apply(this, arguments);
}
function $1cceaedd24710e82$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $1cceaedd24710e82$var$defaultMethod = "get";
const $1cceaedd24710e82$var$defaultEncType = "application/x-www-form-urlencoded";
function $1cceaedd24710e82$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $1cceaedd24710e82$var$isButtonElement(object) {
    return $1cceaedd24710e82$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $1cceaedd24710e82$var$isFormElement(object) {
    return $1cceaedd24710e82$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $1cceaedd24710e82$var$isInputElement(object) {
    return $1cceaedd24710e82$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $1cceaedd24710e82$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $1cceaedd24710e82$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$1cceaedd24710e82$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $1cceaedd24710e82$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $1cceaedd24710e82$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $1cceaedd24710e82$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $1cceaedd24710e82$var$_formDataSupportsSubmitter = null;
function $1cceaedd24710e82$var$isFormDataSubmitterSupported() {
    if ($1cceaedd24710e82$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $1cceaedd24710e82$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $1cceaedd24710e82$var$_formDataSupportsSubmitter = true;
    }
    return $1cceaedd24710e82$var$_formDataSupportsSubmitter;
}
const $1cceaedd24710e82$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $1cceaedd24710e82$var$getFormEncType(encType) {
    if (encType != null && !$1cceaedd24710e82$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $1cceaedd24710e82$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($1cceaedd24710e82$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $67befd869d250436$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $1cceaedd24710e82$var$defaultMethod;
        encType = $1cceaedd24710e82$var$getFormEncType(target.getAttribute("enctype")) || $1cceaedd24710e82$var$defaultEncType;
        formData = new FormData(target);
    } else if ($1cceaedd24710e82$var$isButtonElement(target) || $1cceaedd24710e82$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $67befd869d250436$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $1cceaedd24710e82$var$defaultMethod;
        encType = $1cceaedd24710e82$var$getFormEncType(target.getAttribute("formenctype")) || $1cceaedd24710e82$var$getFormEncType(form.getAttribute("enctype")) || $1cceaedd24710e82$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$1cceaedd24710e82$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($1cceaedd24710e82$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $1cceaedd24710e82$var$defaultMethod;
        action = null;
        encType = $1cceaedd24710e82$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $1cceaedd24710e82$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $1cceaedd24710e82$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $1cceaedd24710e82$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $1cceaedd24710e82$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $1cceaedd24710e82$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $1cceaedd24710e82$export$1f3f55432a00e06d(routes, opts) {
    return (0, $67befd869d250436$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $1cceaedd24710e82$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $67befd869d250436$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $1cceaedd24710e82$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $2bd9a3ffc1ab0195$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnMiss: opts == null ? void 0 : opts.unstable_patchRoutesOnMiss,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $1cceaedd24710e82$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $67befd869d250436$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $1cceaedd24710e82$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $67befd869d250436$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $1cceaedd24710e82$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $2bd9a3ffc1ab0195$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnMiss: opts == null ? void 0 : opts.unstable_patchRoutesOnMiss,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $1cceaedd24710e82$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $1cceaedd24710e82$var$_extends({}, state, {
        errors: $1cceaedd24710e82$var$deserializeErrors(state.errors)
    });
    return state;
}
function $1cceaedd24710e82$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $67befd869d250436$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $1cceaedd24710e82$export$7ad602f0e94e62d1 = /*#__PURE__*/ $bCCVl.createContext({
    isTransitioning: false
});
const $1cceaedd24710e82$export$148fd98d095596d4 = /*#__PURE__*/ $bCCVl.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $1cceaedd24710e82$var$START_TRANSITION = "startTransition";
const $1cceaedd24710e82$var$startTransitionImpl = $bCCVl[$1cceaedd24710e82$var$START_TRANSITION];
const $1cceaedd24710e82$var$FLUSH_SYNC = "flushSync";
const $1cceaedd24710e82$var$flushSyncImpl = $02909f7325781ee4$exports[$1cceaedd24710e82$var$FLUSH_SYNC];
const $1cceaedd24710e82$var$USE_ID = "useId";
const $1cceaedd24710e82$var$useIdImpl = $bCCVl[$1cceaedd24710e82$var$USE_ID];
function $1cceaedd24710e82$var$startTransitionSafe(cb) {
    if ($1cceaedd24710e82$var$startTransitionImpl) $1cceaedd24710e82$var$startTransitionImpl(cb);
    else cb();
}
function $1cceaedd24710e82$var$flushSyncSafe(cb) {
    if ($1cceaedd24710e82$var$flushSyncImpl) $1cceaedd24710e82$var$flushSyncImpl(cb);
    else cb();
}
class $1cceaedd24710e82$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $1cceaedd24710e82$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $bCCVl.useState(router.state);
    let [pendingState, setPendingState] = $bCCVl.useState();
    let [vtContext, setVtContext] = $bCCVl.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $bCCVl.useState();
    let [transition, setTransition] = $bCCVl.useState();
    let [interruption, setInterruption] = $bCCVl.useState();
    let fetcherData = $bCCVl.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $bCCVl.useCallback((cb)=>{
        if (v7_startTransition) $1cceaedd24710e82$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $bCCVl.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $1cceaedd24710e82$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $1cceaedd24710e82$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $1cceaedd24710e82$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $1cceaedd24710e82$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $1cceaedd24710e82$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $bCCVl.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $bCCVl.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $1cceaedd24710e82$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $bCCVl.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $bCCVl.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $bCCVl.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $bCCVl.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $bCCVl.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $bCCVl.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $bCCVl.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $bCCVl.createElement($bCCVl.Fragment, null, /*#__PURE__*/ $bCCVl.createElement((0, $2bd9a3ffc1ab0195$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $bCCVl.createElement((0, $2bd9a3ffc1ab0195$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $bCCVl.createElement($1cceaedd24710e82$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $bCCVl.createElement($1cceaedd24710e82$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $bCCVl.createElement((0, $2bd9a3ffc1ab0195$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $bCCVl.createElement($1cceaedd24710e82$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $1cceaedd24710e82$var$MemoizedDataRoutes = /*#__PURE__*/ $bCCVl.memo($1cceaedd24710e82$var$DataRoutes);
function $1cceaedd24710e82$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $2bd9a3ffc1ab0195$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $1cceaedd24710e82$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $bCCVl.useRef();
    if (historyRef.current == null) historyRef.current = (0, $67befd869d250436$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $bCCVl.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bCCVl.useCallback((newState)=>{
        v7_startTransition && $1cceaedd24710e82$var$startTransitionImpl ? $1cceaedd24710e82$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $bCCVl.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $bCCVl.createElement((0, $2bd9a3ffc1ab0195$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $1cceaedd24710e82$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $bCCVl.useRef();
    if (historyRef.current == null) historyRef.current = (0, $67befd869d250436$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $bCCVl.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bCCVl.useCallback((newState)=>{
        v7_startTransition && $1cceaedd24710e82$var$startTransitionImpl ? $1cceaedd24710e82$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $bCCVl.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $bCCVl.createElement((0, $2bd9a3ffc1ab0195$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $1cceaedd24710e82$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $bCCVl.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bCCVl.useCallback((newState)=>{
        v7_startTransition && $1cceaedd24710e82$var$startTransitionImpl ? $1cceaedd24710e82$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $bCCVl.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $bCCVl.createElement((0, $2bd9a3ffc1ab0195$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $1cceaedd24710e82$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $1cceaedd24710e82$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $1cceaedd24710e82$export$a6c7ac8248d6e38a = /*#__PURE__*/ $bCCVl.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $1cceaedd24710e82$var$_objectWithoutPropertiesLoose(_ref7, $1cceaedd24710e82$var$_excluded);
    let { basename: basename } = $bCCVl.useContext((0, $2bd9a3ffc1ab0195$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $1cceaedd24710e82$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($1cceaedd24710e82$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $67befd869d250436$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $2bd9a3ffc1ab0195$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $1cceaedd24710e82$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $bCCVl.createElement("a", $1cceaedd24710e82$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $1cceaedd24710e82$export$b0d92dbee9b5b60d = /*#__PURE__*/ $bCCVl.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $1cceaedd24710e82$var$_objectWithoutPropertiesLoose(_ref8, $1cceaedd24710e82$var$_excluded2);
    let path = (0, $2bd9a3ffc1ab0195$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $2bd9a3ffc1ab0195$export$45d76561a5302f2b)();
    let routerState = $bCCVl.useContext((0, $2bd9a3ffc1ab0195$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $bCCVl.useContext((0, $2bd9a3ffc1ab0195$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $1cceaedd24710e82$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $67befd869d250436$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $bCCVl.createElement($1cceaedd24710e82$export$a6c7ac8248d6e38a, $1cceaedd24710e82$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $1cceaedd24710e82$export$a7fed597f4b8afd8 = /*#__PURE__*/ $bCCVl.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $1cceaedd24710e82$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $1cceaedd24710e82$var$_objectWithoutPropertiesLoose(_ref9, $1cceaedd24710e82$var$_excluded3);
    let submit = $1cceaedd24710e82$export$47c85c6e3a081d3();
    let formAction = $1cceaedd24710e82$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $bCCVl.createElement("form", $1cceaedd24710e82$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $1cceaedd24710e82$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $1cceaedd24710e82$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $1cceaedd24710e82$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($1cceaedd24710e82$var$DataRouterHook || ($1cceaedd24710e82$var$DataRouterHook = {}));
var $1cceaedd24710e82$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($1cceaedd24710e82$var$DataRouterStateHook || ($1cceaedd24710e82$var$DataRouterStateHook = {}));
// Internal hooks
function $1cceaedd24710e82$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $1cceaedd24710e82$var$useDataRouterContext(hookName) {
    let ctx = $bCCVl.useContext((0, $2bd9a3ffc1ab0195$export$3add0d5dce533e2e));
    !ctx && (0, $67befd869d250436$export$3e9cee6b33872309)(false);
    return ctx;
}
function $1cceaedd24710e82$var$useDataRouterState(hookName) {
    let state = $bCCVl.useContext((0, $2bd9a3ffc1ab0195$export$145dfa71566a64dc));
    !state && (0, $67befd869d250436$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $1cceaedd24710e82$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $2bd9a3ffc1ab0195$export$9770f232ac06a008)();
    let location = (0, $2bd9a3ffc1ab0195$export$45d76561a5302f2b)();
    let path = (0, $2bd9a3ffc1ab0195$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $bCCVl.useCallback((event)=>{
        if ($1cceaedd24710e82$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $67befd869d250436$export$fe53371bee54353d)(location) === (0, $67befd869d250436$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $1cceaedd24710e82$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $bCCVl.useRef($1cceaedd24710e82$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $bCCVl.useRef(false);
    let location = (0, $2bd9a3ffc1ab0195$export$45d76561a5302f2b)();
    let searchParams = $bCCVl.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $1cceaedd24710e82$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $2bd9a3ffc1ab0195$export$9770f232ac06a008)();
    let setSearchParams = $bCCVl.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $1cceaedd24710e82$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $1cceaedd24710e82$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $1cceaedd24710e82$var$fetcherId = 0;
let $1cceaedd24710e82$var$getUniqueFetcherId = ()=>"__" + String(++$1cceaedd24710e82$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $1cceaedd24710e82$export$47c85c6e3a081d3() {
    let { router: router } = $1cceaedd24710e82$var$useDataRouterContext($1cceaedd24710e82$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $bCCVl.useContext((0, $2bd9a3ffc1ab0195$export$26749e8557646306));
    let currentRouteId = (0, $2bd9a3ffc1ab0195$export$5fc8298006ad9e58)();
    return $bCCVl.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $1cceaedd24710e82$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $1cceaedd24710e82$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $1cceaedd24710e82$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $1cceaedd24710e82$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $bCCVl.useContext((0, $2bd9a3ffc1ab0195$export$26749e8557646306));
    let routeContext = $bCCVl.useContext((0, $2bd9a3ffc1ab0195$export$9072aa6dd1f93057));
    !routeContext && (0, $67befd869d250436$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $1cceaedd24710e82$var$_extends({}, (0, $2bd9a3ffc1ab0195$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $2bd9a3ffc1ab0195$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $67befd869d250436$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $67befd869d250436$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $1cceaedd24710e82$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $1cceaedd24710e82$var$useDataRouterContext($1cceaedd24710e82$var$DataRouterHook.UseFetcher);
    let state = $1cceaedd24710e82$var$useDataRouterState($1cceaedd24710e82$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $bCCVl.useContext($1cceaedd24710e82$export$148fd98d095596d4);
    let route = $bCCVl.useContext((0, $2bd9a3ffc1ab0195$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $67befd869d250436$export$3e9cee6b33872309)(false);
    !route && (0, $67befd869d250436$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $67befd869d250436$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $1cceaedd24710e82$var$useIdImpl ? $1cceaedd24710e82$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $bCCVl.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($1cceaedd24710e82$var$getUniqueFetcherId());
    // Registration/cleanup
    $bCCVl.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $bCCVl.useCallback((href, opts)=>{
        !routeId && (0, $67befd869d250436$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $1cceaedd24710e82$export$47c85c6e3a081d3();
    let submit = $bCCVl.useCallback((target, opts)=>{
        submitImpl(target, $1cceaedd24710e82$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $bCCVl.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $bCCVl.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $bCCVl.createElement($1cceaedd24710e82$export$a7fed597f4b8afd8, $1cceaedd24710e82$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $67befd869d250436$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $bCCVl.useMemo(()=>$1cceaedd24710e82$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $1cceaedd24710e82$export$fa996778a3a31087() {
    let state = $1cceaedd24710e82$var$useDataRouterState($1cceaedd24710e82$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $1cceaedd24710e82$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $1cceaedd24710e82$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $1cceaedd24710e82$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $1cceaedd24710e82$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $1cceaedd24710e82$var$useDataRouterContext($1cceaedd24710e82$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $1cceaedd24710e82$var$useDataRouterState($1cceaedd24710e82$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $bCCVl.useContext((0, $2bd9a3ffc1ab0195$export$26749e8557646306));
    let location = (0, $2bd9a3ffc1ab0195$export$45d76561a5302f2b)();
    let matches = (0, $2bd9a3ffc1ab0195$export$2378eb7f5ff86053)();
    let navigation = (0, $2bd9a3ffc1ab0195$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $bCCVl.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $1cceaedd24710e82$var$usePageHide($bCCVl.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $1cceaedd24710e82$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $1cceaedd24710e82$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($1cceaedd24710e82$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $bCCVl.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $1cceaedd24710e82$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $1cceaedd24710e82$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $bCCVl.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($1cceaedd24710e82$var$_extends({}, location, {
                    pathname: (0, $67befd869d250436$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($1cceaedd24710e82$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $bCCVl.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $1cceaedd24710e82$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $bCCVl.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $1cceaedd24710e82$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $bCCVl.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $1cceaedd24710e82$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $2bd9a3ffc1ab0195$export$b273b3273281a049)(when);
    $bCCVl.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $bCCVl.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $1cceaedd24710e82$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $bCCVl.useContext($1cceaedd24710e82$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $67befd869d250436$export$3e9cee6b33872309)(false);
    let { basename: basename } = $1cceaedd24710e82$var$useDataRouterContext($1cceaedd24710e82$var$DataRouterHook.useViewTransitionState);
    let path = (0, $2bd9a3ffc1ab0195$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $67befd869d250436$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $67befd869d250436$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $67befd869d250436$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $67befd869d250436$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $bCCVl = parcelRequire("bCCVl");
const $1a32df2dbd32d8e6$var$useOnlineStatus = ()=>{
    //Check if its online or offline
    const [onlineStatus, setOnlineStatus] = (0, $bCCVl.useState)(true);
    (0, $bCCVl.useEffect)(()=>{
        window.addEventListener("offline", ()=>{
            setOnlineStatus(false);
        });
        window.addEventListener("online", ()=>{
            setOnlineStatus(true);
        });
    }, []);
    //return boolean value
    return onlineStatus;
};
var $1a32df2dbd32d8e6$export$2e2bcd8739ae039 = $1a32df2dbd32d8e6$var$useOnlineStatus;



var $bCCVl = parcelRequire("bCCVl");
const $ee52d48033679fb8$var$UserContext = /*#__PURE__*/ (0, $bCCVl.createContext)({
    loggedInUser: "Default User"
});
var $ee52d48033679fb8$export$2e2bcd8739ae039 = $ee52d48033679fb8$var$UserContext;



var $bCCVl = parcelRequire("bCCVl");
var $f28e0d0ed0dadd16$exports = {};
"use strict";

$f28e0d0ed0dadd16$exports = (parcelRequire("7WyXp"));


var $fca7d9e435ad71ad$var$__defProp = Object.defineProperty;
var $fca7d9e435ad71ad$var$__defProps = Object.defineProperties;
var $fca7d9e435ad71ad$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $fca7d9e435ad71ad$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $fca7d9e435ad71ad$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $fca7d9e435ad71ad$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $fca7d9e435ad71ad$var$__defNormalProp = (obj, key, value)=>key in obj ? $fca7d9e435ad71ad$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $fca7d9e435ad71ad$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($fca7d9e435ad71ad$var$__hasOwnProp.call(b, prop)) $fca7d9e435ad71ad$var$__defNormalProp(a, prop, b[prop]);
    if ($fca7d9e435ad71ad$var$__getOwnPropSymbols) {
        for (var prop of $fca7d9e435ad71ad$var$__getOwnPropSymbols(b))if ($fca7d9e435ad71ad$var$__propIsEnum.call(b, prop)) $fca7d9e435ad71ad$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $fca7d9e435ad71ad$var$__spreadProps = (a, b)=>$fca7d9e435ad71ad$var$__defProps(a, $fca7d9e435ad71ad$var$__getOwnPropDescs(b));
var $fca7d9e435ad71ad$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($fca7d9e435ad71ad$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $fca7d9e435ad71ad$var$__getOwnPropSymbols) {
        for (var prop of $fca7d9e435ad71ad$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $fca7d9e435ad71ad$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $fca7d9e435ad71ad$var$React = // prettier-ignore
// @ts-ignore
"default" in $bCCVl ? $bCCVl["default"] : $bCCVl;
// src/components/Context.ts
var $fca7d9e435ad71ad$var$ContextKey = Symbol.for(`react-redux-context`);
var $fca7d9e435ad71ad$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $fca7d9e435ad71ad$var$getContext() {
    var _a;
    if (!$fca7d9e435ad71ad$var$React.createContext) return {};
    const contextMap = (_a = $fca7d9e435ad71ad$var$gT[$fca7d9e435ad71ad$var$ContextKey]) != null ? _a : $fca7d9e435ad71ad$var$gT[$fca7d9e435ad71ad$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($fca7d9e435ad71ad$var$React.createContext);
    if (!realContext) {
        realContext = $fca7d9e435ad71ad$var$React.createContext(null);
        contextMap.set($fca7d9e435ad71ad$var$React.createContext, realContext);
    }
    return realContext;
}
var $fca7d9e435ad71ad$export$cc80c08dc91f1c00 = /* @__PURE__ */ $fca7d9e435ad71ad$var$getContext();
// src/utils/useSyncExternalStore.ts
var $fca7d9e435ad71ad$var$notInitialized = ()=>{
    throw new Error("uSES not initialized!");
};
// src/hooks/useReduxContext.ts
function $fca7d9e435ad71ad$var$createReduxContextHook(context = $fca7d9e435ad71ad$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $fca7d9e435ad71ad$var$React.useContext(context);
        return contextValue;
    };
}
var $fca7d9e435ad71ad$var$useReduxContext = /* @__PURE__ */ $fca7d9e435ad71ad$var$createReduxContextHook();
// src/hooks/useSelector.ts
var $fca7d9e435ad71ad$var$useSyncExternalStoreWithSelector = $fca7d9e435ad71ad$var$notInitialized;
var $fca7d9e435ad71ad$var$initializeUseSelector = (fn)=>{
    $fca7d9e435ad71ad$var$useSyncExternalStoreWithSelector = fn;
};
var $fca7d9e435ad71ad$var$refEquality = (a, b)=>a === b;
function $fca7d9e435ad71ad$export$2b53f90d2bd1cbfb(context = $fca7d9e435ad71ad$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $fca7d9e435ad71ad$export$cc80c08dc91f1c00 ? $fca7d9e435ad71ad$var$useReduxContext : $fca7d9e435ad71ad$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $fca7d9e435ad71ad$var$refEquality, devModeChecks: devModeChecks = {} } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: stabilityCheck, identityFunctionCheck: identityFunctionCheck } = useReduxContext2();
        const firstRun = $fca7d9e435ad71ad$var$React.useRef(true);
        const wrappedSelector = $fca7d9e435ad71ad$var$React.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            stabilityCheck,
            devModeChecks.stabilityCheck
        ]);
        const selectedState = $fca7d9e435ad71ad$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $fca7d9e435ad71ad$var$React.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $fca7d9e435ad71ad$export$2105062e25df4afe = /* @__PURE__ */ $fca7d9e435ad71ad$export$2b53f90d2bd1cbfb();
// src/utils/react-is.ts
var $fca7d9e435ad71ad$var$REACT_ELEMENT_TYPE = Symbol.for("react.element");
var $fca7d9e435ad71ad$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
var $fca7d9e435ad71ad$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
var $fca7d9e435ad71ad$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
var $fca7d9e435ad71ad$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
var $fca7d9e435ad71ad$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider");
var $fca7d9e435ad71ad$var$REACT_CONTEXT_TYPE = Symbol.for("react.context");
var $fca7d9e435ad71ad$var$REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
var $fca7d9e435ad71ad$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
var $fca7d9e435ad71ad$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
var $fca7d9e435ad71ad$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
var $fca7d9e435ad71ad$var$REACT_MEMO_TYPE = Symbol.for("react.memo");
var $fca7d9e435ad71ad$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
var $fca7d9e435ad71ad$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
var $fca7d9e435ad71ad$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
var $fca7d9e435ad71ad$var$ForwardRef = $fca7d9e435ad71ad$var$REACT_FORWARD_REF_TYPE;
var $fca7d9e435ad71ad$var$Memo = $fca7d9e435ad71ad$var$REACT_MEMO_TYPE;
function $fca7d9e435ad71ad$var$isValidElementType(type) {
    if (typeof type === "string" || typeof type === "function") return true;
    if (type === $fca7d9e435ad71ad$var$REACT_FRAGMENT_TYPE || type === $fca7d9e435ad71ad$var$REACT_PROFILER_TYPE || type === $fca7d9e435ad71ad$var$REACT_STRICT_MODE_TYPE || type === $fca7d9e435ad71ad$var$REACT_SUSPENSE_TYPE || type === $fca7d9e435ad71ad$var$REACT_SUSPENSE_LIST_TYPE || type === $fca7d9e435ad71ad$var$REACT_OFFSCREEN_TYPE) return true;
    if (typeof type === "object" && type !== null) {
        if (type.$$typeof === $fca7d9e435ad71ad$var$REACT_LAZY_TYPE || type.$$typeof === $fca7d9e435ad71ad$var$REACT_MEMO_TYPE || type.$$typeof === $fca7d9e435ad71ad$var$REACT_PROVIDER_TYPE || type.$$typeof === $fca7d9e435ad71ad$var$REACT_CONTEXT_TYPE || type.$$typeof === $fca7d9e435ad71ad$var$REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        type.$$typeof === $fca7d9e435ad71ad$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) return true;
    }
    return false;
}
function $fca7d9e435ad71ad$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const $$typeof = object.$$typeof;
        switch($$typeof){
            case $fca7d9e435ad71ad$var$REACT_ELEMENT_TYPE:
                {
                    const type = object.type;
                    switch(type){
                        case $fca7d9e435ad71ad$var$REACT_FRAGMENT_TYPE:
                        case $fca7d9e435ad71ad$var$REACT_PROFILER_TYPE:
                        case $fca7d9e435ad71ad$var$REACT_STRICT_MODE_TYPE:
                        case $fca7d9e435ad71ad$var$REACT_SUSPENSE_TYPE:
                        case $fca7d9e435ad71ad$var$REACT_SUSPENSE_LIST_TYPE:
                            return type;
                        default:
                            {
                                const $$typeofType = type && type.$$typeof;
                                switch($$typeofType){
                                    case $fca7d9e435ad71ad$var$REACT_SERVER_CONTEXT_TYPE:
                                    case $fca7d9e435ad71ad$var$REACT_CONTEXT_TYPE:
                                    case $fca7d9e435ad71ad$var$REACT_FORWARD_REF_TYPE:
                                    case $fca7d9e435ad71ad$var$REACT_LAZY_TYPE:
                                    case $fca7d9e435ad71ad$var$REACT_MEMO_TYPE:
                                    case $fca7d9e435ad71ad$var$REACT_PROVIDER_TYPE:
                                        return $$typeofType;
                                    default:
                                        return $$typeof;
                                }
                            }
                    }
                }
            case $fca7d9e435ad71ad$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
    return void 0;
}
function $fca7d9e435ad71ad$var$isContextConsumer(object) {
    return $fca7d9e435ad71ad$var$typeOf(object) === $fca7d9e435ad71ad$var$REACT_CONTEXT_TYPE;
}
function $fca7d9e435ad71ad$var$isMemo(object) {
    return $fca7d9e435ad71ad$var$typeOf(object) === $fca7d9e435ad71ad$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $fca7d9e435ad71ad$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $fca7d9e435ad71ad$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $fca7d9e435ad71ad$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $fca7d9e435ad71ad$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $fca7d9e435ad71ad$var$verify(mapStateToProps, "mapStateToProps");
    $fca7d9e435ad71ad$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $fca7d9e435ad71ad$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $fca7d9e435ad71ad$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $fca7d9e435ad71ad$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $fca7d9e435ad71ad$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $fca7d9e435ad71ad$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $fca7d9e435ad71ad$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $fca7d9e435ad71ad$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $fca7d9e435ad71ad$var$verifyPlainObject(value, displayName, methodName) {
    if (!$fca7d9e435ad71ad$var$isPlainObject(value)) $fca7d9e435ad71ad$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $fca7d9e435ad71ad$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $fca7d9e435ad71ad$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $fca7d9e435ad71ad$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $fca7d9e435ad71ad$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $fca7d9e435ad71ad$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $fca7d9e435ad71ad$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $fca7d9e435ad71ad$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $fca7d9e435ad71ad$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $fca7d9e435ad71ad$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $fca7d9e435ad71ad$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $fca7d9e435ad71ad$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $fca7d9e435ad71ad$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $fca7d9e435ad71ad$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $fca7d9e435ad71ad$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $fca7d9e435ad71ad$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $fca7d9e435ad71ad$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $fca7d9e435ad71ad$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $fca7d9e435ad71ad$var$__spreadValues($fca7d9e435ad71ad$var$__spreadValues($fca7d9e435ad71ad$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $fca7d9e435ad71ad$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $fca7d9e435ad71ad$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$fca7d9e435ad71ad$var$defaultMergeProps : typeof mergeProps === "function" ? $fca7d9e435ad71ad$var$wrapMergePropsFunc(mergeProps) : $fca7d9e435ad71ad$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $fca7d9e435ad71ad$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $fca7d9e435ad71ad$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $fca7d9e435ad71ad$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $fca7d9e435ad71ad$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $fca7d9e435ad71ad$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $fca7d9e435ad71ad$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $fca7d9e435ad71ad$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $fca7d9e435ad71ad$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $fca7d9e435ad71ad$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $fca7d9e435ad71ad$var$isReactNative = typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $fca7d9e435ad71ad$var$useIsomorphicLayoutEffect = $fca7d9e435ad71ad$var$canUseDOM || $fca7d9e435ad71ad$var$isReactNative ? $fca7d9e435ad71ad$var$React.useLayoutEffect : $fca7d9e435ad71ad$var$React.useEffect;
// src/utils/shallowEqual.ts
function $fca7d9e435ad71ad$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $fca7d9e435ad71ad$export$d36bdfa510afb180(objA, objB) {
    if ($fca7d9e435ad71ad$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$fca7d9e435ad71ad$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $fca7d9e435ad71ad$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $fca7d9e435ad71ad$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $fca7d9e435ad71ad$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $fca7d9e435ad71ad$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $fca7d9e435ad71ad$var$TYPE_STATICS = {
    [$fca7d9e435ad71ad$var$ForwardRef]: $fca7d9e435ad71ad$var$FORWARD_REF_STATICS,
    [$fca7d9e435ad71ad$var$Memo]: $fca7d9e435ad71ad$var$MEMO_STATICS
};
function $fca7d9e435ad71ad$var$getStatics(component) {
    if ($fca7d9e435ad71ad$var$isMemo(component)) return $fca7d9e435ad71ad$var$MEMO_STATICS;
    return $fca7d9e435ad71ad$var$TYPE_STATICS[component["$$typeof"]] || $fca7d9e435ad71ad$var$REACT_STATICS;
}
var $fca7d9e435ad71ad$var$defineProperty = Object.defineProperty;
var $fca7d9e435ad71ad$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $fca7d9e435ad71ad$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $fca7d9e435ad71ad$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $fca7d9e435ad71ad$var$getPrototypeOf = Object.getPrototypeOf;
var $fca7d9e435ad71ad$var$objectPrototype = Object.prototype;
function $fca7d9e435ad71ad$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($fca7d9e435ad71ad$var$objectPrototype) {
            const inheritedComponent = $fca7d9e435ad71ad$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $fca7d9e435ad71ad$var$objectPrototype) $fca7d9e435ad71ad$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $fca7d9e435ad71ad$var$getOwnPropertyNames(sourceComponent);
        if ($fca7d9e435ad71ad$var$getOwnPropertySymbols) keys = keys.concat($fca7d9e435ad71ad$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $fca7d9e435ad71ad$var$getStatics(targetComponent);
        const sourceStatics = $fca7d9e435ad71ad$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$fca7d9e435ad71ad$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $fca7d9e435ad71ad$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $fca7d9e435ad71ad$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/connect.tsx
var $fca7d9e435ad71ad$var$useSyncExternalStore = $fca7d9e435ad71ad$var$notInitialized;
var $fca7d9e435ad71ad$var$initializeConnect = (fn)=>{
    $fca7d9e435ad71ad$var$useSyncExternalStore = fn;
};
var $fca7d9e435ad71ad$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $fca7d9e435ad71ad$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $fca7d9e435ad71ad$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $fca7d9e435ad71ad$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $fca7d9e435ad71ad$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $fca7d9e435ad71ad$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $fca7d9e435ad71ad$var$strictEqual(a, b) {
    return a === b;
}
var $fca7d9e435ad71ad$var$hasWarnedAboutDeprecatedPureOption = false;
function $fca7d9e435ad71ad$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $fca7d9e435ad71ad$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $fca7d9e435ad71ad$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $fca7d9e435ad71ad$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $fca7d9e435ad71ad$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $fca7d9e435ad71ad$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $fca7d9e435ad71ad$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $fca7d9e435ad71ad$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $fca7d9e435ad71ad$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $fca7d9e435ad71ad$var$React.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $fca7d9e435ad71ad$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $fca7d9e435ad71ad$var$React.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $fca7d9e435ad71ad$var$React.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $fca7d9e435ad71ad$var$React.useMemo(()=>{
                return $fca7d9e435ad71ad$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $fca7d9e435ad71ad$var$React.useMemo(()=>{
                if (!shouldHandleStateChanges) return $fca7d9e435ad71ad$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $fca7d9e435ad71ad$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $fca7d9e435ad71ad$var$React.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $fca7d9e435ad71ad$var$__spreadProps($fca7d9e435ad71ad$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $fca7d9e435ad71ad$var$React.useRef(void 0);
            const lastWrapperProps = $fca7d9e435ad71ad$var$React.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $fca7d9e435ad71ad$var$React.useRef(void 0);
            const renderIsScheduled = $fca7d9e435ad71ad$var$React.useRef(false);
            const isMounted = $fca7d9e435ad71ad$var$React.useRef(false);
            const latestSubscriptionCallbackError = $fca7d9e435ad71ad$var$React.useRef(void 0);
            $fca7d9e435ad71ad$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $fca7d9e435ad71ad$var$React.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $fca7d9e435ad71ad$var$React.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $fca7d9e435ad71ad$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $fca7d9e435ad71ad$var$useIsomorphicLayoutEffectWithArgs($fca7d9e435ad71ad$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $fca7d9e435ad71ad$var$useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $fca7d9e435ad71ad$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $fca7d9e435ad71ad$var$React.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $fca7d9e435ad71ad$var$React.createElement(WrappedComponent, $fca7d9e435ad71ad$var$__spreadProps($fca7d9e435ad71ad$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $fca7d9e435ad71ad$var$React.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $fca7d9e435ad71ad$var$React.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $fca7d9e435ad71ad$var$React.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $fca7d9e435ad71ad$var$React.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $fca7d9e435ad71ad$var$React.createElement(Connect, $fca7d9e435ad71ad$var$__spreadProps($fca7d9e435ad71ad$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $fca7d9e435ad71ad$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $fca7d9e435ad71ad$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $fca7d9e435ad71ad$export$64605811ab45167f = $fca7d9e435ad71ad$var$connect;
// src/components/Provider.tsx
function $fca7d9e435ad71ad$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = "once", identityFunctionCheck: identityFunctionCheck = "once" }) {
    const contextValue = $fca7d9e435ad71ad$var$React.useMemo(()=>{
        const subscription = $fca7d9e435ad71ad$var$createSubscription(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0,
            stabilityCheck: stabilityCheck,
            identityFunctionCheck: identityFunctionCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        identityFunctionCheck
    ]);
    const previousState = $fca7d9e435ad71ad$var$React.useMemo(()=>store.getState(), [
        store
    ]);
    $fca7d9e435ad71ad$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $fca7d9e435ad71ad$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $fca7d9e435ad71ad$var$React.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $fca7d9e435ad71ad$export$2881499e37b75b9a = $fca7d9e435ad71ad$var$Provider;
// src/hooks/useStore.ts
function $fca7d9e435ad71ad$export$671dba69185d0304(context = $fca7d9e435ad71ad$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $fca7d9e435ad71ad$export$cc80c08dc91f1c00 ? $fca7d9e435ad71ad$var$useReduxContext : // @ts-ignore
    $fca7d9e435ad71ad$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $fca7d9e435ad71ad$export$6ccbb43953eebf8 = /* @__PURE__ */ $fca7d9e435ad71ad$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $fca7d9e435ad71ad$export$bc9b55530897c558(context = $fca7d9e435ad71ad$export$cc80c08dc91f1c00) {
    const useStore2 = context === $fca7d9e435ad71ad$export$cc80c08dc91f1c00 ? $fca7d9e435ad71ad$export$6ccbb43953eebf8 : $fca7d9e435ad71ad$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $fca7d9e435ad71ad$export$8ad76b76a4c905f8 = /* @__PURE__ */ $fca7d9e435ad71ad$export$bc9b55530897c558();
// src/exports.ts
var $fca7d9e435ad71ad$export$712ea50be43a7858 = $fca7d9e435ad71ad$var$defaultNoopBatch;
// src/index.ts
$fca7d9e435ad71ad$var$initializeUseSelector((0, $f28e0d0ed0dadd16$exports.useSyncExternalStoreWithSelector));
$fca7d9e435ad71ad$var$initializeConnect($bCCVl.useSyncExternalStore);


const $849b7a06d4c2381c$var$Header = ()=>{
    //let btnLogin="Login";
    const [btnNameReact, setBtnNameReact] = (0, $bCCVl.useState)("Login");
    // console.log("Header Rendered");
    //If no dependency array => useEffect is called on every time to render
    //If dependency array is empty = [] => useEffect is called on initial render(just once time)
    //If dependency array is [btnNameReact] => called every time btnNameReact is updated.
    (0, $bCCVl.useEffect)(()=>{
    //  console.log("useEffect Called");
    }, []);
    const onlineStatus = (0, $1a32df2dbd32d8e6$export$2e2bcd8739ae039)();
    const { loggedInUser: loggedInUser } = (0, $bCCVl.useContext)((0, $ee52d48033679fb8$export$2e2bcd8739ae039));
    // console.log(loggedInUser);   //loggedInUser Show
    //Subscribing to the store using a Selector
    const cartItems = (0, $fca7d9e435ad71ad$export$2105062e25df4afe)((store)=>store.cart.items);
    // console.log(cartItems);
    return /*#__PURE__*/ (0, $2T6zX.jsxs)("div", {
        className: "flex sm:px-0 lg:px-40 justify-between bg-purple-200 shadow-lg sm:bg-yellow-100 lg:bg-orange-600 flex-wrap fixed top-0 w-full z-40",
        children: [
            /*#__PURE__*/ (0, $2T6zX.jsx)("div", {
                className: "logo-container",
                children: /*#__PURE__*/ (0, $2T6zX.jsx)("img", {
                    className: "logo w-24",
                    alt: "logo",
                    src: (0, $7fd0baa016ace72e$export$8878ead86ed0da0b)
                })
            }),
            /*#__PURE__*/ (0, $2T6zX.jsx)("div", {
                className: "flex items-center",
                children: /*#__PURE__*/ (0, $2T6zX.jsxs)("ul", {
                    className: "flex p-2 pr-4 text-white font-bold text-lg",
                    children: [
                        /*#__PURE__*/ (0, $2T6zX.jsxs)("li", {
                            children: [
                                "Online: ",
                                onlineStatus ? "\u2705" : "\u274E"
                            ]
                        }),
                        /*#__PURE__*/ (0, $2T6zX.jsx)("li", {
                            className: "px-4 hover:text-black",
                            children: /*#__PURE__*/ (0, $2T6zX.jsxs)((0, $1cceaedd24710e82$export$a6c7ac8248d6e38a), {
                                to: "/",
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0, $2T6zX.jsx)("i", {
                                        class: "fa fa-home",
                                        "aria-hidden": "true"
                                    }),
                                    "\xa0 Home"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $2T6zX.jsx)("li", {
                            className: "px-4 hover:text-black",
                            children: /*#__PURE__*/ (0, $2T6zX.jsxs)((0, $1cceaedd24710e82$export$a6c7ac8248d6e38a), {
                                to: "/about",
                                children: [
                                    /*#__PURE__*/ (0, $2T6zX.jsx)("i", {
                                        class: "fa fa-user-o",
                                        "aria-hidden": "true"
                                    }),
                                    "\xa0 About Us"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $2T6zX.jsx)("li", {
                            className: "px-4 hover:text-black",
                            children: /*#__PURE__*/ (0, $2T6zX.jsxs)((0, $1cceaedd24710e82$export$a6c7ac8248d6e38a), {
                                to: "/grocery",
                                children: [
                                    /*#__PURE__*/ (0, $2T6zX.jsx)("i", {
                                        class: "fa fa-shopping-basket",
                                        "aria-hidden": "true"
                                    }),
                                    "\xa0 Grocery"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $2T6zX.jsx)("li", {
                            className: "px-4 hover:text-black",
                            children: /*#__PURE__*/ (0, $2T6zX.jsxs)((0, $1cceaedd24710e82$export$a6c7ac8248d6e38a), {
                                to: "/contact",
                                children: [
                                    /*#__PURE__*/ (0, $2T6zX.jsx)("i", {
                                        class: "fa fa-envelope-o",
                                        "aria-hidden": "true"
                                    }),
                                    "\xa0 Contact Us"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $2T6zX.jsxs)("li", {
                            className: "px-4 hover:text-black",
                            children: [
                                " ",
                                /*#__PURE__*/ (0, $2T6zX.jsxs)((0, $1cceaedd24710e82$export$a6c7ac8248d6e38a), {
                                    to: "/cart",
                                    children: [
                                        /*#__PURE__*/ (0, $2T6zX.jsx)("i", {
                                            class: "fa fa-shopping-cart",
                                            "aria-hidden": "true"
                                        }),
                                        "\xa0 Cart ",
                                        /*#__PURE__*/ (0, $2T6zX.jsx)("span", {
                                            className: "font-bold",
                                            children: cartItems.length
                                        }),
                                        " "
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $2T6zX.jsxs)("button", {
                            className: "px-4 login",
                            onClick: ()=>{
                                // btnNameReact="Logout";
                                // setBtnNameReact("Logout");
                                // console.log(btnNameReact);
                                btnNameReact === "Login" ? setBtnNameReact("Logout") : setBtnNameReact("Login");
                            },
                            children: [
                                /*#__PURE__*/ (0, $2T6zX.jsx)("i", {
                                    class: "fa fa-sign-in",
                                    "aria-hidden": "true"
                                }),
                                "\xa0 ",
                                btnNameReact
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $849b7a06d4c2381c$export$2e2bcd8739ae039 = $849b7a06d4c2381c$var$Header;



var $2T6zX = parcelRequire("2T6zX");

var $2T6zX = parcelRequire("2T6zX");

var $bCCVl = parcelRequire("bCCVl");


const $21a9ae7d000f3398$var$RestaurantCard = (props)=>{
    const { loggedInUser: loggedInUser } = (0, $bCCVl.useContext)((0, $ee52d48033679fb8$export$2e2bcd8739ae039));
    // const {resName,cuisine}=props;
    const { resData: resData } = props;
    console.log(resData);
    const { name: name, cuisines: cuisines, avgRating: avgRating, costForTwo: costForTwo, deliveryTime: deliveryTime } = resData.info;
    return /*#__PURE__*/ (0, $2T6zX.jsxs)("div", {
        "data-testid": "resCard",
        className: "res-card m-4 p-4 w-[268px] h-[380px] rounded-lg bg-slate-100 overflow-hidden shadow-xl transition ease-in-out delay-75 hover: -translate-y-1 hover:scale-105 duration-300 hover:bg-gray-200",
        children: [
            /*#__PURE__*/ (0, $2T6zX.jsx)("img", {
                className: "rounded-lg h-48 w-full",
                alt: "res-img",
                src: (0, $7fd0baa016ace72e$export$c65137966c75edf0) + resData.info.cloudinaryImageId
            }),
            /*#__PURE__*/ (0, $2T6zX.jsx)("h3", {
                className: "font-bold text-lg py-2",
                children: name
            }),
            /*#__PURE__*/ (0, $2T6zX.jsx)("h4", {
                children: cuisines.join(", ")
            }),
            /*#__PURE__*/ (0, $2T6zX.jsxs)("h4", {
                children: [
                    /*#__PURE__*/ (0, $2T6zX.jsx)("i", {
                        className: "fa fa-star text-yellow-500",
                        "aria-hidden": "true"
                    }),
                    " ",
                    avgRating,
                    " stars"
                ]
            }),
            /*#__PURE__*/ (0, $2T6zX.jsx)("h4", {
                children: costForTwo
            }),
            /*#__PURE__*/ (0, $2T6zX.jsxs)("h4", {
                children: [
                    deliveryTime,
                    " minutes  "
                ]
            })
        ]
    });
};
const $21a9ae7d000f3398$export$ccb02a230af14023 = (RestaurantCard)=>{
    return (props)=>{
        return /*#__PURE__*/ (0, $2T6zX.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $2T6zX.jsx)("label", {
                    className: "absolute bg-black text-white m-2 p-2 rounded-lg",
                    children: "Promoted"
                }),
                /*#__PURE__*/ (0, $2T6zX.jsx)(RestaurantCard, {
                    ...props
                })
            ]
        });
    };
};
var $21a9ae7d000f3398$export$2e2bcd8739ae039 = $21a9ae7d000f3398$var$RestaurantCard;



var $bCCVl = parcelRequire("bCCVl");
const $6e78419c09133bf4$var$resList = [
    {
        info: {
            id: "78036",
            name: "Burger King",
            cloudinaryImageId: "e33e1d3ba7d6b2bb0d45e1001b731fcf",
            locality: "Central Plaza, Kalina",
            areaName: "Santacruz East",
            costForTwo: 35000,
            costForTwoString: "\u20B9350 for two",
            deliveryTime: 24,
            cuisines: [
                "Burgers",
                "American"
            ],
            avgRating: 4.2,
            feeDetails: {
                restaurantId: "78036",
                fees: [
                    {
                        name: "BASE_DISTANCE",
                        fee: 3200
                    },
                    {
                        name: "BASE_TIME"
                    },
                    {
                        name: "ANCILLARY_SURGE_FEE"
                    }
                ],
                totalFee: 3200
            },
            parentId: "166",
            avgRatingString: "4.2",
            totalRatingsString: "10K+",
            sla: {
                lastMileTravel: 1.5,
                serviceability: "SERVICEABLE",
                slaString: "24 mins",
                lastMileTravelString: "1.5 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2023-11-30 03:45:00",
                opened: true
            },
            badges: {},
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {},
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "ITEMS",
                subHeader: "AT \u20B9129"
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {}
        },
        analytics: {},
        cta: {
            link: "https://www.swiggy.com/restaurants/burger-king-central-plaza-kalina-santacruz-east-mumbai-78036",
            type: "WEBLINK"
        }
    },
    {
        info: {
            id: "32399",
            name: "McDonald's",
            cloudinaryImageId: "bb7ae131544c7d37e10fc5faf76f09d6",
            locality: "Kalina Artista",
            areaName: "Santacruz East",
            costForTwo: 40000,
            costForTwoString: "400 for two",
            deliveryTime: 17,
            cuisines: [
                "Burgers",
                "Beverages",
                "Cafe",
                "Desserts"
            ],
            avgRating: 4.3,
            feeDetails: {
                restaurantId: "32399",
                fees: [
                    {
                        name: "BASE_DISTANCE",
                        fee: 3900
                    },
                    {
                        name: "BASE_TIME"
                    },
                    {
                        name: "ANCILLARY_SURGE_FEE"
                    }
                ],
                totalFee: 3900
            },
            parentId: "630",
            avgRatingString: "4.3",
            totalRatingsString: "10K+",
            sla: {
                lastMileTravel: 1.5,
                serviceability: "SERVICEABLE",
                slaString: "17 mins",
                lastMileTravelString: "1.5 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2023-11-30 03:00:00",
                opened: true
            },
            badges: {
                textExtendedBadges: [
                    {
                        iconId: "guiltfree/GF_Logo_android_3x",
                        shortDescription: "options available",
                        fontColor: "#7E808C"
                    }
                ]
            },
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {},
                    textBased: {},
                    textExtendedBadges: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: "",
                                    fontColor: "#7E808C",
                                    iconId: "guiltfree/GF_Logo_android_3x",
                                    shortDescription: "options available"
                                }
                            }
                        ]
                    }
                }
            },
            aggregatedDiscountInfoV3: {
                header: "10% OFF",
                subHeader: "ABOVE \u20B91000",
                discountTag: "FLAT DEAL"
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {}
        },
        analytics: {},
        cta: {
            link: "https://www.swiggy.com/restaurants/mcdonalds-kalina-artista-santacruz-east-mumbai-32399",
            type: "WEBLINK"
        }
    },
    {
        info: {
            id: "82668",
            name: "The Belgian Waffle Co.",
            cloudinaryImageId: "846dab8cca3c56a482d7cbcda0dd0eb9",
            locality: "Kalina",
            areaName: "Santacruz East",
            costForTwoString: "\u20B9200 for two",
            costForTwo: 20000,
            deliveryTime: 32,
            cuisines: [
                "Waffle",
                "Desserts",
                "Ice Cream",
                "Beverages"
            ],
            avgRating: 4.3,
            veg: true,
            feeDetails: {
                restaurantId: "82668",
                fees: [
                    {
                        name: "BASE_DISTANCE",
                        fee: 3200
                    },
                    {
                        name: "BASE_TIME"
                    },
                    {
                        name: "ANCILLARY_SURGE_FEE"
                    }
                ],
                totalFee: 3200
            },
            parentId: "2233",
            avgRatingString: "4.3",
            totalRatingsString: "1K+",
            sla: {
                lastMileTravel: 1.5,
                serviceability: "SERVICEABLE",
                slaString: "32 mins",
                lastMileTravelString: "1.5 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2023-11-30 04:00:00",
                opened: true
            },
            badges: {},
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {},
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "40% OFF",
                subHeader: "UPTO \u20B980"
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {}
        },
        analytics: {},
        cta: {
            link: "https://www.swiggy.com/restaurants/the-belgian-waffle-co-kalina-santacruz-east-mumbai-82668",
            type: "WEBLINK"
        }
    },
    {
        info: {
            id: "116963",
            name: "Monginis",
            cloudinaryImageId: "hyzmji0gto0g7hag9y3z",
            locality: "Kurla",
            areaName: "Saki Naka",
            costForTwoString: "\u20B9300 for two",
            costForTwo: 30000,
            deliveryTime: 32,
            cuisines: [
                "Bakery",
                "Desserts",
                "Snacks"
            ],
            avgRating: 4.4,
            feeDetails: {
                restaurantId: "116963",
                fees: [
                    {
                        name: "BASE_DISTANCE",
                        fee: 3400
                    },
                    {
                        name: "BASE_TIME"
                    },
                    {
                        name: "ANCILLARY_SURGE_FEE"
                    }
                ],
                totalFee: 3400
            },
            parentId: "5007",
            avgRatingString: "4.4",
            totalRatingsString: "100+",
            sla: {
                deliveryTime: 22,
                lastMileTravel: 1,
                serviceability: "SERVICEABLE",
                slaString: "22 mins",
                lastMileTravelString: "1.0 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2023-11-29 20:00:00",
                opened: true
            },
            badges: {},
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {},
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "20% OFF",
                subHeader: "UPTO \u20B950"
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {}
        },
        analytics: {},
        cta: {
            link: "https://www.swiggy.com/restaurants/monginis-kurla-saki-naka-mumbai-116963",
            type: "WEBLINK"
        }
    },
    {
        info: {
            id: "11239",
            name: "Thambbi",
            cloudinaryImageId: "t6av3q7weumzdozcmowp",
            locality: "Opposite SBI Bank",
            areaName: "Kurla West",
            costForTwoString: "\u20B9400 for two",
            costForTwo: 40000,
            deliveryTime: 24,
            cuisines: [
                "South Indian",
                "Punjabi",
                "Snacks",
                "Thalis"
            ],
            avgRating: 4.4,
            veg: true,
            feeDetails: {
                restaurantId: "11239",
                fees: [
                    {
                        name: "BASE_DISTANCE",
                        fee: 3400
                    },
                    {
                        name: "BASE_TIME"
                    },
                    {
                        name: "ANCILLARY_SURGE_FEE"
                    }
                ],
                totalFee: 3400
            },
            parentId: "2527",
            avgRatingString: "4.4",
            totalRatingsString: "10K+",
            sla: {
                lastMileTravel: 1.3,
                serviceability: "SERVICEABLE",
                slaString: "24 mins",
                lastMileTravelString: "1.3 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2023-11-29 23:00:00",
                opened: true
            },
            badges: {
                textExtendedBadges: [
                    {
                        iconId: "guiltfree/GF_Logo_android_3x",
                        shortDescription: "options available",
                        fontColor: "#7E808C"
                    }
                ]
            },
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {},
                    textBased: {},
                    textExtendedBadges: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: "",
                                    fontColor: "#7E808C",
                                    iconId: "guiltfree/GF_Logo_android_3x",
                                    shortDescription: "options available"
                                }
                            }
                        ]
                    }
                }
            },
            aggregatedDiscountInfoV3: {
                header: "20% OFF",
                subHeader: "UPTO \u20B950"
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {}
        },
        analytics: {},
        cta: {
            link: "https://www.swiggy.com/restaurants/thambbi-opposite-sbi-bank-kurla-west-mumbai-11239",
            type: "WEBLINK"
        }
    },
    {
        info: {
            id: "28405",
            name: "Chinese Wok",
            cloudinaryImageId: "e0839ff574213e6f35b3899ebf1fc597",
            locality: "CST Road",
            areaName: "Santacruz East",
            costForTwoString: "\u20B9250 for two",
            costForTwo: 25000,
            deliveryTime: 22,
            cuisines: [
                "Chinese",
                "Asian",
                "Tibetan",
                "Desserts"
            ],
            avgRating: 4.1,
            feeDetails: {
                restaurantId: "28405",
                fees: [
                    {
                        name: "BASE_DISTANCE",
                        fee: 3200
                    },
                    {
                        name: "BASE_TIME"
                    },
                    {
                        name: "ANCILLARY_SURGE_FEE"
                    }
                ],
                totalFee: 3200
            },
            parentId: "61955",
            avgRatingString: "4.1",
            totalRatingsString: "10K+",
            sla: {
                lastMileTravel: 1.6,
                serviceability: "SERVICEABLE",
                slaString: "22 mins",
                lastMileTravelString: "1.6 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2023-11-30 01:00:00",
                opened: true
            },
            badges: {},
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {},
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "EVERY ITEM",
                subHeader: "@ \u20B9149"
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {}
        },
        analytics: {},
        cta: {
            link: "https://www.swiggy.com/restaurants/chinese-wok-cst-road-santacruz-east-mumbai-28405",
            type: "WEBLINK"
        }
    },
    {
        info: {
            id: "15837",
            name: "PizzaExpress",
            cloudinaryImageId: "bb1d7cd7173f315487ed009ba7ca8b9d",
            locality: "Bandra Kurla Complex",
            areaName: "Bandra Kurla Complex",
            costForTwoString: "\u20B9600 for two",
            costForTwo: 60000,
            deliveryTime: 32,
            cuisines: [
                "Pizzas",
                "Italian"
            ],
            avgRating: 4,
            feeDetails: {
                restaurantId: "15837",
                fees: [
                    {
                        name: "BASE_DISTANCE",
                        fee: 4100
                    },
                    {
                        name: "BASE_TIME"
                    },
                    {
                        name: "ANCILLARY_SURGE_FEE"
                    }
                ],
                totalFee: 4100
            },
            parentId: "3531",
            avgRatingString: "4.0",
            totalRatingsString: "1K+",
            sla: {
                lastMileTravel: 1.4,
                serviceability: "SERVICEABLE",
                slaString: "32 mins",
                lastMileTravelString: "1.4 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2023-11-30 00:45:00",
                opened: true
            },
            badges: {
                imageBadges: [
                    {
                        imageId: "newg.png",
                        description: "Gourmet"
                    }
                ]
            },
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: "Gourmet",
                                    imageId: "newg.png"
                                }
                            }
                        ]
                    },
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "10% OFF",
                subHeader: "ABOVE \u20B91500",
                discountTag: "FLAT DEAL"
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {}
        },
        analytics: {},
        cta: {
            link: "https://www.swiggy.com/restaurants/pizzaexpress-bandra-kurla-complex-mumbai-15837",
            type: "WEBLINK"
        }
    },
    {
        info: {
            id: "9052",
            name: "Subway",
            cloudinaryImageId: "1ace5fa65eff3e1223feb696c956b38b",
            locality: "Central Plaza, Kalina",
            areaName: "Santacruz East",
            costForTwoString: "\u20B9350 for two",
            costForTwo: 35000,
            deliveryTime: 22,
            cuisines: [
                "Salads",
                "Snacks",
                "Desserts",
                "Beverages"
            ],
            avgRating: 4.2,
            feeDetails: {
                restaurantId: "9052",
                fees: [
                    {
                        name: "BASE_DISTANCE",
                        fee: 3200
                    },
                    {
                        name: "BASE_TIME"
                    },
                    {
                        name: "ANCILLARY_SURGE_FEE"
                    }
                ],
                totalFee: 3200
            },
            parentId: "2",
            avgRatingString: "4.2",
            totalRatingsString: "10K+",
            sla: {
                lastMileTravel: 1.5,
                serviceability: "SERVICEABLE",
                slaString: "23 mins",
                lastMileTravelString: "1.5 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2023-11-30 04:00:00",
                opened: true
            },
            badges: {
                textExtendedBadges: [
                    {
                        iconId: "guiltfree/GF_Logo_android_3x",
                        shortDescription: "options available",
                        fontColor: "#7E808C"
                    }
                ]
            },
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {},
                    textBased: {},
                    textExtendedBadges: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: "",
                                    fontColor: "#7E808C",
                                    iconId: "guiltfree/GF_Logo_android_3x",
                                    shortDescription: "options available"
                                }
                            }
                        ]
                    }
                }
            },
            aggregatedDiscountInfoV3: {
                header: "40% OFF",
                subHeader: "UPTO \u20B980"
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {}
        },
        analytics: {},
        cta: {
            link: "https://www.swiggy.com/restaurants/subway-central-plaza-kalina-santacruz-east-mumbai-9052",
            type: "WEBLINK"
        }
    },
    {
        info: {
            id: "391816",
            name: "Louis Burger",
            cloudinaryImageId: "19d3d352cc815b9d88b22617b41fa97b",
            locality: "Trade Centre",
            areaName: "Santacruz Bandra east",
            costForTwoString: "\u20B9600 for two",
            costForTwo: 60000,
            deliveryTime: 27,
            cuisines: [
                "Burgers",
                "American",
                "Fast Food"
            ],
            avgRating: 4.3,
            feeDetails: {
                restaurantId: "391816",
                fees: [
                    {
                        name: "BASE_DISTANCE",
                        fee: 4100
                    },
                    {
                        name: "BASE_TIME"
                    },
                    {
                        name: "ANCILLARY_SURGE_FEE"
                    }
                ],
                totalFee: 4100
            },
            parentId: "22485",
            avgRatingString: "4.3",
            totalRatingsString: "1K+",
            sla: {
                lastMileTravel: 1.4,
                serviceability: "SERVICEABLE",
                slaString: "25 mins",
                lastMileTravelString: "1.4 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2023-11-30 04:00:00",
                opened: true
            },
            badges: {
                imageBadges: [
                    {
                        imageId: "newg.png",
                        description: "Gourmet"
                    }
                ]
            },
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: "Gourmet",
                                    imageId: "newg.png"
                                }
                            }
                        ]
                    },
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "\u20B9125 OFF",
                subHeader: "ABOVE \u20B9249",
                discountTag: "FLAT DEAL"
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {}
        },
        analytics: {},
        cta: {
            link: "https://www.swiggy.com/restaurants/louis-burger-trade-centre-santacruz-bandra-east-mumbai-391816",
            type: "WEBLINK"
        }
    },
    {
        info: {
            id: "395334",
            name: "McDonald's Gourmet Burger Collection",
            cloudinaryImageId: "txirbmikcfw5yijtcfs5",
            locality: "Kalina Artista",
            areaName: "Scruz Bandra East",
            costForTwoString: "\u20B9600 for two",
            costForTwo: 60000,
            deliveryTime: 20,
            cuisines: [
                "Burgers",
                "Beverages",
                "Cafe",
                "Desserts"
            ],
            avgRating: 3.8,
            feeDetails: {
                restaurantId: "395334",
                fees: [
                    {
                        name: "BASE_DISTANCE",
                        fee: 3900
                    },
                    {
                        name: "BASE_TIME"
                    },
                    {
                        name: "ANCILLARY_SURGE_FEE"
                    }
                ],
                totalFee: 3900
            },
            parentId: "10761",
            avgRatingString: "3.8",
            totalRatingsString: "100+",
            sla: {
                deliveryTime: 17,
                lastMileTravel: 1.5,
                serviceability: "SERVICEABLE",
                slaString: "17 mins",
                lastMileTravelString: "1.5 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2023-11-30 03:00:00",
                opened: true
            },
            badges: {},
            isOpen: true,
            aggregatedDiscountInfoV2: {},
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {},
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {}
        },
        analytics: {},
        cta: {
            link: "https://www.swiggy.com/restaurants/mcdonalds-gourmet-burger-collection-kalina-artista-scruz-bandra-east-mumbai-395334",
            type: "WEBLINK"
        }
    },
    {
        info: {
            id: "28721",
            name: "Oven Story Pizza - Standout Toppings",
            cloudinaryImageId: "f986df6f1a1fcf2ff24d2eaf44d570a7",
            locality: "Kalina",
            areaName: "Santacruz East",
            costForTwoString: "\u20B9400 for two",
            costForTwo: 40000,
            deliveryTime: 26,
            cuisines: [
                "Pizzas",
                "Pastas",
                "Italian",
                "Desserts",
                "Beverages"
            ],
            avgRating: 4,
            feeDetails: {
                restaurantId: "28721",
                fees: [
                    {
                        name: "BASE_DISTANCE",
                        fee: 4100
                    },
                    {
                        name: "BASE_TIME"
                    },
                    {
                        name: "ANCILLARY_SURGE_FEE"
                    }
                ],
                totalFee: 4100
            },
            parentId: "3534",
            avgRatingString: "4.0",
            totalRatingsString: "1K+",
            sla: {
                lastMileTravel: 1.9,
                serviceability: "SERVICEABLE",
                slaString: "30-42 mins",
                lastMileTravelString: "1.9 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2023-11-29 23:59:00",
                opened: true
            },
            badges: {},
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {},
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "60% OFF",
                subHeader: "UPTO \u20B9120"
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {}
        },
        analytics: {},
        cta: {
            link: "https://www.swiggy.com/restaurants/oven-story-pizza-standout-toppings-kalina-santacruz-east-mumbai-28721",
            type: "WEBLINK"
        }
    },
    {
        info: {
            id: "42885",
            name: "Rolls Mania",
            cloudinaryImageId: "g7donnzr1ev21elpr3nf",
            locality: "Santacruz East",
            areaName: "Santacruz East",
            costForTwoString: "\u20B9200 for two",
            costForTwo: 20000,
            deliveryTime: 22,
            cuisines: [
                "Indian"
            ],
            avgRating: 4.2,
            feeDetails: {
                restaurantId: "42885",
                fees: [
                    {
                        name: "BASE_DISTANCE",
                        fee: 3400
                    },
                    {
                        name: "BASE_TIME"
                    },
                    {
                        name: "ANCILLARY_SURGE_FEE"
                    }
                ],
                totalFee: 3400
            },
            parentId: "171118",
            avgRatingString: "4.2",
            totalRatingsString: "1K+",
            sla: {
                deliveryTime: 25,
                lastMileTravel: 1.5,
                serviceability: "SERVICEABLE",
                slaString: "25 mins",
                lastMileTravelString: "1.5 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2023-11-30 03:30:00",
                opened: true
            },
            badges: {},
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {},
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "50% OFF",
                subHeader: "UPTO \u20B9100"
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {}
        },
        analytics: {},
        cta: {
            link: "https://www.swiggy.com/restaurants/rolls-mania-santacruz-east-mumbai-42885",
            type: "WEBLINK"
        }
    },
    {
        info: {
            id: "156134",
            name: "The Good Bowl",
            cloudinaryImageId: "0b3356a88b6fc5966c452c4c9b1b5e4a",
            locality: "BKC FC",
            areaName: "Santacruz East",
            costForTwoString: "\u20B9400 for two",
            costForTwo: 40000,
            deliveryTime: 32,
            cuisines: [
                "Biryani",
                "North Indian",
                "Pastas",
                "Punjabi",
                "Desserts",
                "Beverages"
            ],
            avgRating: 4.1,
            feeDetails: {
                restaurantId: "156134",
                fees: [
                    {
                        name: "BASE_DISTANCE",
                        fee: 3200
                    },
                    {
                        name: "BASE_TIME"
                    },
                    {
                        name: "ANCILLARY_SURGE_FEE"
                    }
                ],
                totalFee: 3200
            },
            parentId: "7918",
            avgRatingString: "4.1",
            totalRatingsString: "1K+",
            sla: {
                deliveryTime: 26,
                lastMileTravel: 1.6,
                serviceability: "SERVICEABLE",
                slaString: "26 mins",
                lastMileTravelString: "1.6 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2023-11-29 23:59:00",
                opened: true
            },
            badges: {},
            isOpen: true,
            aggregatedDiscountInfoV2: {},
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {},
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {}
        },
        analytics: {},
        cta: {
            link: "https://www.swiggy.com/restaurants/the-good-bowl-bkc-fc-santacruz-east-mumbai-156134",
            type: "WEBLINK"
        }
    },
    {
        info: {
            id: "202836",
            name: "Hangout Cakes & More",
            cloudinaryImageId: "51f9c55884b15013b2c8582505a1ee4f",
            locality: "CST Road",
            areaName: "Santacruz East",
            costForTwoString: "\u20B9150 for two",
            costForTwo: 15000,
            deliveryTime: 22,
            cuisines: [
                "Bakery"
            ],
            avgRating: 4.3,
            veg: true,
            feeDetails: {
                restaurantId: "202836",
                fees: [
                    {
                        name: "BASE_DISTANCE",
                        fee: 4100
                    },
                    {
                        name: "BASE_TIME"
                    },
                    {
                        name: "ANCILLARY_SURGE_FEE"
                    }
                ],
                totalFee: 4100
            },
            parentId: "4508",
            avgRatingString: "4.3",
            totalRatingsString: "1K+",
            sla: {
                lastMileTravel: 1.5,
                serviceability: "SERVICEABLE",
                slaString: "22 mins",
                lastMileTravelString: "1.5 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2023-11-29 23:59:00",
                opened: true
            },
            badges: {
                imageBadges: [
                    {
                        imageId: "v1695133679/badges/Pure_Veg111.png",
                        description: "pureveg"
                    }
                ]
            },
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: "pureveg",
                                    imageId: "v1695133679/badges/Pure_Veg111.png"
                                }
                            }
                        ]
                    },
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "60% OFF",
                subHeader: "UPTO \u20B9120"
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {}
        },
        analytics: {},
        cta: {
            link: "https://www.swiggy.com/restaurants/hangout-cakes-and-more-cst-road-santacruz-east-mumbai-202836",
            type: "WEBLINK"
        }
    },
    {
        info: {
            id: "58396",
            name: "Apsara Ice Creams",
            cloudinaryImageId: "hal5rg4uzokxwbtwfrh5",
            locality: "CST Road",
            areaName: "Santacruz East",
            costForTwoString: "\u20B9150 for two",
            costForTwo: 15000,
            deliveryTime: 22,
            cuisines: [
                "Ice Cream",
                "Desserts"
            ],
            avgRating: 4.7,
            veg: true,
            feeDetails: {
                restaurantId: "58396",
                fees: [
                    {
                        name: "BASE_DISTANCE",
                        fee: 3200
                    },
                    {
                        name: "BASE_TIME"
                    },
                    {
                        name: "ANCILLARY_SURGE_FEE"
                    }
                ],
                totalFee: 3200
            },
            parentId: "35219",
            avgRatingString: "4.7",
            totalRatingsString: "1K+",
            sla: {
                deliveryTime: 22,
                lastMileTravel: 1.5,
                serviceability: "SERVICEABLE",
                slaString: "22 mins",
                lastMileTravelString: "1.5 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2023-11-29 23:59:00",
                opened: true
            },
            badges: {
                textExtendedBadges: [
                    {
                        iconId: "guiltfree/GF_Logo_android_3x",
                        shortDescription: "options available",
                        fontColor: "#7E808C"
                    }
                ]
            },
            isOpen: true,
            aggregatedDiscountInfoV2: {},
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {},
                    textBased: {},
                    textExtendedBadges: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: "",
                                    fontColor: "#7E808C",
                                    iconId: "guiltfree/GF_Logo_android_3x",
                                    shortDescription: "options available"
                                }
                            }
                        ]
                    }
                }
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {}
        },
        analytics: {},
        cta: {
            link: "https://www.swiggy.com/restaurants/apsara-ice-creams-cst-road-santacruz-east-mumbai-58396",
            type: "WEBLINK"
        }
    },
    {
        info: {
            id: "17499",
            name: "Faasos - Wraps & Rolls",
            cloudinaryImageId: "af33b81798b11deba338e94b7585d348",
            locality: "Kalina",
            areaName: "Santacruz East",
            costForTwoString: "\u20B9250 for two",
            costForTwo: 25000,
            deliveryTime: 28,
            cuisines: [
                "Kebabs",
                "Fast Food",
                "Snacks",
                "North Indian",
                "American",
                "Healthy Food",
                "Desserts",
                "Beverages"
            ],
            avgRating: 4.1,
            feeDetails: {
                restaurantId: "17499",
                fees: [
                    {
                        name: "BASE_DISTANCE",
                        fee: 3200
                    },
                    {
                        name: "BASE_TIME"
                    },
                    {
                        name: "ANCILLARY_SURGE_FEE"
                    }
                ],
                totalFee: 3200
            },
            parentId: "21809",
            avgRatingString: "4.1",
            totalRatingsString: "10K+",
            sla: {
                deliveryTime: 28,
                lastMileTravel: 1.9,
                serviceability: "SERVICEABLE",
                slaString: "28 mins",
                lastMileTravelString: "1.9 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2023-11-29 23:59:00",
                opened: true
            },
            badges: {
                textExtendedBadges: [
                    {
                        iconId: "guiltfree/GF_Logo_android_3x",
                        shortDescription: "options available",
                        fontColor: "#7E808C"
                    }
                ]
            },
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {},
                    textBased: {},
                    textExtendedBadges: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: "",
                                    fontColor: "#7E808C",
                                    iconId: "guiltfree/GF_Logo_android_3x",
                                    shortDescription: "options available"
                                }
                            }
                        ]
                    }
                }
            },
            aggregatedDiscountInfoV3: {
                header: "ITEMS",
                subHeader: "AT \u20B999"
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {}
        },
        analytics: {},
        cta: {
            link: "https://www.swiggy.com/restaurants/faasos-wraps-and-rolls-kalina-santacruz-east-mumbai-17499",
            type: "WEBLINK"
        }
    },
    {
        info: {
            id: "62894",
            name: "LunchBox - Meals and Thalis",
            cloudinaryImageId: "pjobovhpe4jwxdxoe1ns",
            locality: "Kalina",
            areaName: "Santacruz East",
            costForTwoString: "\u20B9200 for two",
            costForTwo: 20000,
            deliveryTime: 28,
            cuisines: [
                "Biryani",
                "North Indian",
                "Punjabi",
                "Healthy Food",
                "Desserts",
                "Beverages"
            ],
            avgRating: 4.1,
            feeDetails: {
                restaurantId: "62894",
                fees: [
                    {
                        name: "BASE_DISTANCE",
                        fee: 3200
                    },
                    {
                        name: "BASE_TIME"
                    },
                    {
                        name: "ANCILLARY_SURGE_FEE"
                    }
                ],
                totalFee: 3200
            },
            parentId: "4925",
            avgRatingString: "4.1",
            totalRatingsString: "5K+",
            sla: {
                deliveryTime: 28,
                lastMileTravel: 1.9,
                serviceability: "SERVICEABLE",
                slaString: "28 mins",
                lastMileTravelString: "1.9 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2023-11-29 23:59:00",
                opened: true
            },
            badges: {
                textExtendedBadges: [
                    {
                        iconId: "guiltfree/GF_Logo_android_3x",
                        shortDescription: "options available",
                        fontColor: "#7E808C"
                    }
                ]
            },
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {},
                    textBased: {},
                    textExtendedBadges: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: "",
                                    fontColor: "#7E808C",
                                    iconId: "guiltfree/GF_Logo_android_3x",
                                    shortDescription: "options available"
                                }
                            }
                        ]
                    }
                }
            },
            aggregatedDiscountInfoV3: {
                header: "ITEMS",
                subHeader: "AT \u20B9159"
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {}
        },
        analytics: {},
        cta: {
            link: "https://www.swiggy.com/restaurants/lunchbox-meals-and-thalis-kalina-santacruz-east-mumbai-62894",
            type: "WEBLINK"
        }
    },
    {
        info: {
            id: "337459",
            name: "Goodness To Go",
            cloudinaryImageId: "xnqmiqatrp5ki0k206o3",
            locality: "Bandra Kurla Complex",
            areaName: "Kurla",
            costForTwoString: "\u20B9350 for two",
            costForTwo: 35000,
            deliveryTime: 32,
            cuisines: [
                "Salads",
                "European",
                "Italian",
                "Juices",
                "Bakery",
                "Desserts"
            ],
            avgRating: 4.2,
            feeDetails: {
                restaurantId: "337459",
                fees: [
                    {
                        name: "BASE_DISTANCE",
                        fee: 3200
                    },
                    {
                        name: "BASE_TIME"
                    },
                    {
                        name: "ANCILLARY_SURGE_FEE"
                    }
                ],
                totalFee: 3200
            },
            parentId: "12021",
            avgRatingString: "4.2",
            totalRatingsString: "500+",
            sla: {
                deliveryTime: 34,
                lastMileTravel: 1.5,
                serviceability: "SERVICEABLE",
                slaString: "34 mins",
                lastMileTravelString: "1.5 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2023-11-29 23:30:00",
                opened: true
            },
            badges: {},
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {},
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "\u20B9125 OFF",
                subHeader: "ABOVE \u20B9249",
                discountTag: "FLAT DEAL"
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {}
        },
        analytics: {},
        cta: {
            link: "https://www.swiggy.com/restaurants/goodness-to-go-bandra-complex-kurla-mumbai-337459",
            type: "WEBLINK"
        }
    },
    {
        info: {
            id: "86155",
            name: "Kitchen Garden by Suzette",
            cloudinaryImageId: "bttsvynpr8x77z6hu9b1",
            locality: "BKC",
            areaName: "Scruz Bandra East",
            costForTwoString: "\u20B91100 for two",
            costForTwo: 110000,
            deliveryTime: 27,
            cuisines: [
                "Salads"
            ],
            avgRating: 4.5,
            feeDetails: {
                restaurantId: "86155",
                fees: [
                    {
                        name: "BASE_DISTANCE",
                        fee: 4100
                    },
                    {
                        name: "BASE_TIME"
                    },
                    {
                        name: "ANCILLARY_SURGE_FEE"
                    }
                ],
                totalFee: 4100
            },
            parentId: "5477",
            avgRatingString: "4.5",
            totalRatingsString: "1K+",
            sla: {
                deliveryTime: 27,
                lastMileTravel: 1.4,
                serviceability: "SERVICEABLE",
                slaString: "27 mins",
                lastMileTravelString: "1.4 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2023-11-29 19:30:00",
                opened: true
            },
            badges: {},
            isOpen: true,
            aggregatedDiscountInfoV2: {},
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {},
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {}
        },
        analytics: {},
        cta: {
            link: "https://www.swiggy.com/restaurants/kitchen-garden-by-suzette-bkc-scruz-bandra-east-mumbai-86155",
            type: "WEBLINK"
        }
    },
    {
        info: {
            id: "5691",
            name: "Smoke House Deli",
            cloudinaryImageId: "f5rgvghgew6hmnmbg3rn",
            locality: "Bandra Kurla Complex",
            areaName: "Bandra Kurla Complex",
            costForTwoString: "\u20B9600 for two",
            costForTwo: 60000,
            deliveryTime: 36,
            cuisines: [
                "American",
                "Italian",
                "European"
            ],
            avgRating: 4.3,
            feeDetails: {
                restaurantId: "5691",
                fees: [
                    {
                        name: "BASE_DISTANCE",
                        fee: 4100
                    },
                    {
                        name: "BASE_TIME"
                    },
                    {
                        name: "ANCILLARY_SURGE_FEE"
                    }
                ],
                totalFee: 4100
            },
            parentId: "874",
            avgRatingString: "4.3",
            totalRatingsString: "5K+",
            sla: {
                deliveryTime: 36,
                lastMileTravel: 1.5,
                serviceability: "SERVICEABLE",
                slaString: "36 mins",
                lastMileTravelString: "1.5 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2023-11-29 23:30:00",
                opened: true
            },
            badges: {
                imageBadges: [
                    {
                        imageId: "newg.png",
                        description: "Gourmet"
                    }
                ]
            },
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: "Gourmet",
                                    imageId: "newg.png"
                                }
                            }
                        ]
                    },
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "60% OFF",
                subHeader: "UPTO \u20B9120"
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {}
        },
        analytics: {},
        cta: {
            link: "https://www.swiggy.com/restaurants/smoke-house-deli-bandra-kurla-complex-mumbai-5691",
            type: "WEBLINK"
        }
    }
];
var $6e78419c09133bf4$export$2e2bcd8739ae039 = $6e78419c09133bf4$var$resList;



var $2T6zX = parcelRequire("2T6zX");
const $908ef0a010594a4d$var$Shimmer = ()=>{
    return /*#__PURE__*/ (0, $2T6zX.jsxs)("div", {
        className: "shimmer-container",
        children: [
            /*#__PURE__*/ (0, $2T6zX.jsx)("div", {
                className: "shimmer-cards"
            }),
            /*#__PURE__*/ (0, $2T6zX.jsx)("div", {
                className: "shimmer-cards"
            }),
            /*#__PURE__*/ (0, $2T6zX.jsx)("div", {
                className: "shimmer-cards"
            }),
            /*#__PURE__*/ (0, $2T6zX.jsx)("div", {
                className: "shimmer-cards"
            }),
            /*#__PURE__*/ (0, $2T6zX.jsx)("div", {
                className: "shimmer-cards"
            }),
            /*#__PURE__*/ (0, $2T6zX.jsx)("div", {
                className: "shimmer-cards"
            }),
            /*#__PURE__*/ (0, $2T6zX.jsx)("div", {
                className: "shimmer-cards"
            }),
            /*#__PURE__*/ (0, $2T6zX.jsx)("div", {
                className: "shimmer-cards"
            }),
            /*#__PURE__*/ (0, $2T6zX.jsx)("div", {
                className: "shimmer-cards"
            }),
            /*#__PURE__*/ (0, $2T6zX.jsx)("div", {
                className: "shimmer-cards"
            }),
            /*#__PURE__*/ (0, $2T6zX.jsx)("div", {
                className: "shimmer-cards"
            }),
            /*#__PURE__*/ (0, $2T6zX.jsx)("div", {
                className: "shimmer-cards"
            }),
            /*#__PURE__*/ (0, $2T6zX.jsx)("div", {
                className: "shimmer-cards"
            }),
            /*#__PURE__*/ (0, $2T6zX.jsx)("div", {
                className: "shimmer-cards"
            }),
            /*#__PURE__*/ (0, $2T6zX.jsx)("div", {
                className: "shimmer-cards"
            })
        ]
    });
};
var $908ef0a010594a4d$export$2e2bcd8739ae039 = $908ef0a010594a4d$var$Shimmer;





// const listOfRestaurant=[
//     {
//         data: {
//           id: "78036",
//           name: "Burger King",
//           cloudinaryImageId: "e33e1d3ba7d6b2bb0d45e1001b731fcf",
//           locality: "Central Plaza, Kalina",
//           areaName: "Santacruz East",
//           costForTwo: 35000,
//           costForTwoString: "₹350 for two",
//           deliveryTime: 24,
//           cuisines: ["Burgers", "American"],
//           avgRating: 3.2,
//           feeDetails: {
//             restaurantId: "78036",
//             fees: [
//               {
//                 name: "BASE_DISTANCE",
//                 fee: 3200,
//               },
//               {
//                 name: "BASE_TIME",
//               },
//               {
//                 name: "ANCILLARY_SURGE_FEE",
//               },
//             ],
//             totalFee: 3200,
//           },
//           parentId: "166",
//           avgRatingString: "4.2",
//           totalRatingsString: "10K+",
//           sla: {
//             lastMileTravel: 1.5,
//             serviceability: "SERVICEABLE",
//             slaString: "24 mins",
//             lastMileTravelString: "1.5 km",
//             iconType: "ICON_TYPE_EMPTY",
//           },
//           availability: {
//             nextCloseTime: "2023-11-30 03:45:00",
//             opened: true,
//           },
//           badges: {},
//           isOpen: true,
//           type: "F",
//           badgesV2: {
//             entityBadges: {
//               imageBased: {},
//               textBased: {},
//               textExtendedBadges: {},
//             },
//           },
//           aggregatedDiscountInfoV3: {
//             header: "ITEMS",
//             subHeader: "AT ₹129",
//           },
//           differentiatedUi: {
//             displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
//             differentiatedUiMediaDetails: {
//               mediaType: "ADS_MEDIA_ENUM_IMAGE",
//               lottie: {},
//               video: {},
//             },
//           },
//           reviewsSummary: {},
//           displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
//           restaurantOfferPresentationInfo: {},
//         },
//         analytics: {},
//         cta: {
//           link: "https://www.swiggy.com/restaurants/burger-king-central-plaza-kalina-santacruz-east-mumbai-78036",
//           type: "WEBLINK",
//         },
//       },
//       {
//         data: {
//           id: "32399",
//           name: "McDonald's",
//           cloudinaryImageId: "bb7ae131544c7d37e10fc5faf76f09d6",
//           locality: "Kalina Artista",
//           areaName: "Santacruz East",
//           costForTwo: 40000,
//           costForTwoString: "400 for two",
//           deliveryTime: 17,
//           cuisines: ["Burgers", "Beverages", "Cafe", "Desserts"],
//           avgRating: 4.3,
//           feeDetails: {
//             restaurantId: "32399",
//             fees: [
//               {
//                 name: "BASE_DISTANCE",
//                 fee: 3900,
//               },
//               {
//                 name: "BASE_TIME",
//               },
//               {
//                 name: "ANCILLARY_SURGE_FEE",
//               },
//             ],
//             totalFee: 3900,
//           },
//           parentId: "630",
//           avgRatingString: "4.3",
//           totalRatingsString: "10K+",
//           sla: {
//             lastMileTravel: 1.5,
//             serviceability: "SERVICEABLE",
//             slaString: "17 mins",
//             lastMileTravelString: "1.5 km",
//             iconType: "ICON_TYPE_EMPTY",
//           },
//           availability: {
//             nextCloseTime: "2023-11-30 03:00:00",
//             opened: true,
//           },
//           badges: {
//             textExtendedBadges: [
//               {
//                 iconId: "guiltfree/GF_Logo_android_3x",
//                 shortDescription: "options available",
//                 fontColor: "#7E808C",
//               },
//             ],
//           },
//           isOpen: true,
//           type: "F",
//           badgesV2: {
//             entityBadges: {
//               imageBased: {},
//               textBased: {},
//               textExtendedBadges: {
//                 badgeObject: [
//                   {
//                     attributes: {
//                       description: "",
//                       fontColor: "#7E808C",
//                       iconId: "guiltfree/GF_Logo_android_3x",
//                       shortDescription: "options available",
//                     },
//                   },
//                 ],
//               },
//             },
//           },
//           aggregatedDiscountInfoV3: {
//             header: "10% OFF",
//             subHeader: "ABOVE ₹1000",
//             discountTag: "FLAT DEAL",
//           },
//           differentiatedUi: {
//             displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
//             differentiatedUiMediaDetails: {
//               mediaType: "ADS_MEDIA_ENUM_IMAGE",
//               lottie: {},
//               video: {},
//             },
//           },
//           reviewsSummary: {},
//           displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
//           restaurantOfferPresentationInfo: {},
//         },
//         analytics: {},
//         cta: {
//           link: "https://www.swiggy.com/restaurants/mcdonalds-kalina-artista-santacruz-east-mumbai-32399",
//           type: "WEBLINK",
//         },
//       },
//       {
//         data: {
//           id: "82668",
//           name: "The Belgian Waffle Co.",
//           cloudinaryImageId: "846dab8cca3c56a482d7cbcda0dd0eb9",
//           locality: "Kalina",
//           areaName: "Santacruz East",
//           costForTwoString: "₹200 for two",
//           costForTwo: 20000,
//           deliveryTime: 32,
//           cuisines: ["Waffle", "Desserts", "Ice Cream", "Beverages"],
//           avgRating: 4.3,
//           veg: true,
//           feeDetails: {
//             restaurantId: "82668",
//             fees: [
//               {
//                 name: "BASE_DISTANCE",
//                 fee: 3200,
//               },
//               {
//                 name: "BASE_TIME",
//               },
//               {
//                 name: "ANCILLARY_SURGE_FEE",
//               },
//             ],
//             totalFee: 3200,
//           },
//           parentId: "2233",
//           avgRatingString: "4.3",
//           totalRatingsString: "1K+",
//           sla: {
//             lastMileTravel: 1.5,
//             serviceability: "SERVICEABLE",
//             slaString: "32 mins",
//             lastMileTravelString: "1.5 km",
//             iconType: "ICON_TYPE_EMPTY",
//           },
//           availability: {
//             nextCloseTime: "2023-11-30 04:00:00",
//             opened: true,
//           },
//           badges: {},
//           isOpen: true,
//           type: "F",
//           badgesV2: {
//             entityBadges: {
//               imageBased: {},
//               textBased: {},
//               textExtendedBadges: {},
//             },
//           },
//           aggregatedDiscountInfoV3: {
//             header: "40% OFF",
//             subHeader: "UPTO ₹80",
//           },
//           differentiatedUi: {
//             displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
//             differentiatedUiMediaDetails: {
//               mediaType: "ADS_MEDIA_ENUM_IMAGE",
//               lottie: {},
//               video: {},
//             },
//           },
//           reviewsSummary: {},
//           displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
//           restaurantOfferPresentationInfo: {},
//         },
//         analytics: {},
//         cta: {
//           link: "https://www.swiggy.com/restaurants/the-belgian-waffle-co-kalina-santacruz-east-mumbai-82668",
//           type: "WEBLINK",
//         },
//       },
// ];
const $f7ea6cd679c020e3$var$Body = ()=>{
    //UseState
    //Local State Variable - Super powerful variable
    // const [listOfRestaurants, setListOfRestaurant] = useState(resList);    //resList old data
    const [listOfRestaurants, setListOfRestaurant] = (0, $bCCVl.useState)([]); //resList is empty now
    const [filteredRestaurant, setFilteredRestaurant] = (0, $bCCVl.useState)([]);
    const [searchText, setSearchText] = (0, $bCCVl.useState)("");
    const RestaurantCardPromoted = (0, $21a9ae7d000f3398$export$ccb02a230af14023)((0, $21a9ae7d000f3398$export$2e2bcd8739ae039));
    //Whenever state variable update, react triggers a reconciliation cycle(re render the component) 
    console.log("Body rendered again and again");
    //Normal Js variable
    // let resList = [];
    //UseEffect
    //2 arguments- call back function and dependency array
    (0, $bCCVl.useEffect)(()=>{
        // console.log("useEffect rendered");
        fetchData();
    }, []);
    const fetchData = async ()=>{
        //  const data=await fetch("https://www.swiggy.com/dapi/restaurants/list/v5?lat=19.2069473&lng=73.1034258&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING");
        const data = await fetch("https://www.swiggy.com/dapi/restaurants/list/v5?lat=19.2069473&lng=73.1034258&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING");
        const json = await data.json();
        console.log(json?.data?.cards[1]?.card?.card?.gridElements?.infoWithStyle?.restaurants);
        setListOfRestaurant(json?.data?.cards[1]?.card?.card?.gridElements?.infoWithStyle?.restaurants);
        // setListOfRestaurant(json.data.cards[1].card.card.gridElements.infoWithStyle.restaurants);
        // setListOfRestaurant(json.data.cards[4].card.card.gridElements.infoWithStyle.restaurants);
        setFilteredRestaurant(json?.data?.cards[1]?.card?.card?.gridElements?.infoWithStyle?.restaurants);
    };
    // console.log("Body rendered");
    //Conditioanal Rendering 
    // if(listOfRestaurants.length ===0){
    //    // return <h3>Loading.........</h3>;
    //   return <Shimmer/>
    // }
    const onlineStatus = (0, $1a32df2dbd32d8e6$export$2e2bcd8739ae039)();
    if (onlineStatus == false) return /*#__PURE__*/ (0, $2T6zX.jsx)("h1", {
        children: "Looks like you are offline!! Please check your internet connection;"
    });
    const { loggedInUser: loggedInUser, setUserName: setUserName } = (0, $bCCVl.useContext)((0, $ee52d48033679fb8$export$2e2bcd8739ae039));
    //Ternary Condition
    return listOfRestaurants.length === 0 ? /*#__PURE__*/ (0, $2T6zX.jsx)((0, $908ef0a010594a4d$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $2T6zX.jsxs)("div", {
        className: "body",
        children: [
            /*#__PURE__*/ (0, $2T6zX.jsxs)("div", {
                className: "filter flex flex-wrap pt-24 justify-center",
                children: [
                    /*#__PURE__*/ (0, $2T6zX.jsxs)("div", {
                        className: "search px-5 my-7 flex",
                        children: [
                            /*#__PURE__*/ (0, $2T6zX.jsx)("input", {
                                type: "text",
                                "data-testid": "searchInput",
                                className: "border border-solid border-black rounded-lg",
                                value: searchText,
                                onChange: (e)=>{
                                    setSearchText(e.target.value);
                                }
                            }),
                            /*#__PURE__*/ (0, $2T6zX.jsx)("button", {
                                className: "px-5 py-0 mx-3 rounded-lg bg-orange-600 text-white hover:text-black font-semibold",
                                onClick: ()=>{
                                    //Filter the restaurant cards and update the UI
                                    //searchText
                                    console.log(searchText);
                                    const filteredRestaurant = listOfRestaurants.filter((res)=>res.info.name.toLowerCase().includes(searchText.toLowerCase()));
                                    // setListOfRestaurant(filteredRestaurant);
                                    setFilteredRestaurant(filteredRestaurant);
                                },
                                children: "Search"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2T6zX.jsx)("button", {
                        className: "px-5 py-2 my-7 rounded-lg bg-orange-600 text-white hover:text-black font-semibold",
                        onClick: ()=>{
                            const filterList = listOfRestaurants.filter((res)=>res.info.avgRating > 4.3);
                            console.log(filterList);
                            //setListOfRestaurant(filterList);
                            setFilteredRestaurant(filterList);
                        },
                        children: "Top Rated Restaurants"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2T6zX.jsx)("div", {
                className: "res-container flex flex-wrap justify-start sm:px-0 lg:px-40",
                children: filteredRestaurant.map((restaurant)=>/*#__PURE__*/ (0, $2T6zX.jsx)((0, $1cceaedd24710e82$export$a6c7ac8248d6e38a), {
                        to: "/restaurants/" + restaurant.info.id,
                        children: restaurant.info.promoted ? /*#__PURE__*/ (0, $2T6zX.jsx)(RestaurantCardPromoted, {
                            resData: restaurant
                        }) : /*#__PURE__*/ (0, $2T6zX.jsx)((0, $21a9ae7d000f3398$export$2e2bcd8739ae039), {
                            resData: restaurant
                        })
                    }, restaurant.info.id))
            })
        ]
    });
};
var $f7ea6cd679c020e3$export$2e2bcd8739ae039 = $f7ea6cd679c020e3$var$Body;



var $2T6zX = parcelRequire("2T6zX");

var $2T6zX = parcelRequire("2T6zX");

var $bCCVl = parcelRequire("bCCVl");
const $6dd3d40a8cb6d561$var$User = (props)=>{
    const [count] = (0, $bCCVl.useState)(0);
    const [count2] = (0, $bCCVl.useState)(3);
    const { name: name, location: location } = props;
    return /*#__PURE__*/ (0, $2T6zX.jsxs)("div", {
        className: "user-card",
        children: [
            /*#__PURE__*/ (0, $2T6zX.jsx)("h1", {
                children: "Functioanl Component"
            }),
            /*#__PURE__*/ (0, $2T6zX.jsxs)("h1", {
                children: [
                    "Count: ",
                    count,
                    ", Count2: ",
                    count2
                ]
            }),
            /*#__PURE__*/ (0, $2T6zX.jsxs)("h2", {
                children: [
                    "Name: ",
                    name
                ]
            }),
            /*#__PURE__*/ (0, $2T6zX.jsxs)("h3", {
                children: [
                    "Location: ",
                    location
                ]
            }),
            /*#__PURE__*/ (0, $2T6zX.jsx)("h4", {
                children: "Contact: 9403386226"
            })
        ]
    });
};
var $6dd3d40a8cb6d561$export$2e2bcd8739ae039 = $6dd3d40a8cb6d561$var$User;



var $2T6zX = parcelRequire("2T6zX");

var $bCCVl = parcelRequire("bCCVl");
class $283c1e7c514d99b3$var$UserClass extends (0, (/*@__PURE__*/$parcel$interopDefault($bCCVl))).Component {
    constructor(props){
        super(props);
        this.state = {
            name: "Himani Patil",
            email: "himani.patil29792@gmail.com"
        };
        // console.log(props);
        console.log(this.props.name + "Child Constructor");
    }
    async componentDidMount() {
        console.log(this.props.name + "Child ComponentDidMount");
        //API Call
        const data = await fetch("https://api.github.com/users/Himanipatil29792");
        const json = await data.json();
        this.setState({
            userInfo: json
        });
        console.log(json);
    }
    componentDidUpdate() {
        console.log("Component Did Update");
    }
    render() {
        // const {name,email}=this.props;
        const { name: name, email: email, count: count, count2: count2 } = this.state;
        // const {name, location}=this.state;
        console.log(this.props.name + "Child Render");
        return /*#__PURE__*/ (0, $2T6zX.jsx)("div", {
            className: "user-card",
            children: /*#__PURE__*/ (0, $2T6zX.jsx)("div", {
                className: "flex  justify-around flex-row",
                children: /*#__PURE__*/ (0, $2T6zX.jsxs)("div", {
                    className: "github  border border-white lg:w-2/6 sm:w-12  rounded-lg shadow-xl text-orange-600 font-bold p-4 my-10 transition ease-in-out delay-75 hover: -translate-y-1 hover:scale-105 duration-300",
                    children: [
                        /*#__PURE__*/ (0, $2T6zX.jsxs)("span", {
                            className: "flex flex-row items-center justify-center",
                            children: [
                                /*#__PURE__*/ (0, $2T6zX.jsx)("a", {
                                    href: "https://github.com/Himanipatil29792",
                                    target: "_blank",
                                    children: /*#__PURE__*/ (0, $2T6zX.jsx)("i", {
                                        class: "fa fa-github fa-2x m-2",
                                        "aria-hidden": "true"
                                    })
                                }),
                                /*#__PURE__*/ (0, $2T6zX.jsx)("a", {
                                    href: "https://www.linkedin.com/in/himani-jayesh-patil-959465a0/",
                                    target: "_blank",
                                    children: /*#__PURE__*/ (0, $2T6zX.jsx)("i", {
                                        class: "fa fa-linkedin-square fa-2x m-2",
                                        "aria-hidden": "true"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $2T6zX.jsxs)("h1", {
                            className: "p-2",
                            children: [
                                " Name: ",
                                name
                            ]
                        }),
                        /*#__PURE__*/ (0, $2T6zX.jsxs)("h2", {
                            className: "p-2",
                            children: [
                                "Email: ",
                                email
                            ]
                        }),
                        /*#__PURE__*/ (0, $2T6zX.jsx)("p", {
                            className: "p-4",
                            children: "I'm a passionate Front-End Developer with 6 years of experience in building responsive and interactive web applications. Proficient in React.js, JavaScript, jQuery , HTML5, CSS3, and Bootstrap5. Specializes in creating responsive designs and user-friendly interfaces."
                        })
                    ]
                })
            })
        });
    }
}
var $283c1e7c514d99b3$export$2e2bcd8739ae039 /*
---Mounting----
-constructor (dummy)
-Render (dummy)
    <html Dummy>
    componentDidMount
    <API Call>
    <this.setState> -> State variable is updated

----Update-----
-render(API data)
-<html (new API data loaded)>
-ComponentDidUpdate
*/  = $283c1e7c514d99b3$var$UserClass;



var $bCCVl = parcelRequire("bCCVl");

// About component convert class based componnent
// class About extends React.Component{}
class $c772aa1e51119bea$var$About extends (0, $bCCVl.Component) {
    constructor(props){
        super(props);
    // console.log("Parent Constructor");
    }
    componentDidMount() {
    // console.log("Parent ComponentDidMount");
    }
    render() {
        // console.log("Parent Render");
        return /*#__PURE__*/ (0, $2T6zX.jsxs)("div", {
            className: "mt-28 text-center",
            children: [
                /*#__PURE__*/ (0, $2T6zX.jsx)("h1", {
                    className: "font-bold text-3xl p-4 m-4",
                    children: "About Page"
                }),
                /*#__PURE__*/ (0, $2T6zX.jsx)("div", {}),
                /*#__PURE__*/ (0, $2T6zX.jsx)((0, $283c1e7c514d99b3$export$2e2bcd8739ae039), {
                    name: name,
                    location: "Mumbai class"
                })
            ]
        });
    }
}
var // const About=()=>{
//     return (
//         <div>
//             <h1>About Page</h1>
//             <User name={"Himani Patil function props"} location={"Domivali props"} />
//             <UserClass name={"Himani Patil class props"} location={"Mumbai class"} />
//         </div>
//     );
// }
$c772aa1e51119bea$export$2e2bcd8739ae039 /*
-Parent Constructor
-Parent Render
    
    -First Constructor
    -First Render

    -Second constructor
    -Second Render

    -third constructor
    -third Render

    <DOM UPDATED - IN SINGLE BATCH
    -First ComponentDidMount
    -Second ComponentDidMount
    -Third ComponentDidMount

-Parent ComponentDidMount
*/  = $c772aa1e51119bea$var$About;



var $2T6zX = parcelRequire("2T6zX");
const $d9a7192050356875$var$Contact = ()=>{
    return /*#__PURE__*/ (0, $2T6zX.jsxs)("div", {
        className: "w6/12 text-center mt-28",
        children: [
            /*#__PURE__*/ (0, $2T6zX.jsx)("h1", {
                className: "font-bold text-3xl p-4 m-4",
                children: "Contact Page"
            }),
            /*#__PURE__*/ (0, $2T6zX.jsxs)("form", {
                children: [
                    /*#__PURE__*/ (0, $2T6zX.jsx)("input", {
                        type: "text",
                        placeholder: "name",
                        className: "border border-black p-2 m-2"
                    }),
                    /*#__PURE__*/ (0, $2T6zX.jsx)("input", {
                        type: "text",
                        placeholder: "message",
                        className: "border border-black p-2 m-2"
                    }),
                    /*#__PURE__*/ (0, $2T6zX.jsx)("button", {
                        className: "border border-black p-2 m-2",
                        children: "Submit"
                    })
                ]
            })
        ]
    });
};
var $d9a7192050356875$export$2e2bcd8739ae039 = $d9a7192050356875$var$Contact;



var $2T6zX = parcelRequire("2T6zX");

const $f49d2f70ada93472$var$Error = ()=>{
    const err = (0, $2bd9a3ffc1ab0195$export$ed527bf60f6e05f2)();
    console.log(err);
    return /*#__PURE__*/ (0, $2T6zX.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $2T6zX.jsx)("h1", {
                children: "Oops!!"
            }),
            /*#__PURE__*/ (0, $2T6zX.jsx)("h2", {
                children: "Something went wrong!!"
            }),
            /*#__PURE__*/ (0, $2T6zX.jsxs)("h2", {
                children: [
                    err.status,
                    ": ",
                    err.statusText
                ]
            })
        ]
    });
};
var $f49d2f70ada93472$export$2e2bcd8739ae039 = $f49d2f70ada93472$var$Error;



var $2T6zX = parcelRequire("2T6zX");

var $bCCVl = parcelRequire("bCCVl");




var $bCCVl = parcelRequire("bCCVl");

const $dc837782a668f0e9$var$useRestaurantMenu = (resId)=>{
    const [resInfo, setResInfo] = (0, $bCCVl.useState)(null);
    //Fetch Data
    (0, $bCCVl.useEffect)(()=>{
        fetchData();
    }, []);
    const fetchData = async ()=>{
        const data = await fetch((0, $7fd0baa016ace72e$export$d28dc33571f365ee) + resId);
        const json = await data.json();
        // console.log(json);
        setResInfo(json.data);
    };
    return resInfo;
};
var $dc837782a668f0e9$export$2e2bcd8739ae039 = $dc837782a668f0e9$var$useRestaurantMenu;



var $2T6zX = parcelRequire("2T6zX");
parcelRequire("bCCVl");

var $2T6zX = parcelRequire("2T6zX");


// src/utils/formatProdErrorMessage.ts
function $7c4fd50405af3d52$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $7c4fd50405af3d52$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $7c4fd50405af3d52$var$symbol_observable_default = $7c4fd50405af3d52$var$$$observable;
// src/utils/actionTypes.ts
var $7c4fd50405af3d52$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $7c4fd50405af3d52$var$ActionTypes = {
    INIT: `@@redux/INIT${$7c4fd50405af3d52$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$7c4fd50405af3d52$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$7c4fd50405af3d52$var$randomString()}`
};
var $7c4fd50405af3d52$export$4219e499db7ca678 = $7c4fd50405af3d52$var$ActionTypes;
// src/utils/isPlainObject.ts
function $7c4fd50405af3d52$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $7c4fd50405af3d52$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($7c4fd50405af3d52$var$isDate(val)) return "date";
    if ($7c4fd50405af3d52$var$isError(val)) return "error";
    const constructorName = $7c4fd50405af3d52$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $7c4fd50405af3d52$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $7c4fd50405af3d52$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $7c4fd50405af3d52$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $7c4fd50405af3d52$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $7c4fd50405af3d52$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($7c4fd50405af3d52$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($7c4fd50405af3d52$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($7c4fd50405af3d52$var$formatProdErrorMessage(1));
        return enhancer($7c4fd50405af3d52$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($7c4fd50405af3d52$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($7c4fd50405af3d52$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($7c4fd50405af3d52$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($7c4fd50405af3d52$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$7c4fd50405af3d52$export$53b83ca8eaab0383(action)) throw new Error($7c4fd50405af3d52$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($7c4fd50405af3d52$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($7c4fd50405af3d52$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($7c4fd50405af3d52$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($7c4fd50405af3d52$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $7c4fd50405af3d52$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($7c4fd50405af3d52$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$7c4fd50405af3d52$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $7c4fd50405af3d52$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$7c4fd50405af3d52$var$symbol_observable_default]: observable
    };
    return store;
}
function $7c4fd50405af3d52$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $7c4fd50405af3d52$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $7c4fd50405af3d52$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $7c4fd50405af3d52$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $7c4fd50405af3d52$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$7c4fd50405af3d52$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$7c4fd50405af3d52$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $7c4fd50405af3d52$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $7c4fd50405af3d52$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $7c4fd50405af3d52$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($7c4fd50405af3d52$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $7c4fd50405af3d52$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($7c4fd50405af3d52$var$formatProdErrorMessage(13));
    });
}
function $7c4fd50405af3d52$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $7c4fd50405af3d52$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($7c4fd50405af3d52$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $7c4fd50405af3d52$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $7c4fd50405af3d52$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $7c4fd50405af3d52$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($7c4fd50405af3d52$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $7c4fd50405af3d52$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $7c4fd50405af3d52$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $7c4fd50405af3d52$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($7c4fd50405af3d52$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $7c4fd50405af3d52$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $7c4fd50405af3d52$export$b956e38827fca970(action) {
    return $7c4fd50405af3d52$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}


var $283688714b443320$var$__defProp = Object.defineProperty;
var $283688714b443320$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $283688714b443320$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $283688714b443320$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $283688714b443320$var$__defNormalProp = (obj, key, value)=>key in obj ? $283688714b443320$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $283688714b443320$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($283688714b443320$var$__hasOwnProp.call(b, prop)) $283688714b443320$var$__defNormalProp(a, prop, b[prop]);
    if ($283688714b443320$var$__getOwnPropSymbols) {
        for (var prop of $283688714b443320$var$__getOwnPropSymbols(b))if ($283688714b443320$var$__propIsEnum.call(b, prop)) $283688714b443320$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $283688714b443320$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $283688714b443320$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $283688714b443320$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $283688714b443320$var$errors = [];
function $283688714b443320$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $283688714b443320$var$getPrototypeOf = Object.getPrototypeOf;
function $283688714b443320$export$541ac630993a4c84(value) {
    return !!value && !!value[$283688714b443320$var$DRAFT_STATE];
}
function $283688714b443320$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $283688714b443320$var$isPlainObject(value) || Array.isArray(value) || !!value[$283688714b443320$export$6ee2082928bcb0ee] || !!((_a = value.constructor) == null ? void 0 : _a[$283688714b443320$export$6ee2082928bcb0ee]) || $283688714b443320$var$isMap(value) || $283688714b443320$var$isSet(value);
}
var $283688714b443320$var$objectCtorString = Object.prototype.constructor.toString();
function $283688714b443320$var$isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    const proto = $283688714b443320$var$getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === $283688714b443320$var$objectCtorString;
}
function $283688714b443320$export$22e8af3f75a010e3(value) {
    if (!$283688714b443320$export$541ac630993a4c84(value)) $283688714b443320$var$die(15, value);
    return value[$283688714b443320$var$DRAFT_STATE].base_;
}
function $283688714b443320$var$each(obj, iter) {
    if ($283688714b443320$var$getArchtype(obj) === 0 /* Object */ ) Reflect.ownKeys(obj).forEach((key)=>{
        iter(key, obj[key], obj);
    });
    else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $283688714b443320$var$getArchtype(thing) {
    const state = thing[$283688714b443320$var$DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : $283688714b443320$var$isMap(thing) ? 2 /* Map */  : $283688714b443320$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function $283688714b443320$var$has(thing, prop) {
    return $283688714b443320$var$getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function $283688714b443320$var$get(thing, prop) {
    return $283688714b443320$var$getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function $283688714b443320$var$set(thing, propOrOldValue, value) {
    const t = $283688714b443320$var$getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function $283688714b443320$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $283688714b443320$var$isMap(target) {
    return target instanceof Map;
}
function $283688714b443320$var$isSet(target) {
    return target instanceof Set;
}
function $283688714b443320$var$latest(state) {
    return state.copy_ || state.base_;
}
function $283688714b443320$var$shallowCopy(base, strict) {
    if ($283688714b443320$var$isMap(base)) return new Map(base);
    if ($283688714b443320$var$isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    const isPlain = $283688714b443320$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = Object.getOwnPropertyDescriptors(base);
        delete descriptors[$283688714b443320$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc.writable === false) {
                desc.writable = true;
                desc.configurable = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                configurable: true,
                writable: true,
                // could live with !!desc.set as well here...
                enumerable: desc.enumerable,
                value: base[key]
            };
        }
        return Object.create($283688714b443320$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $283688714b443320$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return $283688714b443320$var$__spreadValues({}, base);
        const obj = Object.create(proto);
        return Object.assign(obj, base);
    }
}
function $283688714b443320$export$792f3d81ea979f55(obj, deep = false) {
    if ($283688714b443320$var$isFrozen(obj) || $283688714b443320$export$541ac630993a4c84(obj) || !$283688714b443320$export$16e3aed3edb85946(obj)) return obj;
    if ($283688714b443320$var$getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = $283688714b443320$var$dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) Object.entries(obj).forEach(([key, value])=>$283688714b443320$export$792f3d81ea979f55(value, true));
    return obj;
}
function $283688714b443320$var$dontMutateFrozenCollections() {
    $283688714b443320$var$die(2);
}
function $283688714b443320$var$isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var $283688714b443320$var$plugins = {};
function $283688714b443320$var$getPlugin(pluginKey) {
    const plugin = $283688714b443320$var$plugins[pluginKey];
    if (!plugin) $283688714b443320$var$die(0, pluginKey);
    return plugin;
}
function $283688714b443320$var$loadPlugin(pluginKey, implementation) {
    if (!$283688714b443320$var$plugins[pluginKey]) $283688714b443320$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $283688714b443320$var$currentScope;
function $283688714b443320$var$getCurrentScope() {
    return $283688714b443320$var$currentScope;
}
function $283688714b443320$var$createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function $283688714b443320$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        $283688714b443320$var$getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $283688714b443320$var$revokeScope(scope) {
    $283688714b443320$var$leaveScope(scope);
    scope.drafts_.forEach($283688714b443320$var$revokeDraft);
    scope.drafts_ = null;
}
function $283688714b443320$var$leaveScope(scope) {
    if (scope === $283688714b443320$var$currentScope) $283688714b443320$var$currentScope = scope.parent_;
}
function $283688714b443320$var$enterScope(immer2) {
    return $283688714b443320$var$currentScope = $283688714b443320$var$createScope($283688714b443320$var$currentScope, immer2);
}
function $283688714b443320$var$revokeDraft(draft) {
    const state = draft[$283688714b443320$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $283688714b443320$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$283688714b443320$var$DRAFT_STATE].modified_) {
            $283688714b443320$var$revokeScope(scope);
            $283688714b443320$var$die(4);
        }
        if ($283688714b443320$export$16e3aed3edb85946(result)) {
            result = $283688714b443320$var$finalize(scope, result);
            if (!scope.parent_) $283688714b443320$var$maybeFreeze(scope, result);
        }
        if (scope.patches_) $283688714b443320$var$getPlugin("Patches").generateReplacementPatches_(baseDraft[$283688714b443320$var$DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = $283688714b443320$var$finalize(scope, baseDraft, []);
    $283688714b443320$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $283688714b443320$export$45b790e32b2810ee ? result : void 0;
}
function $283688714b443320$var$finalize(rootScope, value, path) {
    if ($283688714b443320$var$isFrozen(value)) return value;
    const state = value[$283688714b443320$var$DRAFT_STATE];
    if (!state) {
        $283688714b443320$var$each(value, (key, childValue)=>$283688714b443320$var$finalizeProperty(rootScope, state, value, key, childValue, path));
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        $283688714b443320$var$maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        const result = state.copy_;
        let resultEach = result;
        let isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        $283688714b443320$var$each(resultEach, (key, childValue)=>$283688714b443320$var$finalizeProperty(rootScope, state, result, key, childValue, path, isSet2));
        $283688714b443320$var$maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) $283688714b443320$var$getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function $283688714b443320$var$finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if ($283688714b443320$export$541ac630993a4c84(childValue)) {
        const path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !$283688714b443320$var$has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        const res = $283688714b443320$var$finalize(rootScope, childValue, path);
        $283688714b443320$var$set(targetObject, prop, res);
        if ($283688714b443320$export$541ac630993a4c84(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if ($283688714b443320$export$16e3aed3edb85946(childValue) && !$283688714b443320$var$isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        $283688714b443320$var$finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop)) $283688714b443320$var$maybeFreeze(rootScope, childValue);
    }
}
function $283688714b443320$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $283688714b443320$export$792f3d81ea979f55(value, deep);
}
// src/core/proxy.ts
function $283688714b443320$var$createProxyProxy(base, parent) {
    const isArray = Array.isArray(base);
    const state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $283688714b443320$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    let target = state;
    let traps = $283688714b443320$var$objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = $283688714b443320$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var $283688714b443320$var$objectTraps = {
    get (state, prop) {
        if (prop === $283688714b443320$var$DRAFT_STATE) return state;
        const source = $283688714b443320$var$latest(state);
        if (!$283688714b443320$var$has(source, prop)) return $283688714b443320$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$283688714b443320$export$16e3aed3edb85946(value)) return value;
        if (value === $283688714b443320$var$peek(state.base_, prop)) {
            $283688714b443320$var$prepareCopy(state);
            return state.copy_[prop] = $283688714b443320$var$createProxy(value, state);
        }
        return value;
    },
    has (state, prop) {
        return prop in $283688714b443320$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($283688714b443320$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $283688714b443320$var$getDescriptorFromProto($283688714b443320$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $283688714b443320$var$peek($283688714b443320$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$283688714b443320$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if ($283688714b443320$var$is(value, current2) && (value !== void 0 || $283688714b443320$var$has(state.base_, prop))) return true;
            $283688714b443320$var$prepareCopy(state);
            $283688714b443320$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty (state, prop) {
        if ($283688714b443320$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            $283688714b443320$var$prepareCopy(state);
            $283688714b443320$var$markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $283688714b443320$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty () {
        $283688714b443320$var$die(11);
    },
    getPrototypeOf (state) {
        return $283688714b443320$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $283688714b443320$var$die(12);
    }
};
var $283688714b443320$var$arrayTraps = {};
$283688714b443320$var$each($283688714b443320$var$objectTraps, (key, fn)=>{
    $283688714b443320$var$arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
$283688714b443320$var$arrayTraps.deleteProperty = function(state, prop) {
    return $283688714b443320$var$arrayTraps.set.call(this, state, prop, void 0);
};
$283688714b443320$var$arrayTraps.set = function(state, prop, value) {
    return $283688714b443320$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $283688714b443320$var$peek(draft, prop) {
    const state = draft[$283688714b443320$var$DRAFT_STATE];
    const source = state ? $283688714b443320$var$latest(state) : draft;
    return source[prop];
}
function $283688714b443320$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $283688714b443320$var$getDescriptorFromProto(source, prop);
    return desc ? `value` in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $283688714b443320$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $283688714b443320$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $283688714b443320$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $283688714b443320$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $283688714b443320$var$markChanged(state.parent_);
    }
}
function $283688714b443320$var$prepareCopy(state) {
    if (!state.copy_) state.copy_ = $283688714b443320$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var $283688714b443320$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (typeof base === "function" && typeof recipe !== "function") {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (typeof recipe !== "function") $283688714b443320$var$die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") $283688714b443320$var$die(7);
            let result;
            if ($283688714b443320$export$16e3aed3edb85946(base)) {
                const scope = $283688714b443320$var$enterScope(this);
                const proxy = $283688714b443320$var$createProxy(base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $283688714b443320$var$revokeScope(scope);
                    else $283688714b443320$var$leaveScope(scope);
                }
                $283688714b443320$var$usePatchesInScope(scope, patchListener);
                return $283688714b443320$var$processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $283688714b443320$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $283688714b443320$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $283688714b443320$var$getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else $283688714b443320$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (typeof base === "function") return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    createDraft(base) {
        if (!$283688714b443320$export$16e3aed3edb85946(base)) $283688714b443320$var$die(8);
        if ($283688714b443320$export$541ac630993a4c84(base)) base = $283688714b443320$export$97aac956da55dae9(base);
        const scope = $283688714b443320$var$enterScope(this);
        const proxy = $283688714b443320$var$createProxy(base, void 0);
        proxy[$283688714b443320$var$DRAFT_STATE].isManual_ = true;
        $283688714b443320$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$283688714b443320$var$DRAFT_STATE];
        if (!state || !state.isManual_) $283688714b443320$var$die(9);
        const { scope_: scope } = state;
        $283688714b443320$var$usePatchesInScope(scope, patchListener);
        return $283688714b443320$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $283688714b443320$var$getPlugin("Patches").applyPatches_;
        if ($283688714b443320$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $283688714b443320$var$createProxy(value, parent) {
    const draft = $283688714b443320$var$isMap(value) ? $283688714b443320$var$getPlugin("MapSet").proxyMap_(value, parent) : $283688714b443320$var$isSet(value) ? $283688714b443320$var$getPlugin("MapSet").proxySet_(value, parent) : $283688714b443320$var$createProxyProxy(value, parent);
    const scope = parent ? parent.scope_ : $283688714b443320$var$getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function $283688714b443320$export$97aac956da55dae9(value) {
    if (!$283688714b443320$export$541ac630993a4c84(value)) $283688714b443320$var$die(10, value);
    return $283688714b443320$var$currentImpl(value);
}
function $283688714b443320$var$currentImpl(value) {
    if (!$283688714b443320$export$16e3aed3edb85946(value) || $283688714b443320$var$isFrozen(value)) return value;
    const state = value[$283688714b443320$var$DRAFT_STATE];
    let copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $283688714b443320$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = $283688714b443320$var$shallowCopy(value, true);
    $283688714b443320$var$each(copy, (key, childValue)=>{
        $283688714b443320$var$set(copy, key, $283688714b443320$var$currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $283688714b443320$export$d3a6659991a0696c() {
    const errorOffset = 16;
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_ } = state;
        $283688714b443320$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $283688714b443320$var$get(base_, key);
            const value = $283688714b443320$var$get(copy_, key);
            const op = !assignedValue ? REMOVE : $283688714b443320$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === $283688714b443320$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $283688714b443320$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) $283688714b443320$var$die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") $283688714b443320$var$die(errorOffset + 3);
                base = $283688714b443320$var$get(base, p);
                if (typeof base !== "object") $283688714b443320$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $283688714b443320$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $283688714b443320$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $283688714b443320$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$283688714b443320$export$16e3aed3edb85946(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if ($283688714b443320$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($283688714b443320$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($283688714b443320$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($283688714b443320$var$has(obj, $283688714b443320$export$6ee2082928bcb0ee)) cloned[$283688714b443320$export$6ee2082928bcb0ee] = obj[$283688714b443320$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($283688714b443320$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $283688714b443320$var$loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function $283688714b443320$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$283688714b443320$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $283688714b443320$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false
            };
        }
        get size() {
            return $283688714b443320$var$latest(this[$283688714b443320$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $283688714b443320$var$latest(this[$283688714b443320$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$283688714b443320$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$283688714b443320$var$latest(state).has(key) || $283688714b443320$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $283688714b443320$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$283688714b443320$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $283688714b443320$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$283688714b443320$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($283688714b443320$var$latest(state).size) {
                prepareMapCopy(state);
                $283688714b443320$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $283688714b443320$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$283688714b443320$var$DRAFT_STATE];
            $283688714b443320$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$283688714b443320$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $283688714b443320$var$latest(state).get(key);
            if (state.finalized_ || !$283688714b443320$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $283688714b443320$var$createProxy(value, state);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $283688714b443320$var$latest(this[$283688714b443320$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($283688714b443320$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$283688714b443320$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $283688714b443320$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
        }
        get size() {
            return $283688714b443320$var$latest(this[$283688714b443320$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$283688714b443320$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$283688714b443320$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $283688714b443320$var$markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$283688714b443320$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $283688714b443320$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$283688714b443320$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($283688714b443320$var$latest(state).size) {
                prepareSetCopy(state);
                $283688714b443320$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$283688714b443320$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$283688714b443320$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($283688714b443320$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($283688714b443320$export$16e3aed3edb85946(value)) {
                    const draft = $283688714b443320$var$createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $283688714b443320$var$die(3, JSON.stringify($283688714b443320$var$latest(state)));
    }
    $283688714b443320$var$loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var $283688714b443320$var$immer = new $283688714b443320$export$aaadc6ff0f822719();
var $283688714b443320$export$b46cabe22e78bc00 = $283688714b443320$var$immer.produce;
var $283688714b443320$export$4da66d41c9492c78 = $283688714b443320$var$immer.produceWithPatches.bind($283688714b443320$var$immer);
var $283688714b443320$export$573f26f60825c493 = $283688714b443320$var$immer.setAutoFreeze.bind($283688714b443320$var$immer);
var $283688714b443320$export$333ce65961cbe047 = $283688714b443320$var$immer.setUseStrictShallowCopy.bind($283688714b443320$var$immer);
var $283688714b443320$export$a8b8e03e6bbe5473 = $283688714b443320$var$immer.applyPatches.bind($283688714b443320$var$immer);
var $283688714b443320$export$3c3214997190395f = $283688714b443320$var$immer.createDraft.bind($283688714b443320$var$immer);
var $283688714b443320$export$c60f5e69c521b528 = $283688714b443320$var$immer.finishDraft.bind($283688714b443320$var$immer);
function $283688714b443320$export$c05b21e3257751e5(value) {
    return value;
}
function $283688714b443320$export$20f911b3f8cf0b74(value) {
    return value;
}


var $7f9e1deb9b6d74d3$var$__defProp = Object.defineProperty;
var $7f9e1deb9b6d74d3$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $7f9e1deb9b6d74d3$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $7f9e1deb9b6d74d3$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $7f9e1deb9b6d74d3$var$__defNormalProp = (obj, key, value)=>key in obj ? $7f9e1deb9b6d74d3$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $7f9e1deb9b6d74d3$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($7f9e1deb9b6d74d3$var$__hasOwnProp.call(b, prop)) $7f9e1deb9b6d74d3$var$__defNormalProp(a, prop, b[prop]);
    if ($7f9e1deb9b6d74d3$var$__getOwnPropSymbols) {
        for (var prop of $7f9e1deb9b6d74d3$var$__getOwnPropSymbols(b))if ($7f9e1deb9b6d74d3$var$__propIsEnum.call(b, prop)) $7f9e1deb9b6d74d3$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $7f9e1deb9b6d74d3$var$__publicField = (obj, key, value)=>{
    $7f9e1deb9b6d74d3$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $7f9e1deb9b6d74d3$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $7f9e1deb9b6d74d3$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $7f9e1deb9b6d74d3$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $7f9e1deb9b6d74d3$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($7f9e1deb9b6d74d3$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $7f9e1deb9b6d74d3$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $7f9e1deb9b6d74d3$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $7f9e1deb9b6d74d3$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $7f9e1deb9b6d74d3$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $7f9e1deb9b6d74d3$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $7f9e1deb9b6d74d3$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $7f9e1deb9b6d74d3$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $7f9e1deb9b6d74d3$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $7f9e1deb9b6d74d3$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = $7f9e1deb9b6d74d3$var$__spreadValues($7f9e1deb9b6d74d3$var$__spreadValues({}, $7f9e1deb9b6d74d3$var$globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $7f9e1deb9b6d74d3$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $7f9e1deb9b6d74d3$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $7f9e1deb9b6d74d3$var$$REVISION = 0;
var $7f9e1deb9b6d74d3$var$CURRENT_TRACKER = null;
var $7f9e1deb9b6d74d3$var$Cell = class {
    constructor(initialValue, isEqual = $7f9e1deb9b6d74d3$var$tripleEq){
        $7f9e1deb9b6d74d3$var$__publicField(this, "revision", $7f9e1deb9b6d74d3$var$$REVISION);
        $7f9e1deb9b6d74d3$var$__publicField(this, "_value");
        $7f9e1deb9b6d74d3$var$__publicField(this, "_lastValue");
        $7f9e1deb9b6d74d3$var$__publicField(this, "_isEqual", $7f9e1deb9b6d74d3$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $7f9e1deb9b6d74d3$var$CURRENT_TRACKER == null || $7f9e1deb9b6d74d3$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$7f9e1deb9b6d74d3$var$$REVISION;
    }
};
function $7f9e1deb9b6d74d3$var$tripleEq(a, b) {
    return a === b;
}
var $7f9e1deb9b6d74d3$var$TrackingCache = class {
    constructor(fn){
        $7f9e1deb9b6d74d3$var$__publicField(this, "_cachedValue");
        $7f9e1deb9b6d74d3$var$__publicField(this, "_cachedRevision", -1);
        $7f9e1deb9b6d74d3$var$__publicField(this, "_deps", []);
        $7f9e1deb9b6d74d3$var$__publicField(this, "hits", 0);
        $7f9e1deb9b6d74d3$var$__publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $7f9e1deb9b6d74d3$var$CURRENT_TRACKER;
            $7f9e1deb9b6d74d3$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $7f9e1deb9b6d74d3$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $7f9e1deb9b6d74d3$var$CURRENT_TRACKER == null || $7f9e1deb9b6d74d3$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $7f9e1deb9b6d74d3$var$getValue(cell) {
    if (!(cell instanceof $7f9e1deb9b6d74d3$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $7f9e1deb9b6d74d3$var$setValue(storage, value) {
    if (!(storage instanceof $7f9e1deb9b6d74d3$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $7f9e1deb9b6d74d3$var$createCell(initialValue, isEqual = $7f9e1deb9b6d74d3$var$tripleEq) {
    return new $7f9e1deb9b6d74d3$var$Cell(initialValue, isEqual);
}
function $7f9e1deb9b6d74d3$var$createCache(fn) {
    $7f9e1deb9b6d74d3$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $7f9e1deb9b6d74d3$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $7f9e1deb9b6d74d3$var$neverEq = (a, b)=>false;
function $7f9e1deb9b6d74d3$var$createTag() {
    return $7f9e1deb9b6d74d3$var$createCell(null, $7f9e1deb9b6d74d3$var$neverEq);
}
function $7f9e1deb9b6d74d3$var$dirtyTag(tag, value) {
    $7f9e1deb9b6d74d3$var$setValue(tag, value);
}
var $7f9e1deb9b6d74d3$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $7f9e1deb9b6d74d3$var$createTag();
    $7f9e1deb9b6d74d3$var$getValue(tag);
};
var $7f9e1deb9b6d74d3$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $7f9e1deb9b6d74d3$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $7f9e1deb9b6d74d3$var$REDUX_PROXY_LABEL = Symbol();
var $7f9e1deb9b6d74d3$var$nextId = 0;
var $7f9e1deb9b6d74d3$var$proto = Object.getPrototypeOf({});
var $7f9e1deb9b6d74d3$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        $7f9e1deb9b6d74d3$var$__publicField(this, "proxy", new Proxy(this, $7f9e1deb9b6d74d3$var$objectProxyHandler));
        $7f9e1deb9b6d74d3$var$__publicField(this, "tag", $7f9e1deb9b6d74d3$var$createTag());
        $7f9e1deb9b6d74d3$var$__publicField(this, "tags", {});
        $7f9e1deb9b6d74d3$var$__publicField(this, "children", {});
        $7f9e1deb9b6d74d3$var$__publicField(this, "collectionTag", null);
        $7f9e1deb9b6d74d3$var$__publicField(this, "id", $7f9e1deb9b6d74d3$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $7f9e1deb9b6d74d3$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $7f9e1deb9b6d74d3$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $7f9e1deb9b6d74d3$var$createNode(childValue);
                if (childNode.tag) $7f9e1deb9b6d74d3$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $7f9e1deb9b6d74d3$var$createTag();
                    tag.value = childValue;
                }
                $7f9e1deb9b6d74d3$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $7f9e1deb9b6d74d3$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $7f9e1deb9b6d74d3$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        $7f9e1deb9b6d74d3$var$__publicField(this, "proxy", new Proxy([
            this
        ], $7f9e1deb9b6d74d3$var$arrayProxyHandler));
        $7f9e1deb9b6d74d3$var$__publicField(this, "tag", $7f9e1deb9b6d74d3$var$createTag());
        $7f9e1deb9b6d74d3$var$__publicField(this, "tags", {});
        $7f9e1deb9b6d74d3$var$__publicField(this, "children", {});
        $7f9e1deb9b6d74d3$var$__publicField(this, "collectionTag", null);
        $7f9e1deb9b6d74d3$var$__publicField(this, "id", $7f9e1deb9b6d74d3$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $7f9e1deb9b6d74d3$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $7f9e1deb9b6d74d3$var$consumeCollection(node);
        return $7f9e1deb9b6d74d3$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $7f9e1deb9b6d74d3$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $7f9e1deb9b6d74d3$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $7f9e1deb9b6d74d3$var$objectProxyHandler.has(node, prop);
    }
};
function $7f9e1deb9b6d74d3$var$createNode(value) {
    if (Array.isArray(value)) return new $7f9e1deb9b6d74d3$var$ArrayTreeNode(value);
    return new $7f9e1deb9b6d74d3$var$ObjectTreeNode(value);
}
function $7f9e1deb9b6d74d3$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $7f9e1deb9b6d74d3$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $7f9e1deb9b6d74d3$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $7f9e1deb9b6d74d3$var$dirtyCollection(node);
            $7f9e1deb9b6d74d3$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $7f9e1deb9b6d74d3$var$updateNode(childNode, newChildValue);
        else {
            $7f9e1deb9b6d74d3$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $7f9e1deb9b6d74d3$var$deleteNode(node) {
    if (node.tag) $7f9e1deb9b6d74d3$var$dirtyTag(node.tag, null);
    $7f9e1deb9b6d74d3$var$dirtyCollection(node);
    for(const key in node.tags)$7f9e1deb9b6d74d3$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$7f9e1deb9b6d74d3$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $7f9e1deb9b6d74d3$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $7f9e1deb9b6d74d3$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $7f9e1deb9b6d74d3$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $7f9e1deb9b6d74d3$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $7f9e1deb9b6d74d3$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $7f9e1deb9b6d74d3$export$3f025202a230c6dd = (a, b)=>a === b;
function $7f9e1deb9b6d74d3$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $7f9e1deb9b6d74d3$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $7f9e1deb9b6d74d3$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $7f9e1deb9b6d74d3$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $7f9e1deb9b6d74d3$var$createSingletonCache(comparator) : $7f9e1deb9b6d74d3$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $7f9e1deb9b6d74d3$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $7f9e1deb9b6d74d3$export$c8f9cf88d9fdee55(func) {
    const node = $7f9e1deb9b6d74d3$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $7f9e1deb9b6d74d3$var$createCacheKeyComparator($7f9e1deb9b6d74d3$export$3f025202a230c6dd);
    const cache = $7f9e1deb9b6d74d3$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $7f9e1deb9b6d74d3$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $7f9e1deb9b6d74d3$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $7f9e1deb9b6d74d3$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $7f9e1deb9b6d74d3$var$StrongRef;
var $7f9e1deb9b6d74d3$var$UNTERMINATED = 0;
var $7f9e1deb9b6d74d3$var$TERMINATED = 1;
function $7f9e1deb9b6d74d3$var$createCacheNode() {
    return {
        s: $7f9e1deb9b6d74d3$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $7f9e1deb9b6d74d3$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $7f9e1deb9b6d74d3$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a, _b;
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $7f9e1deb9b6d74d3$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $7f9e1deb9b6d74d3$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $7f9e1deb9b6d74d3$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new $7f9e1deb9b6d74d3$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $7f9e1deb9b6d74d3$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $7f9e1deb9b6d74d3$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $7f9e1deb9b6d74d3$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $7f9e1deb9b6d74d3$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $7f9e1deb9b6d74d3$var$__spreadValues($7f9e1deb9b6d74d3$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $7f9e1deb9b6d74d3$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $7f9e1deb9b6d74d3$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $7f9e1deb9b6d74d3$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $7f9e1deb9b6d74d3$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $7f9e1deb9b6d74d3$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $7f9e1deb9b6d74d3$export$595d22ed68ca2841 = /* @__PURE__ */ $7f9e1deb9b6d74d3$export$5943f4447f6ef248($7f9e1deb9b6d74d3$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $7f9e1deb9b6d74d3$export$75979cfcd91bf38f = Object.assign((inputSelectorsObject, selectorCreator = $7f9e1deb9b6d74d3$export$595d22ed68ca2841)=>{
    $7f9e1deb9b6d74d3$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$7f9e1deb9b6d74d3$export$75979cfcd91bf38f
});


// src/index.ts
function $c6e0c572660e3c5c$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $c6e0c572660e3c5c$export$dd164f5517779f15 = $c6e0c572660e3c5c$var$createThunkMiddleware();
var $c6e0c572660e3c5c$export$16d06542a1949d9e = $c6e0c572660e3c5c$var$createThunkMiddleware;


var $f35e65d8cff8ccc8$exports = {};
// shim for using process in browser
var $f35e65d8cff8ccc8$var$process = $f35e65d8cff8ccc8$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $f35e65d8cff8ccc8$var$cachedSetTimeout;
var $f35e65d8cff8ccc8$var$cachedClearTimeout;
function $f35e65d8cff8ccc8$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $f35e65d8cff8ccc8$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $f35e65d8cff8ccc8$var$cachedSetTimeout = setTimeout;
        else $f35e65d8cff8ccc8$var$cachedSetTimeout = $f35e65d8cff8ccc8$var$defaultSetTimout;
    } catch (e) {
        $f35e65d8cff8ccc8$var$cachedSetTimeout = $f35e65d8cff8ccc8$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $f35e65d8cff8ccc8$var$cachedClearTimeout = clearTimeout;
        else $f35e65d8cff8ccc8$var$cachedClearTimeout = $f35e65d8cff8ccc8$var$defaultClearTimeout;
    } catch (e) {
        $f35e65d8cff8ccc8$var$cachedClearTimeout = $f35e65d8cff8ccc8$var$defaultClearTimeout;
    }
})();
function $f35e65d8cff8ccc8$var$runTimeout(fun) {
    if ($f35e65d8cff8ccc8$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($f35e65d8cff8ccc8$var$cachedSetTimeout === $f35e65d8cff8ccc8$var$defaultSetTimout || !$f35e65d8cff8ccc8$var$cachedSetTimeout) && setTimeout) {
        $f35e65d8cff8ccc8$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $f35e65d8cff8ccc8$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $f35e65d8cff8ccc8$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $f35e65d8cff8ccc8$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $f35e65d8cff8ccc8$var$runClearTimeout(marker) {
    if ($f35e65d8cff8ccc8$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($f35e65d8cff8ccc8$var$cachedClearTimeout === $f35e65d8cff8ccc8$var$defaultClearTimeout || !$f35e65d8cff8ccc8$var$cachedClearTimeout) && clearTimeout) {
        $f35e65d8cff8ccc8$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $f35e65d8cff8ccc8$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $f35e65d8cff8ccc8$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $f35e65d8cff8ccc8$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $f35e65d8cff8ccc8$var$queue = [];
var $f35e65d8cff8ccc8$var$draining = false;
var $f35e65d8cff8ccc8$var$currentQueue;
var $f35e65d8cff8ccc8$var$queueIndex = -1;
function $f35e65d8cff8ccc8$var$cleanUpNextTick() {
    if (!$f35e65d8cff8ccc8$var$draining || !$f35e65d8cff8ccc8$var$currentQueue) return;
    $f35e65d8cff8ccc8$var$draining = false;
    if ($f35e65d8cff8ccc8$var$currentQueue.length) $f35e65d8cff8ccc8$var$queue = $f35e65d8cff8ccc8$var$currentQueue.concat($f35e65d8cff8ccc8$var$queue);
    else $f35e65d8cff8ccc8$var$queueIndex = -1;
    if ($f35e65d8cff8ccc8$var$queue.length) $f35e65d8cff8ccc8$var$drainQueue();
}
function $f35e65d8cff8ccc8$var$drainQueue() {
    if ($f35e65d8cff8ccc8$var$draining) return;
    var timeout = $f35e65d8cff8ccc8$var$runTimeout($f35e65d8cff8ccc8$var$cleanUpNextTick);
    $f35e65d8cff8ccc8$var$draining = true;
    var len = $f35e65d8cff8ccc8$var$queue.length;
    while(len){
        $f35e65d8cff8ccc8$var$currentQueue = $f35e65d8cff8ccc8$var$queue;
        $f35e65d8cff8ccc8$var$queue = [];
        while(++$f35e65d8cff8ccc8$var$queueIndex < len)if ($f35e65d8cff8ccc8$var$currentQueue) $f35e65d8cff8ccc8$var$currentQueue[$f35e65d8cff8ccc8$var$queueIndex].run();
        $f35e65d8cff8ccc8$var$queueIndex = -1;
        len = $f35e65d8cff8ccc8$var$queue.length;
    }
    $f35e65d8cff8ccc8$var$currentQueue = null;
    $f35e65d8cff8ccc8$var$draining = false;
    $f35e65d8cff8ccc8$var$runClearTimeout(timeout);
}
$f35e65d8cff8ccc8$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $f35e65d8cff8ccc8$var$queue.push(new $f35e65d8cff8ccc8$var$Item(fun, args));
    if ($f35e65d8cff8ccc8$var$queue.length === 1 && !$f35e65d8cff8ccc8$var$draining) $f35e65d8cff8ccc8$var$runTimeout($f35e65d8cff8ccc8$var$drainQueue);
};
// v8 likes predictible objects
function $f35e65d8cff8ccc8$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$f35e65d8cff8ccc8$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$f35e65d8cff8ccc8$var$process.title = "browser";
$f35e65d8cff8ccc8$var$process.browser = true;
$f35e65d8cff8ccc8$var$process.env = {};
$f35e65d8cff8ccc8$var$process.argv = [];
$f35e65d8cff8ccc8$var$process.version = ""; // empty string to avoid regexp issues
$f35e65d8cff8ccc8$var$process.versions = {};
function $f35e65d8cff8ccc8$var$noop() {}
$f35e65d8cff8ccc8$var$process.on = $f35e65d8cff8ccc8$var$noop;
$f35e65d8cff8ccc8$var$process.addListener = $f35e65d8cff8ccc8$var$noop;
$f35e65d8cff8ccc8$var$process.once = $f35e65d8cff8ccc8$var$noop;
$f35e65d8cff8ccc8$var$process.off = $f35e65d8cff8ccc8$var$noop;
$f35e65d8cff8ccc8$var$process.removeListener = $f35e65d8cff8ccc8$var$noop;
$f35e65d8cff8ccc8$var$process.removeAllListeners = $f35e65d8cff8ccc8$var$noop;
$f35e65d8cff8ccc8$var$process.emit = $f35e65d8cff8ccc8$var$noop;
$f35e65d8cff8ccc8$var$process.prependListener = $f35e65d8cff8ccc8$var$noop;
$f35e65d8cff8ccc8$var$process.prependOnceListener = $f35e65d8cff8ccc8$var$noop;
$f35e65d8cff8ccc8$var$process.listeners = function(name) {
    return [];
};
$f35e65d8cff8ccc8$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$f35e65d8cff8ccc8$var$process.cwd = function() {
    return "/";
};
$f35e65d8cff8ccc8$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$f35e65d8cff8ccc8$var$process.umask = function() {
    return 0;
};


var $4682a312fbf2690b$var$__defProp = Object.defineProperty;
var $4682a312fbf2690b$var$__defProps = Object.defineProperties;
var $4682a312fbf2690b$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $4682a312fbf2690b$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $4682a312fbf2690b$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $4682a312fbf2690b$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $4682a312fbf2690b$var$__defNormalProp = (obj, key, value)=>key in obj ? $4682a312fbf2690b$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $4682a312fbf2690b$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($4682a312fbf2690b$var$__hasOwnProp.call(b, prop)) $4682a312fbf2690b$var$__defNormalProp(a, prop, b[prop]);
    if ($4682a312fbf2690b$var$__getOwnPropSymbols) {
        for (var prop of $4682a312fbf2690b$var$__getOwnPropSymbols(b))if ($4682a312fbf2690b$var$__propIsEnum.call(b, prop)) $4682a312fbf2690b$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $4682a312fbf2690b$var$__spreadProps = (a, b)=>$4682a312fbf2690b$var$__defProps(a, $4682a312fbf2690b$var$__getOwnPropDescs(b));
var $4682a312fbf2690b$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($4682a312fbf2690b$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $4682a312fbf2690b$var$__getOwnPropSymbols) {
        for (var prop of $4682a312fbf2690b$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $4682a312fbf2690b$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $4682a312fbf2690b$var$__publicField = (obj, key, value)=>$4682a312fbf2690b$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var $4682a312fbf2690b$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector2 = (0, $7f9e1deb9b6d74d3$export$5943f4447f6ef248)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, $283688714b443320$export$541ac630993a4c84)(value) ? (0, $283688714b443320$export$97aac956da55dae9)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var $4682a312fbf2690b$export$a5d3c27355e35910 = /* @__PURE__ */ $4682a312fbf2690b$export$aab6de9e3dbb1473((0, $7f9e1deb9b6d74d3$export$8402dc26d96f6902));
var $4682a312fbf2690b$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $7c4fd50405af3d52$export$f672e0b6f7222cd7;
    return (0, $7c4fd50405af3d52$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $4682a312fbf2690b$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $4682a312fbf2690b$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $4682a312fbf2690b$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($4682a312fbf2690b$export$378fa86b259c0280(0));
            return $4682a312fbf2690b$var$__spreadValues($4682a312fbf2690b$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $7c4fd50405af3d52$export$b956e38827fca970)(action) && action.type === type;
    return actionCreator;
}
function $4682a312fbf2690b$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $4682a312fbf2690b$var$hasMatchFunction(action);
}
function $4682a312fbf2690b$export$ebd532f9034651f3(action) {
    return (0, $7c4fd50405af3d52$export$b956e38827fca970)(action) && Object.keys(action).every($4682a312fbf2690b$var$isValidKey);
}
function $4682a312fbf2690b$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $4682a312fbf2690b$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $4682a312fbf2690b$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $4682a312fbf2690b$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
function $4682a312fbf2690b$var$find(iterable, comparator) {
    for (const entry of iterable){
        if (comparator(entry)) return entry;
    }
    return void 0;
}
var $4682a312fbf2690b$export$1908877435b1d5e9 = class _Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
};
function $4682a312fbf2690b$var$freezeDraftable(val) {
    return (0, $283688714b443320$export$16e3aed3edb85946)(val) ? (0, $283688714b443320$export$b46cabe22e78bc00)(val, ()=>{}) : val;
}
function $4682a312fbf2690b$var$emplace(map, key, handler) {
    if (map.has(key)) {
        let value = map.get(key);
        if (handler.update) {
            value = handler.update(value, key, map);
            map.set(key, value);
        }
        return value;
    }
    if (!handler.insert) throw new Error($4682a312fbf2690b$export$378fa86b259c0280(10));
    const inserted = handler.insert(key, map);
    map.set(key, inserted);
    return inserted;
}
// src/immutableStateInvariantMiddleware.ts
function $4682a312fbf2690b$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $4682a312fbf2690b$var$trackForMutations(isImmutable, ignorePaths, obj) {
    const trackedProperties = $4682a312fbf2690b$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations () {
            return $4682a312fbf2690b$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $4682a312fbf2690b$var$trackProperties(isImmutable, ignorePaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(const key in obj){
            const childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $4682a312fbf2690b$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $4682a312fbf2690b$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = $4682a312fbf2690b$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $4682a312fbf2690b$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $4682a312fbf2690b$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $7c4fd50405af3d52$export$53b83ca8eaab0383)(val);
}
function $4682a312fbf2690b$export$ada5dca0b571bc7(value, path = "", isSerializable = $4682a312fbf2690b$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $4682a312fbf2690b$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $4682a312fbf2690b$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $4682a312fbf2690b$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$4682a312fbf2690b$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $4682a312fbf2690b$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function $4682a312fbf2690b$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $4682a312fbf2690b$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options != null ? options : {};
        let middlewareArray = new $4682a312fbf2690b$export$1908877435b1d5e9();
        if (thunk) {
            if ($4682a312fbf2690b$var$isBoolean(thunk)) middlewareArray.push((0, $c6e0c572660e3c5c$export$dd164f5517779f15));
            else middlewareArray.push((0, $c6e0c572660e3c5c$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var $4682a312fbf2690b$export$8fb31c0f05df007b = "RTK_autoBatch";
var $4682a312fbf2690b$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$4682a312fbf2690b$export$8fb31c0f05df007b]: true
            }
        });
var $4682a312fbf2690b$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var $4682a312fbf2690b$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $4682a312fbf2690b$var$createQueueWithTimer(10);
var $4682a312fbf2690b$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? $4682a312fbf2690b$var$rAF : options.type === "callback" ? options.queueNotification : $4682a312fbf2690b$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$4682a312fbf2690b$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var $4682a312fbf2690b$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options != null ? options : {};
        let enhancerArray = new $4682a312fbf2690b$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($4682a312fbf2690b$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
function $4682a312fbf2690b$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $4682a312fbf2690b$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $7c4fd50405af3d52$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $7c4fd50405af3d52$export$66e4520cdb265d18)(reducer);
    else throw new Error($4682a312fbf2690b$export$378fa86b259c0280(1));
    let finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    let finalCompose = (0, $7c4fd50405af3d52$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $4682a312fbf2690b$var$composeWithDevTools($4682a312fbf2690b$var$__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false
    }, typeof devTools === "object" && devTools));
    const middlewareEnhancer = (0, $7c4fd50405af3d52$export$9ff26e0402cc7b7)(...finalMiddleware);
    const getDefaultEnhancers = $4682a312fbf2690b$var$buildGetDefaultEnhancers(middlewareEnhancer);
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $7c4fd50405af3d52$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $4682a312fbf2690b$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($4682a312fbf2690b$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($4682a312fbf2690b$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $4682a312fbf2690b$var$isStateFunction(x) {
    return typeof x === "function";
}
function $4682a312fbf2690b$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $4682a312fbf2690b$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($4682a312fbf2690b$var$isStateFunction(initialState)) getInitialState = ()=>$4682a312fbf2690b$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $4682a312fbf2690b$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $283688714b443320$export$541ac630993a4c84)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $283688714b443320$export$16e3aed3edb85946)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw new Error($4682a312fbf2690b$export$378fa86b259c0280(9));
                    }
                    return result;
                } else return (0, $283688714b443320$export$b46cabe22e78bc00)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/matchers.ts
var $4682a312fbf2690b$var$matches = (matcher, action)=>{
    if ($4682a312fbf2690b$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $4682a312fbf2690b$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$4682a312fbf2690b$var$matches(matcher, action));
    };
}
function $4682a312fbf2690b$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$4682a312fbf2690b$var$matches(matcher, action));
    };
}
function $4682a312fbf2690b$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $4682a312fbf2690b$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $4682a312fbf2690b$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$4682a312fbf2690b$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$4682a312fbf2690b$var$isAsyncThunkArray(asyncThunks)) return $4682a312fbf2690b$export$872dec21e9a69476()(asyncThunks[0]);
    return $4682a312fbf2690b$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function $4682a312fbf2690b$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$4682a312fbf2690b$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$4682a312fbf2690b$var$isAsyncThunkArray(asyncThunks)) return $4682a312fbf2690b$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $4682a312fbf2690b$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function $4682a312fbf2690b$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $4682a312fbf2690b$export$9dd1fb32974da385($4682a312fbf2690b$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
    if (!$4682a312fbf2690b$var$isAsyncThunkArray(asyncThunks)) return $4682a312fbf2690b$export$fcc3388fb56de601()(asyncThunks[0]);
    return $4682a312fbf2690b$export$9dd1fb32974da385($4682a312fbf2690b$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
}
function $4682a312fbf2690b$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$4682a312fbf2690b$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$4682a312fbf2690b$var$isAsyncThunkArray(asyncThunks)) return $4682a312fbf2690b$export$1da80a6ef1307441()(asyncThunks[0]);
    return $4682a312fbf2690b$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function $4682a312fbf2690b$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$4682a312fbf2690b$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$4682a312fbf2690b$var$isAsyncThunkArray(asyncThunks)) return $4682a312fbf2690b$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $4682a312fbf2690b$export$2c3435c7647f7b0d(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
// src/nanoid.ts
var $4682a312fbf2690b$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $4682a312fbf2690b$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $4682a312fbf2690b$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $4682a312fbf2690b$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $4682a312fbf2690b$var$RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $4682a312fbf2690b$var$__publicField(this, "_type");
    }
};
var $4682a312fbf2690b$var$FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $4682a312fbf2690b$var$__publicField(this, "_type");
    }
};
var $4682a312fbf2690b$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $4682a312fbf2690b$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $4682a312fbf2690b$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = $4682a312fbf2690b$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: $4682a312fbf2690b$var$__spreadProps($4682a312fbf2690b$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            }));
        const pending = $4682a312fbf2690b$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: $4682a312fbf2690b$var$__spreadProps($4682a312fbf2690b$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            }));
        const rejected = $4682a312fbf2690b$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $4682a312fbf2690b$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $4682a312fbf2690b$var$__spreadProps($4682a312fbf2690b$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            }));
        function actionCreator(arg) {
            return (dispatch, getState, extra)=>{
                const requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $4682a312fbf2690b$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                const promise = async function() {
                    var _a, _b;
                    let finalAction;
                    try {
                        let conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($4682a312fbf2690b$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler);
                        });
                        dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $4682a312fbf2690b$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $4682a312fbf2690b$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $4682a312fbf2690b$var$RejectWithValue) throw result;
                                if (result instanceof $4682a312fbf2690b$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $4682a312fbf2690b$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($4682a312fbf2690b$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $4682a312fbf2690b$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function $4682a312fbf2690b$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $4682a312fbf2690b$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $4682a312fbf2690b$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $4682a312fbf2690b$export$343355ed40c51c46 = {
    [$4682a312fbf2690b$var$asyncThunkSymbol]: $4682a312fbf2690b$export$6abd22dc03e5063f
};
var $4682a312fbf2690b$export$23a094319a4b586 = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})($4682a312fbf2690b$export$23a094319a4b586 || {});
function $4682a312fbf2690b$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $4682a312fbf2690b$export$affdea4146de9cf5({ creators: creators } = {}) {
    var _a;
    const cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[$4682a312fbf2690b$var$asyncThunkSymbol];
    return function createSlice2(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($4682a312fbf2690b$export$378fa86b259c0280(11));
        typeof $f35e65d8cff8ccc8$exports;
        const reducers = (typeof options.reducers === "function" ? options.reducers($4682a312fbf2690b$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($4682a312fbf2690b$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($4682a312fbf2690b$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $4682a312fbf2690b$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($4682a312fbf2690b$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $4682a312fbf2690b$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $4682a312fbf2690b$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $4682a312fbf2690b$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = $4682a312fbf2690b$var$__spreadValues($4682a312fbf2690b$var$__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return $4682a312fbf2690b$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = getInitialState();
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = $4682a312fbf2690b$var$emplace(injectedSelectorCache, injected, {
                    insert: ()=>/* @__PURE__ */ new WeakMap()
                });
                return $4682a312fbf2690b$var$emplace(selectorCache, selectState, {
                    insert: ()=>{
                        var _a2;
                        const map = {};
                        for (const [name2, selector] of Object.entries((_a2 = options.selectors) != null ? _a2 : {}))map[name2] = $4682a312fbf2690b$var$wrapSelector(selector, selectState, getInitialState, injected);
                        return map;
                    }
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = $4682a312fbf2690b$var$__spreadProps($4682a312fbf2690b$var$__spreadValues({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto (injectable, _a2 = {}) {
                var _b = _a2, { reducerPath: pathOpt } = _b, config = $4682a312fbf2690b$var$__objRest(_b, [
                    "reducerPath"
                ]);
                const newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return $4682a312fbf2690b$var$__spreadValues($4682a312fbf2690b$var$__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $4682a312fbf2690b$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $4682a312fbf2690b$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $4682a312fbf2690b$export$affdea4146de9cf5();
function $4682a312fbf2690b$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return $4682a312fbf2690b$var$__spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $4682a312fbf2690b$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$4682a312fbf2690b$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($4682a312fbf2690b$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $4682a312fbf2690b$export$309c7a02b0b0bc62(type, prepareCallback) : $4682a312fbf2690b$export$309c7a02b0b0bc62(type));
}
function $4682a312fbf2690b$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $4682a312fbf2690b$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $4682a312fbf2690b$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($4682a312fbf2690b$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $4682a312fbf2690b$var$noop,
        pending: pending || $4682a312fbf2690b$var$noop,
        rejected: rejected || $4682a312fbf2690b$var$noop,
        settled: settled || $4682a312fbf2690b$var$noop
    });
}
function $4682a312fbf2690b$var$noop() {}
// src/entities/entity_state.ts
function $4682a312fbf2690b$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $4682a312fbf2690b$var$createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign($4682a312fbf2690b$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $4682a312fbf2690b$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = $4682a312fbf2690b$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
var $4682a312fbf2690b$var$isDraftTyped = (0, $283688714b443320$export$541ac630993a4c84);
function $4682a312fbf2690b$var$createSingleArgumentStateOperator(mutator) {
    const operator = $4682a312fbf2690b$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $4682a312fbf2690b$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $4682a312fbf2690b$export$ebd532f9034651f3(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($4682a312fbf2690b$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $283688714b443320$export$b46cabe22e78bc00)(state, runMutator);
    };
}
function $4682a312fbf2690b$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $4682a312fbf2690b$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $4682a312fbf2690b$var$getCurrent(value) {
    return (0, $283688714b443320$export$541ac630993a4c84)(value) ? (0, $283688714b443320$export$97aac956da55dae9)(value) : value;
}
function $4682a312fbf2690b$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $4682a312fbf2690b$var$ensureEntitiesArray(newEntities);
    const existingIdsArray = $4682a312fbf2690b$var$getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const updated = [];
    for (const entity of newEntities){
        const id = $4682a312fbf2690b$var$selectIdValue(entity, selectId);
        if (existingIds.has(id)) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $4682a312fbf2690b$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $4682a312fbf2690b$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $4682a312fbf2690b$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $4682a312fbf2690b$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $4682a312fbf2690b$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $4682a312fbf2690b$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = $4682a312fbf2690b$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            var _a;
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: $4682a312fbf2690b$var$__spreadValues($4682a312fbf2690b$var$__spreadValues({}, (_a = updatesPerEntity[update.id]) == null ? void 0 : _a.changes), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>$4682a312fbf2690b$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $4682a312fbf2690b$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $4682a312fbf2690b$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $4682a312fbf2690b$var$createStateOperator(addOneMutably),
        addMany: $4682a312fbf2690b$var$createStateOperator(addManyMutably),
        setOne: $4682a312fbf2690b$var$createStateOperator(setOneMutably),
        setMany: $4682a312fbf2690b$var$createStateOperator(setManyMutably),
        setAll: $4682a312fbf2690b$var$createStateOperator(setAllMutably),
        updateOne: $4682a312fbf2690b$var$createStateOperator(updateOneMutably),
        updateMany: $4682a312fbf2690b$var$createStateOperator(updateManyMutably),
        upsertOne: $4682a312fbf2690b$var$createStateOperator(upsertOneMutably),
        upsertMany: $4682a312fbf2690b$var$createStateOperator(upsertManyMutably),
        removeOne: $4682a312fbf2690b$var$createStateOperator(removeOneMutably),
        removeMany: $4682a312fbf2690b$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $4682a312fbf2690b$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        const res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $4682a312fbf2690b$var$insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = $4682a312fbf2690b$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $4682a312fbf2690b$var$createSortedStateAdapter(selectId, comparer) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $4682a312fbf2690b$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $4682a312fbf2690b$var$ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds != null ? existingIds : $4682a312fbf2690b$var$getCurrent(state.ids));
        const models = newEntities.filter((model)=>!existingKeys.has($4682a312fbf2690b$var$selectIdValue(model, selectId)));
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $4682a312fbf2690b$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities)delete state.entities[selectId(item)];
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $4682a312fbf2690b$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = $4682a312fbf2690b$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        if (updated.length) updateManyMutably(updated, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    const mergeFunction = (state, addedItems, appliedUpdates, replacedIds)=>{
        const currentEntities = $4682a312fbf2690b$var$getCurrent(state.entities);
        const currentIds = $4682a312fbf2690b$var$getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) $4682a312fbf2690b$var$insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $4682a312fbf2690b$var$createStateOperator(addOneMutably),
        updateOne: $4682a312fbf2690b$var$createStateOperator(updateOneMutably),
        upsertOne: $4682a312fbf2690b$var$createStateOperator(upsertOneMutably),
        setOne: $4682a312fbf2690b$var$createStateOperator(setOneMutably),
        setMany: $4682a312fbf2690b$var$createStateOperator(setManyMutably),
        setAll: $4682a312fbf2690b$var$createStateOperator(setAllMutably),
        addMany: $4682a312fbf2690b$var$createStateOperator(addManyMutably),
        updateMany: $4682a312fbf2690b$var$createStateOperator(updateManyMutably),
        upsertMany: $4682a312fbf2690b$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $4682a312fbf2690b$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = $4682a312fbf2690b$var$__spreadValues({
        sortComparer: false,
        selectId: (instance)=>instance.id
    }, options);
    const stateAdapter = sortComparer ? $4682a312fbf2690b$var$createSortedStateAdapter(selectId, sortComparer) : $4682a312fbf2690b$var$createUnsortedStateAdapter(selectId);
    const stateFactory = $4682a312fbf2690b$var$createInitialStateFactory(stateAdapter);
    const selectorsFactory = $4682a312fbf2690b$var$createSelectorsFactory();
    return $4682a312fbf2690b$var$__spreadValues($4682a312fbf2690b$var$__spreadValues($4682a312fbf2690b$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var $4682a312fbf2690b$var$task = "task";
var $4682a312fbf2690b$var$listener = "listener";
var $4682a312fbf2690b$var$completed = "completed";
var $4682a312fbf2690b$var$cancelled = "cancelled";
var $4682a312fbf2690b$var$taskCancelled = `task-${$4682a312fbf2690b$var$cancelled}`;
var $4682a312fbf2690b$var$taskCompleted = `task-${$4682a312fbf2690b$var$completed}`;
var $4682a312fbf2690b$var$listenerCancelled = `${$4682a312fbf2690b$var$listener}-${$4682a312fbf2690b$var$cancelled}`;
var $4682a312fbf2690b$var$listenerCompleted = `${$4682a312fbf2690b$var$listener}-${$4682a312fbf2690b$var$completed}`;
var $4682a312fbf2690b$export$cb1bdac908fed7f = class {
    constructor(code){
        this.code = code;
        $4682a312fbf2690b$var$__publicField(this, "name", "TaskAbortError");
        $4682a312fbf2690b$var$__publicField(this, "message");
        this.message = `${$4682a312fbf2690b$var$task} ${$4682a312fbf2690b$var$cancelled} (reason: ${code})`;
    }
};
// src/listenerMiddleware/utils.ts
var $4682a312fbf2690b$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new Error($4682a312fbf2690b$export$378fa86b259c0280(32));
};
var $4682a312fbf2690b$var$noop2 = ()=>{};
var $4682a312fbf2690b$var$catchRejection = (promise, onError = $4682a312fbf2690b$var$noop2)=>{
    promise.catch(onError);
    return promise;
};
var $4682a312fbf2690b$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
var $4682a312fbf2690b$var$abortControllerWithReason = (abortController, reason)=>{
    const signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/task.ts
var $4682a312fbf2690b$var$validateActive = (signal)=>{
    if (signal.aborted) {
        const { reason: reason } = signal;
        throw new $4682a312fbf2690b$export$cb1bdac908fed7f(reason);
    }
};
function $4682a312fbf2690b$var$raceWithSignal(signal, promise) {
    let cleanup = $4682a312fbf2690b$var$noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $4682a312fbf2690b$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $4682a312fbf2690b$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $4682a312fbf2690b$var$noop2;
    });
}
var $4682a312fbf2690b$var$runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value: value
        };
    } catch (error) {
        return {
            status: error instanceof $4682a312fbf2690b$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp == null || cleanUp();
    }
};
var $4682a312fbf2690b$var$createPause = (signal)=>{
    return (promise)=>{
        return $4682a312fbf2690b$var$catchRejection($4682a312fbf2690b$var$raceWithSignal(signal, promise).then((output)=>{
            $4682a312fbf2690b$var$validateActive(signal);
            return output;
        }));
    };
};
var $4682a312fbf2690b$var$createDelay = (signal)=>{
    const pause = $4682a312fbf2690b$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign: $4682a312fbf2690b$var$assign } = Object;
var $4682a312fbf2690b$var$INTERNAL_NIL_TOKEN = {};
var $4682a312fbf2690b$var$alm = "listenerMiddleware";
var $4682a312fbf2690b$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$4682a312fbf2690b$var$addAbortSignalListener(parentAbortSignal, ()=>$4682a312fbf2690b$var$abortControllerWithReason(controller, parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $4682a312fbf2690b$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $4682a312fbf2690b$var$runTask(async ()=>{
            $4682a312fbf2690b$var$validateActive(parentAbortSignal);
            $4682a312fbf2690b$var$validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: $4682a312fbf2690b$var$createPause(childAbortController.signal),
                delay: $4682a312fbf2690b$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $4682a312fbf2690b$var$validateActive(childAbortController.signal);
            return result2;
        }, ()=>$4682a312fbf2690b$var$abortControllerWithReason(childAbortController, $4682a312fbf2690b$var$taskCompleted));
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($4682a312fbf2690b$var$noop2));
        return {
            result: $4682a312fbf2690b$var$createPause(parentAbortSignal)(result),
            cancel () {
                $4682a312fbf2690b$var$abortControllerWithReason(childAbortController, $4682a312fbf2690b$var$taskCancelled);
            }
        };
    };
};
var $4682a312fbf2690b$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $4682a312fbf2690b$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate: predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $4682a312fbf2690b$var$raceWithSignal(signal, Promise.race(promises));
            $4682a312fbf2690b$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$4682a312fbf2690b$var$catchRejection(take(predicate, timeout));
};
var $4682a312fbf2690b$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $4682a312fbf2690b$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($4682a312fbf2690b$export$378fa86b259c0280(21));
    $4682a312fbf2690b$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $4682a312fbf2690b$var$createListenerEntry = /* @__PURE__ */ $4682a312fbf2690b$var$assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $4682a312fbf2690b$var$getListenerEntryPropsFrom(options);
    const id = $4682a312fbf2690b$export$ac4959f4f1338dfc();
    const entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($4682a312fbf2690b$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>$4682a312fbf2690b$var$createListenerEntry
});
var $4682a312fbf2690b$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        $4682a312fbf2690b$var$abortControllerWithReason(controller, $4682a312fbf2690b$var$listenerCancelled);
    });
};
var $4682a312fbf2690b$var$createClearListenerMiddleware = (listenerMap)=>{
    return ()=>{
        listenerMap.forEach($4682a312fbf2690b$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $4682a312fbf2690b$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var $4682a312fbf2690b$export$f03a6b845d3fb58b = /* @__PURE__ */ $4682a312fbf2690b$var$assign(/* @__PURE__ */ $4682a312fbf2690b$export$309c7a02b0b0bc62(`${$4682a312fbf2690b$var$alm}/add`), {
    withTypes: ()=>$4682a312fbf2690b$export$f03a6b845d3fb58b
});
var $4682a312fbf2690b$export$b1b8022855fb2b71 = /* @__PURE__ */ $4682a312fbf2690b$export$309c7a02b0b0bc62(`${$4682a312fbf2690b$var$alm}/removeAll`);
var $4682a312fbf2690b$export$b03e9483f936dccb = /* @__PURE__ */ $4682a312fbf2690b$var$assign(/* @__PURE__ */ $4682a312fbf2690b$export$309c7a02b0b0bc62(`${$4682a312fbf2690b$var$alm}/remove`), {
    withTypes: ()=>$4682a312fbf2690b$export$b03e9483f936dccb
});
var $4682a312fbf2690b$var$defaultErrorHandler = (...args)=>{
    console.error(`${$4682a312fbf2690b$var$alm}/error`, ...args);
};
var $4682a312fbf2690b$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const { extra: extra, onError: onError = $4682a312fbf2690b$var$defaultErrorHandler } = middlewareOptions;
    $4682a312fbf2690b$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $4682a312fbf2690b$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        let entry = $4682a312fbf2690b$var$find(Array.from(listenerMap.values()), (existingEntry)=>existingEntry.effect === options.effect);
        if (!entry) entry = $4682a312fbf2690b$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    $4682a312fbf2690b$var$assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const { type: type, effect: effect, predicate: predicate } = $4682a312fbf2690b$var$getListenerEntryPropsFrom(options);
        const entry = $4682a312fbf2690b$var$find(Array.from(listenerMap.values()), (entry2)=>{
            const matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $4682a312fbf2690b$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    $4682a312fbf2690b$var$assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $4682a312fbf2690b$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            $4682a312fbf2690b$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $4682a312fbf2690b$var$createDelay(internalTaskController.signal),
                pause: $4682a312fbf2690b$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $4682a312fbf2690b$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            $4682a312fbf2690b$var$abortControllerWithReason(controller, $4682a312fbf2690b$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    $4682a312fbf2690b$var$abortControllerWithReason(internalTaskController, $4682a312fbf2690b$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $4682a312fbf2690b$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $4682a312fbf2690b$export$cb1bdac908fed7f)) $4682a312fbf2690b$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            $4682a312fbf2690b$var$abortControllerWithReason(internalTaskController, $4682a312fbf2690b$var$listenerCompleted);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $4682a312fbf2690b$var$createClearListenerMiddleware(listenerMap);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $7c4fd50405af3d52$export$b956e38827fca970)(action)) return next(action);
                if ($4682a312fbf2690b$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($4682a312fbf2690b$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($4682a312fbf2690b$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $4682a312fbf2690b$var$INTERNAL_NIL_TOKEN) throw new Error($4682a312fbf2690b$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $4682a312fbf2690b$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $4682a312fbf2690b$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
var $4682a312fbf2690b$var$createMiddlewareEntry = (middleware)=>({
        id: $4682a312fbf2690b$export$ac4959f4f1338dfc(),
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
var $4682a312fbf2690b$var$matchInstance = (instanceId)=>(action)=>{
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
var $4682a312fbf2690b$export$4bb1606a79445586 = ()=>{
    const instanceId = $4682a312fbf2690b$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign($4682a312fbf2690b$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            let entry = $4682a312fbf2690b$var$find(Array.from(middlewareMap.values()), (entry2)=>entry2.middleware === middleware2);
            if (!entry) entry = $4682a312fbf2690b$var$createMiddlewareEntry(middleware2);
            middlewareMap.set(entry.id, entry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$4682a312fbf2690b$var$emplace(entry.applied, api, {
                insert: ()=>entry.middleware(api)
            }));
        return (0, $7c4fd50405af3d52$export$f672e0b6f7222cd7)(...appliedMiddleware);
    };
    const isWithMiddleware = $4682a312fbf2690b$export$9dd1fb32974da385(withMiddleware, $4682a312fbf2690b$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $4682a312fbf2690b$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var $4682a312fbf2690b$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$4682a312fbf2690b$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var $4682a312fbf2690b$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $4682a312fbf2690b$var$isStateProxy = (value)=>!!value && !!value[$4682a312fbf2690b$var$ORIGINAL_STATE];
var $4682a312fbf2690b$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $4682a312fbf2690b$var$createStateProxy = (state, reducerMap)=>$4682a312fbf2690b$var$emplace($4682a312fbf2690b$var$stateProxyMap, state, {
        insert: ()=>new Proxy(state, {
                get: (target, prop, receiver)=>{
                    if (prop === $4682a312fbf2690b$var$ORIGINAL_STATE) return target;
                    const result = Reflect.get(target, prop, receiver);
                    if (typeof result === "undefined") {
                        const reducer = reducerMap[prop.toString()];
                        if (reducer) {
                            const reducerResult = reducer(void 0, {
                                type: $4682a312fbf2690b$export$ac4959f4f1338dfc()
                            });
                            if (typeof reducerResult === "undefined") throw new Error($4682a312fbf2690b$export$378fa86b259c0280(24));
                            return reducerResult;
                        }
                    }
                    return result;
                }
            })
    });
var $4682a312fbf2690b$var$original = (state)=>{
    if (!$4682a312fbf2690b$var$isStateProxy(state)) throw new Error($4682a312fbf2690b$export$378fa86b259c0280(25));
    return state[$4682a312fbf2690b$var$ORIGINAL_STATE];
};
var $4682a312fbf2690b$var$noopReducer = (state = {})=>state;
function $4682a312fbf2690b$export$a3734c7614660b9(...slices) {
    const reducerMap = Object.fromEntries($4682a312fbf2690b$var$getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, $7c4fd50405af3d52$export$66e4520cdb265d18)(reducerMap) : $4682a312fbf2690b$var$noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) {
            typeof $f35e65d8cff8ccc8$exports;
            return combinedReducer;
        }
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn($4682a312fbf2690b$var$createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap), ...args);
        };
    }, {
        original: $4682a312fbf2690b$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $4682a312fbf2690b$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}


const $b52d866ccdc67166$var$cartSlice = (0, $4682a312fbf2690b$export$4d8d9bd83c24ae8b)({
    name: "cart",
    initialState: {
        // items: ["Burger","pizza"],
        items: []
    },
    reducers: {
        addItem: (state, action)=>{
            // Vanilla (older) Redux => Dont mutate state, returning was mandatory
            // const newState = [...state];
            // newState.item.push(action.payload);
            // return newState;
            //Redux toolkit
            // Mutating the state here its not returning mandatory and behind the scene redux is immutable
            state.items.push(action.payload);
        },
        removeItem: (state, action)=>{
            state.items.pop();
        },
        // originalState = {items: ["pizza"]}
        clearItem: (state, action)=>{
            //Redux toolkit - either mutate the existing state or return a new state
            // state.items.length = 0;   //[]  empty array
            return {
                items: []
            }; // this new object will be replaced inside original Sate = { items: []}
        }
    }
});
const { addItem: $b52d866ccdc67166$export$fb9705de59d96855, removeItem: $b52d866ccdc67166$export$fe2d9b4e03920b4c, clearItem: $b52d866ccdc67166$export$c4418ad9fa7bfb0c } = $b52d866ccdc67166$var$cartSlice.actions;
var $b52d866ccdc67166$export$2e2bcd8739ae039 = $b52d866ccdc67166$var$cartSlice.reducer;


const $a2dad74370173474$var$ItemList = ({ items: items })=>{
    // console.log(items );
    const dispatch = (0, $fca7d9e435ad71ad$export$8ad76b76a4c905f8)();
    const handleAddItem = (item)=>{
        //Dispatch an action
        // dispatch(addItem("pizza")); 
        dispatch((0, $b52d866ccdc67166$export$fb9705de59d96855)(item));
    };
    return /*#__PURE__*/ (0, $2T6zX.jsx)("div", {
        children: items.map((item)=>/*#__PURE__*/ (0, $2T6zX.jsxs)("div", {
                className: "p-2 m-2 border-b-2 border-gray-200 text-left flex justify-between flex-wrap",
                children: [
                    /*#__PURE__*/ (0, $2T6zX.jsxs)("div", {
                        className: "lg:w-9/12 sm:w-full",
                        children: [
                            /*#__PURE__*/ (0, $2T6zX.jsx)("span", {
                                className: "font-bold py-2",
                                children: item.card.info.name
                            }),
                            /*#__PURE__*/ (0, $2T6zX.jsxs)("span", {
                                className: "font-bold",
                                children: [
                                    "- \u20B9 ",
                                    item.card.info.price ? item.card.info.price / 100 : item.card.info.defaultPrice / 100
                                ]
                            }),
                            /*#__PURE__*/ (0, $2T6zX.jsx)("p", {
                                className: "text-xs",
                                children: item.card.info.description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2T6zX.jsxs)("div", {
                        className: "lg:w-3/12 sm:w-full",
                        children: [
                            /*#__PURE__*/ (0, $2T6zX.jsx)("div", {
                                className: "absolute",
                                children: /*#__PURE__*/ (0, $2T6zX.jsxs)("button", {
                                    className: "p-1 bg-white shadow-lg rounded-lg text-orange-600 mx-7 mt-12 text-sm font-bold",
                                    onClick: ()=>handleAddItem(item),
                                    children: [
                                        "Add ",
                                        /*#__PURE__*/ (0, $2T6zX.jsx)("i", {
                                            class: "fa fa-plus",
                                            "aria-hidden": "true"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $2T6zX.jsx)("img", {
                                src: (0, $7fd0baa016ace72e$export$c65137966c75edf0) + item.card.info.imageId,
                                className: "w-28"
                            })
                        ]
                    })
                ]
            }, item.card.info.id))
    });
};
var $a2dad74370173474$export$2e2bcd8739ae039 = $a2dad74370173474$var$ItemList;


const $3c1859c473a00b8b$var$RestaurantCategory = ({ data: data, showItem: showItem, setShowIndex: setShowIndex })=>{
    //ShowItem hide and show using useState
    // const [showItem, setShowItem]=useState(false);
    const handleClick = ()=>{
        // console.log("Clicked");
        // setShowItem(true);
        // setShowItem(!showItem);   //Toggle a Item
        setShowIndex();
    };
    //console.log(data);
    return /*#__PURE__*/ (0, $2T6zX.jsx)("div", {
        children: /*#__PURE__*/ (0, $2T6zX.jsxs)("div", {
            className: "bg-gray-100 lg:w-6/12 sm:w-full mx-auto my-4 cursor-pointer shadow-lg p-4",
            children: [
                /*#__PURE__*/ (0, $2T6zX.jsxs)("div", {
                    className: "flex justify-between",
                    onClick: handleClick,
                    children: [
                        /*#__PURE__*/ (0, $2T6zX.jsxs)("span", {
                            className: "font-bold text-lg",
                            children: [
                                data.title,
                                " (",
                                data.itemCards.length,
                                ")"
                            ]
                        }),
                        /*#__PURE__*/ (0, $2T6zX.jsx)("span", {
                            children: "\u2B07\uFE0F"
                        })
                    ]
                }),
                showItem && /*#__PURE__*/ (0, $2T6zX.jsx)((0, $a2dad74370173474$export$2e2bcd8739ae039), {
                    items: data.itemCards
                })
            ]
        })
    });
};
var $3c1859c473a00b8b$export$2e2bcd8739ae039 = $3c1859c473a00b8b$var$RestaurantCategory;


const $eb4378f77fb83373$var$RestaurantMenu = ()=>{
    // const[resInfo, setResInfo]=useState(null);
    const [showIndex, setShowIndex] = (0, $bCCVl.useState)(0);
    const { resId: resId } = (0, $2bd9a3ffc1ab0195$export$99eaa27ddbbb95ef)();
    //console.log(resId);
    //This is a Custom hooks
    const resInfo = (0, $dc837782a668f0e9$export$2e2bcd8739ae039)(resId);
    // useEffect(()=>{
    //     fetchMenu();
    // },[]);
    // const fetchMenu=async()=>{
    //    const data=await fetch(RESTAURANT_MENU + resId);
    //     const json=await data.json();
    //     console.log(json);
    //    setResInfo(json.data);
    // }
    if (resInfo === null) return /*#__PURE__*/ (0, $2T6zX.jsx)((0, $908ef0a010594a4d$export$2e2bcd8739ae039), {});
    const { name: name, cuisines: cuisines, costForTwoMessage: costForTwoMessage } = resInfo?.cards[2]?.card?.card?.info;
    const { itemCards: itemCards } = resInfo?.cards[4]?.groupedCard?.cardGroupMap?.REGULAR?.cards[2]?.card?.card;
    // console.log(itemCards);
    // console.log(resInfo?.cards[4]?.groupedCard?.cardGroupMap?.REGULAR?.cards);
    const categories = resInfo?.cards[4]?.groupedCard?.cardGroupMap?.REGULAR?.cards.filter((c)=>c.card?.card?.["@type"] === "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory");
    // console.log(categories);
    return /*#__PURE__*/ (0, $2T6zX.jsxs)("div", {
        className: "text-center mt-32",
        children: [
            /*#__PURE__*/ (0, $2T6zX.jsx)("h2", {
                className: "font-bold my-6 text-2xl",
                children: name
            }),
            /*#__PURE__*/ (0, $2T6zX.jsxs)("p", {
                className: "font-bold",
                children: [
                    cuisines.join(""),
                    " - ",
                    costForTwoMessage
                ]
            }),
            categories.map((category, index)=>//Controlled component
                /*#__PURE__*/ (0, $2T6zX.jsx)((0, $3c1859c473a00b8b$export$2e2bcd8739ae039), {
                    data: category?.card?.card,
                    showItem: index === showIndex ? true : false,
                    setShowIndex: ()=>setShowIndex(index)
                }, category?.card?.card?.title))
        ]
    });
};
var $eb4378f77fb83373$export$2e2bcd8739ae039 = $eb4378f77fb83373$var$RestaurantMenu;





//const { configureStore } = require("@reduxjs/toolkit");


const $f77e393fe08f1188$var$appStore = (0, $4682a312fbf2690b$export$7d8a5b498da695ac)({
    reducer: {
        cart: (0, $b52d866ccdc67166$export$2e2bcd8739ae039)
    }
});
var $f77e393fe08f1188$export$2e2bcd8739ae039 = $f77e393fe08f1188$var$appStore;



var $2T6zX = parcelRequire("2T6zX");



const $e3d9fcbe90850002$var$Cart = ()=>{
    const cartItems = (0, $fca7d9e435ad71ad$export$2105062e25df4afe)((store)=>store.cart.items);
    // const store=useSelector((store) => store);
    // const cartItems=store.cart.items;   // less efficient
    //console.log(cartItems);
    const dispatch = (0, $fca7d9e435ad71ad$export$8ad76b76a4c905f8)();
    const handleClearCart = ()=>{
        dispatch((0, $b52d866ccdc67166$export$c4418ad9fa7bfb0c)());
    };
    return /*#__PURE__*/ (0, $2T6zX.jsxs)("div", {
        className: "mt-28 text-center",
        children: [
            /*#__PURE__*/ (0, $2T6zX.jsx)("h1", {
                className: "font-bold text-3xl p-4 m-4",
                children: "Cart"
            }),
            /*#__PURE__*/ (0, $2T6zX.jsxs)("div", {
                className: "w-6/12 m-auto",
                children: [
                    /*#__PURE__*/ (0, $2T6zX.jsx)("button", {
                        onClick: handleClearCart,
                        className: "p-2 m-2 bg-black text-white",
                        children: "Clear Cart"
                    }),
                    cartItems.length == 0 && /*#__PURE__*/ (0, $2T6zX.jsx)("h1", {
                        children: "Cart is empty. Add Item to the Card !!"
                    }),
                    /*#__PURE__*/ (0, $2T6zX.jsx)((0, $a2dad74370173474$export$2e2bcd8739ae039), {
                        items: cartItems
                    })
                ]
            })
        ]
    });
};
var $e3d9fcbe90850002$export$2e2bcd8739ae039 = $e3d9fcbe90850002$var$Cart;



var $2T6zX = parcelRequire("2T6zX");

const $0301d74955b0f7fe$var$Footer = ()=>{
    return /*#__PURE__*/ (0, $2T6zX.jsx)("div", {
        class: "footer bg-gray-950 sm:px-0 lg:px-40 p-4 text-gray-300 mt-5",
        children: /*#__PURE__*/ (0, $2T6zX.jsxs)("div", {
            class: "flex justify-around flex-wrap mt-10",
            children: [
                /*#__PURE__*/ (0, $2T6zX.jsxs)("div", {
                    class: "",
                    children: [
                        /*#__PURE__*/ (0, $2T6zX.jsx)("img", {
                            className: "logo w-24",
                            alt: "logo",
                            src: (0, $7fd0baa016ace72e$export$8878ead86ed0da0b)
                        }),
                        /*#__PURE__*/ (0, $2T6zX.jsx)("span", {
                            class: "text-gray-400 font-semibold my-2 mt-3",
                            children: "@copyright 2024"
                        }),
                        /*#__PURE__*/ (0, $2T6zX.jsx)("p", {
                            class: "text-gray-400 font-semibold mt-3",
                            children: "Designed & Developed by"
                        }),
                        /*#__PURE__*/ (0, $2T6zX.jsx)("a", {
                            href: "https://www.linkedin.com/in/himani-jayesh-patil-959465a0/",
                            target: "_blank",
                            children: /*#__PURE__*/ (0, $2T6zX.jsx)("p", {
                                class: "font-semibold text-orange-600",
                                children: "Himani Patil"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2T6zX.jsxs)("div", {
                    class: "",
                    children: [
                        /*#__PURE__*/ (0, $2T6zX.jsx)("p", {
                            class: "font-bold text-lg mb-8",
                            children: "Company"
                        }),
                        /*#__PURE__*/ (0, $2T6zX.jsx)("p", {
                            class: "my-3 cursor-pointer text-gray-400 font-semibold",
                            children: "Home"
                        }),
                        /*#__PURE__*/ (0, $2T6zX.jsx)("p", {
                            class: "my-3 cursor-pointer text-gray-400 font-semibold",
                            children: "About Us"
                        }),
                        /*#__PURE__*/ (0, $2T6zX.jsx)("p", {
                            class: "my-3 cursor-pointer text-gray-400 font-semibold",
                            children: "Careers"
                        }),
                        /*#__PURE__*/ (0, $2T6zX.jsx)("p", {
                            class: "my-3 cursor-pointer text-gray-400 font-semibold",
                            children: "Team"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2T6zX.jsxs)("div", {
                    class: "",
                    children: [
                        /*#__PURE__*/ (0, $2T6zX.jsx)("p", {
                            class: "font-bold text-lg mb-8",
                            children: "Contact us"
                        }),
                        /*#__PURE__*/ (0, $2T6zX.jsx)("p", {
                            class: "my-3 cursor-pointer text-gray-400 font-semibold",
                            children: "Help & Support"
                        }),
                        /*#__PURE__*/ (0, $2T6zX.jsx)("p", {
                            class: "my-3 cursor-pointer text-gray-400 font-semibold",
                            children: "Partner with us"
                        }),
                        /*#__PURE__*/ (0, $2T6zX.jsx)("p", {
                            class: "my-3 cursor-pointer text-gray-400 font-semibold",
                            children: "Ride with us"
                        }),
                        /*#__PURE__*/ (0, $2T6zX.jsx)("p", {
                            class: "my-3 cursor-pointer text-gray-400 font-semibold",
                            children: "Tearms & Condition"
                        }),
                        /*#__PURE__*/ (0, $2T6zX.jsx)("p", {
                            class: "my-3 cursor-pointer text-gray-400 font-semibold",
                            children: "Privacy Policy"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2T6zX.jsxs)("div", {
                    class: "",
                    children: [
                        /*#__PURE__*/ (0, $2T6zX.jsx)("p", {
                            class: "font-bold text-lg mb-8",
                            children: "We deliver to:"
                        }),
                        /*#__PURE__*/ (0, $2T6zX.jsx)("p", {
                            class: "my-3 cursor-pointer text-gray-400 font-semibold",
                            children: "Mumbai"
                        }),
                        /*#__PURE__*/ (0, $2T6zX.jsx)("p", {
                            class: "my-3 cursor-pointer text-gray-400 font-semibold",
                            children: "Pune"
                        }),
                        /*#__PURE__*/ (0, $2T6zX.jsx)("p", {
                            class: "my-3 cursor-pointer text-gray-400 font-semibold",
                            children: "Bangalore"
                        }),
                        /*#__PURE__*/ (0, $2T6zX.jsx)("p", {
                            class: "my-3 cursor-pointer text-gray-400 font-semibold",
                            children: "Hyderabad"
                        }),
                        /*#__PURE__*/ (0, $2T6zX.jsx)("p", {
                            class: "my-3 cursor-pointer text-gray-400 font-semibold",
                            children: "Delhi"
                        })
                    ]
                })
            ]
        })
    });
};
var $0301d74955b0f7fe$export$2e2bcd8739ae039 = $0301d74955b0f7fe$var$Footer;



const $429fdc10c6cf8af6$var$Grocery = /*#__PURE__*/ (0, $bCCVl.lazy)(()=>(parcelRequire("98FoB")));
// const heading=React.createElement("h1",{id:"heading"},"Hello world! First React Program");
// console.log(heading);  //convert object
// const root=ReactDOM.createRoot(document.getElementById("root"));
// root.render(heading);
/*
<div id="parant">
    <div id="child">
    <h1>I am h1 Tag</h1>
    <h2>I am h2 Tag</h2>
    </div>
     <div id="child2">
    <h1>I am h1 Tag</h1>
    <h2>I am h2 Tag</h2>
    </div>
</div>
*/ // const parent=React.createElement("div",{id:"parent"},
//     React.createElement("div",{id:"child"},
//         React.createElement("h1",{}, "I am h1 tag")
//     )
// );
// const parent=React.createElement("div",{id:"parent"},
//     [
//      React.createElement("div",{id:"child"},
//          [React.createElement("h1",{}, "This is the h1 heading"),
//          React.createElement("h2",{}, "I am h2 tag")
//      ]),
//      React.createElement("div",{id:"child2"},
//          [React.createElement("h1",{}, "I am h1 tag"),
//          React.createElement("h2",{}, "I am h2 tag")
//      ])
//     ]
//  );
//  const root=ReactDOM.createRoot(document.getElementById("root"));
//  root.render(parent);
//React.createElement => Object => HTMLElement(render)
// const heading=React.createElement("h1",{id:"heading"},"Hello world! First React Program");
// console.log(heading);  //convert object
//JSX = HTML like or XML like syntax
//JSX (transpiled before it reaches the JS) - Parcel -Babel
//JSX => Babel transpiled it to React.createElement => ReactElement -JS Object => HTMLElement (render)
// const jsxHeading=(
// <h1 id="heading" className="head" tabIndex="5">Namste React JSX</h1>
// );
// console.log(jsxHeading);
//Title Function
// const Title=()=>(
//     <h1 id="heading" className="head" tabIndex="5">Namste React Title Component</h1>
//     );
//     const elem=<span>Span React Element</span>;
//Title Variable
// const title=(
//     <h1 id="heading" className="head" tabIndex="5">
//     {elem} &
//     Namste React Title Variable</h1>
//     ); 
//React Functional Component
// const fn=()=>{
//     return true;
// }
// const fn2=()=>true;
// const HeadingComponent=()=>{
//     <h1>Namaste React Functional Component</h1>
// }
// const HeadingComponent=()=>(
//     <div id="container">
//     <Title/>   
//     {jsxHeading}
//     {title}
// <h1 className="heading">Namaste React Functional Component</h1>
// </div>
// );
//This is Component Composition in HeadingComponent inside rendering a Title Component
// const resObj =
//   {
//     data: {
//       id: "78036",
//       name: "Burger King",
//       cloudinaryImageId: "e33e1d3ba7d6b2bb0d45e1001b731fcf",
//       locality: "Central Plaza, Kalina",
//       areaName: "Santacruz East",
//       costForTwo: 35000,
//       costForTwoString: "₹350 for two",
//       deliveryTime: 24,
//       cuisines: ["Burgers", "American"],
//       avgRating: 4.2,
//       feeDetails: {
//         restaurantId: "78036",
//         fees: [
//           {
//             name: "BASE_DISTANCE",
//             fee: 3200,
//           },
//           {
//             name: "BASE_TIME",
//           },
//           {
//             name: "ANCILLARY_SURGE_FEE",
//           },
//         ],
//         totalFee: 3200,
//       },
//       parentId: "166",
//       avgRatingString: "4.2",
//       totalRatingsString: "10K+",
//       sla: {
//         lastMileTravel: 1.5,
//         serviceability: "SERVICEABLE",
//         slaString: "24 mins",
//         lastMileTravelString: "1.5 km",
//         iconType: "ICON_TYPE_EMPTY",
//       },
//       availability: {
//         nextCloseTime: "2023-11-30 03:45:00",
//         opened: true,
//       },
//       badges: {},
//       isOpen: true,
//       type: "F",
//       badgesV2: {
//         entityBadges: {
//           imageBased: {},
//           textBased: {},
//           textExtendedBadges: {},
//         },
//       },
//       aggregatedDiscountInfoV3: {
//         header: "ITEMS",
//         subHeader: "AT ₹129",
//       },
//       differentiatedUi: {
//         displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
//         differentiatedUiMediaDetails: {
//           mediaType: "ADS_MEDIA_ENUM_IMAGE",
//           lottie: {},
//           video: {},
//         },
//       },
//       reviewsSummary: {},
//       displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
//       restaurantOfferPresentationInfo: {},
//     },
//     analytics: {},
//     cta: {
//       link: "https://www.swiggy.com/restaurants/burger-king-central-plaza-kalina-santacruz-east-mumbai-78036",
//       type: "WEBLINK",
//     },
//   };
// not using keys (not acceptable) <<<<< index as key <<<<< Unique id (best practice)
const $429fdc10c6cf8af6$var$AppLayout = ()=>{
    const [userName, setUserName] = (0, $bCCVl.useState)();
    //Authentication
    (0, $bCCVl.useEffect)(()=>{
        //Make an API call and send username and password
        const data = {
            name: "Himani Patil"
        };
        setUserName(data.name);
    }, []);
    return(//Default User
    /*#__PURE__*/ (0, $2T6zX.jsx)((0, $fca7d9e435ad71ad$export$2881499e37b75b9a), {
        store: (0, $f77e393fe08f1188$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $2T6zX.jsx)((0, $ee52d48033679fb8$export$2e2bcd8739ae039).Provider, {
            value: {
                loggedInUser: userName,
                setUserName: setUserName
            },
            children: /*#__PURE__*/ (0, $2T6zX.jsxs)("div", {
                className: "app",
                children: [
                    /*#__PURE__*/ (0, $2T6zX.jsx)((0, $849b7a06d4c2381c$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $2T6zX.jsx)((0, $2bd9a3ffc1ab0195$export$910ae8079b2c2852), {}),
                    /*#__PURE__*/ (0, $2T6zX.jsx)((0, $0301d74955b0f7fe$export$2e2bcd8739ae039), {})
                ]
            })
        })
    }));
};
const $429fdc10c6cf8af6$var$appRouter = (0, $1cceaedd24710e82$export$1f3f55432a00e06d)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $2T6zX.jsx)($429fdc10c6cf8af6$var$AppLayout, {}),
        children: [
            {
                path: "/",
                element: /*#__PURE__*/ (0, $2T6zX.jsx)((0, $f7ea6cd679c020e3$export$2e2bcd8739ae039), {})
            },
            {
                path: "/about",
                element: /*#__PURE__*/ (0, $2T6zX.jsx)((0, $c772aa1e51119bea$export$2e2bcd8739ae039), {})
            },
            {
                path: "/contact",
                element: /*#__PURE__*/ (0, $2T6zX.jsx)((0, $d9a7192050356875$export$2e2bcd8739ae039), {})
            },
            {
                path: "/cart",
                element: /*#__PURE__*/ (0, $2T6zX.jsx)((0, $e3d9fcbe90850002$export$2e2bcd8739ae039), {})
            },
            {
                path: "/grocery",
                element: /*#__PURE__*/ (0, $2T6zX.jsx)((0, $bCCVl.Suspense), {
                    fallback: /*#__PURE__*/ (0, $2T6zX.jsx)("h1", {
                        children: "Loading........"
                    }),
                    children: /*#__PURE__*/ (0, $2T6zX.jsx)($429fdc10c6cf8af6$var$Grocery, {})
                })
            },
            {
                path: "/restaurants/:resId",
                element: /*#__PURE__*/ (0, $2T6zX.jsx)((0, $eb4378f77fb83373$export$2e2bcd8739ae039), {})
            }
        ],
        errorElement: /*#__PURE__*/ (0, $2T6zX.jsx)((0, $f49d2f70ada93472$export$2e2bcd8739ae039), {})
    }
]);
const $429fdc10c6cf8af6$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($9a2f8d1b85cf3b27$exports))).createRoot(document.getElementById("root"));
// root.render(<AppLayout/>);
// root.render(heading);
// root.render(jsxHeading);
// root.render(<HeadingComponent/>);
$429fdc10c6cf8af6$var$root.render(/*#__PURE__*/ (0, $2T6zX.jsx)((0, $1cceaedd24710e82$export$323e4fc2fa4753fb), {
    router: $429fdc10c6cf8af6$var$appRouter
}));


//# sourceMappingURL=index.16aa5ba8.js.map
